(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":51,"./util":63}],2:[function(require,module,exports){
var util = require("./util");
var unbind = 0;
function getPageCategory() {
	//return window.pageContext.title || "Content"; ###### this throws product name
	switch(window.Resources.PAGE_CATEGORY)	{
	case 'product-showincategory':
		return "Product Page";
		break;
	case 'product-show':
		return "Product Page";
		break;
	case 'search-show':
		return "Category Page";
		break;
	case 'home-show':
		return "Home Page"
		break;
	case 'cart-show':
		return "Cart Page"
		break;
	case 'cart-addtowishlist':
		return "Cart Page"
		break;
	case 'customerservice-contactus':
		return "Contact Customer Care"
		break;
	case 'customerservice-concierge':
		return "Ask An Expert"
		break;
	case 'account-startregister':
		return "Account Creation"
		break;
	case 'account-editprofile' :
		return "My Account"
		break;
	case 'address-list':
		return "My Account"
		break;
	case 'paymentinstruments-list':
		return "My Account"
		break;
	case 'wishlist-show':
		return "My Account"
		break;
	case 'order-history':
		return "My Account"
		break;
	case 'orderreplenishment-show':
		return "My Account"
		break;
	case 'login-show':
		return "Account Registration"
		break;
	case 'coshipping-start':
		return "Checkout"
		break;
	case 'coshipping-singleshipping':
		return "Checkout"
		break;
	case 'cobilling-start':
		return "Checkout"
		break;
	case 'cobilling-billing':
		return "Checkout"
		break;
	case 'search-showcontent':
		return "Site Search"
		break;
	case 'giftcert-purchase':
		return "Gift Card Page"
		break;
	case 'cocustomer-loginform':
		return "Customer Login";
		break;
	case 'default-start':
		return "Home Page";
		break;
	case 'search-brandify':
		return "Store Locator Page";
		break;
	default:
		return "Content";
		break;
	}
}
// Specific for checkout and cart page only
function couponsubcategory(){
	switch(window.Resources.PAGE_CATEGORY){
	case 'cart-show':
		return "Cart"
		break;
	case 'coshipping-start':
		return "Shipping"
		break;
	case 'coshipping-singleshipping':
		return "Payment"
		break;
	case 'cobilling-start':
		return "Payment"
		break;
	case 'cobilling-removegiftcertificate':
		return "Payment"
		break;
	case 'cobilling-billing':
		return "Review"
		break;
	case 'account-editprofile' :
		return "Profile"
		break;
	case 'address-list':
		return "Addresses"
		break;
	case 'paymentinstruments-list':
		return "Payment Methods"
		break;
	case 'wishlist-show':
		return "Saved For Later"
		break;
	case 'order-history':
		return "Order History"
		break;
	case 'orderreplenishment-show':
		return "Replenishment"
		break;
	default:
		break;
	}
}

function isMobile() {
	return $(window).width() <= 640;
}
//Specific for PDP
function getProductName()	{
	return $(".product-detail .product-name").text();
}
//Specific for PDP
function getProductBrand() {
	return "Shiseido"; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID()	{
	return $("#pid").val();
}
//Specific for PDP
function getProductCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(1)").text().trim();
}
//Specific for PDP
function getProductsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim();
}
// Specific for PDP
function getProductOrederType() {
	var replen = $(".replenishmentCycle").val();
	if(replen>0){
		return "Replenishment"
	} else {
		return "Regular"
	}
	 
}

function getPageSubcategory() {
	return window.pageContext.title || "Content";
}

function getLanguage() {
	if (window.User.locale.indexOf("en") >= 0) {
		return "English";
	} else if (window.User.locale.indexOf("cn") >= 0) {
		return "Chinese";
	} else if (window.User.locale.indexOf("es") >= 0) {
		return "Spanish";
	} else {
		return window.User.locale;
	}
}

// page-specific: Cart, Checkout
function getPageError() {
	var $errorMsg = $(".error-form");
	if ($errorMsg.length === 0) {
		return "";
	}

	return $errorMsg.html().trim();
}

function getActiveSortingRule() {
	var httpParams = util.getQueryStringParams(window.location.href);
	var sortParam = httpParams["srule"];

	if (!sortParam) {
		return null;
	}

	return sortParam.split("-").map(function (w) {
		return w[0].toUpperCase() + w.substr(1);
	}).join(" ");
}

function pushToDataLayer(o) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(util.filterObj(o));
	//alert(JSON.stringify(util.filterObj(o)));
}

function isScrolledIntoView(elem)
{
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height() + 600;
	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height() - 1000;
	return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function getpage(){
	 var url = window.location.href;
	 var splittedurl = url.split("?");
	 var page = splittedurl[0].split("/");
	 return page[page.length-1]
}
//page-specific: PLP
function getRefinementsFromURL() {
	var str = "";
	if(window.location.href.split("?").length > 1){
		var urlparam;
		if(window.location.href.split("?")[1].indexOf("&")>-1){
			urlparam = window.location.href.split("?")[1].split("&");
			var length = urlparam.length;
			var prefnval,prefnkey,prefvval,prefvkey;
			for(var i =0;i<length;i++){
				var prefn = urlparam[i].indexOf("prefn");
				if(prefn > -1){
				  prefnkey = urlparam[i].split("=")[0];
				  prefnval = urlparam[i].split("=")[1];
				  console.log(prefnkey);
				  var num = prefnkey.charAt(5);
				  for(var a =0;a<length;a++){
					var prefv = urlparam[a].indexOf("prefv");
					prefvkey = urlparam[a].split("=")[0];
					if(prefvkey == "prefv"+num){
					   prefvval = urlparam[a].split("=")[1];
					   str += "[" + prefnval  + ":" + prefvval  + "]";
					}	
				  }
				} 
			}
		}
	}
	return str;
}

function trackConsultationEvent(data) {
	var TOOL_TYPES = {
		"skincareConsultation": "Skincare Consultation"
	};

	pushToDataLayer({
		"event": "consultation" + data.element[0].toUpperCase() + data.element.substr(1),
		"pageCategory": "Consultation Tool",
		"consultationToolType": TOOL_TYPES[data.toolname] || data.toolname,
		"consultationQuestion": data.question,
		"consultationResponse": data.answers[0]
	});
}

function trackConsultationPageview(data) {
	pushToDataLayer({
		"page": getpage(),
		"event": "consultationSteps",
		"pageCategory": getPageCategory(),
		"pageSubCategory": getPageSubcategory(),
		"consultationToolType": data.toolname,
		"consultationStep": data.pagename
	});
}

function trackInternalPromotionEvent(data) {
	
	var promotionURL = data.pageName;
	
	pushToDataLayer({
		"event": "eePromoClick",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
		"position": data.position,
		"id": data.id,
		"creative": data.creative,
		"name": data.name
		}]
	}), (function(){setTimeout(function(){
		if (promotionURL != undefined) {
			document.location = promotionURL;
		}
		}, 1000);
	})();
}

function trackInternalPromotionPageView(data) {
	pushToDataLayer({
		"eeAction": "eePromoView",
		"event" : "eePromoView",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
		"position": data.position,
		"id": data.id,
		"creative": data.creative,
		"name": data.name
		}]
	});
}

function initializeGlobalEvents() {
	var navctr = true;
	var gtmNavData = "";

	var xArray = $('.search-result-items .column').filter(function () {
		return $(this).data('colors-to-show') !== undefined
	});

	$(document)
	
		// add to wishlist in pdp and quickview
		.on('click', "#save-for-later", function (e) {
				pushToDataLayer({
					"event": "clickSaveForLater",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": getPageCategory(),
					"productId": getProductID()
					});
		})

		// add to wishlist in cart
		.on('click', ".add-to-wishlist",function (e) {
			var index = $(this).parents(".cart-row").index();
			pushToDataLayer({
				"event": "clickSaveForLater",
				"productCategory":basketConfirmation.productLineItems[index-1].category,
				"productSubCategory":basketConfirmation.productLineItems[index-1].subCategory,
				"productName":basketConfirmation.productLineItems[index-1].name,
				"pageCategory": getPageCategory(),
				"productId": basketConfirmation.productLineItems[index-1].id
			});
		})
		
		// remove to wishlist PDP
		.on('click', ".remove-from-wishlist", function(e) {
			pushToDataLayer({
				"event": "removeFromWishlist",
				"productCategory":getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": getPageCategory(),
				"productId": getProductID()
				});
		})

		// remove to wishlist from my account
		.on('click', ".wishlist-item .delete-item", function(e) {
			var data =  $(this).data("catid");
			var productCategory = data[data.length-2];
			var productSubCategory = data[data.length-3];
			pushToDataLayer({
				"event": "removeFromWishlist",
				"productCategory":productCategory,
				"productSubCategory": productSubCategory,
				"pageSubCategory": "Save for Later",
				"productName": $(this).data("productname"),
				"pageCategory": getPageCategory(),
				"productId": $(this).data("productid")
				});
		})

		// remove to wishlist Quickview
		.on('click', "#modal-content .remove-from-wishlist", function(e) {
			pushToDataLayer({
				"event": "removeFromWishlist",
				"productCategory":getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": getPageCategory(),
				"productId": getProductID()
				});
		})

		// newsletter in navigation;
		.on("clicknewsletter", function (e, data) {
				 pushToDataLayer({
					"event": "newsletterSubscription",
					"siteLocation": data.siteloc,
					"pageSubCategory": getPageCategory() == "My Account" ? getProductsubCategory():"",
					"pageCategory": getPageCategory()
					});
		 })


		// click ask question in pdp
		.on("click",".bv-ask-question",	function (e) {
			pushToDataLayer({
				page:getpage(),
				"event": "askQuestion",
				productCategory:getProductCategory(),
				pageSubCategory:"Ask a Question",
				productName:getProductName(),
				pageCategory:"Product Page"
			});
		})

		// Scroll on reviews in pdp
		.scroll(function() {
			 if($(".bv-content-list-Reviews").length){
				if(isScrolledIntoView(".bv-content-list-Reviews") && unbind < 1)
				{
					unbind = 1;
					pushToDataLayer({
							page: getpage(),
							event: "productReviewsView",
							productCategory: getProductCategory(),
							pageSubCategory: "Reviews",
							productName:getProductName(),
							pageCategory: "Product Page"
					});
				}
			 }
		})
		
		// Click on Reviews in PDP
		.on("click", ".bv-inline-histogram-ratings-star-container", function () {
			pushToDataLayer({
				page: getpage(),
				event: "productReviewsView",
				productCategory: getProductCategory(),
				pageSubCategory: "Reviews",
				productName:getProductName(),
				pageCategory: "Product Page"
			});
		})

		// Check balance giftcard in gift card page
		.on('click', "#CheckBalanceButton", function(){
			if($("#dwfrm_giftcert_balance_giftCertID").val() != "" && $("#dwfrm_giftcert_balance_giftCertPIN").val() != ""){
				pushToDataLayer({
					"event": "giftCard",
					"pageSubCategory": "Gift Card",
					"pageCategory": "My Account"
					});
			}
		})

		// Check balance giftcard in checkout page
		.on('click', ".modal-body .gift-cert-balance-submit #check-giftcert-modal", function(e){
			if($(".modal-body .gift-card-number #dwfrm_billing_giftCertCode").val() != "" && $(".modal-body .gift-card-pin #dwfrm_giftcert_balance_giftCertPIN").val() != ""){
				pushToDataLayer({
					"event": "giftCard",
					"pageSubCategory": "Payment",
					"pageCategory": "Checkout"
					});

			}
		})

		// add to cart from PDP
		.on('click', '#add-to-cart', function (e) {
			if(getPageCategory() == "Cart Page"){
				if(sessionStorage.getItem("cartupdate")){
					sessionStorage.setItem("productUpdate","1");
				}
			}else{
				pushToDataLayer({
					"currencyCode": window.Resources.CURRENCY,
					"event": "addToCart",
					"productOrderType": getProductOrederType(),
					"addToCartType": "Product Page",
					"pageCategory": getPageCategory(),
					'products': [{
					"id": getProductID(),
					"category": window.productCache.catid,
					"price": $("#add-to-cart").data("price"),
					"name": getProductName(),
					"brand": getProductBrand(),
					"quantity": Number($(".quantity select").val()),
					"size": $("#pdp-swatches li.selected").text().trim(),
					"subCategory" : window.productCache.subcategory,
					"subSubCategory" : window.productCache.subsubcategory,
					"productAutoReplen":$("#add-to-cart").data("replenishable"),
					"productOutOfStock": $("#add-to-cart").data("instock"),
					"productColor": $("#va-color option:selected").text().split("/")[0].trim(),
					"productType": "Product",
					"productNumReviews":"",
					"productStarRating":""}]
					});
			}
		})
		
		// Submit ask a question
		.on('click', ".bv-submission-section button:contains('Post Question')" , function(e){
				pushToDataLayer({
					"page": getpage(),
					"event": "submitQuestion",
					"productCategory": getProductCategory(),
					"question": $("#bv-textarea-field-questionsummary").val(),
					"productName": getProductName(),
					"pageSubCategory": "Ask a Question",
					"pageCategory": getPageCategory()
					});
		})
		
		// remove from cart
		.on('click', ".item-user-actions .button-text[value='Remove']", function (e) {
			var index = $(this).parents(".cart-row").index();
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "removeFromCart",
				"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
				"pageCategory": getPageCategory(),
				'products': [{
				"id": basketConfirmation.productLineItems[index-1].id,
				"category": basketConfirmation.productLineItems[index-1].category,
				"price": basketConfirmation.productLineItems[index-1].price,
				"name": basketConfirmation.productLineItems[index-1].name,
				"brand": getProductBrand(),
				"quantity": basketConfirmation.productLineItems[index-1].quantity,
				"size": basketConfirmation.productLineItems[index-1].size,
				"subCategory" : basketConfirmation.productLineItems[index-1].subCategory,
				"subSubCategory" :basketConfirmation.productLineItems[index-1].subSubCategory,
				"productAutoReplen": basketConfirmation.productLineItems[index-1].productAutoReplen,
				"productOutOfStock":basketConfirmation.productLineItems[index-1].productAutoReplen.productOutOfStock,
				"productColor":  basketConfirmation.productLineItems[index-1].productColor,
				"productType": basketConfirmation.productLineItems[index-1].productType}]

			})

		})
		// click zoom in pdp
		.on('click', ".product-primary-image .image-zoom", function (e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": getPageCategory(),
				"productId": getProductID(),
				"interactionType" : "Zoom"
			})

		})
		
		// click full ingredients in pdp
		.on('click', ".pdp-content-section .full-ingredients", function(e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": getPageCategory(),
				"productId": getProductID(),
				"interactionType" : "View Full Product Ingredients"
			})
		})
		
		.on("click", ".cart-promo-approaching", function(){
			pushToDataLayer({
				"event": "eePromoClick",
				"pageSubCategory": "Internal marketing",
				"pageCategory": "Cart Page",
				'promotions': [{
				"position": "Cart",
				"id": $(".cart-promo-approaching").data("promoid"),
				"creative": "Cart-Banner",
				"name": $(".cart-promo-approaching").data("promoname")
				}]
			})
		})
		
		.on("click", ".cart-coupon-code #add-coupon", function () {
			localStorage.removeItem('couponvalidation');
		})
		
		// track share button on PDP
		.on("click", ".social-sharing-container .share-icon", function() {
			pushToDataLayer({
				"socialAction": "Share",
				"event": "socialShare",
				"siteLocation": "product page",
				"pageCategory": getPageCategory(),
				"socialNetwork": $(this).data("share")
				})

		})
		
		// Track Follow button on Footer
		.on("click", ".social-links a", function() {
			pushToDataLayer({
				"socialAction": "Follow",
				"event": "socialFollow",
				"siteLocation": "footer",
				"pageCategory": getPageCategory(),
				"socialNetwork": $(this).data("follow")
				})
		})
		
		// Add to Cart in Save for later
		.on("click",".wishlist-item .add-to-cart", function(){
			var index = $(this).parents('form').index();
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "addToCart",
				"productOrderType": getProductOrederType(),
				"addToCartType": getPageCategory(),
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": getPageCategory(),
				'products': [{
				"id": wishlistItem.product[index].id,
				"category": wishlistItem.product[index].category,
				"price": wishlistItem.product[index].price,
				"name": wishlistItem.product[index].name,
				"brand": wishlistItem.product[index].brand,
				"quantity": wishlistItem.product[index].quantity,
				"size": wishlistItem.product[index].size,
				"subCategory" : wishlistItem.product[index].subcategory,
				"subSubCategory" : wishlistItem.product[index].subcategory,
				"productAutoReplen":wishlistItem.product[index].productAutoReplen,
				"productOutOfStock": wishlistItem.product[index].productOutOfStock,
				"productColor": wishlistItem.product[index].color,
				"productType": "Product",
				"productNumReviews":"",
				"productStarRating":""}]
				});
		})
		
		// Add to all to Cart
		.on("click",".add-all-to-cart", function(){
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "addToCart",
				"productOrderType": getProductOrederType(),
				"addToCartType": getPageCategory(),
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": getPageCategory(),
				'products': wishlistItem.product
				});
			
		})
		
		// click email hyper link in navigation
		.on('click','.emailcsr-nav', function(){
			if(window.Resources.PAGE_CATEGORY == "page-show"){
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					//"pageSubCategory": couponsubcategory(),
					"pageCategory": getProductCategory()
					});
				
			}else{
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					"pageSubCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? "" :couponsubcategory(),
					"pageCategory": getPageCategory()
					});
			}
			
		})
		// Click email link in the customer care
		.on("click",".content-asset a:contains('customerservice@shiseidousa.com')",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": window.Resources.PAGE_CATEGORY=="cart-show" ? "Right Nav":"Body",
				//"pageSubCategory": couponsubcategory(),
				"pageCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? getPageCategory(): getProductCategory()
				});
		})
		
		.on("gtmcontactus",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Contact Customer Care Submission",
				"siteLocation": "Body",
				"pageCategory": getPageCategory()
				});
		})
		.on("askanexpert",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Ask An Expert Submission",
				"siteLocation": "Body",
				"pageSubCategory": couponsubcategory(),
				"pageCategory": "Ask An Expert"
			});
		})
		
		.on("click",".LPMcontainer",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Live Chat",
				"siteLocation": getPageCategory()=="Checkout" ? "Header": "Body",
				"pageSubCategory":couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		})
		
		.on("click",".LPMimage",function(){
			var id = $(this).attr("id");
			var chk = id.charAt(id.length - 1)
			if(chk == 1){
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Live Chat",
					"siteLocation": "Pop-up",
					"pageSubCategory":couponsubcategory(),
					"pageCategory": getPageCategory()
				});
			}
		})

		.on("click",".footer-container .products ul li:nth-child(4)",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Phone",
				"siteLocation": "Footer",
				"pageSubCategory":window.Resources.PAGE_CATEGORY=="cart-show" ? "" :couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		})
		
		// click on recommendation
		.on("click",".recommendation-item",function(){
			if(getPageCategory()== "Product Page"){
				sessionStorage.setItem('listType', "we recommend");
				sessionStorage.setItem('listName', getProductCategory());
			}else if(getPageCategory()== "Home Page"){
				sessionStorage.setItem('listType', "recently viewed");
				sessionStorage.setItem('listName', getProductCategory());
			}
				
		})
		
		
		.on("click",".catalog-link",function(e){
			 if(navctr==true){
				 gtmNavData = $(this).text().trim();
				 sessionStorage.setItem("navlink",gtmNavData);
				 sessionStorage.setItem("menuloc","topmenu");
				 util.setCookie('navdata',gtmNavData,.20);
				 navctr = false;
			 }
		})
		
		.on("click",".main-nav .has-sub-menu a",function(e){
			if(navctr==true){
				gtmNavData = $(this).text().trim();
				sessionStorage.setItem("navlink",gtmNavData);
				sessionStorage.setItem("menuloc","topmenu");
				util.setCookie('navdata',gtmNavData,.20);
				navctr = false;
			}
		})
		
		.on("click",".refinement-header",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		.on("click",".refinement-link",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		.on("click",".breadcrumb-element",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("breadcrumbs",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		.on("change","#quantity",function(e){
			if(getPageCategory() == "Cart Page"){
				if($(".edit-modal").length > 0){
					sessionStorage.setItem("cartupdate","1");
				}else{
					sessionStorage.setItem("productUpdate","1");
				}
				
			}
			
		})
		
		.on("change",".quantity-select",function(e){
			if(window.Resources.PAGE_CATEGORY == "wishlist-show"){
				sessionStorage.setItem("productUpdate","1");
			}
		})
		
		.on("click",".account-left-nav li",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		// Remove uservalidation attribute for userlogin validation
		.on('click', ".user-logout", function (e) {
			localStorage.removeItem('uservalidation');
		})
		
		.on("change","#va-color",function(){
			if(getPageCategory() == "Cart Page"){
				sessionStorage.setItem("cartupdate","1");
			}
		})
		
		.on("click",".close-button",function(){
			if(getPageCategory() == "Cart Page"){
				sessionStorage.setItem("cartupdate","");
			}
		})
		
		.on("click","#save-for-later",function(){
			if(getPageCategory() == "Cart Page"){
				sessionStorage.setItem("cartupdate","");
			}
		})
		
		.on("click","#pdp-swatches .selectable",function(){
			if(getPageCategory() == "Cart Page"){
				if(!$(this).hasClass("selected")){
					sessionStorage.setItem("cartupdate","1");
				}
			}
		})
		
		.on("click",".search-suggestion-wrapper .hit",function(){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData.replace(/\s\s+/g, ' '));
			sessionStorage.setItem("menuloc","site search pop-in");
		})
		
		.on("click",".search-suggestion-wrapper .product-suggestion",function(){
			gtmNavData = $(this).text().trim();
			var rep = gtmNavData.replace(/\n/g," "); 
			sessionStorage.setItem("navlink",rep.replace(/ +/g," "));
			sessionStorage.setItem("menuloc","site search pop-in");
		})
		
		.on("click", "#search-result-items .column .product-image .thumb-link", function(){
			var index = xArray.index($(this).parents(".column"));
			if(index > 0){
				pushToDataLayer({
					"event": "eeListClick",
					"pageSubCategory": "",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"filterChoice" : getActiveSortingRule(),
					"dropDown" : getRefinementsFromURL(),
					'products': [{
					"listType" :window.productData.product[index].listType,
					"listName": window.productData.product[index].listName,
					"position": window.productData.product[index].position,
					"id": window.productData.product[index].id,
					"category": getProductCategory(),
					"price": window.productData.product[index].price,
					"name": window.productData.product[index].name,
					"brand": getProductBrand(),
					"quantity": window.productData.product[index].quantity,
					"size": window.productData.product[index].size,
					"subCategory" : window.productData.product[index].subCategory,
					"subSubCategory" : window.productData.product[index].subSubCategory,
					"productAutoReplen": window.productData.product[index].productAutoReplen,
					"productOutOfStock": window.productData.product[index].productOutOfStock,
					"productColor": window.productData.product[index].productColor,
					"productType": window.productData.product[index].productType,
					"productNumReviews": "",
					"productStarRating": ""}]
				})
			}
		})
		
		.on("click", "#search-result-items .column .name-link", function(){
			var index = xArray.index($(this).parents(".column"));
			if(index > 0){
				pushToDataLayer({
					"event": "eeListClick",
					"pageSubCategory": "",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"filterChoice" : getActiveSortingRule(),
					"dropDown" : getRefinementsFromURL(),
					'products': [{
					"listType" :window.productData.product[index].listType,
					"listName": window.productData.product[index].listName,
					"position": window.productData.product[index].position,
					"id": window.productData.product[index].id,
					"category": getProductCategory(),
					"price": window.productData.product[index].price,
					"name": window.productData.product[index].name,
					"brand": getProductBrand(),
					"quantity": window.productData.product[index].quantity,
					"size": window.productData.product[index].size,
					"subCategory" : window.productData.product[index].subCategory,
					"subSubCategory" : window.productData.product[index].subSubCategory,
					"productAutoReplen": window.productData.product[index].productAutoReplen,
					"productOutOfStock": window.productData.product[index].productOutOfStock,
					"productColor": window.productData.product[index].productColor,
					"productType": window.productData.product[index].productType,
					"productNumReviews": "",
					"productStarRating": ""}]
				})
			}
		})
		
}

module.exports = {
	init: function () {
		initializeGlobalEvents();
	},
	tagmanager: {
		click: function (data) {
			return trackConsultationEvent(data);
		},

		pageview: function (data) {
			return trackConsultationPageview(data);
		}
	},
	gtmInternalPromotion: {
		click: function (data) {
			return trackInternalPromotionEvent(data);
		},

		pageview: function (data) {
			return trackInternalPromotionPageView(data);
		}
	}
}
},{"./util":63}],3:[function(require,module,exports){
/**
 *	(c) 2009-2014 Demandware Inc.
 *	Subject to standard usage terms and conditions
 *	For all details and documentation:
 *	https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

var analytics = require('./analytics'),
  dialog = require('./dialog'),
  quickview = require('./quickview'),
  minicart = require('./minicart'),
  page = require('./page'),
  searchplaceholder = require('./searchplaceholder'),
  searchsuggest = require('./searchsuggest'),
  tooltip = require('./tooltip'),
  util = require('./util'),
  validator = require('./validator'),
  slick = require('./slick'),
  tls = require('./tls'),
  video = require('./video'),
  headerMenu = require('./header-menu'),
  headerNav = require('./header-nav'),
  orderreplenishment = require('./order-replenishment'),
  inputEntry = require('./input-entry'),
  staticCartin = require('./static-cartin'),
  recaptcha = require('./recaptcha');

// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
  var s = document.createElement('script');
  s.setAttribute(
    'src',
    'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js'
  );
  s.setAttribute('type', 'text/javascript');
  document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
require('./captcha')();

function initializeEvents() {
  var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

  $('body')
    .on('keydown', 'textarea[data-character-limit]', function (e) {
      var text = $(this).val().trim(),
        charsLimit = $(this).data('character-limit'),
        charsUsed = text.length;

      if (
        charsUsed >= charsLimit &&
        controlKeys.indexOf(e.which.toString()) < 0
      ) {
        e.preventDefault();
      }
    })
    .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
      var text = $(this).val().trim(),
        charsLimit = $(this).data('character-limit'),
        charsUsed = text.length,
        charsRemain = charsLimit - charsUsed;

      if (charsRemain < 0) {
        $(this).val(text.slice(0, charsRemain));
        charsRemain = 0;
      }

      $(this)
        .next('div.char-count')
        .find('.char-remain-count')
        .html(charsRemain);
    });

  /**
   * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
   * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
   * */
  //【サイトリニューアル 1.0】 Start デザイン変更に伴う修正
//  var $searchContainer = $('#hd-search');
  var $searchContainer = $('#h__search');
  //【サイトリニューアル 1.0】 End デザイン変更に伴う修正
  searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

  // add show/hide navigation elements
  $('.secondary-navigation .toggle').on('click', function () {
    $(this).toggleClass('expanded').next('ul').toggle();
  });

  // add generic toggle functionality
  $('.toggle').next('.toggle-content').hide();
  $('.toggle').on('click', function () {
    $(this).toggleClass('expanded').next('.toggle-content').toggle();
  });

  // add custom toggle functionality
  $('.c-title__has-toggle:not(.u__toggle-opened)').next('.toggle-content').hide();
  $('.c-title__has-toggle').on('click', function () {
    $(this).toggleClass('u__toggle-opened').next('.toggle-content').slideToggle(250);
  });

  // subscribe email box
  var $subscribeEmail = $('.subscribe-email');
  if ($subscribeEmail.length > 0) {
    $subscribeEmail
      .on('focus', function () {
        var val = $(this.val());
        if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
          return; // do not animate when contains non-default value
        }

        $(this).animate({ color: '#999999' }, 500, 'linear', function () {
          $(this).val('').css('color', '#333333');
        });
      })
      .on('blur', function () {
        var val = $(this).val().trim();
        if (val.length > 0) {
          return; // do not animate when contains value
        }
        $(this)
          .val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
          .css('color', '#999999')
          .animate({ color: '#333333' }, 500, 'linear');
      });
  }

  $('.privacy-policy').on('click', function (e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href'),
      options: {
        height: 600
      }
    });
  });

  // main menu toggle
  $('.menu-toggle').on('click', function () {
    $('#wrapper').toggleClass('menu-active');
  });
  /*$('.menu-category li .menu-item-toggle').on('click', function (e) {
		e.preventDefault();
		var $parentLi = $(e.target).closest('li');
		$parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa-chevron-up active').addClass('fa-chevron-right');
		$parentLi.toggleClass('active');
		$(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
	});*/
  $('.user-account').on('click', function (e) {
    e.preventDefault();
    $(this).parent('.user-info').toggleClass('active');
  });

  $('#sign-in-dropdown-link').on('click', function (e) {
    e.preventDefault();
    $(this).parent().find('#sign-in-dropdown').toggleClass('is-open');
  });

  // GA 360 Social Event
  $('a.instagram').on('click', function () {
    window.dataLayer.push({
      event: 'clickSocial',
      socialNetwork: 'Instagram',
      userStatus:
        $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged'
    });
  });

  $('a.twitter').on('click', function () {
    window.dataLayer.push({
      event: 'clickSocial',
      socialNetwork: 'Twitter',
      userStatus:
        $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged'
    });
  });

  $('a.line').on('click', function () {
    window.dataLayer.push({
      event: 'clickSocial',
      socialNetwork: 'Line',
      userStatus:
        $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged'
    });
  });

  $('#hd-menu-list .menu-category.level-1 .has-sub-menu').on(
    'mouseover',
    function () {
      $('select').trigger('blur');
    }
  );
}
/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
  // add class to html for css targeting
  $('html').addClass('js');
  if (SitePreferences.LISTING_INFINITE_SCROLL) {
    $('html').addClass('infinite-scroll');
  }
  // load js specific styles
  util.limitCharacters();
}

//ヘッダー固定
/*
function minimizedHeaderHandler() {
  var $w = $(window),
    $body = $('body'),
    $stickyHeader = $('#header'),
    $headerBanner = $('.header-banner'),
    $wrapper = $('#wrapper');

  var checkScrolledDown = function () {
    var headerScrollOffset = $headerBanner.outerHeight();

    if ($body.hasClass('is-reveal-open')) {
      return false;
    }

    if (!headerScrollOffset) {
      headerScrollOffset = 0;
    }

    if ($w.scrollTop() > headerScrollOffset) {
      $wrapper.css('padding-top', $stickyHeader.outerHeight());
      $stickyHeader.addClass('sticky-header');
    } else {
      $stickyHeader.removeClass('sticky-header');
      $wrapper.css('padding-top', 0);
    }
  };

  checkScrolledDown();

  $w.on('scroll', function () {
    checkScrolledDown();
  });
}
*/

// フッタを最下部で固定
/*
function stickyFooterHandler() {
  $(window).on('load resize', function () {
    var $breadcrumb = $('.breadcrumb').not('.checkout-progress-indicator');
    var totalPadding = $('#footer').outerHeight(true);

    if (
      $('.checkout-progress-indicator').length === 0 &&
      $breadcrumb.length > 0
    ) {
      totalPadding = $('#footer').outerHeight() + $breadcrumb.outerHeight(true);
    }

    $('#main,div[role="main"]').css('padding-bottom', totalPadding + 'px');
    $breadcrumb.css('bottom', $('#footer').outerHeight() + 'px');
  });
}
*/

//ページの先頭へ戻る
/*
function backToTopHandler() {
  var $w = $(window),
    $pagetop = $('#to-pagetop').find('a'),
    $footer = $('#footer'),
    $breadcrumb = $('.breadcrumb:last-child');

  var scrollToTop = function (e) {
    e.preventDefault();

    $('html, body').animate(
      {
        scrollTop: $('body').offset().top
      },
      500
    );
  };

  var $cartFixed = $('.product-add-to-cart-fixed'),
    cartFixedExists = false;
  if ($cartFixed.length > 0) {
    cartFixedExists = true;
  }

  $(document).on('load.backToTop scroll.backToTop', function () {
    var scrollPos = $w.scrollTop(),
      windowH = window.innerHeight,
      footerPos = $footer.offset().top;

    if (
      Foundation.MediaQuery.is('medium') &&
      windowH > document.documentElement.clientHeight
    ) {
      windowH = document.documentElement.clientHeight;
    }

    if (scrollPos > 100) {
      $pagetop.addClass('show');
    } else {
      $pagetop.removeClass('show');
    }

    if (scrollPos + windowH > footerPos) {
      $pagetop.css(
        'bottom',
        scrollPos +
          windowH -
          footerPos +
          ($breadcrumb.length > 0 ? $breadcrumb.height() / 2 - 3 : 0)
      );
    } else {
      if (Foundation.MediaQuery.is('small only')) {
        if (cartFixedExists && $cartFixed.is(':visible')) {
          $pagetop.css('bottom', 92);
        } else {
          $pagetop.css('bottom', 32);
        }
      } else {
        if (cartFixedExists && $cartFixed.is(':visible')) {
          $pagetop.css('bottom', 120);
        } else {
          $pagetop.css('bottom', 20);
        }
      }
    }
  });

  $pagetop.on('click.backToTop', scrollToTop);
}
*/

// グローバルメニュー設定
function responsiveMegaMenu() {

/***
  var $hdNav = $('#hd-nav'),
    $hdNavMenu = $hdNav.find('> .nav'),
    $hdNavMenuL1 = $hdNavMenu.find('.level-1'),
    $hdClose = $('#hd-close');

  // メニュー全体表示
  $hdNav.find('h2.menu').on('click', function () {
    $hdNavMenu.addClass('show');
  });

  $hdClose.on('click', function () {
    $hdNavMenu.removeClass('show').find('.level-2').removeClass('active');
    $hdNavMenuL1.css('height', 'auto');
  });

  // 下層メニュー表示
  $hdNavMenu
    .find('.menu-item-toggle')
    .on('click', function () {
      var $target = $(this).next();

      $target.addClass('active');
      $hdNavMenuL1.css('height', $target.outerHeight());
    })
    .end()
    .find('.mobile-menu-back')
    .on('click', function () {
      var $target = $(this).parents('.active');

      $target.eq(0).removeClass('active');

      if ($target.length > 1) {
        $hdNavMenuL1.css('height', $target.eq(1).outerHeight());
      } else {
        $hdNavMenuL1.css('height', 'auto');
      }
    });

  // 検索表示
  var $hdSearch = $('#h__search');

  $hdSearch.find('.icon').on('click', function () {
    $hdSearch.toggleClass('show');
  });

  // リンクなし
  $('a.no-link, span.category-header').on('click', function (e) {
    e.preventDefault();
    $(this).next('.menu-item-toggle').trigger('click');
  });
***/
}

// フッターメニュー設定
function setFooterMenu() {
	// スマホメニューリスト開閉
	$('.footer-menu-title--sp-toggle').on('click', function() {
		$(this).toggleClass('u__toggle-opened').find('+ .u__toggle-target').slideToggle(300);
	});
}

// 2024/08/09 RENEWAL2023-636 Start
function clickFooterSocialMediaIcons() {
    $('.footer-sns li a').on('click', function() {
        var socialNetwork = '';
        const className = $(this).attr('class');
        if (className === 'footer-sns-instagram') {
        	socialNetwork = 'Instagram';
        } else if (className === 'footer-sns-twitter') {
        	socialNetwork = 'Twitter';
        } else if (className === 'footer-sns-line') {
        	socialNetwork = 'LINE';
        }

        window.dataLayer.push({
           "event": "clickSocial",
           "socialNetwork": socialNetwork,
           "userStatus": window.UserStatus.userStatus
        })
    });
}
//2024/08/09 RENEWAL2023-636 End

function searchMenuEvent() {
  // Search for mobile view
  $('.quick-access-menu [title="Search"]').on('click', function (e) {
    e.preventDefault();

    $('.header-search').slideToggle();
  });

  // show the search button when the user switches to desktop view
  $(window).on('resize', function (e) {
    if (window.innerWidth > window.innerHeight || window.innerWidth >= 768) {
      $('.header-search').show();
    } else {
      $('.header-search').hide();
    }
  });
}

function playVideoHandler() {
  var MAIN_VIDEO_SELECTOR = '.main-video';
  var CAROUSEL_VIDEO_SELECTOR = '.modal-video';
  $(document)
    // main video (inline)
    .on('click', MAIN_VIDEO_SELECTOR, function () {
      var $this = $(this);

      var $inlineEle = $this.parent('div'),
        videoId = $this.data('video-id');

      video.playInline($inlineEle, videoId);
    })

    // carousel videos (launched in modal)
    .on('click', CAROUSEL_VIDEO_SELECTOR, function () {
      var videoId = $(this).data('video-id');

      video.playInModal(videoId);
    });
}

function setAnchorScroll() {
  var $header = $('#header');

  $('a.ss[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var $this = $(this),
      offsetTop = $this.hasClass('nh') ? 0 : $header.outerHeight();

    $('html, body').animate(
      {
        scrollTop: $($this.attr('href')).offset().top - offsetTop
      },
      500
    );
  });
}

var pages = {
  account: require('./pages/account'),
  point: require('./pages/point'),
  cart: require('./pages/cart'),
  checkout: require('./pages/checkout'),
  compare: require('./pages/compare'),
  product: require('./pages/product'),
  registry: require('./pages/registry'),
  search: require('./pages/search'),
  storefront: require('./pages/storefront'),
  wishlist: require('./pages/wishlist'),
  storelocator: require('./pages/storelocator'),
  receipt: require('./pages/receipt'),
  contentproduct: require('./pages/contentproduct')
};

if (
  typeof window.pageContext != 'undefined' &&
  window.pageContext != null &&
  window.pageContext.hasOwnProperty('ns')
) {
  if (window.pageContext.ns === 'contentproduct') {
    pages['contentproduct'].init_window();
  }
}

var app = {
  init: function () {
    $(document).foundation();

    if (document.cookie.length === 0) {
      $('<div/>')
        .addClass('browser-compatibility-alert')
        .append(
          $('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)
        )
        .appendTo('#browser-check');
    }

    initializeDom();
    initializeEvents();
//    backToTopHandler();
//    minimizedHeaderHandler();
//    stickyFooterHandler();
//    responsiveMegaMenu();
    setFooterMenu();
    // 2024/08/09 RENEWAL2023-636 Start
    clickFooterSocialMediaIcons();
    // 2024/08/09 RENEWAL2023-636 End
    searchMenuEvent();
    setAnchorScroll();

    // init specific global components
    headerNav.init();
    tooltip.init();
    minicart.init();
    validator.init();
    orderreplenishment.init();
    slick.init();
    searchplaceholder.init();
    video.init();
    inputEntry.entry();
    playVideoHandler();

    // Static Cart In Button
    staticCartin.init();

    // execute page specific initializations
    $.extend(page, window.pageContext);

    var ns = page.ns;

    if (ns && pages[ns] && pages[ns].init) {
      pages[ns].init();
    }

    // Check TLS status if indicated by site preference
    if (SitePreferences.CHECK_TLS === true) {
      tls.getUserAgent();
    }
  }
};

// general extension functions
(function () {
  String.format = function () {
    var s = arguments[0];
    var i,
      len = arguments.length - 1;

    for (i = 0; i < len; i++) {
      var reg = new RegExp('\\{' + i + '\\}', 'gm');
      s = s.replace(reg, arguments[i + 1]);
    }

    return s;
  };
})();

// initialize app
$(document).ready(function () {
  app.init();
});

},{"./analytics":2,"./captcha":5,"./cookieprivacy":7,"./dialog":9,"./header-menu":12,"./header-nav":13,"./input-entry":14,"./jquery-ext":15,"./minicart":17,"./order-replenishment":19,"./page":20,"./pages/account":21,"./pages/cart":22,"./pages/checkout":26,"./pages/compare":32,"./pages/contentproduct":33,"./pages/point":34,"./pages/product":38,"./pages/receipt":44,"./pages/registry":45,"./pages/search":46,"./pages/storefront":47,"./pages/storelocator":48,"./pages/wishlist":49,"./quickview":52,"./recaptcha":53,"./searchplaceholder":54,"./searchsuggest":55,"./slick":56,"./static-cartin":57,"./tls":61,"./tooltip":62,"./util":63,"./validator":64,"./video":65}],4:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
  page = require('./page'),
  util = require('./util');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';
var selectedBonusBtn = null;

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
  var bonusproducts = [];

  var i, len;
  for (i = 0, len = selectedList.length; i < len; i++) {
    var p = {
      pid: selectedList[i].pid,
      qty: selectedList[i].qty,
      options: {},
    };
    var a,
      alen,
      bp = selectedList[i];
    if (bp.options) {
      for (a = 0, alen = bp.options.length; a < alen; a++) {
        var opt = bp.options[a];
        p.options = { optionName: opt.name, optionValue: opt.value };
      }
    }
    bonusproducts.push({ product: p });
  }
  return { bonusproducts: bonusproducts };
}

var selectedItemTemplate = function (data) {
  var attributes = '';
  for (var attrID in data.attributes) {
    var attr = data.attributes[attrID];
    attributes += '<li data-attribute-id="' + attrID + '">\n';
    attributes +=
      '<span class="display-name">' + attr.displayName + '</span>: ';
    attributes +=
      '<span class="display-value">' + attr.displayValue + '</span>\n';
    attributes += '</li>';
  }
  attributes += '<li class="item-qty">\n';
  attributes += '<span class="display-name">Qty</span>: ';
  attributes += '<span class="display-value">' + data.qty + '</span>';
  return [
    '<li class="selected-bonus-item" data-uuid="' +
      data.uuid +
      '" data-pid="' +
      data.pid +
      '">',
    '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
    '<div class="item-name">' + data.name + '</div>',
    '<ul class="item-attributes">',
    attributes,
    '<ul>',
    '<li>',
  ].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
  $('.bonus-product-item:not([data-producttype="master"]) .swatches li')
    .not('.selected')
    .not('.variation-group-value')
    .hide();
  // prevent unselecting the selected variant
  $('.bonus-product-item .swatches .selected').on('click', function () {
    return false;
  });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
  var $bonusProductList = $('#bonus-product-list');
  if (!selectedList.length) {
    $bonusProductList.find('li.selected-bonus-item').remove();
  } else {
    var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
    var i, len;

    // Remove all <li class="selected-bonus-item"> before appending to ul element
    var li = $('.selected-bonus-items > li.selected-bonus-item');
    if (typeof li !== 'undefined' && li.length > 0) {
      $(li).each(function () {
        $(this).remove();
      });
    }
    for (i = 0, len = selectedList.length; i < len; i++) {
      var item = selectedList[i];
      var li = selectedItemTemplate(item);
      $(li).appendTo(ulList);
    }
  }

  // get remaining item count
  var remain = maxItems - selectedList.length;
  $bonusProductList.find('.bonus-items-available').text(remain);
  if (remain <= 0) {
    $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
  } else {
    selectedBonusBtn.prop('disabled', false);
  }
}

function initializeGrid() {
  // When initializing bonus grid, clear the selectedList
  selectedList = [];
  var $bonusProduct = $('#bonus-product-dialog'),
    $bonusProductList = $('#bonus-product-list'),
    bliData = $bonusProductList.data('line-item-detail');
  maxItems = bliData.maxItems;
  bliUUID = bliData.uuid;

  if (bliData.itemCount >= maxItems) {
    $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
  }

  var cartItems = $bonusProductList.find('.selected-bonus-item');
  cartItems.each(function () {
    var ci = $(this);
    var product = {
      uuid: ci.data('uuid'),
      pid: ci.data('pid'),
      // correct get quantity of product
      qty: ci.find('.item-qty .display-value').text(),
      name: ci.find('.item-name').html(),
      attributes: {},
    };
    var attributes = ci.find('ul.item-attributes li');
    attributes.each(function () {
      var li = $(this);
      product.attributes[li.data('attributeId')] = {
        displayName: li.children('.display-name').html(),
        displayValue: li.children('.display-value').html(),
      };
    });
    selectedList.push(product);
  });

  $bonusProductList
    .on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
      e.preventDefault();
      var url = this.href,
        $this = $(this);
      url = util.appendParamsToUrl(url, {
        source: 'bonus',
        format: 'ajax',
      });
      $.ajax({
        url: url,
        success: function (response) {
          $this.closest('.bonus-product-item').empty().html(response);
          hideSwatches();
        },
      });
    })
    .on('change', '.input-text', function () {
      $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
      e.preventDefault();
      selectedBonusBtn = $(this);
      if (selectedList.length >= maxItems) {
        $bonusProductList
          .find('.select-bonus-item')
          .attr('disabled', 'disabled');
        $bonusProductList.find('.bonus-items-available').text('0');
        return;
      }

      var form = $(this).closest('.bonus-product-form'),
        detail = $(this).closest('.product-detail'),
        uuid = form.find('input[name="productUUID"]').val(),
        qtyVal = form.find('input[name="Quantity"]').val(),
        qty = isNaN(qtyVal) ? 1 : +qtyVal;
      // get quantity of current product in selectedList
      var currentPid = form.find('input[name="pid"]').val();
      var addedQty = 0;
      for (var i = 0; i < selectedList.length; i++) {
        addedQty += parseInt(selectedList[i].qty);
      }
      addedQty = addedQty + qty;

      if (qty > maxItems || addedQty > maxItems) {
        $bonusProductList
          .find('.select-bonus-item')
          .attr('disabled', 'disabled');
        form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
        return;
      }

      var product = {
        uuid: uuid,
        pid: form.find('input[name="pid"]').val(),
        qty: qty,
        name: detail.find('.product-name').text(),
        attributes: detail.find('.product-variations').data('attributes'),
        options: [],
      };

      var optionSelects = form.find('.product-option');

      optionSelects.each(function () {
        product.options.push({
          name: this.name,
          value: $(this).val(),
          display: $(this).children(':selected').first().html(),
        });
      });
      //update qty
      var pid = product.pid;
      for (var i = 0; i < selectedList.length; i++) {
        if (selectedList[i].pid === pid) {
          selectedList.splice(i, 1);
        }
      }
      selectedList.push(product);
      updateSummary();
    })
    .on('click', '.remove-link', function (e) {
      e.preventDefault();
      var container = $(this).closest('.selected-bonus-item');
      if (!container.data('uuid')) {
        return;
      }

      var uuid = container.data('uuid');
      var i,
        len = selectedList.length;
      for (i = 0; i < len; i++) {
        if (selectedList[i].uuid === uuid) {
          selectedList.splice(i, 1);
          break;
        }
      }
      updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
      e.preventDefault();
      var url = util.appendParamsToUrl(Urls.addBonusProduct, {
        bonusDiscountLineItemUUID: bliUUID,
      });
      var bonusProducts = getBonusProducts();
      if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
        bonusProducts.bonusproducts[0].product.qty = maxItems;
      }
      // make the server call
      $.ajax({
        type: 'POST',
        dataType: 'json',
        cache: false,
        contentType: 'application/json',
        url: url,
        data: JSON.stringify(bonusProducts),
      })
        .done(function () {
          // success
          page.refresh();
        })
        .fail(function (xhr, textStatus) {
          // failed
          if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
          } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
          }
        })
        .always(function () {
          $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
      e.preventDefault();
      var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

      //get the next page of choice of bonus products
      var lineItemDetail = JSON.parse(
        $('#bonus-product-list').attr('data-line-item-detail')
      );
      lineItemDetail.pageStart =
        lineItemDetail.pageStart + lineItemDetail.pageSize;
      $('#bonus-product-list').attr(
        'data-line-item-detail',
        JSON.stringify(lineItemDetail)
      );

      var url = util.appendParamsToUrl(Urls.getBonusProducts, {
        bonusDiscountLineItemUUID: uuid,
        format: 'ajax',
        lazyLoad: 'true',
        pageStart: lineItemDetail.pageStart,
        pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
        bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail
          .bpTotal,
      });

      $.ajax({
        type: 'GET',
        cache: false,
        contentType: 'application/json',
        url: url,
      })
        .done(function (data) {
          //add the new page to DOM and remove 'More' link if it is the last page of results
          $('#more-bonus-products').before(data);
          if (
            lineItemDetail.pageStart + lineItemDetail.pageSize >=
            $('#bonus-product-list').data().lineItemDetail.bpTotal
          ) {
            $('#more-bonus-products').remove();
          }
        })
        .fail(function (xhr, textStatus) {
          if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
          } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
          }
        });
    });
}

var bonusProductsView = {
  /**
   * @function
   * @description Open the list of bonus products selection dialog
   */
  show: function (url) {
    var $bonusProduct = $('#bonus-product-dialog');
    // create the dialog
    dialog.open({
      target: $bonusProduct,
      url: url,
      options: {
        width: 795,
        title: Resources.BONUS_PRODUCTS,
      },
      callback: function () {
        initializeGrid();
        hideSwatches();
      },
    });
  },
  /**
   * @function
   * @description Open bonus product promo prompt dialog
   */
  loadBonusOption: function () {
    var self = this,
      bonusDiscountContainer = document.querySelector(
        '.bonus-discount-container'
      );
    if (!bonusDiscountContainer) {
      return;
    }

    // get the html from minicart, then trash it
    var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
    bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

    dialog.open({
      html: bonusDiscountContainerHtml,
      options: {
        width: 400,
        title: Resources.BONUS_PRODUCT,
        buttons: [
          {
            text: Resources.SELECT_BONUS_PRODUCTS,
            click: function () {
              var uuid = $('.bonus-product-promo').data('lineitemid'),
                url = util.appendParamsToUrl(Urls.getBonusProducts, {
                  bonusDiscountLineItemUUID: uuid,
                  source: 'bonus',
                  format: 'ajax',
                  lazyLoad: 'false',
                  pageStart: 0,
                  pageSize: 10,
                  bonusProductsTotal: -1,
                });
              $(this).dialog('close');
              self.show(url);
            },
          },
          {
            text: Resources.NO_THANKS,
            click: function () {
              $(this).dialog('close');
            },
          },
        ],
      },
      callback: function () {
        // show hide promo details
        $('.show-promo-details').on('click', function () {
          $('.promo-details').toggleClass('visible');
        });
      },
    });
  },
};

module.exports = bonusProductsView;

},{"./dialog":9,"./page":20,"./util":63}],5:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');
var util = require('./util');
var SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
module.exports = function () {
    /**
     * if the session.privacy.ratelimited element is present then show the notification
     * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
     */
    if (SessionAttributes.SHOW_CAPTCHA) {
        dialog.open({
            html: '<p>' + Resources.ARE_YOU_HUMAN + '</p>',
            options: {
                closeOnEscape: false,
                dialogClass: 'no-close',
                buttons: [{
                    text: Resources.OK,
                    click: function () {
                        var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
                        $.ajax({
                            url: url
                        });
                        $(this).dialog('close');
                    }
                }]
            }
        });
    }
};

},{"./dialog":9,"./util":63}],6:[function(require,module,exports){
'use strict';

var page = require('./page'),
  util = require('./util'),
  TPromise = require('promise');

var _currentCategory = '',
  MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
  var $compareContainer = $('.compare-items');
  var $compareItems = $compareContainer.find('.compare-item');
  var numActive = $compareItems.filter('.active').length;

  if (numActive < 2) {
    $('#compare-items-button').attr('disabled', 'disabled');
  } else {
    $('#compare-items-button').prop('disabled', false);
  }

  $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
  // get the first compare-item not currently active
  var $item = $('.compare-items .compare-item').not('.active').first(),
    $productTile = $('#' + data.uuid);

  if ($item.length === 0) {
    if ($productTile.length > 0) {
      $productTile.find('.compare-check')[0].checked = false;
    }
    window.alert(Resources.COMPARE_ADD_FAIL);
    return;
  }

  // if already added somehow, return
  if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
    return;
  }
  // set as active item
  $item
    .addClass('active')
    .attr('data-uuid', data.uuid)
    .attr('data-itemid', data.itemid)
    .data('uuid', data.uuid)
    .data('itemid', data.itemid)
    .append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
  if ($item.length === 0) {
    return;
  }
  // remove class, data and id from item
  $item
    .removeClass('active')
    .removeAttr('data-uuid')
    .removeAttr('data-itemid')
    .data('uuid', '')
    .data('itemid', '')
    // remove the image
    .find('.compare-item-image')
    .remove();
}

function addProductAjax(args) {
  var promise = new TPromise(function (resolve, reject) {
    $.ajax({
      url: Urls.compareAdd,
      data: {
        pid: args.itemid,
        category: _currentCategory,
      },
      dataType: 'json',
    })
      .done(function (response) {
        if (!response || !response.success) {
          reject(new Error(Resources.COMPARE_ADD_FAIL));
        } else {
          resolve(response);
        }
      })
      .fail(function (jqxhr, status, err) {
        reject(new Error(err));
      });
  });
  return promise;
}

function removeProductAjax(args) {
  var promise = new TPromise(function (resolve, reject) {
    $.ajax({
      url: Urls.compareRemove,
      data: {
        pid: args.itemid,
        category: _currentCategory,
      },
      dataType: 'json',
    })
      .done(function (response) {
        if (!response || !response.success) {
          reject(new Error(Resources.COMPARE_REMOVE_FAIL));
        } else {
          resolve(response);
        }
      })
      .fail(function (jqxhr, status, err) {
        reject(new Error(err));
      });
  });
  return promise;
}

function shiftImages() {
  return new TPromise(function (resolve) {
    var $items = $('.compare-items .compare-item');
    $items.each(function (i, item) {
      var $item = $(item);
      // last item
      if (i === $items.length - 1) {
        return removeFromList($item);
      }
      var $next = $items.eq(i + 1);
      if ($next.hasClass('active')) {
        // remove its own image
        $next.find('.compare-item-image').detach().appendTo($item);
        $item
          .addClass('active')
          .attr('data-uuid', $next.data('uuid'))
          .attr('data-itemid', $next.data('itemid'))
          .data('uuid', $next.data('uuid'))
          .data('itemid', $next.data('itemid'));
      }
    });
    resolve();
  });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
  var promise;
  var $items = $('.compare-items .compare-item');
  var $cb = $(args.cb);
  var numActive = $items.filter('.active').length;
  if (numActive === MAX_ACTIVE) {
    if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
      $cb[0].checked = false;
      return;
    }

    // remove product using id
    var $firstItem = $items.first();
    promise = removeItem($firstItem).then(function () {
      return shiftImages();
    });
  } else {
    promise = TPromise.resolve(0);
  }
  return promise
    .then(function () {
      return addProductAjax(args).then(function () {
        addToList(args);
        if ($cb && $cb.length > 0) {
          $cb[0].checked = true;
        }
        refreshContainer();
      });
    })
    .then(null, function () {
      if ($cb && $cb.length > 0) {
        $cb[0].checked = false;
      }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
  var $cb = args.cb ? $(args.cb) : null;
  return removeProductAjax(args).then(
    function () {
      var $item = $('[data-uuid="' + args.uuid + '"]');
      removeFromList($item);
      if ($cb && $cb.length > 0) {
        $cb[0].checked = false;
      }
      refreshContainer();
    },
    function () {
      if ($cb && $cb.length > 0) {
        $cb[0].checked = true;
      }
    }
  );
}

function removeItem($item) {
  var uuid = $item.data('uuid'),
    $productTile = $('#' + uuid);
  return removeProduct({
    itemid: $item.data('itemid'),
    uuid: uuid,
    cb: $productTile.length === 0 ? null : $productTile.find('.compare-check'),
  });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
  var $compareContainer = $('.compare-items');
  _currentCategory = $compareContainer.data('category') || '';
  var $active = $compareContainer.find('.compare-item').filter('.active');
  $active.each(function () {
    var $productTile = $('#' + $(this).data('uuid'));
    if ($productTile.length === 0) {
      return;
    }
    $productTile.find('.compare-check')[0].checked = true;
  });
  // set container state
  refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
  // add event to buttons to remove products
  $('.compare-item').on('click', '.compare-item-remove', function () {
    removeItem($(this).closest('.compare-item'));
  });

  // Button to go to compare page
  $('#compare-items-button').on('click', function () {
    page.redirect(
      util.appendParamToURL(Urls.compareShow, 'category', _currentCategory)
    );
  });

  // Button to clear all compared items
  // rely on refreshContainer to take care of hiding the container
  $('#clear-compared-items').on('click', function () {
    $('.compare-items .active').each(function () {
      removeItem($(this));
    });
  });
}

exports.init = function () {
  initializeDom();
  initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":20,"./util":63,"promise":72}],7:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function () {
                            $(this).dialog('close');
                            enableCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/';
        }
    }
};

},{"./dialog":9}],8:[function(require,module,exports){
'use strict';

const MAX_LENGTH = {
  NAME: 14,
  CITY: 28,
  ADDRESS: 32
};

const MIN_LENGTH = {
  CITY: 1,
  ADDRESS: 1
};

exports.charcode_validation = function (value, el) {
  var str = value;
  var strLength = str.length;
  var formId = el.name.split('_').slice(-1)[0];
  delete el.dataset.custom_validation_error_msg;

  switch (formId) {
    case 'firstname': // 同内容でフィールド命名の異なる、複数のフォームからの呼び出しに対応
    case 'firstName':
      if (strLength > MAX_LENGTH.NAME) {
        el.dataset.custom_validation_error_msg = Resources.VALIDATE_FIRSTNAME_RANGE;
        return false;
      }
      break;
    case 'lastname':
    case 'lastName':
      if (strLength > MAX_LENGTH.NAME) {
          el.dataset.custom_validation_error_msg = Resources.VALIDATE_LASTNAME_RANGE;
          return false;
      }
      break;
    case 'city':
      if (strLength > MAX_LENGTH.CITY || strLength < MIN_LENGTH.CITY) {
          el.dataset.custom_validation_error_msg = MIN_LENGTH.CITY + ' ～ ' + MAX_LENGTH.CITY + Resources.VALIDATE_ADDRESS_RANGE;
          return false;
      }
      break;
    case 'address1':
      if (strLength > MAX_LENGTH.ADDRESS || strLength < MIN_LENGTH.ADDRESS) {
        el.dataset.custom_validation_error_msg = MIN_LENGTH.ADDRESS + ' ～ ' + MAX_LENGTH.ADDRESS + Resources.VALIDATE_ADDRESS_RANGE;
        return false;
      }
      break;
    case 'address2':
      if (strLength === 0) {
    	  break;
      }
      if (strLength > MAX_LENGTH.ADDRESS || strLength < MIN_LENGTH.ADDRESS) {
    	  el.dataset.custom_validation_error_msg = MIN_LENGTH.ADDRESS + ' ～ ' + MAX_LENGTH.ADDRESS + Resources.VALIDATE_ADDRESS_RANGE;
          return false;
      }
      break;
    default:
      break;
  }
  for (var i = 0; i < strLength; i++) {
    var char = str.charAt(i);
    var code = str.charCodeAt(i).toString(16);

    // 許容されるコードに含まれていなかったらNG
    if (acceptableCodes.indexOf(code) < 0) {
    	el.dataset.custom_validation_error_msg = Resources.VALIDATE_CHARCODE;
        return false;
    }

    // 使えない文字が含まれていたらNG
    if (ngChars.indexOf(char) >= 0) {
      el.dataset.custom_validation_error_msg = Resources.VALIDATE_CHARCODE;
      return false;
    }
  }
  return true;
};

//　対向システムでは使えない文字
var ngChars = ['<', '>', '\\', "'", '"', ';', ',', '?', '\t'];

// MS932で許容される文字のコード群
var acceptableCodes = [
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '2a',
  '2b',
  '2c',
  '2d',
  '2e',
  '2f',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '3a',
  '3b',
  '3c',
  '3d',
  '3e',
  '3f',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '4a',
  '4b',
  '4c',
  '4d',
  '4e',
  '4f',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
  '5a',
  '5b',
  '5c',
  '5d',
  '5e',
  '5f',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '6a',
  '6b',
  '6c',
  '6d',
  '6e',
  '6f',
  '70',
  '71',
  '72',
  '73',
  '74',
  '75',
  '76',
  '77',
  '78',
  '79',
  '7a',
  '7b',
  '7c',
  '7d',
  '7e',
  'ff61',
  'ff62',
  'ff63',
  'ff64',
  'ff65',
  'ff66',
  'ff67',
  'ff68',
  'ff69',
  'ff6a',
  'ff6b',
  'ff6c',
  'ff6d',
  'ff6e',
  'ff6f',
  'ff70',
  'ff71',
  'ff72',
  'ff73',
  'ff74',
  'ff75',
  'ff76',
  'ff77',
  'ff78',
  'ff79',
  'ff7a',
  'ff7b',
  'ff7c',
  'ff7d',
  'ff7e',
  'ff7f',
  'ff80',
  'ff81',
  'ff82',
  'ff83',
  'ff84',
  'ff85',
  'ff86',
  'ff87',
  'ff88',
  'ff89',
  'ff8a',
  'ff8b',
  'ff8c',
  'ff8d',
  'ff8e',
  'ff8f',
  'ff90',
  'ff91',
  'ff92',
  'ff93',
  'ff94',
  'ff95',
  'ff96',
  'ff97',
  'ff98',
  'ff99',
  'ff9a',
  'ff9b',
  'ff9c',
  'ff9d',
  'ff9e',
  'ff9f',
  '3000',
  '3001',
  '3002',
  'ff0c',
  'ff0e',
  '30fb',
  'ff1a',
  'ff1b',
  'ff1f',
  'ff01',
  '309b',
  '309c',
  'b4',
  'ff40',
  'a8',
  'ff3e',
  'ffe3',
  'ff3f',
  '30fd',
  '30fe',
  '309d',
  '309e',
  '3003',
  '4edd',
  '3005',
  '3006',
  '3007',
  '30fc',
  '2015',
  '2010',
  'ff0f',
  'ff3c',
  'ff5e',
  '2225',
  'ff5c',
  '2026',
  '2025',
  '2018',
  '2019',
  '201c',
  '201d',
  'ff08',
  'ff09',
  '3014',
  '3015',
  'ff3b',
  'ff3d',
  'ff5b',
  'ff5d',
  '3008',
  '3009',
  '300a',
  '300b',
  '300c',
  '300d',
  '300e',
  '300f',
  '3010',
  '3011',
  'ff0b',
  'ff0d',
  'b1',
  'd7',
  'f7',
  'ff1d',
  '2260',
  'ff1c',
  'ff1e',
  '2266',
  '2267',
  '221e',
  '2234',
  '2642',
  '2640',
  'b0',
  '2032',
  '2033',
  '2103',
  'ffe5',
  'ff04',
  'ffe0',
  'ffe1',
  'ff05',
  'ff03',
  'ff06',
  'ff0a',
  'ff20',
  'a7',
  '2606',
  '2605',
  '25cb',
  '25cf',
  '25ce',
  '25c7',
  '25c6',
  '25a1',
  '25a0',
  '25b3',
  '25b2',
  '25bd',
  '25bc',
  '203b',
  '3012',
  '2192',
  '2190',
  '2191',
  '2193',
  '3013',
  '2208',
  '220b',
  '2286',
  '2287',
  '2282',
  '2283',
  '222a',
  '2229',
  '2227',
  '2228',
  'ffe2',
  '21d2',
  '21d4',
  '2200',
  '2203',
  '2220',
  '22a5',
  '2312',
  '2202',
  '2207',
  '2261',
  '2252',
  '226a',
  '226b',
  '221a',
  '223d',
  '221d',
  '2235',
  '222b',
  '222c',
  '212b',
  '2030',
  '266f',
  '266d',
  '266a',
  '2020',
  '2021',
  'b6',
  '25ef',
  'ff10',
  'ff11',
  'ff12',
  'ff13',
  'ff14',
  'ff15',
  'ff16',
  'ff17',
  'ff18',
  'ff19',
  'ff21',
  'ff22',
  'ff23',
  'ff24',
  'ff25',
  'ff26',
  'ff27',
  'ff28',
  'ff29',
  'ff2a',
  'ff2b',
  'ff2c',
  'ff2d',
  'ff2e',
  'ff2f',
  'ff30',
  'ff31',
  'ff32',
  'ff33',
  'ff34',
  'ff35',
  'ff36',
  'ff37',
  'ff38',
  'ff39',
  'ff3a',
  'ff41',
  'ff42',
  'ff43',
  'ff44',
  'ff45',
  'ff46',
  'ff47',
  'ff48',
  'ff49',
  'ff4a',
  'ff4b',
  'ff4c',
  'ff4d',
  'ff4e',
  'ff4f',
  'ff50',
  'ff51',
  'ff52',
  'ff53',
  'ff54',
  'ff55',
  'ff56',
  'ff57',
  'ff58',
  'ff59',
  'ff5a',
  '3041',
  '3042',
  '3043',
  '3044',
  '3045',
  '3046',
  '3047',
  '3048',
  '3049',
  '304a',
  '304b',
  '304c',
  '304d',
  '304e',
  '304f',
  '3050',
  '3051',
  '3052',
  '3053',
  '3054',
  '3055',
  '3056',
  '3057',
  '3058',
  '3059',
  '305a',
  '305b',
  '305c',
  '305d',
  '305e',
  '305f',
  '3060',
  '3061',
  '3062',
  '3063',
  '3064',
  '3065',
  '3066',
  '3067',
  '3068',
  '3069',
  '306a',
  '306b',
  '306c',
  '306d',
  '306e',
  '306f',
  '3070',
  '3071',
  '3072',
  '3073',
  '3074',
  '3075',
  '3076',
  '3077',
  '3078',
  '3079',
  '307a',
  '307b',
  '307c',
  '307d',
  '307e',
  '307f',
  '3080',
  '3081',
  '3082',
  '3083',
  '3084',
  '3085',
  '3086',
  '3087',
  '3088',
  '3089',
  '308a',
  '308b',
  '308c',
  '308d',
  '308e',
  '308f',
  '3090',
  '3091',
  '3092',
  '3093',
  '30a1',
  '30a2',
  '30a3',
  '30a4',
  '30a5',
  '30a6',
  '30a7',
  '30a8',
  '30a9',
  '30aa',
  '30ab',
  '30ac',
  '30ad',
  '30ae',
  '30af',
  '30b0',
  '30b1',
  '30b2',
  '30b3',
  '30b4',
  '30b5',
  '30b6',
  '30b7',
  '30b8',
  '30b9',
  '30ba',
  '30bb',
  '30bc',
  '30bd',
  '30be',
  '30bf',
  '30c0',
  '30c1',
  '30c2',
  '30c3',
  '30c4',
  '30c5',
  '30c6',
  '30c7',
  '30c8',
  '30c9',
  '30ca',
  '30cb',
  '30cc',
  '30cd',
  '30ce',
  '30cf',
  '30d0',
  '30d1',
  '30d2',
  '30d3',
  '30d4',
  '30d5',
  '30d6',
  '30d7',
  '30d8',
  '30d9',
  '30da',
  '30db',
  '30dc',
  '30dd',
  '30de',
  '30df',
  '30e0',
  '30e1',
  '30e2',
  '30e3',
  '30e4',
  '30e5',
  '30e6',
  '30e7',
  '30e8',
  '30e9',
  '30ea',
  '30eb',
  '30ec',
  '30ed',
  '30ee',
  '30ef',
  '30f0',
  '30f1',
  '30f2',
  '30f3',
  '30f4',
  '30f5',
  '30f6',
  '391',
  '392',
  '393',
  '394',
  '395',
  '396',
  '397',
  '398',
  '399',
  '39a',
  '39b',
  '39c',
  '39d',
  '39e',
  '39f',
  '3a0',
  '3a1',
  '3a3',
  '3a4',
  '3a5',
  '3a6',
  '3a7',
  '3a8',
  '3a9',
  '3b1',
  '3b2',
  '3b3',
  '3b4',
  '3b5',
  '3b6',
  '3b7',
  '3b8',
  '3b9',
  '3ba',
  '3bb',
  '3bc',
  '3bd',
  '3be',
  '3bf',
  '3c0',
  '3c1',
  '3c3',
  '3c4',
  '3c5',
  '3c6',
  '3c7',
  '3c8',
  '3c9',
  '410',
  '411',
  '412',
  '413',
  '414',
  '415',
  '401',
  '416',
  '417',
  '418',
  '419',
  '41a',
  '41b',
  '41c',
  '41d',
  '41e',
  '41f',
  '420',
  '421',
  '422',
  '423',
  '424',
  '425',
  '426',
  '427',
  '428',
  '429',
  '42a',
  '42b',
  '42c',
  '42d',
  '42e',
  '42f',
  '430',
  '431',
  '432',
  '433',
  '434',
  '435',
  '451',
  '436',
  '437',
  '438',
  '439',
  '43a',
  '43b',
  '43c',
  '43d',
  '43e',
  '43f',
  '440',
  '441',
  '442',
  '443',
  '444',
  '445',
  '446',
  '447',
  '448',
  '449',
  '44a',
  '44b',
  '44c',
  '44d',
  '44e',
  '44f',
  '2500',
  '2502',
  '250c',
  '2510',
  '2518',
  '2514',
  '251c',
  '252c',
  '2524',
  '2534',
  '253c',
  '2501',
  '2503',
  '250f',
  '2513',
  '251b',
  '2517',
  '2523',
  '2533',
  '252b',
  '253b',
  '254b',
  '2520',
  '252f',
  '2528',
  '2537',
  '253f',
  '251d',
  '2530',
  '2525',
  '2538',
  '2542',
  '4e9c',
  '5516',
  '5a03',
  '963f',
  '54c0',
  '611b',
  '6328',
  '59f6',
  '9022',
  '8475',
  '831c',
  '7a50',
  '60aa',
  '63e1',
  '6e25',
  '65ed',
  '8466',
  '82a6',
  '9bf5',
  '6893',
  '5727',
  '65a1',
  '6271',
  '5b9b',
  '59d0',
  '867b',
  '98f4',
  '7d62',
  '7dbe',
  '9b8e',
  '6216',
  '7c9f',
  '88b7',
  '5b89',
  '5eb5',
  '6309',
  '6697',
  '6848',
  '95c7',
  '978d',
  '674f',
  '4ee5',
  '4f0a',
  '4f4d',
  '4f9d',
  '5049',
  '56f2',
  '5937',
  '59d4',
  '5a01',
  '5c09',
  '60df',
  '610f',
  '6170',
  '6613',
  '6905',
  '70ba',
  '754f',
  '7570',
  '79fb',
  '7dad',
  '7def',
  '80c3',
  '840e',
  '8863',
  '8b02',
  '9055',
  '907a',
  '533b',
  '4e95',
  '4ea5',
  '57df',
  '80b2',
  '90c1',
  '78ef',
  '4e00',
  '58f1',
  '6ea2',
  '9038',
  '7a32',
  '8328',
  '828b',
  '9c2f',
  '5141',
  '5370',
  '54bd',
  '54e1',
  '56e0',
  '59fb',
  '5f15',
  '98f2',
  '6deb',
  '80e4',
  '852d',
  '9662',
  '9670',
  '96a0',
  '97fb',
  '540b',
  '53f3',
  '5b87',
  '70cf',
  '7fbd',
  '8fc2',
  '96e8',
  '536f',
  '9d5c',
  '7aba',
  '4e11',
  '7893',
  '81fc',
  '6e26',
  '5618',
  '5504',
  '6b1d',
  '851a',
  '9c3b',
  '59e5',
  '53a9',
  '6d66',
  '74dc',
  '958f',
  '5642',
  '4e91',
  '904b',
  '96f2',
  '834f',
  '990c',
  '53e1',
  '55b6',
  '5b30',
  '5f71',
  '6620',
  '66f3',
  '6804',
  '6c38',
  '6cf3',
  '6d29',
  '745b',
  '76c8',
  '7a4e',
  '9834',
  '82f1',
  '885b',
  '8a60',
  '92ed',
  '6db2',
  '75ab',
  '76ca',
  '99c5',
  '60a6',
  '8b01',
  '8d8a',
  '95b2',
  '698e',
  '53ad',
  '5186',
  '5712',
  '5830',
  '5944',
  '5bb4',
  '5ef6',
  '6028',
  '63a9',
  '63f4',
  '6cbf',
  '6f14',
  '708e',
  '7114',
  '7159',
  '71d5',
  '733f',
  '7e01',
  '8276',
  '82d1',
  '8597',
  '9060',
  '925b',
  '9d1b',
  '5869',
  '65bc',
  '6c5a',
  '7525',
  '51f9',
  '592e',
  '5965',
  '5f80',
  '5fdc',
  '62bc',
  '65fa',
  '6a2a',
  '6b27',
  '6bb4',
  '738b',
  '7fc1',
  '8956',
  '9d2c',
  '9d0e',
  '9ec4',
  '5ca1',
  '6c96',
  '837b',
  '5104',
  '5c4b',
  '61b6',
  '81c6',
  '6876',
  '7261',
  '4e59',
  '4ffa',
  '5378',
  '6069',
  '6e29',
  '7a4f',
  '97f3',
  '4e0b',
  '5316',
  '4eee',
  '4f55',
  '4f3d',
  '4fa1',
  '4f73',
  '52a0',
  '53ef',
  '5609',
  '590f',
  '5ac1',
  '5bb6',
  '5be1',
  '79d1',
  '6687',
  '679c',
  '67b6',
  '6b4c',
  '6cb3',
  '706b',
  '73c2',
  '798d',
  '79be',
  '7a3c',
  '7b87',
  '82b1',
  '82db',
  '8304',
  '8377',
  '83ef',
  '83d3',
  '8766',
  '8ab2',
  '5629',
  '8ca8',
  '8fe6',
  '904e',
  '971e',
  '868a',
  '4fc4',
  '5ce8',
  '6211',
  '7259',
  '753b',
  '81e5',
  '82bd',
  '86fe',
  '8cc0',
  '96c5',
  '9913',
  '99d5',
  '4ecb',
  '4f1a',
  '89e3',
  '56de',
  '584a',
  '58ca',
  '5efb',
  '5feb',
  '602a',
  '6094',
  '6062',
  '61d0',
  '6212',
  '62d0',
  '6539',
  '9b41',
  '6666',
  '68b0',
  '6d77',
  '7070',
  '754c',
  '7686',
  '7d75',
  '82a5',
  '87f9',
  '958b',
  '968e',
  '8c9d',
  '51f1',
  '52be',
  '5916',
  '54b3',
  '5bb3',
  '5d16',
  '6168',
  '6982',
  '6daf',
  '788d',
  '84cb',
  '8857',
  '8a72',
  '93a7',
  '9ab8',
  '6d6c',
  '99a8',
  '86d9',
  '57a3',
  '67ff',
  '86ce',
  '920e',
  '5283',
  '5687',
  '5404',
  '5ed3',
  '62e1',
  '64b9',
  '683c',
  '6838',
  '6bbb',
  '7372',
  '78ba',
  '7a6b',
  '899a',
  '89d2',
  '8d6b',
  '8f03',
  '90ed',
  '95a3',
  '9694',
  '9769',
  '5b66',
  '5cb3',
  '697d',
  '984d',
  '984e',
  '639b',
  '7b20',
  '6a2b',
  '6a7f',
  '68b6',
  '9c0d',
  '6f5f',
  '5272',
  '559d',
  '6070',
  '62ec',
  '6d3b',
  '6e07',
  '6ed1',
  '845b',
  '8910',
  '8f44',
  '4e14',
  '9c39',
  '53f6',
  '691b',
  '6a3a',
  '9784',
  '682a',
  '515c',
  '7ac3',
  '84b2',
  '91dc',
  '938c',
  '565b',
  '9d28',
  '6822',
  '8305',
  '8431',
  '7ca5',
  '5208',
  '82c5',
  '74e6',
  '4e7e',
  '4f83',
  '51a0',
  '5bd2',
  '520a',
  '52d8',
  '52e7',
  '5dfb',
  '559a',
  '582a',
  '59e6',
  '5b8c',
  '5b98',
  '5bdb',
  '5e72',
  '5e79',
  '60a3',
  '611f',
  '6163',
  '61be',
  '63db',
  '6562',
  '67d1',
  '6853',
  '68fa',
  '6b3e',
  '6b53',
  '6c57',
  '6f22',
  '6f97',
  '6f45',
  '74b0',
  '7518',
  '76e3',
  '770b',
  '7aff',
  '7ba1',
  '7c21',
  '7de9',
  '7f36',
  '7ff0',
  '809d',
  '8266',
  '839e',
  '89b3',
  '8acc',
  '8cab',
  '9084',
  '9451',
  '9593',
  '9591',
  '95a2',
  '9665',
  '97d3',
  '9928',
  '8218',
  '4e38',
  '542b',
  '5cb8',
  '5dcc',
  '73a9',
  '764c',
  '773c',
  '5ca9',
  '7feb',
  '8d0b',
  '96c1',
  '9811',
  '9854',
  '9858',
  '4f01',
  '4f0e',
  '5371',
  '559c',
  '5668',
  '57fa',
  '5947',
  '5b09',
  '5bc4',
  '5c90',
  '5e0c',
  '5e7e',
  '5fcc',
  '63ee',
  '673a',
  '65d7',
  '65e2',
  '671f',
  '68cb',
  '68c4',
  '6a5f',
  '5e30',
  '6bc5',
  '6c17',
  '6c7d',
  '757f',
  '7948',
  '5b63',
  '7a00',
  '7d00',
  '5fbd',
  '898f',
  '8a18',
  '8cb4',
  '8d77',
  '8ecc',
  '8f1d',
  '98e2',
  '9a0e',
  '9b3c',
  '4e80',
  '507d',
  '5100',
  '5993',
  '5b9c',
  '622f',
  '6280',
  '64ec',
  '6b3a',
  '72a0',
  '7591',
  '7947',
  '7fa9',
  '87fb',
  '8abc',
  '8b70',
  '63ac',
  '83ca',
  '97a0',
  '5409',
  '5403',
  '55ab',
  '6854',
  '6a58',
  '8a70',
  '7827',
  '6775',
  '9ecd',
  '5374',
  '5ba2',
  '811a',
  '8650',
  '9006',
  '4e18',
  '4e45',
  '4ec7',
  '4f11',
  '53ca',
  '5438',
  '5bae',
  '5f13',
  '6025',
  '6551',
  '673d',
  '6c42',
  '6c72',
  '6ce3',
  '7078',
  '7403',
  '7a76',
  '7aae',
  '7b08',
  '7d1a',
  '7cfe',
  '7d66',
  '65e7',
  '725b',
  '53bb',
  '5c45',
  '5de8',
  '62d2',
  '62e0',
  '6319',
  '6e20',
  '865a',
  '8a31',
  '8ddd',
  '92f8',
  '6f01',
  '79a6',
  '9b5a',
  '4ea8',
  '4eab',
  '4eac',
  '4f9b',
  '4fa0',
  '50d1',
  '5147',
  '7af6',
  '5171',
  '51f6',
  '5354',
  '5321',
  '537f',
  '53eb',
  '55ac',
  '5883',
  '5ce1',
  '5f37',
  '5f4a',
  '602f',
  '6050',
  '606d',
  '631f',
  '6559',
  '6a4b',
  '6cc1',
  '72c2',
  '72ed',
  '77ef',
  '80f8',
  '8105',
  '8208',
  '854e',
  '90f7',
  '93e1',
  '97ff',
  '9957',
  '9a5a',
  '4ef0',
  '51dd',
  '5c2d',
  '6681',
  '696d',
  '5c40',
  '66f2',
  '6975',
  '7389',
  '6850',
  '7c81',
  '50c5',
  '52e4',
  '5747',
  '5dfe',
  '9326',
  '65a4',
  '6b23',
  '6b3d',
  '7434',
  '7981',
  '79bd',
  '7b4b',
  '7dca',
  '82b9',
  '83cc',
  '887f',
  '895f',
  '8b39',
  '8fd1',
  '91d1',
  '541f',
  '9280',
  '4e5d',
  '5036',
  '53e5',
  '533a',
  '72d7',
  '7396',
  '77e9',
  '82e6',
  '8eaf',
  '99c6',
  '99c8',
  '99d2',
  '5177',
  '611a',
  '865e',
  '55b0',
  '7a7a',
  '5076',
  '5bd3',
  '9047',
  '9685',
  '4e32',
  '6adb',
  '91e7',
  '5c51',
  '5c48',
  '6398',
  '7a9f',
  '6c93',
  '9774',
  '8f61',
  '7aaa',
  '718a',
  '9688',
  '7c82',
  '6817',
  '7e70',
  '6851',
  '936c',
  '52f2',
  '541b',
  '85ab',
  '8a13',
  '7fa4',
  '8ecd',
  '90e1',
  '5366',
  '8888',
  '7941',
  '4fc2',
  '50be',
  '5211',
  '5144',
  '5553',
  '572d',
  '73ea',
  '578b',
  '5951',
  '5f62',
  '5f84',
  '6075',
  '6176',
  '6167',
  '61a9',
  '63b2',
  '643a',
  '656c',
  '666f',
  '6842',
  '6e13',
  '7566',
  '7a3d',
  '7cfb',
  '7d4c',
  '7d99',
  '7e4b',
  '7f6b',
  '830e',
  '834a',
  '86cd',
  '8a08',
  '8a63',
  '8b66',
  '8efd',
  '981a',
  '9d8f',
  '82b8',
  '8fce',
  '9be8',
  '5287',
  '621f',
  '6483',
  '6fc0',
  '9699',
  '6841',
  '5091',
  '6b20',
  '6c7a',
  '6f54',
  '7a74',
  '7d50',
  '8840',
  '8a23',
  '6708',
  '4ef6',
  '5039',
  '5026',
  '5065',
  '517c',
  '5238',
  '5263',
  '55a7',
  '570f',
  '5805',
  '5acc',
  '5efa',
  '61b2',
  '61f8',
  '62f3',
  '6372',
  '691c',
  '6a29',
  '727d',
  '72ac',
  '732e',
  '7814',
  '786f',
  '7d79',
  '770c',
  '80a9',
  '898b',
  '8b19',
  '8ce2',
  '8ed2',
  '9063',
  '9375',
  '967a',
  '9855',
  '9a13',
  '9e78',
  '5143',
  '539f',
  '53b3',
  '5e7b',
  '5f26',
  '6e1b',
  '6e90',
  '7384',
  '73fe',
  '7d43',
  '8237',
  '8a00',
  '8afa',
  '9650',
  '4e4e',
  '500b',
  '53e4',
  '547c',
  '56fa',
  '59d1',
  '5b64',
  '5df1',
  '5eab',
  '5f27',
  '6238',
  '6545',
  '67af',
  '6e56',
  '72d0',
  '7cca',
  '88b4',
  '80a1',
  '80e1',
  '83f0',
  '864e',
  '8a87',
  '8de8',
  '9237',
  '96c7',
  '9867',
  '9f13',
  '4e94',
  '4e92',
  '4f0d',
  '5348',
  '5449',
  '543e',
  '5a2f',
  '5f8c',
  '5fa1',
  '609f',
  '68a7',
  '6a8e',
  '745a',
  '7881',
  '8a9e',
  '8aa4',
  '8b77',
  '9190',
  '4e5e',
  '9bc9',
  '4ea4',
  '4f7c',
  '4faf',
  '5019',
  '5016',
  '5149',
  '516c',
  '529f',
  '52b9',
  '52fe',
  '539a',
  '53e3',
  '5411',
  '540e',
  '5589',
  '5751',
  '57a2',
  '597d',
  '5b54',
  '5b5d',
  '5b8f',
  '5de5',
  '5de7',
  '5df7',
  '5e78',
  '5e83',
  '5e9a',
  '5eb7',
  '5f18',
  '6052',
  '614c',
  '6297',
  '62d8',
  '63a7',
  '653b',
  '6602',
  '6643',
  '66f4',
  '676d',
  '6821',
  '6897',
  '69cb',
  '6c5f',
  '6d2a',
  '6d69',
  '6e2f',
  '6e9d',
  '7532',
  '7687',
  '786c',
  '7a3f',
  '7ce0',
  '7d05',
  '7d18',
  '7d5e',
  '7db1',
  '8015',
  '8003',
  '80af',
  '80b1',
  '8154',
  '818f',
  '822a',
  '8352',
  '884c',
  '8861',
  '8b1b',
  '8ca2',
  '8cfc',
  '90ca',
  '9175',
  '9271',
  '783f',
  '92fc',
  '95a4',
  '964d',
  '9805',
  '9999',
  '9ad8',
  '9d3b',
  '525b',
  '52ab',
  '53f7',
  '5408',
  '58d5',
  '62f7',
  '6fe0',
  '8c6a',
  '8f5f',
  '9eb9',
  '514b',
  '523b',
  '544a',
  '56fd',
  '7a40',
  '9177',
  '9d60',
  '9ed2',
  '7344',
  '6f09',
  '8170',
  '7511',
  '5ffd',
  '60da',
  '9aa8',
  '72db',
  '8fbc',
  '6b64',
  '9803',
  '4eca',
  '56f0',
  '5764',
  '58be',
  '5a5a',
  '6068',
  '61c7',
  '660f',
  '6606',
  '6839',
  '68b1',
  '6df7',
  '75d5',
  '7d3a',
  '826e',
  '9b42',
  '4e9b',
  '4f50',
  '53c9',
  '5506',
  '5d6f',
  '5de6',
  '5dee',
  '67fb',
  '6c99',
  '7473',
  '7802',
  '8a50',
  '9396',
  '88df',
  '5750',
  '5ea7',
  '632b',
  '50b5',
  '50ac',
  '518d',
  '6700',
  '54c9',
  '585e',
  '59bb',
  '5bb0',
  '5f69',
  '624d',
  '63a1',
  '683d',
  '6b73',
  '6e08',
  '707d',
  '91c7',
  '7280',
  '7815',
  '7826',
  '796d',
  '658e',
  '7d30',
  '83dc',
  '88c1',
  '8f09',
  '969b',
  '5264',
  '5728',
  '6750',
  '7f6a',
  '8ca1',
  '51b4',
  '5742',
  '962a',
  '583a',
  '698a',
  '80b4',
  '54b2',
  '5d0e',
  '57fc',
  '7895',
  '9dfa',
  '4f5c',
  '524a',
  '548b',
  '643e',
  '6628',
  '6714',
  '67f5',
  '7a84',
  '7b56',
  '7d22',
  '932f',
  '685c',
  '9bad',
  '7b39',
  '5319',
  '518a',
  '5237',
  '5bdf',
  '62f6',
  '64ae',
  '64e6',
  '672d',
  '6bba',
  '85a9',
  '96d1',
  '7690',
  '9bd6',
  '634c',
  '9306',
  '9bab',
  '76bf',
  '6652',
  '4e09',
  '5098',
  '53c2',
  '5c71',
  '60e8',
  '6492',
  '6563',
  '685f',
  '71e6',
  '73ca',
  '7523',
  '7b97',
  '7e82',
  '8695',
  '8b83',
  '8cdb',
  '9178',
  '9910',
  '65ac',
  '66ab',
  '6b8b',
  '4ed5',
  '4ed4',
  '4f3a',
  '4f7f',
  '523a',
  '53f8',
  '53f2',
  '55e3',
  '56db',
  '58eb',
  '59cb',
  '59c9',
  '59ff',
  '5b50',
  '5c4d',
  '5e02',
  '5e2b',
  '5fd7',
  '601d',
  '6307',
  '652f',
  '5b5c',
  '65af',
  '65bd',
  '65e8',
  '679d',
  '6b62',
  '6b7b',
  '6c0f',
  '7345',
  '7949',
  '79c1',
  '7cf8',
  '7d19',
  '7d2b',
  '80a2',
  '8102',
  '81f3',
  '8996',
  '8a5e',
  '8a69',
  '8a66',
  '8a8c',
  '8aee',
  '8cc7',
  '8cdc',
  '96cc',
  '98fc',
  '6b6f',
  '4e8b',
  '4f3c',
  '4f8d',
  '5150',
  '5b57',
  '5bfa',
  '6148',
  '6301',
  '6642',
  '6b21',
  '6ecb',
  '6cbb',
  '723e',
  '74bd',
  '75d4',
  '78c1',
  '793a',
  '800c',
  '8033',
  '81ea',
  '8494',
  '8f9e',
  '6c50',
  '9e7f',
  '5f0f',
  '8b58',
  '9d2b',
  '7afa',
  '8ef8',
  '5b8d',
  '96eb',
  '4e03',
  '53f1',
  '57f7',
  '5931',
  '5ac9',
  '5ba4',
  '6089',
  '6e7f',
  '6f06',
  '75be',
  '8cea',
  '5b9f',
  '8500',
  '7be0',
  '5072',
  '67f4',
  '829d',
  '5c61',
  '854a',
  '7e1e',
  '820e',
  '5199',
  '5c04',
  '6368',
  '8d66',
  '659c',
  '716e',
  '793e',
  '7d17',
  '8005',
  '8b1d',
  '8eca',
  '906e',
  '86c7',
  '90aa',
  '501f',
  '52fa',
  '5c3a',
  '6753',
  '707c',
  '7235',
  '914c',
  '91c8',
  '932b',
  '82e5',
  '5bc2',
  '5f31',
  '60f9',
  '4e3b',
  '53d6',
  '5b88',
  '624b',
  '6731',
  '6b8a',
  '72e9',
  '73e0',
  '7a2e',
  '816b',
  '8da3',
  '9152',
  '9996',
  '5112',
  '53d7',
  '546a',
  '5bff',
  '6388',
  '6a39',
  '7dac',
  '9700',
  '56da',
  '53ce',
  '5468',
  '5b97',
  '5c31',
  '5dde',
  '4fee',
  '6101',
  '62fe',
  '6d32',
  '79c0',
  '79cb',
  '7d42',
  '7e4d',
  '7fd2',
  '81ed',
  '821f',
  '8490',
  '8846',
  '8972',
  '8b90',
  '8e74',
  '8f2f',
  '9031',
  '914b',
  '916c',
  '96c6',
  '919c',
  '4ec0',
  '4f4f',
  '5145',
  '5341',
  '5f93',
  '620e',
  '67d4',
  '6c41',
  '6e0b',
  '7363',
  '7e26',
  '91cd',
  '9283',
  '53d4',
  '5919',
  '5bbf',
  '6dd1',
  '795d',
  '7e2e',
  '7c9b',
  '587e',
  '719f',
  '51fa',
  '8853',
  '8ff0',
  '4fca',
  '5cfb',
  '6625',
  '77ac',
  '7ae3',
  '821c',
  '99ff',
  '51c6',
  '5faa',
  '65ec',
  '696f',
  '6b89',
  '6df3',
  '6e96',
  '6f64',
  '76fe',
  '7d14',
  '5de1',
  '9075',
  '9187',
  '9806',
  '51e6',
  '521d',
  '6240',
  '6691',
  '66d9',
  '6e1a',
  '5eb6',
  '7dd2',
  '7f72',
  '66f8',
  '85af',
  '85f7',
  '8af8',
  '52a9',
  '53d9',
  '5973',
  '5e8f',
  '5f90',
  '6055',
  '92e4',
  '9664',
  '50b7',
  '511f',
  '52dd',
  '5320',
  '5347',
  '53ec',
  '54e8',
  '5546',
  '5531',
  '5617',
  '5968',
  '59be',
  '5a3c',
  '5bb5',
  '5c06',
  '5c0f',
  '5c11',
  '5c1a',
  '5e84',
  '5e8a',
  '5ee0',
  '5f70',
  '627f',
  '6284',
  '62db',
  '638c',
  '6377',
  '6607',
  '660c',
  '662d',
  '6676',
  '677e',
  '68a2',
  '6a1f',
  '6a35',
  '6cbc',
  '6d88',
  '6e09',
  '6e58',
  '713c',
  '7126',
  '7167',
  '75c7',
  '7701',
  '785d',
  '7901',
  '7965',
  '79f0',
  '7ae0',
  '7b11',
  '7ca7',
  '7d39',
  '8096',
  '83d6',
  '848b',
  '8549',
  '885d',
  '88f3',
  '8a1f',
  '8a3c',
  '8a54',
  '8a73',
  '8c61',
  '8cde',
  '91a4',
  '9266',
  '937e',
  '9418',
  '969c',
  '9798',
  '4e0a',
  '4e08',
  '4e1e',
  '4e57',
  '5197',
  '5270',
  '57ce',
  '5834',
  '58cc',
  '5b22',
  '5e38',
  '60c5',
  '64fe',
  '6761',
  '6756',
  '6d44',
  '72b6',
  '7573',
  '7a63',
  '84b8',
  '8b72',
  '91b8',
  '9320',
  '5631',
  '57f4',
  '98fe',
  '62ed',
  '690d',
  '6b96',
  '71ed',
  '7e54',
  '8077',
  '8272',
  '89e6',
  '98df',
  '8755',
  '8fb1',
  '5c3b',
  '4f38',
  '4fe1',
  '4fb5',
  '5507',
  '5a20',
  '5bdd',
  '5be9',
  '5fc3',
  '614e',
  '632f',
  '65b0',
  '664b',
  '68ee',
  '699b',
  '6d78',
  '6df1',
  '7533',
  '75b9',
  '771f',
  '795e',
  '79e6',
  '7d33',
  '81e3',
  '82af',
  '85aa',
  '89aa',
  '8a3a',
  '8eab',
  '8f9b',
  '9032',
  '91dd',
  '9707',
  '4eba',
  '4ec1',
  '5203',
  '5875',
  '58ec',
  '5c0b',
  '751a',
  '5c3d',
  '814e',
  '8a0a',
  '8fc5',
  '9663',
  '976d',
  '7b25',
  '8acf',
  '9808',
  '9162',
  '56f3',
  '53a8',
  '9017',
  '5439',
  '5782',
  '5e25',
  '63a8',
  '6c34',
  '708a',
  '7761',
  '7c8b',
  '7fe0',
  '8870',
  '9042',
  '9154',
  '9310',
  '9318',
  '968f',
  '745e',
  '9ac4',
  '5d07',
  '5d69',
  '6570',
  '67a2',
  '8da8',
  '96db',
  '636e',
  '6749',
  '6919',
  '83c5',
  '9817',
  '96c0',
  '88fe',
  '6f84',
  '647a',
  '5bf8',
  '4e16',
  '702c',
  '755d',
  '662f',
  '51c4',
  '5236',
  '52e2',
  '59d3',
  '5f81',
  '6027',
  '6210',
  '653f',
  '6574',
  '661f',
  '6674',
  '68f2',
  '6816',
  '6b63',
  '6e05',
  '7272',
  '751f',
  '76db',
  '7cbe',
  '8056',
  '58f0',
  '88fd',
  '897f',
  '8aa0',
  '8a93',
  '8acb',
  '901d',
  '9192',
  '9752',
  '9759',
  '6589',
  '7a0e',
  '8106',
  '96bb',
  '5e2d',
  '60dc',
  '621a',
  '65a5',
  '6614',
  '6790',
  '77f3',
  '7a4d',
  '7c4d',
  '7e3e',
  '810a',
  '8cac',
  '8d64',
  '8de1',
  '8e5f',
  '78a9',
  '5207',
  '62d9',
  '63a5',
  '6442',
  '6298',
  '8a2d',
  '7a83',
  '7bc0',
  '8aac',
  '96ea',
  '7d76',
  '820c',
  '8749',
  '4ed9',
  '5148',
  '5343',
  '5360',
  '5ba3',
  '5c02',
  '5c16',
  '5ddd',
  '6226',
  '6247',
  '64b0',
  '6813',
  '6834',
  '6cc9',
  '6d45',
  '6d17',
  '67d3',
  '6f5c',
  '714e',
  '717d',
  '65cb',
  '7a7f',
  '7bad',
  '7dda',
  '7e4a',
  '7fa8',
  '817a',
  '821b',
  '8239',
  '85a6',
  '8a6e',
  '8cce',
  '8df5',
  '9078',
  '9077',
  '92ad',
  '9291',
  '9583',
  '9bae',
  '524d',
  '5584',
  '6f38',
  '7136',
  '5168',
  '7985',
  '7e55',
  '81b3',
  '7cce',
  '564c',
  '5851',
  '5ca8',
  '63aa',
  '66fe',
  '66fd',
  '695a',
  '72d9',
  '758f',
  '758e',
  '790e',
  '7956',
  '79df',
  '7c97',
  '7d20',
  '7d44',
  '8607',
  '8a34',
  '963b',
  '9061',
  '9f20',
  '50e7',
  '5275',
  '53cc',
  '53e2',
  '5009',
  '55aa',
  '58ee',
  '594f',
  '723d',
  '5b8b',
  '5c64',
  '531d',
  '60e3',
  '60f3',
  '635c',
  '6383',
  '633f',
  '63bb',
  '64cd',
  '65e9',
  '66f9',
  '5de3',
  '69cd',
  '69fd',
  '6f15',
  '71e5',
  '4e89',
  '75e9',
  '76f8',
  '7a93',
  '7cdf',
  '7dcf',
  '7d9c',
  '8061',
  '8349',
  '8358',
  '846c',
  '84bc',
  '85fb',
  '88c5',
  '8d70',
  '9001',
  '906d',
  '9397',
  '971c',
  '9a12',
  '50cf',
  '5897',
  '618e',
  '81d3',
  '8535',
  '8d08',
  '9020',
  '4fc3',
  '5074',
  '5247',
  '5373',
  '606f',
  '6349',
  '675f',
  '6e2c',
  '8db3',
  '901f',
  '4fd7',
  '5c5e',
  '8cca',
  '65cf',
  '7d9a',
  '5352',
  '8896',
  '5176',
  '63c3',
  '5b58',
  '5b6b',
  '5c0a',
  '640d',
  '6751',
  '905c',
  '4ed6',
  '591a',
  '592a',
  '6c70',
  '8a51',
  '553e',
  '5815',
  '59a5',
  '60f0',
  '6253',
  '67c1',
  '8235',
  '6955',
  '9640',
  '99c4',
  '9a28',
  '4f53',
  '5806',
  '5bfe',
  '8010',
  '5cb1',
  '5e2f',
  '5f85',
  '6020',
  '614b',
  '6234',
  '66ff',
  '6cf0',
  '6ede',
  '80ce',
  '817f',
  '82d4',
  '888b',
  '8cb8',
  '9000',
  '902e',
  '968a',
  '9edb',
  '9bdb',
  '4ee3',
  '53f0',
  '5927',
  '7b2c',
  '918d',
  '984c',
  '9df9',
  '6edd',
  '7027',
  '5353',
  '5544',
  '5b85',
  '6258',
  '629e',
  '62d3',
  '6ca2',
  '6fef',
  '7422',
  '8a17',
  '9438',
  '6fc1',
  '8afe',
  '8338',
  '51e7',
  '86f8',
  '53ea',
  '53e9',
  '4f46',
  '9054',
  '8fb0',
  '596a',
  '8131',
  '5dfd',
  '7aea',
  '8fbf',
  '68da',
  '8c37',
  '72f8',
  '9c48',
  '6a3d',
  '8ab0',
  '4e39',
  '5358',
  '5606',
  '5766',
  '62c5',
  '63a2',
  '65e6',
  '6b4e',
  '6de1',
  '6e5b',
  '70ad',
  '77ed',
  '7aef',
  '7baa',
  '7dbb',
  '803d',
  '80c6',
  '86cb',
  '8a95',
  '935b',
  '56e3',
  '58c7',
  '5f3e',
  '65ad',
  '6696',
  '6a80',
  '6bb5',
  '7537',
  '8ac7',
  '5024',
  '77e5',
  '5730',
  '5f1b',
  '6065',
  '667a',
  '6c60',
  '75f4',
  '7a1a',
  '7f6e',
  '81f4',
  '8718',
  '9045',
  '99b3',
  '7bc9',
  '755c',
  '7af9',
  '7b51',
  '84c4',
  '9010',
  '79e9',
  '7a92',
  '8336',
  '5ae1',
  '7740',
  '4e2d',
  '4ef2',
  '5b99',
  '5fe0',
  '62bd',
  '663c',
  '67f1',
  '6ce8',
  '866b',
  '8877',
  '8a3b',
  '914e',
  '92f3',
  '99d0',
  '6a17',
  '7026',
  '732a',
  '82e7',
  '8457',
  '8caf',
  '4e01',
  '5146',
  '51cb',
  '558b',
  '5bf5',
  '5e16',
  '5e33',
  '5e81',
  '5f14',
  '5f35',
  '5f6b',
  '5fb4',
  '61f2',
  '6311',
  '66a2',
  '671d',
  '6f6e',
  '7252',
  '753a',
  '773a',
  '8074',
  '8139',
  '8178',
  '8776',
  '8abf',
  '8adc',
  '8d85',
  '8df3',
  '929a',
  '9577',
  '9802',
  '9ce5',
  '52c5',
  '6357',
  '76f4',
  '6715',
  '6c88',
  '73cd',
  '8cc3',
  '93ae',
  '9673',
  '6d25',
  '589c',
  '690e',
  '69cc',
  '8ffd',
  '939a',
  '75db',
  '901a',
  '585a',
  '6802',
  '63b4',
  '69fb',
  '4f43',
  '6f2c',
  '67d8',
  '8fbb',
  '8526',
  '7db4',
  '9354',
  '693f',
  '6f70',
  '576a',
  '58f7',
  '5b2c',
  '7d2c',
  '722a',
  '540a',
  '91e3',
  '9db4',
  '4ead',
  '4f4e',
  '505c',
  '5075',
  '5243',
  '8c9e',
  '5448',
  '5824',
  '5b9a',
  '5e1d',
  '5e95',
  '5ead',
  '5ef7',
  '5f1f',
  '608c',
  '62b5',
  '633a',
  '63d0',
  '68af',
  '6c40',
  '7887',
  '798e',
  '7a0b',
  '7de0',
  '8247',
  '8a02',
  '8ae6',
  '8e44',
  '9013',
  '90b8',
  '912d',
  '91d8',
  '9f0e',
  '6ce5',
  '6458',
  '64e2',
  '6575',
  '6ef4',
  '7684',
  '7b1b',
  '9069',
  '93d1',
  '6eba',
  '54f2',
  '5fb9',
  '64a4',
  '8f4d',
  '8fed',
  '9244',
  '5178',
  '586b',
  '5929',
  '5c55',
  '5e97',
  '6dfb',
  '7e8f',
  '751c',
  '8cbc',
  '8ee2',
  '985b',
  '70b9',
  '4f1d',
  '6bbf',
  '6fb1',
  '7530',
  '96fb',
  '514e',
  '5410',
  '5835',
  '5857',
  '59ac',
  '5c60',
  '5f92',
  '6597',
  '675c',
  '6e21',
  '767b',
  '83df',
  '8ced',
  '9014',
  '90fd',
  '934d',
  '7825',
  '783a',
  '52aa',
  '5ea6',
  '571f',
  '5974',
  '6012',
  '5012',
  '515a',
  '51ac',
  '51cd',
  '5200',
  '5510',
  '5854',
  '5858',
  '5957',
  '5b95',
  '5cf6',
  '5d8b',
  '60bc',
  '6295',
  '642d',
  '6771',
  '6843',
  '68bc',
  '68df',
  '76d7',
  '6dd8',
  '6e6f',
  '6d9b',
  '706f',
  '71c8',
  '5f53',
  '75d8',
  '7977',
  '7b49',
  '7b54',
  '7b52',
  '7cd6',
  '7d71',
  '5230',
  '8463',
  '8569',
  '85e4',
  '8a0e',
  '8b04',
  '8c46',
  '8e0f',
  '9003',
  '900f',
  '9419',
  '9676',
  '982d',
  '9a30',
  '95d8',
  '50cd',
  '52d5',
  '540c',
  '5802',
  '5c0e',
  '61a7',
  '649e',
  '6d1e',
  '77b3',
  '7ae5',
  '80f4',
  '8404',
  '9053',
  '9285',
  '5ce0',
  '9d07',
  '533f',
  '5f97',
  '5fb3',
  '6d9c',
  '7279',
  '7763',
  '79bf',
  '7be4',
  '6bd2',
  '72ec',
  '8aad',
  '6803',
  '6a61',
  '51f8',
  '7a81',
  '6934',
  '5c4a',
  '9cf6',
  '82eb',
  '5bc5',
  '9149',
  '701e',
  '5678',
  '5c6f',
  '60c7',
  '6566',
  '6c8c',
  '8c5a',
  '9041',
  '9813',
  '5451',
  '66c7',
  '920d',
  '5948',
  '90a3',
  '5185',
  '4e4d',
  '51ea',
  '8599',
  '8b0e',
  '7058',
  '637a',
  '934b',
  '6962',
  '99b4',
  '7e04',
  '7577',
  '5357',
  '6960',
  '8edf',
  '96e3',
  '6c5d',
  '4e8c',
  '5c3c',
  '5f10',
  '8fe9',
  '5302',
  '8cd1',
  '8089',
  '8679',
  '5eff',
  '65e5',
  '4e73',
  '5165',
  '5982',
  '5c3f',
  '97ee',
  '4efb',
  '598a',
  '5fcd',
  '8a8d',
  '6fe1',
  '79b0',
  '7962',
  '5be7',
  '8471',
  '732b',
  '71b1',
  '5e74',
  '5ff5',
  '637b',
  '649a',
  '71c3',
  '7c98',
  '4e43',
  '5efc',
  '4e4b',
  '57dc',
  '56a2',
  '60a9',
  '6fc3',
  '7d0d',
  '80fd',
  '8133',
  '81bf',
  '8fb2',
  '8997',
  '86a4',
  '5df4',
  '628a',
  '64ad',
  '8987',
  '6777',
  '6ce2',
  '6d3e',
  '7436',
  '7834',
  '5a46',
  '7f75',
  '82ad',
  '99ac',
  '4ff3',
  '5ec3',
  '62dd',
  '6392',
  '6557',
  '676f',
  '76c3',
  '724c',
  '80cc',
  '80ba',
  '8f29',
  '914d',
  '500d',
  '57f9',
  '5a92',
  '6885',
  '6973',
  '7164',
  '72fd',
  '8cb7',
  '58f2',
  '8ce0',
  '966a',
  '9019',
  '877f',
  '79e4',
  '77e7',
  '8429',
  '4f2f',
  '5265',
  '535a',
  '62cd',
  '67cf',
  '6cca',
  '767d',
  '7b94',
  '7c95',
  '8236',
  '8584',
  '8feb',
  '66dd',
  '6f20',
  '7206',
  '7e1b',
  '83ab',
  '99c1',
  '9ea6',
  '51fd',
  '7bb1',
  '7872',
  '7bb8',
  '8087',
  '7b48',
  '6ae8',
  '5e61',
  '808c',
  '7551',
  '7560',
  '516b',
  '9262',
  '6e8c',
  '767a',
  '9197',
  '9aea',
  '4f10',
  '7f70',
  '629c',
  '7b4f',
  '95a5',
  '9ce9',
  '567a',
  '5859',
  '86e4',
  '96bc',
  '4f34',
  '5224',
  '534a',
  '53cd',
  '53db',
  '5e06',
  '642c',
  '6591',
  '677f',
  '6c3e',
  '6c4e',
  '7248',
  '72af',
  '73ed',
  '7554',
  '7e41',
  '822c',
  '85e9',
  '8ca9',
  '7bc4',
  '91c6',
  '7169',
  '9812',
  '98ef',
  '633d',
  '6669',
  '756a',
  '76e4',
  '78d0',
  '8543',
  '86ee',
  '532a',
  '5351',
  '5426',
  '5983',
  '5e87',
  '5f7c',
  '60b2',
  '6249',
  '6279',
  '62ab',
  '6590',
  '6bd4',
  '6ccc',
  '75b2',
  '76ae',
  '7891',
  '79d8',
  '7dcb',
  '7f77',
  '80a5',
  '88ab',
  '8ab9',
  '8cbb',
  '907f',
  '975e',
  '98db',
  '6a0b',
  '7c38',
  '5099',
  '5c3e',
  '5fae',
  '6787',
  '6bd8',
  '7435',
  '7709',
  '7f8e',
  '9f3b',
  '67ca',
  '7a17',
  '5339',
  '758b',
  '9aed',
  '5f66',
  '819d',
  '83f1',
  '8098',
  '5f3c',
  '5fc5',
  '7562',
  '7b46',
  '903c',
  '6867',
  '59eb',
  '5a9b',
  '7d10',
  '767e',
  '8b2c',
  '4ff5',
  '5f6a',
  '6a19',
  '6c37',
  '6f02',
  '74e2',
  '7968',
  '8868',
  '8a55',
  '8c79',
  '5edf',
  '63cf',
  '75c5',
  '79d2',
  '82d7',
  '9328',
  '92f2',
  '849c',
  '86ed',
  '9c2d',
  '54c1',
  '5f6c',
  '658c',
  '6d5c',
  '7015',
  '8ca7',
  '8cd3',
  '983b',
  '654f',
  '74f6',
  '4e0d',
  '4ed8',
  '57e0',
  '592b',
  '5a66',
  '5bcc',
  '51a8',
  '5e03',
  '5e9c',
  '6016',
  '6276',
  '6577',
  '65a7',
  '666e',
  '6d6e',
  '7236',
  '7b26',
  '8150',
  '819a',
  '8299',
  '8b5c',
  '8ca0',
  '8ce6',
  '8d74',
  '961c',
  '9644',
  '4fae',
  '64ab',
  '6b66',
  '821e',
  '8461',
  '856a',
  '90e8',
  '5c01',
  '6953',
  '98a8',
  '847a',
  '8557',
  '4f0f',
  '526f',
  '5fa9',
  '5e45',
  '670d',
  '798f',
  '8179',
  '8907',
  '8986',
  '6df5',
  '5f17',
  '6255',
  '6cb8',
  '4ecf',
  '7269',
  '9b92',
  '5206',
  '543b',
  '5674',
  '58b3',
  '61a4',
  '626e',
  '711a',
  '596e',
  '7c89',
  '7cde',
  '7d1b',
  '96f0',
  '6587',
  '805e',
  '4e19',
  '4f75',
  '5175',
  '5840',
  '5e63',
  '5e73',
  '5f0a',
  '67c4',
  '4e26',
  '853d',
  '9589',
  '965b',
  '7c73',
  '9801',
  '50fb',
  '58c1',
  '7656',
  '78a7',
  '5225',
  '77a5',
  '8511',
  '7b86',
  '504f',
  '5909',
  '7247',
  '7bc7',
  '7de8',
  '8fba',
  '8fd4',
  '904d',
  '4fbf',
  '52c9',
  '5a29',
  '5f01',
  '97ad',
  '4fdd',
  '8217',
  '92ea',
  '5703',
  '6355',
  '6b69',
  '752b',
  '88dc',
  '8f14',
  '7a42',
  '52df',
  '5893',
  '6155',
  '620a',
  '66ae',
  '6bcd',
  '7c3f',
  '83e9',
  '5023',
  '4ff8',
  '5305',
  '5446',
  '5831',
  '5949',
  '5b9d',
  '5cf0',
  '5cef',
  '5d29',
  '5e96',
  '62b1',
  '6367',
  '653e',
  '65b9',
  '670b',
  '6cd5',
  '6ce1',
  '70f9',
  '7832',
  '7e2b',
  '80de',
  '82b3',
  '840c',
  '84ec',
  '8702',
  '8912',
  '8a2a',
  '8c4a',
  '90a6',
  '92d2',
  '98fd',
  '9cf3',
  '9d6c',
  '4e4f',
  '4ea1',
  '508d',
  '5256',
  '574a',
  '59a8',
  '5e3d',
  '5fd8',
  '5fd9',
  '623f',
  '66b4',
  '671b',
  '67d0',
  '68d2',
  '5192',
  '7d21',
  '80aa',
  '81a8',
  '8b00',
  '8c8c',
  '8cbf',
  '927e',
  '9632',
  '5420',
  '982c',
  '5317',
  '50d5',
  '535c',
  '58a8',
  '64b2',
  '6734',
  '7267',
  '7766',
  '7a46',
  '91e6',
  '52c3',
  '6ca1',
  '6b86',
  '5800',
  '5e4c',
  '5954',
  '672c',
  '7ffb',
  '51e1',
  '76c6',
  '6469',
  '78e8',
  '9b54',
  '9ebb',
  '57cb',
  '59b9',
  '6627',
  '679a',
  '6bce',
  '54e9',
  '69d9',
  '5e55',
  '819c',
  '6795',
  '9baa',
  '67fe',
  '9c52',
  '685d',
  '4ea6',
  '4fe3',
  '53c8',
  '62b9',
  '672b',
  '6cab',
  '8fc4',
  '4fad',
  '7e6d',
  '9ebf',
  '4e07',
  '6162',
  '6e80',
  '6f2b',
  '8513',
  '5473',
  '672a',
  '9b45',
  '5df3',
  '7b95',
  '5cac',
  '5bc6',
  '871c',
  '6e4a',
  '84d1',
  '7a14',
  '8108',
  '5999',
  '7c8d',
  '6c11',
  '7720',
  '52d9',
  '5922',
  '7121',
  '725f',
  '77db',
  '9727',
  '9d61',
  '690b',
  '5a7f',
  '5a18',
  '51a5',
  '540d',
  '547d',
  '660e',
  '76df',
  '8ff7',
  '9298',
  '9cf4',
  '59ea',
  '725d',
  '6ec5',
  '514d',
  '68c9',
  '7dbf',
  '7dec',
  '9762',
  '9eba',
  '6478',
  '6a21',
  '8302',
  '5984',
  '5b5f',
  '6bdb',
  '731b',
  '76f2',
  '7db2',
  '8017',
  '8499',
  '5132',
  '6728',
  '9ed9',
  '76ee',
  '6762',
  '52ff',
  '9905',
  '5c24',
  '623b',
  '7c7e',
  '8cb0',
  '554f',
  '60b6',
  '7d0b',
  '9580',
  '5301',
  '4e5f',
  '51b6',
  '591c',
  '723a',
  '8036',
  '91ce',
  '5f25',
  '77e2',
  '5384',
  '5f79',
  '7d04',
  '85ac',
  '8a33',
  '8e8d',
  '9756',
  '67f3',
  '85ae',
  '9453',
  '6109',
  '6108',
  '6cb9',
  '7652',
  '8aed',
  '8f38',
  '552f',
  '4f51',
  '512a',
  '52c7',
  '53cb',
  '5ba5',
  '5e7d',
  '60a0',
  '6182',
  '63d6',
  '6709',
  '67da',
  '6e67',
  '6d8c',
  '7336',
  '7337',
  '7531',
  '7950',
  '88d5',
  '8a98',
  '904a',
  '9091',
  '90f5',
  '96c4',
  '878d',
  '5915',
  '4e88',
  '4f59',
  '4e0e',
  '8a89',
  '8f3f',
  '9810',
  '50ad',
  '5e7c',
  '5996',
  '5bb9',
  '5eb8',
  '63da',
  '63fa',
  '64c1',
  '66dc',
  '694a',
  '69d8',
  '6d0b',
  '6eb6',
  '7194',
  '7528',
  '7aaf',
  '7f8a',
  '8000',
  '8449',
  '84c9',
  '8981',
  '8b21',
  '8e0a',
  '9065',
  '967d',
  '990a',
  '617e',
  '6291',
  '6b32',
  '6c83',
  '6d74',
  '7fcc',
  '7ffc',
  '6dc0',
  '7f85',
  '87ba',
  '88f8',
  '6765',
  '83b1',
  '983c',
  '96f7',
  '6d1b',
  '7d61',
  '843d',
  '916a',
  '4e71',
  '5375',
  '5d50',
  '6b04',
  '6feb',
  '85cd',
  '862d',
  '89a7',
  '5229',
  '540f',
  '5c65',
  '674e',
  '68a8',
  '7406',
  '7483',
  '75e2',
  '88cf',
  '88e1',
  '91cc',
  '96e2',
  '9678',
  '5f8b',
  '7387',
  '7acb',
  '844e',
  '63a0',
  '7565',
  '5289',
  '6d41',
  '6e9c',
  '7409',
  '7559',
  '786b',
  '7c92',
  '9686',
  '7adc',
  '9f8d',
  '4fb6',
  '616e',
  '65c5',
  '865c',
  '4e86',
  '4eae',
  '50da',
  '4e21',
  '51cc',
  '5bee',
  '6599',
  '6881',
  '6dbc',
  '731f',
  '7642',
  '77ad',
  '7a1c',
  '7ce7',
  '826f',
  '8ad2',
  '907c',
  '91cf',
  '9675',
  '9818',
  '529b',
  '7dd1',
  '502b',
  '5398',
  '6797',
  '6dcb',
  '71d0',
  '7433',
  '81e8',
  '8f2a',
  '96a3',
  '9c57',
  '9e9f',
  '7460',
  '5841',
  '6d99',
  '7d2f',
  '985e',
  '4ee4',
  '4f36',
  '4f8b',
  '51b7',
  '52b1',
  '5dba',
  '601c',
  '73b2',
  '793c',
  '82d3',
  '9234',
  '96b7',
  '96f6',
  '970a',
  '9e97',
  '9f62',
  '66a6',
  '6b74',
  '5217',
  '52a3',
  '70c8',
  '88c2',
  '5ec9',
  '604b',
  '6190',
  '6f23',
  '7149',
  '7c3e',
  '7df4',
  '806f',
  '84ee',
  '9023',
  '932c',
  '5442',
  '9b6f',
  '6ad3',
  '7089',
  '8cc2',
  '8def',
  '9732',
  '52b4',
  '5a41',
  '5eca',
  '5f04',
  '6717',
  '697c',
  '6994',
  '6d6a',
  '6f0f',
  '7262',
  '72fc',
  '7bed',
  '8001',
  '807e',
  '874b',
  '90ce',
  '516d',
  '9e93',
  '7984',
  '808b',
  '9332',
  '8ad6',
  '502d',
  '548c',
  '8a71',
  '6b6a',
  '8cc4',
  '8107',
  '60d1',
  '67a0',
  '9df2',
  '4e99',
  '4e98',
  '9c10',
  '8a6b',
  '85c1',
  '8568',
  '6900',
  '6e7e',
  '7897',
  '8155',
  '5f0c',
  '4e10',
  '4e15',
  '4e2a',
  '4e31',
  '4e36',
  '4e3c',
  '4e3f',
  '4e42',
  '4e56',
  '4e58',
  '4e82',
  '4e85',
  '8c6b',
  '4e8a',
  '8212',
  '5f0d',
  '4e8e',
  '4e9e',
  '4e9f',
  '4ea0',
  '4ea2',
  '4eb0',
  '4eb3',
  '4eb6',
  '4ece',
  '4ecd',
  '4ec4',
  '4ec6',
  '4ec2',
  '4ed7',
  '4ede',
  '4eed',
  '4edf',
  '4ef7',
  '4f09',
  '4f5a',
  '4f30',
  '4f5b',
  '4f5d',
  '4f57',
  '4f47',
  '4f76',
  '4f88',
  '4f8f',
  '4f98',
  '4f7b',
  '4f69',
  '4f70',
  '4f91',
  '4f6f',
  '4f86',
  '4f96',
  '5118',
  '4fd4',
  '4fdf',
  '4fce',
  '4fd8',
  '4fdb',
  '4fd1',
  '4fda',
  '4fd0',
  '4fe4',
  '4fe5',
  '501a',
  '5028',
  '5014',
  '502a',
  '5025',
  '5005',
  '4f1c',
  '4ff6',
  '5021',
  '5029',
  '502c',
  '4ffe',
  '4fef',
  '5011',
  '5006',
  '5043',
  '5047',
  '6703',
  '5055',
  '5050',
  '5048',
  '505a',
  '5056',
  '506c',
  '5078',
  '5080',
  '509a',
  '5085',
  '50b4',
  '50b2',
  '50c9',
  '50ca',
  '50b3',
  '50c2',
  '50d6',
  '50de',
  '50e5',
  '50ed',
  '50e3',
  '50ee',
  '50f9',
  '50f5',
  '5109',
  '5101',
  '5102',
  '5116',
  '5115',
  '5114',
  '511a',
  '5121',
  '513a',
  '5137',
  '513c',
  '513b',
  '513f',
  '5140',
  '5152',
  '514c',
  '5154',
  '5162',
  '7af8',
  '5169',
  '516a',
  '516e',
  '5180',
  '5182',
  '56d8',
  '518c',
  '5189',
  '518f',
  '5191',
  '5193',
  '5195',
  '5196',
  '51a4',
  '51a6',
  '51a2',
  '51a9',
  '51aa',
  '51ab',
  '51b3',
  '51b1',
  '51b2',
  '51b0',
  '51b5',
  '51bd',
  '51c5',
  '51c9',
  '51db',
  '51e0',
  '8655',
  '51e9',
  '51ed',
  '51f0',
  '51f5',
  '51fe',
  '5204',
  '520b',
  '5214',
  '520e',
  '5227',
  '522a',
  '522e',
  '5233',
  '5239',
  '524f',
  '5244',
  '524b',
  '524c',
  '525e',
  '5254',
  '526a',
  '5274',
  '5269',
  '5273',
  '527f',
  '527d',
  '528d',
  '5294',
  '5292',
  '5271',
  '5288',
  '5291',
  '8fa8',
  '8fa7',
  '52ac',
  '52ad',
  '52bc',
  '52b5',
  '52c1',
  '52cd',
  '52d7',
  '52de',
  '52e3',
  '52e6',
  '98ed',
  '52e0',
  '52f3',
  '52f5',
  '52f8',
  '52f9',
  '5306',
  '5308',
  '7538',
  '530d',
  '5310',
  '530f',
  '5315',
  '531a',
  '5323',
  '532f',
  '5331',
  '5333',
  '5338',
  '5340',
  '5346',
  '5345',
  '4e17',
  '5349',
  '534d',
  '51d6',
  '535e',
  '5369',
  '536e',
  '5918',
  '537b',
  '5377',
  '5382',
  '5396',
  '53a0',
  '53a6',
  '53a5',
  '53ae',
  '53b0',
  '53b6',
  '53c3',
  '7c12',
  '96d9',
  '53df',
  '66fc',
  '71ee',
  '53ee',
  '53e8',
  '53ed',
  '53fa',
  '5401',
  '543d',
  '5440',
  '542c',
  '542d',
  '543c',
  '542e',
  '5436',
  '5429',
  '541d',
  '544e',
  '548f',
  '5475',
  '548e',
  '545f',
  '5471',
  '5477',
  '5470',
  '5492',
  '547b',
  '5480',
  '5476',
  '5484',
  '5490',
  '5486',
  '54c7',
  '54a2',
  '54b8',
  '54a5',
  '54ac',
  '54c4',
  '54c8',
  '54a8',
  '54ab',
  '54c2',
  '54a4',
  '54be',
  '54bc',
  '54d8',
  '54e5',
  '54e6',
  '550f',
  '5514',
  '54fd',
  '54ee',
  '54ed',
  '54fa',
  '54e2',
  '5539',
  '5540',
  '5563',
  '554c',
  '552e',
  '555c',
  '5545',
  '5556',
  '5557',
  '5538',
  '5533',
  '555d',
  '5599',
  '5580',
  '54af',
  '558a',
  '559f',
  '557b',
  '557e',
  '5598',
  '559e',
  '55ae',
  '557c',
  '5583',
  '55a9',
  '5587',
  '55a8',
  '55da',
  '55c5',
  '55df',
  '55c4',
  '55dc',
  '55e4',
  '55d4',
  '5614',
  '55f7',
  '5616',
  '55fe',
  '55fd',
  '561b',
  '55f9',
  '564e',
  '5650',
  '71df',
  '5634',
  '5636',
  '5632',
  '5638',
  '566b',
  '5664',
  '562f',
  '566c',
  '566a',
  '5686',
  '5680',
  '568a',
  '56a0',
  '5694',
  '568f',
  '56a5',
  '56ae',
  '56b6',
  '56b4',
  '56c2',
  '56bc',
  '56c1',
  '56c3',
  '56c0',
  '56c8',
  '56ce',
  '56d1',
  '56d3',
  '56d7',
  '56ee',
  '56f9',
  '5700',
  '56ff',
  '5704',
  '5709',
  '5708',
  '570b',
  '570d',
  '5713',
  '5718',
  '5716',
  '55c7',
  '571c',
  '5726',
  '5737',
  '5738',
  '574e',
  '573b',
  '5740',
  '574f',
  '5769',
  '57c0',
  '5788',
  '5761',
  '577f',
  '5789',
  '5793',
  '57a0',
  '57b3',
  '57a4',
  '57aa',
  '57b0',
  '57c3',
  '57c6',
  '57d4',
  '57d2',
  '57d3',
  '580a',
  '57d6',
  '57e3',
  '580b',
  '5819',
  '581d',
  '5872',
  '5821',
  '5862',
  '584b',
  '5870',
  '6bc0',
  '5852',
  '583d',
  '5879',
  '5885',
  '58b9',
  '589f',
  '58ab',
  '58ba',
  '58de',
  '58bb',
  '58b8',
  '58ae',
  '58c5',
  '58d3',
  '58d1',
  '58d7',
  '58d9',
  '58d8',
  '58e5',
  '58dc',
  '58e4',
  '58df',
  '58ef',
  '58fa',
  '58f9',
  '58fb',
  '58fc',
  '58fd',
  '5902',
  '590a',
  '5910',
  '591b',
  '68a6',
  '5925',
  '592c',
  '592d',
  '5932',
  '5938',
  '593e',
  '7ad2',
  '5955',
  '5950',
  '594e',
  '595a',
  '5958',
  '5962',
  '5960',
  '5967',
  '596c',
  '5969',
  '5978',
  '5981',
  '599d',
  '4f5e',
  '4fab',
  '59a3',
  '59b2',
  '59c6',
  '59e8',
  '59dc',
  '598d',
  '59d9',
  '59da',
  '5a25',
  '5a1f',
  '5a11',
  '5a1c',
  '5a09',
  '5a1a',
  '5a40',
  '5a6c',
  '5a49',
  '5a35',
  '5a36',
  '5a62',
  '5a6a',
  '5a9a',
  '5abc',
  '5abe',
  '5acb',
  '5ac2',
  '5abd',
  '5ae3',
  '5ad7',
  '5ae6',
  '5ae9',
  '5ad6',
  '5afa',
  '5afb',
  '5b0c',
  '5b0b',
  '5b16',
  '5b32',
  '5ad0',
  '5b2a',
  '5b36',
  '5b3e',
  '5b43',
  '5b45',
  '5b40',
  '5b51',
  '5b55',
  '5b5a',
  '5b5b',
  '5b65',
  '5b69',
  '5b70',
  '5b73',
  '5b75',
  '5b78',
  '6588',
  '5b7a',
  '5b80',
  '5b83',
  '5ba6',
  '5bb8',
  '5bc3',
  '5bc7',
  '5bc9',
  '5bd4',
  '5bd0',
  '5be4',
  '5be6',
  '5be2',
  '5bde',
  '5be5',
  '5beb',
  '5bf0',
  '5bf6',
  '5bf3',
  '5c05',
  '5c07',
  '5c08',
  '5c0d',
  '5c13',
  '5c20',
  '5c22',
  '5c28',
  '5c38',
  '5c39',
  '5c41',
  '5c46',
  '5c4e',
  '5c53',
  '5c50',
  '5c4f',
  '5b71',
  '5c6c',
  '5c6e',
  '4e62',
  '5c76',
  '5c79',
  '5c8c',
  '5c91',
  '5c94',
  '599b',
  '5cab',
  '5cbb',
  '5cb6',
  '5cbc',
  '5cb7',
  '5cc5',
  '5cbe',
  '5cc7',
  '5cd9',
  '5ce9',
  '5cfd',
  '5cfa',
  '5ced',
  '5d8c',
  '5cea',
  '5d0b',
  '5d15',
  '5d17',
  '5d5c',
  '5d1f',
  '5d1b',
  '5d11',
  '5d14',
  '5d22',
  '5d1a',
  '5d19',
  '5d18',
  '5d4c',
  '5d52',
  '5d4e',
  '5d4b',
  '5d6c',
  '5d73',
  '5d76',
  '5d87',
  '5d84',
  '5d82',
  '5da2',
  '5d9d',
  '5dac',
  '5dae',
  '5dbd',
  '5d90',
  '5db7',
  '5dbc',
  '5dc9',
  '5dcd',
  '5dd3',
  '5dd2',
  '5dd6',
  '5ddb',
  '5deb',
  '5df2',
  '5df5',
  '5e0b',
  '5e1a',
  '5e19',
  '5e11',
  '5e1b',
  '5e36',
  '5e37',
  '5e44',
  '5e43',
  '5e40',
  '5e4e',
  '5e57',
  '5e54',
  '5e5f',
  '5e62',
  '5e64',
  '5e47',
  '5e75',
  '5e76',
  '5e7a',
  '9ebc',
  '5e7f',
  '5ea0',
  '5ec1',
  '5ec2',
  '5ec8',
  '5ed0',
  '5ecf',
  '5ed6',
  '5ee3',
  '5edd',
  '5eda',
  '5edb',
  '5ee2',
  '5ee1',
  '5ee8',
  '5ee9',
  '5eec',
  '5ef1',
  '5ef3',
  '5ef0',
  '5ef4',
  '5ef8',
  '5efe',
  '5f03',
  '5f09',
  '5f5d',
  '5f5c',
  '5f0b',
  '5f11',
  '5f16',
  '5f29',
  '5f2d',
  '5f38',
  '5f41',
  '5f48',
  '5f4c',
  '5f4e',
  '5f2f',
  '5f51',
  '5f56',
  '5f57',
  '5f59',
  '5f61',
  '5f6d',
  '5f73',
  '5f77',
  '5f83',
  '5f82',
  '5f7f',
  '5f8a',
  '5f88',
  '5f91',
  '5f87',
  '5f9e',
  '5f99',
  '5f98',
  '5fa0',
  '5fa8',
  '5fad',
  '5fbc',
  '5fd6',
  '5ffb',
  '5fe4',
  '5ff8',
  '5ff1',
  '5fdd',
  '60b3',
  '5fff',
  '6021',
  '6060',
  '6019',
  '6010',
  '6029',
  '600e',
  '6031',
  '601b',
  '6015',
  '602b',
  '6026',
  '600f',
  '603a',
  '605a',
  '6041',
  '606a',
  '6077',
  '605f',
  '604a',
  '6046',
  '604d',
  '6063',
  '6043',
  '6064',
  '6042',
  '606c',
  '606b',
  '6059',
  '6081',
  '608d',
  '60e7',
  '6083',
  '609a',
  '6084',
  '609b',
  '6096',
  '6097',
  '6092',
  '60a7',
  '608b',
  '60e1',
  '60b8',
  '60e0',
  '60d3',
  '60b4',
  '5ff0',
  '60bd',
  '60c6',
  '60b5',
  '60d8',
  '614d',
  '6115',
  '6106',
  '60f6',
  '60f7',
  '6100',
  '60f4',
  '60fa',
  '6103',
  '6121',
  '60fb',
  '60f1',
  '610d',
  '610e',
  '6147',
  '613e',
  '6128',
  '6127',
  '614a',
  '613f',
  '613c',
  '612c',
  '6134',
  '613d',
  '6142',
  '6144',
  '6173',
  '6177',
  '6158',
  '6159',
  '615a',
  '616b',
  '6174',
  '616f',
  '6165',
  '6171',
  '615f',
  '615d',
  '6153',
  '6175',
  '6199',
  '6196',
  '6187',
  '61ac',
  '6194',
  '619a',
  '618a',
  '6191',
  '61ab',
  '61ae',
  '61cc',
  '61ca',
  '61c9',
  '61f7',
  '61c8',
  '61c3',
  '61c6',
  '61ba',
  '61cb',
  '7f79',
  '61cd',
  '61e6',
  '61e3',
  '61f6',
  '61fa',
  '61f4',
  '61ff',
  '61fd',
  '61fc',
  '61fe',
  '6200',
  '6208',
  '6209',
  '620d',
  '620c',
  '6214',
  '621b',
  '621e',
  '6221',
  '622a',
  '622e',
  '6230',
  '6232',
  '6233',
  '6241',
  '624e',
  '625e',
  '6263',
  '625b',
  '6260',
  '6268',
  '627c',
  '6282',
  '6289',
  '627e',
  '6292',
  '6293',
  '6296',
  '62d4',
  '6283',
  '6294',
  '62d7',
  '62d1',
  '62bb',
  '62cf',
  '62ff',
  '62c6',
  '64d4',
  '62c8',
  '62dc',
  '62cc',
  '62ca',
  '62c2',
  '62c7',
  '629b',
  '62c9',
  '630c',
  '62ee',
  '62f1',
  '6327',
  '6302',
  '6308',
  '62ef',
  '62f5',
  '6350',
  '633e',
  '634d',
  '641c',
  '634f',
  '6396',
  '638e',
  '6380',
  '63ab',
  '6376',
  '63a3',
  '638f',
  '6389',
  '639f',
  '63b5',
  '636b',
  '6369',
  '63be',
  '63e9',
  '63c0',
  '63c6',
  '63e3',
  '63c9',
  '63d2',
  '63f6',
  '63c4',
  '6416',
  '6434',
  '6406',
  '6413',
  '6426',
  '6436',
  '651d',
  '6417',
  '6428',
  '640f',
  '6467',
  '646f',
  '6476',
  '644e',
  '652a',
  '6495',
  '6493',
  '64a5',
  '64a9',
  '6488',
  '64bc',
  '64da',
  '64d2',
  '64c5',
  '64c7',
  '64bb',
  '64d8',
  '64c2',
  '64f1',
  '64e7',
  '8209',
  '64e0',
  '64e1',
  '62ac',
  '64e3',
  '64ef',
  '652c',
  '64f6',
  '64f4',
  '64f2',
  '64fa',
  '6500',
  '64fd',
  '6518',
  '651c',
  '6505',
  '6524',
  '6523',
  '652b',
  '6534',
  '6535',
  '6537',
  '6536',
  '6538',
  '754b',
  '6548',
  '6556',
  '6555',
  '654d',
  '6558',
  '655e',
  '655d',
  '6572',
  '6578',
  '6582',
  '6583',
  '8b8a',
  '659b',
  '659f',
  '65ab',
  '65b7',
  '65c3',
  '65c6',
  '65c1',
  '65c4',
  '65cc',
  '65d2',
  '65db',
  '65d9',
  '65e0',
  '65e1',
  '65f1',
  '6772',
  '660a',
  '6603',
  '65fb',
  '6773',
  '6635',
  '6636',
  '6634',
  '661c',
  '664f',
  '6644',
  '6649',
  '6641',
  '665e',
  '665d',
  '6664',
  '6667',
  '6668',
  '665f',
  '6662',
  '6670',
  '6683',
  '6688',
  '668e',
  '6689',
  '6684',
  '6698',
  '669d',
  '66c1',
  '66b9',
  '66c9',
  '66be',
  '66bc',
  '66c4',
  '66b8',
  '66d6',
  '66da',
  '66e0',
  '663f',
  '66e6',
  '66e9',
  '66f0',
  '66f5',
  '66f7',
  '670f',
  '6716',
  '671e',
  '6726',
  '6727',
  '9738',
  '672e',
  '673f',
  '6736',
  '6741',
  '6738',
  '6737',
  '6746',
  '675e',
  '6760',
  '6759',
  '6763',
  '6764',
  '6789',
  '6770',
  '67a9',
  '677c',
  '676a',
  '678c',
  '678b',
  '67a6',
  '67a1',
  '6785',
  '67b7',
  '67ef',
  '67b4',
  '67ec',
  '67b3',
  '67e9',
  '67b8',
  '67e4',
  '67de',
  '67dd',
  '67e2',
  '67ee',
  '67b9',
  '67ce',
  '67c6',
  '67e7',
  '6a9c',
  '681e',
  '6846',
  '6829',
  '6840',
  '684d',
  '6832',
  '684e',
  '68b3',
  '682b',
  '6859',
  '6863',
  '6877',
  '687f',
  '689f',
  '688f',
  '68ad',
  '6894',
  '689d',
  '689b',
  '6883',
  '6aae',
  '68b9',
  '6874',
  '68b5',
  '68a0',
  '68ba',
  '690f',
  '688d',
  '687e',
  '6901',
  '68ca',
  '6908',
  '68d8',
  '6922',
  '6926',
  '68e1',
  '690c',
  '68cd',
  '68d4',
  '68e7',
  '68d5',
  '6936',
  '6912',
  '6904',
  '68d7',
  '68e3',
  '6925',
  '68f9',
  '68e0',
  '68ef',
  '6928',
  '692a',
  '691a',
  '6923',
  '6921',
  '68c6',
  '6979',
  '6977',
  '695c',
  '6978',
  '696b',
  '6954',
  '697e',
  '696e',
  '6939',
  '6974',
  '693d',
  '6959',
  '6930',
  '6961',
  '695e',
  '695d',
  '6981',
  '696a',
  '69b2',
  '69ae',
  '69d0',
  '69bf',
  '69c1',
  '69d3',
  '69be',
  '69ce',
  '5be8',
  '69ca',
  '69dd',
  '69bb',
  '69c3',
  '69a7',
  '6a2e',
  '6991',
  '69a0',
  '699c',
  '6995',
  '69b4',
  '69de',
  '69e8',
  '6a02',
  '6a1b',
  '69ff',
  '6b0a',
  '69f9',
  '69f2',
  '69e7',
  '6a05',
  '69b1',
  '6a1e',
  '69ed',
  '6a14',
  '69eb',
  '6a0a',
  '6a12',
  '6ac1',
  '6a23',
  '6a13',
  '6a44',
  '6a0c',
  '6a72',
  '6a36',
  '6a78',
  '6a47',
  '6a62',
  '6a59',
  '6a66',
  '6a48',
  '6a38',
  '6a22',
  '6a90',
  '6a8d',
  '6aa0',
  '6a84',
  '6aa2',
  '6aa3',
  '6a97',
  '8617',
  '6abb',
  '6ac3',
  '6ac2',
  '6ab8',
  '6ab3',
  '6aac',
  '6ade',
  '6ad1',
  '6adf',
  '6aaa',
  '6ada',
  '6aea',
  '6afb',
  '6b05',
  '8616',
  '6afa',
  '6b12',
  '6b16',
  '9b31',
  '6b1f',
  '6b38',
  '6b37',
  '76dc',
  '6b39',
  '98ee',
  '6b47',
  '6b43',
  '6b49',
  '6b50',
  '6b59',
  '6b54',
  '6b5b',
  '6b5f',
  '6b61',
  '6b78',
  '6b79',
  '6b7f',
  '6b80',
  '6b84',
  '6b83',
  '6b8d',
  '6b98',
  '6b95',
  '6b9e',
  '6ba4',
  '6baa',
  '6bab',
  '6baf',
  '6bb2',
  '6bb1',
  '6bb3',
  '6bb7',
  '6bbc',
  '6bc6',
  '6bcb',
  '6bd3',
  '6bdf',
  '6bec',
  '6beb',
  '6bf3',
  '6bef',
  '9ebe',
  '6c08',
  '6c13',
  '6c14',
  '6c1b',
  '6c24',
  '6c23',
  '6c5e',
  '6c55',
  '6c62',
  '6c6a',
  '6c82',
  '6c8d',
  '6c9a',
  '6c81',
  '6c9b',
  '6c7e',
  '6c68',
  '6c73',
  '6c92',
  '6c90',
  '6cc4',
  '6cf1',
  '6cd3',
  '6cbd',
  '6cd7',
  '6cc5',
  '6cdd',
  '6cae',
  '6cb1',
  '6cbe',
  '6cba',
  '6cdb',
  '6cef',
  '6cd9',
  '6cea',
  '6d1f',
  '884d',
  '6d36',
  '6d2b',
  '6d3d',
  '6d38',
  '6d19',
  '6d35',
  '6d33',
  '6d12',
  '6d0c',
  '6d63',
  '6d93',
  '6d64',
  '6d5a',
  '6d79',
  '6d59',
  '6d8e',
  '6d95',
  '6fe4',
  '6d85',
  '6df9',
  '6e15',
  '6e0a',
  '6db5',
  '6dc7',
  '6de6',
  '6db8',
  '6dc6',
  '6dec',
  '6dde',
  '6dcc',
  '6de8',
  '6dd2',
  '6dc5',
  '6dfa',
  '6dd9',
  '6de4',
  '6dd5',
  '6dea',
  '6dee',
  '6e2d',
  '6e6e',
  '6e2e',
  '6e19',
  '6e72',
  '6e5f',
  '6e3e',
  '6e23',
  '6e6b',
  '6e2b',
  '6e76',
  '6e4d',
  '6e1f',
  '6e43',
  '6e3a',
  '6e4e',
  '6e24',
  '6eff',
  '6e1d',
  '6e38',
  '6e82',
  '6eaa',
  '6e98',
  '6ec9',
  '6eb7',
  '6ed3',
  '6ebd',
  '6eaf',
  '6ec4',
  '6eb2',
  '6ed4',
  '6ed5',
  '6e8f',
  '6ea5',
  '6ec2',
  '6e9f',
  '6f41',
  '6f11',
  '704c',
  '6eec',
  '6ef8',
  '6efe',
  '6f3f',
  '6ef2',
  '6f31',
  '6eef',
  '6f32',
  '6ecc',
  '6f3e',
  '6f13',
  '6ef7',
  '6f86',
  '6f7a',
  '6f78',
  '6f81',
  '6f80',
  '6f6f',
  '6f5b',
  '6ff3',
  '6f6d',
  '6f82',
  '6f7c',
  '6f58',
  '6f8e',
  '6f91',
  '6fc2',
  '6f66',
  '6fb3',
  '6fa3',
  '6fa1',
  '6fa4',
  '6fb9',
  '6fc6',
  '6faa',
  '6fdf',
  '6fd5',
  '6fec',
  '6fd4',
  '6fd8',
  '6ff1',
  '6fee',
  '6fdb',
  '7009',
  '700b',
  '6ffa',
  '7011',
  '7001',
  '700f',
  '6ffe',
  '701b',
  '701a',
  '6f74',
  '701d',
  '7018',
  '701f',
  '7030',
  '703e',
  '7032',
  '7051',
  '7063',
  '7099',
  '7092',
  '70af',
  '70f1',
  '70ac',
  '70b8',
  '70b3',
  '70ae',
  '70df',
  '70cb',
  '70dd',
  '70d9',
  '7109',
  '70fd',
  '711c',
  '7119',
  '7165',
  '7155',
  '7188',
  '7166',
  '7162',
  '714c',
  '7156',
  '716c',
  '718f',
  '71fb',
  '7184',
  '7195',
  '71a8',
  '71ac',
  '71d7',
  '71b9',
  '71be',
  '71d2',
  '71c9',
  '71d4',
  '71ce',
  '71e0',
  '71ec',
  '71e7',
  '71f5',
  '71fc',
  '71f9',
  '71ff',
  '720d',
  '7210',
  '721b',
  '7228',
  '722d',
  '722c',
  '7230',
  '7232',
  '723b',
  '723c',
  '723f',
  '7240',
  '7246',
  '724b',
  '7258',
  '7274',
  '727e',
  '7282',
  '7281',
  '7287',
  '7292',
  '7296',
  '72a2',
  '72a7',
  '72b9',
  '72b2',
  '72c3',
  '72c6',
  '72c4',
  '72ce',
  '72d2',
  '72e2',
  '72e0',
  '72e1',
  '72f9',
  '72f7',
  '500f',
  '7317',
  '730a',
  '731c',
  '7316',
  '731d',
  '7334',
  '732f',
  '7329',
  '7325',
  '733e',
  '734e',
  '734f',
  '9ed8',
  '7357',
  '736a',
  '7368',
  '7370',
  '7378',
  '7375',
  '737b',
  '737a',
  '73c8',
  '73b3',
  '73ce',
  '73bb',
  '73c0',
  '73e5',
  '73ee',
  '73de',
  '74a2',
  '7405',
  '746f',
  '7425',
  '73f8',
  '7432',
  '743a',
  '7455',
  '743f',
  '745f',
  '7459',
  '7441',
  '745c',
  '7469',
  '7470',
  '7463',
  '746a',
  '7476',
  '747e',
  '748b',
  '749e',
  '74a7',
  '74ca',
  '74cf',
  '74d4',
  '73f1',
  '74e0',
  '74e3',
  '74e7',
  '74e9',
  '74ee',
  '74f2',
  '74f0',
  '74f1',
  '74f8',
  '74f7',
  '7504',
  '7503',
  '7505',
  '750c',
  '750e',
  '750d',
  '7515',
  '7513',
  '751e',
  '7526',
  '752c',
  '753c',
  '7544',
  '754d',
  '754a',
  '7549',
  '755b',
  '7546',
  '755a',
  '7569',
  '7564',
  '7567',
  '756b',
  '756d',
  '7578',
  '7576',
  '7586',
  '7587',
  '7574',
  '758a',
  '7589',
  '7582',
  '7594',
  '759a',
  '759d',
  '75a5',
  '75a3',
  '75c2',
  '75b3',
  '75c3',
  '75b5',
  '75bd',
  '75b8',
  '75bc',
  '75b1',
  '75cd',
  '75ca',
  '75d2',
  '75d9',
  '75e3',
  '75de',
  '75fe',
  '75ff',
  '75fc',
  '7601',
  '75f0',
  '75fa',
  '75f2',
  '75f3',
  '760b',
  '760d',
  '7609',
  '761f',
  '7627',
  '7620',
  '7621',
  '7622',
  '7624',
  '7634',
  '7630',
  '763b',
  '7647',
  '7648',
  '7646',
  '765c',
  '7658',
  '7661',
  '7662',
  '7668',
  '7669',
  '766a',
  '7667',
  '766c',
  '7670',
  '7672',
  '7676',
  '7678',
  '767c',
  '7680',
  '7683',
  '7688',
  '768b',
  '768e',
  '7696',
  '7693',
  '7699',
  '769a',
  '76b0',
  '76b4',
  '76b8',
  '76b9',
  '76ba',
  '76c2',
  '76cd',
  '76d6',
  '76d2',
  '76de',
  '76e1',
  '76e5',
  '76e7',
  '76ea',
  '862f',
  '76fb',
  '7708',
  '7707',
  '7704',
  '7729',
  '7724',
  '771e',
  '7725',
  '7726',
  '771b',
  '7737',
  '7738',
  '7747',
  '775a',
  '7768',
  '776b',
  '775b',
  '7765',
  '777f',
  '777e',
  '7779',
  '778e',
  '778b',
  '7791',
  '77a0',
  '779e',
  '77b0',
  '77b6',
  '77b9',
  '77bf',
  '77bc',
  '77bd',
  '77bb',
  '77c7',
  '77cd',
  '77d7',
  '77da',
  '77dc',
  '77e3',
  '77ee',
  '77fc',
  '780c',
  '7812',
  '7926',
  '7820',
  '792a',
  '7845',
  '788e',
  '7874',
  '7886',
  '787c',
  '789a',
  '788c',
  '78a3',
  '78b5',
  '78aa',
  '78af',
  '78d1',
  '78c6',
  '78cb',
  '78d4',
  '78be',
  '78bc',
  '78c5',
  '78ca',
  '78ec',
  '78e7',
  '78da',
  '78fd',
  '78f4',
  '7907',
  '7912',
  '7911',
  '7919',
  '792c',
  '792b',
  '7940',
  '7960',
  '7957',
  '795f',
  '795a',
  '7955',
  '7953',
  '797a',
  '797f',
  '798a',
  '799d',
  '79a7',
  '9f4b',
  '79aa',
  '79ae',
  '79b3',
  '79b9',
  '79ba',
  '79c9',
  '79d5',
  '79e7',
  '79ec',
  '79e1',
  '79e3',
  '7a08',
  '7a0d',
  '7a18',
  '7a19',
  '7a20',
  '7a1f',
  '7980',
  '7a31',
  '7a3b',
  '7a3e',
  '7a37',
  '7a43',
  '7a57',
  '7a49',
  '7a61',
  '7a62',
  '7a69',
  '9f9d',
  '7a70',
  '7a79',
  '7a7d',
  '7a88',
  '7a97',
  '7a95',
  '7a98',
  '7a96',
  '7aa9',
  '7ac8',
  '7ab0',
  '7ab6',
  '7ac5',
  '7ac4',
  '7abf',
  '9083',
  '7ac7',
  '7aca',
  '7acd',
  '7acf',
  '7ad5',
  '7ad3',
  '7ad9',
  '7ada',
  '7add',
  '7ae1',
  '7ae2',
  '7ae6',
  '7aed',
  '7af0',
  '7b02',
  '7b0f',
  '7b0a',
  '7b06',
  '7b33',
  '7b18',
  '7b19',
  '7b1e',
  '7b35',
  '7b28',
  '7b36',
  '7b50',
  '7b7a',
  '7b04',
  '7b4d',
  '7b0b',
  '7b4c',
  '7b45',
  '7b75',
  '7b65',
  '7b74',
  '7b67',
  '7b70',
  '7b71',
  '7b6c',
  '7b6e',
  '7b9d',
  '7b98',
  '7b9f',
  '7b8d',
  '7b9c',
  '7b9a',
  '7b8b',
  '7b92',
  '7b8f',
  '7b5d',
  '7b99',
  '7bcb',
  '7bc1',
  '7bcc',
  '7bcf',
  '7bb4',
  '7bc6',
  '7bdd',
  '7be9',
  '7c11',
  '7c14',
  '7be6',
  '7be5',
  '7c60',
  '7c00',
  '7c07',
  '7c13',
  '7bf3',
  '7bf7',
  '7c17',
  '7c0d',
  '7bf6',
  '7c23',
  '7c27',
  '7c2a',
  '7c1f',
  '7c37',
  '7c2b',
  '7c3d',
  '7c4c',
  '7c43',
  '7c54',
  '7c4f',
  '7c40',
  '7c50',
  '7c58',
  '7c5f',
  '7c64',
  '7c56',
  '7c65',
  '7c6c',
  '7c75',
  '7c83',
  '7c90',
  '7ca4',
  '7cad',
  '7ca2',
  '7cab',
  '7ca1',
  '7ca8',
  '7cb3',
  '7cb2',
  '7cb1',
  '7cae',
  '7cb9',
  '7cbd',
  '7cc0',
  '7cc5',
  '7cc2',
  '7cd8',
  '7cd2',
  '7cdc',
  '7ce2',
  '9b3b',
  '7cef',
  '7cf2',
  '7cf4',
  '7cf6',
  '7cfa',
  '7d06',
  '7d02',
  '7d1c',
  '7d15',
  '7d0a',
  '7d45',
  '7d4b',
  '7d2e',
  '7d32',
  '7d3f',
  '7d35',
  '7d46',
  '7d73',
  '7d56',
  '7d4e',
  '7d72',
  '7d68',
  '7d6e',
  '7d4f',
  '7d63',
  '7d93',
  '7d89',
  '7d5b',
  '7d8f',
  '7d7d',
  '7d9b',
  '7dba',
  '7dae',
  '7da3',
  '7db5',
  '7dc7',
  '7dbd',
  '7dab',
  '7e3d',
  '7da2',
  '7daf',
  '7ddc',
  '7db8',
  '7d9f',
  '7db0',
  '7dd8',
  '7ddd',
  '7de4',
  '7dde',
  '7dfb',
  '7df2',
  '7de1',
  '7e05',
  '7e0a',
  '7e23',
  '7e21',
  '7e12',
  '7e31',
  '7e1f',
  '7e09',
  '7e0b',
  '7e22',
  '7e46',
  '7e66',
  '7e3b',
  '7e35',
  '7e39',
  '7e43',
  '7e37',
  '7e32',
  '7e3a',
  '7e67',
  '7e5d',
  '7e56',
  '7e5e',
  '7e59',
  '7e5a',
  '7e79',
  '7e6a',
  '7e69',
  '7e7c',
  '7e7b',
  '7e83',
  '7dd5',
  '7e7d',
  '8fae',
  '7e7f',
  '7e88',
  '7e89',
  '7e8c',
  '7e92',
  '7e90',
  '7e93',
  '7e94',
  '7e96',
  '7e8e',
  '7e9b',
  '7e9c',
  '7f38',
  '7f3a',
  '7f45',
  '7f4c',
  '7f4d',
  '7f4e',
  '7f50',
  '7f51',
  '7f55',
  '7f54',
  '7f58',
  '7f5f',
  '7f60',
  '7f68',
  '7f69',
  '7f67',
  '7f78',
  '7f82',
  '7f86',
  '7f83',
  '7f88',
  '7f87',
  '7f8c',
  '7f94',
  '7f9e',
  '7f9d',
  '7f9a',
  '7fa3',
  '7faf',
  '7fb2',
  '7fb9',
  '7fae',
  '7fb6',
  '7fb8',
  '8b71',
  '7fc5',
  '7fc6',
  '7fca',
  '7fd5',
  '7fd4',
  '7fe1',
  '7fe6',
  '7fe9',
  '7ff3',
  '7ff9',
  '98dc',
  '8006',
  '8004',
  '800b',
  '8012',
  '8018',
  '8019',
  '801c',
  '8021',
  '8028',
  '803f',
  '803b',
  '804a',
  '8046',
  '8052',
  '8058',
  '805a',
  '805f',
  '8062',
  '8068',
  '8073',
  '8072',
  '8070',
  '8076',
  '8079',
  '807d',
  '807f',
  '8084',
  '8086',
  '8085',
  '809b',
  '8093',
  '809a',
  '80ad',
  '5190',
  '80ac',
  '80db',
  '80e5',
  '80d9',
  '80dd',
  '80c4',
  '80da',
  '80d6',
  '8109',
  '80ef',
  '80f1',
  '811b',
  '8129',
  '8123',
  '812f',
  '814b',
  '968b',
  '8146',
  '813e',
  '8153',
  '8151',
  '80fc',
  '8171',
  '816e',
  '8165',
  '8166',
  '8174',
  '8183',
  '8188',
  '818a',
  '8180',
  '8182',
  '81a0',
  '8195',
  '81a4',
  '81a3',
  '815f',
  '8193',
  '81a9',
  '81b0',
  '81b5',
  '81be',
  '81b8',
  '81bd',
  '81c0',
  '81c2',
  '81ba',
  '81c9',
  '81cd',
  '81d1',
  '81d9',
  '81d8',
  '81c8',
  '81da',
  '81df',
  '81e0',
  '81e7',
  '81fa',
  '81fb',
  '81fe',
  '8201',
  '8202',
  '8205',
  '8207',
  '820a',
  '820d',
  '8210',
  '8216',
  '8229',
  '822b',
  '8238',
  '8233',
  '8240',
  '8259',
  '8258',
  '825d',
  '825a',
  '825f',
  '8264',
  '8262',
  '8268',
  '826a',
  '826b',
  '822e',
  '8271',
  '8277',
  '8278',
  '827e',
  '828d',
  '8292',
  '82ab',
  '829f',
  '82bb',
  '82ac',
  '82e1',
  '82e3',
  '82df',
  '82d2',
  '82f4',
  '82f3',
  '82fa',
  '8393',
  '8303',
  '82fb',
  '82f9',
  '82de',
  '8306',
  '82dc',
  '8309',
  '82d9',
  '8335',
  '8334',
  '8316',
  '8332',
  '8331',
  '8340',
  '8339',
  '8350',
  '8345',
  '832f',
  '832b',
  '8317',
  '8318',
  '8385',
  '839a',
  '83aa',
  '839f',
  '83a2',
  '8396',
  '8323',
  '838e',
  '8387',
  '838a',
  '837c',
  '83b5',
  '8373',
  '8375',
  '83a0',
  '8389',
  '83a8',
  '83f4',
  '8413',
  '83eb',
  '83ce',
  '83fd',
  '8403',
  '83d8',
  '840b',
  '83c1',
  '83f7',
  '8407',
  '83e0',
  '83f2',
  '840d',
  '8422',
  '8420',
  '83bd',
  '8438',
  '8506',
  '83fb',
  '846d',
  '842a',
  '843c',
  '855a',
  '8484',
  '8477',
  '846b',
  '84ad',
  '846e',
  '8482',
  '8469',
  '8446',
  '842c',
  '846f',
  '8479',
  '8435',
  '84ca',
  '8462',
  '84b9',
  '84bf',
  '849f',
  '84d9',
  '84cd',
  '84bb',
  '84da',
  '84d0',
  '84c1',
  '84c6',
  '84d6',
  '84a1',
  '8521',
  '84ff',
  '84f4',
  '8517',
  '8518',
  '852c',
  '851f',
  '8515',
  '8514',
  '84fc',
  '8540',
  '8563',
  '8558',
  '8548',
  '8541',
  '8602',
  '854b',
  '8555',
  '8580',
  '85a4',
  '8588',
  '8591',
  '858a',
  '85a8',
  '856d',
  '8594',
  '859b',
  '85ea',
  '8587',
  '859c',
  '8577',
  '857e',
  '8590',
  '85c9',
  '85ba',
  '85cf',
  '85b9',
  '85d0',
  '85d5',
  '85dd',
  '85e5',
  '85dc',
  '85f9',
  '860a',
  '8613',
  '860b',
  '85fe',
  '85fa',
  '8606',
  '8622',
  '861a',
  '8630',
  '863f',
  '864d',
  '4e55',
  '8654',
  '865f',
  '8667',
  '8671',
  '8693',
  '86a3',
  '86a9',
  '86aa',
  '868b',
  '868c',
  '86b6',
  '86af',
  '86c4',
  '86c6',
  '86b0',
  '86c9',
  '8823',
  '86ab',
  '86d4',
  '86de',
  '86e9',
  '86ec',
  '86df',
  '86db',
  '86ef',
  '8712',
  '8706',
  '8708',
  '8700',
  '8703',
  '86fb',
  '8711',
  '8709',
  '870d',
  '86f9',
  '870a',
  '8734',
  '873f',
  '8737',
  '873b',
  '8725',
  '8729',
  '871a',
  '8760',
  '875f',
  '8778',
  '874c',
  '874e',
  '8774',
  '8757',
  '8768',
  '876e',
  '8759',
  '8753',
  '8763',
  '876a',
  '8805',
  '87a2',
  '879f',
  '8782',
  '87af',
  '87cb',
  '87bd',
  '87c0',
  '87d0',
  '96d6',
  '87ab',
  '87c4',
  '87b3',
  '87c7',
  '87c6',
  '87bb',
  '87ef',
  '87f2',
  '87e0',
  '880f',
  '880d',
  '87fe',
  '87f6',
  '87f7',
  '880e',
  '87d2',
  '8811',
  '8816',
  '8815',
  '8822',
  '8821',
  '8831',
  '8836',
  '8839',
  '8827',
  '883b',
  '8844',
  '8842',
  '8852',
  '8859',
  '885e',
  '8862',
  '886b',
  '8881',
  '887e',
  '889e',
  '8875',
  '887d',
  '88b5',
  '8872',
  '8882',
  '8897',
  '8892',
  '88ae',
  '8899',
  '88a2',
  '888d',
  '88a4',
  '88b0',
  '88bf',
  '88b1',
  '88c3',
  '88c4',
  '88d4',
  '88d8',
  '88d9',
  '88dd',
  '88f9',
  '8902',
  '88fc',
  '88f4',
  '88e8',
  '88f2',
  '8904',
  '890c',
  '890a',
  '8913',
  '8943',
  '891e',
  '8925',
  '892a',
  '892b',
  '8941',
  '8944',
  '893b',
  '8936',
  '8938',
  '894c',
  '891d',
  '8960',
  '895e',
  '8966',
  '8964',
  '896d',
  '896a',
  '896f',
  '8974',
  '8977',
  '897e',
  '8983',
  '8988',
  '898a',
  '8993',
  '8998',
  '89a1',
  '89a9',
  '89a6',
  '89ac',
  '89af',
  '89b2',
  '89ba',
  '89bd',
  '89bf',
  '89c0',
  '89da',
  '89dc',
  '89dd',
  '89e7',
  '89f4',
  '89f8',
  '8a03',
  '8a16',
  '8a10',
  '8a0c',
  '8a1b',
  '8a1d',
  '8a25',
  '8a36',
  '8a41',
  '8a5b',
  '8a52',
  '8a46',
  '8a48',
  '8a7c',
  '8a6d',
  '8a6c',
  '8a62',
  '8a85',
  '8a82',
  '8a84',
  '8aa8',
  '8aa1',
  '8a91',
  '8aa5',
  '8aa6',
  '8a9a',
  '8aa3',
  '8ac4',
  '8acd',
  '8ac2',
  '8ada',
  '8aeb',
  '8af3',
  '8ae7',
  '8ae4',
  '8af1',
  '8b14',
  '8ae0',
  '8ae2',
  '8af7',
  '8ade',
  '8adb',
  '8b0c',
  '8b07',
  '8b1a',
  '8ae1',
  '8b16',
  '8b10',
  '8b17',
  '8b20',
  '8b33',
  '97ab',
  '8b26',
  '8b2b',
  '8b3e',
  '8b28',
  '8b41',
  '8b4c',
  '8b4f',
  '8b4e',
  '8b49',
  '8b56',
  '8b5b',
  '8b5a',
  '8b6b',
  '8b5f',
  '8b6c',
  '8b6f',
  '8b74',
  '8b7d',
  '8b80',
  '8b8c',
  '8b8e',
  '8b92',
  '8b93',
  '8b96',
  '8b99',
  '8b9a',
  '8c3a',
  '8c41',
  '8c3f',
  '8c48',
  '8c4c',
  '8c4e',
  '8c50',
  '8c55',
  '8c62',
  '8c6c',
  '8c78',
  '8c7a',
  '8c82',
  '8c89',
  '8c85',
  '8c8a',
  '8c8d',
  '8c8e',
  '8c94',
  '8c7c',
  '8c98',
  '621d',
  '8cad',
  '8caa',
  '8cbd',
  '8cb2',
  '8cb3',
  '8cae',
  '8cb6',
  '8cc8',
  '8cc1',
  '8ce4',
  '8ce3',
  '8cda',
  '8cfd',
  '8cfa',
  '8cfb',
  '8d04',
  '8d05',
  '8d0a',
  '8d07',
  '8d0f',
  '8d0d',
  '8d10',
  '9f4e',
  '8d13',
  '8ccd',
  '8d14',
  '8d16',
  '8d67',
  '8d6d',
  '8d71',
  '8d73',
  '8d81',
  '8d99',
  '8dc2',
  '8dbe',
  '8dba',
  '8dcf',
  '8dda',
  '8dd6',
  '8dcc',
  '8ddb',
  '8dcb',
  '8dea',
  '8deb',
  '8ddf',
  '8de3',
  '8dfc',
  '8e08',
  '8e09',
  '8dff',
  '8e1d',
  '8e1e',
  '8e10',
  '8e1f',
  '8e42',
  '8e35',
  '8e30',
  '8e34',
  '8e4a',
  '8e47',
  '8e49',
  '8e4c',
  '8e50',
  '8e48',
  '8e59',
  '8e64',
  '8e60',
  '8e2a',
  '8e63',
  '8e55',
  '8e76',
  '8e72',
  '8e7c',
  '8e81',
  '8e87',
  '8e85',
  '8e84',
  '8e8b',
  '8e8a',
  '8e93',
  '8e91',
  '8e94',
  '8e99',
  '8eaa',
  '8ea1',
  '8eac',
  '8eb0',
  '8ec6',
  '8eb1',
  '8ebe',
  '8ec5',
  '8ec8',
  '8ecb',
  '8edb',
  '8ee3',
  '8efc',
  '8efb',
  '8eeb',
  '8efe',
  '8f0a',
  '8f05',
  '8f15',
  '8f12',
  '8f19',
  '8f13',
  '8f1c',
  '8f1f',
  '8f1b',
  '8f0c',
  '8f26',
  '8f33',
  '8f3b',
  '8f39',
  '8f45',
  '8f42',
  '8f3e',
  '8f4c',
  '8f49',
  '8f46',
  '8f4e',
  '8f57',
  '8f5c',
  '8f62',
  '8f63',
  '8f64',
  '8f9c',
  '8f9f',
  '8fa3',
  '8fad',
  '8faf',
  '8fb7',
  '8fda',
  '8fe5',
  '8fe2',
  '8fea',
  '8fef',
  '9087',
  '8ff4',
  '9005',
  '8ff9',
  '8ffa',
  '9011',
  '9015',
  '9021',
  '900d',
  '901e',
  '9016',
  '900b',
  '9027',
  '9036',
  '9035',
  '9039',
  '8ff8',
  '904f',
  '9050',
  '9051',
  '9052',
  '900e',
  '9049',
  '903e',
  '9056',
  '9058',
  '905e',
  '9068',
  '906f',
  '9076',
  '96a8',
  '9072',
  '9082',
  '907d',
  '9081',
  '9080',
  '908a',
  '9089',
  '908f',
  '90a8',
  '90af',
  '90b1',
  '90b5',
  '90e2',
  '90e4',
  '6248',
  '90db',
  '9102',
  '9112',
  '9119',
  '9132',
  '9130',
  '914a',
  '9156',
  '9158',
  '9163',
  '9165',
  '9169',
  '9173',
  '9172',
  '918b',
  '9189',
  '9182',
  '91a2',
  '91ab',
  '91af',
  '91aa',
  '91b5',
  '91b4',
  '91ba',
  '91c0',
  '91c1',
  '91c9',
  '91cb',
  '91d0',
  '91d6',
  '91df',
  '91e1',
  '91db',
  '91fc',
  '91f5',
  '91f6',
  '921e',
  '91ff',
  '9214',
  '922c',
  '9215',
  '9211',
  '925e',
  '9257',
  '9245',
  '9249',
  '9264',
  '9248',
  '9295',
  '923f',
  '924b',
  '9250',
  '929c',
  '9296',
  '9293',
  '929b',
  '925a',
  '92cf',
  '92b9',
  '92b7',
  '92e9',
  '930f',
  '92fa',
  '9344',
  '932e',
  '9319',
  '9322',
  '931a',
  '9323',
  '933a',
  '9335',
  '933b',
  '935c',
  '9360',
  '937c',
  '936e',
  '9356',
  '93b0',
  '93ac',
  '93ad',
  '9394',
  '93b9',
  '93d6',
  '93d7',
  '93e8',
  '93e5',
  '93d8',
  '93c3',
  '93dd',
  '93d0',
  '93c8',
  '93e4',
  '941a',
  '9414',
  '9413',
  '9403',
  '9407',
  '9410',
  '9436',
  '942b',
  '9435',
  '9421',
  '943a',
  '9441',
  '9452',
  '9444',
  '945b',
  '9460',
  '9462',
  '945e',
  '946a',
  '9229',
  '9470',
  '9475',
  '9477',
  '947d',
  '945a',
  '947c',
  '947e',
  '9481',
  '947f',
  '9582',
  '9587',
  '958a',
  '9594',
  '9596',
  '9598',
  '9599',
  '95a0',
  '95a8',
  '95a7',
  '95ad',
  '95bc',
  '95bb',
  '95b9',
  '95be',
  '95ca',
  '6ff6',
  '95c3',
  '95cd',
  '95cc',
  '95d5',
  '95d4',
  '95d6',
  '95dc',
  '95e1',
  '95e5',
  '95e2',
  '9621',
  '9628',
  '962e',
  '962f',
  '9642',
  '964c',
  '964f',
  '964b',
  '9677',
  '965c',
  '965e',
  '965d',
  '965f',
  '9666',
  '9672',
  '966c',
  '968d',
  '9698',
  '9695',
  '9697',
  '96aa',
  '96a7',
  '96b1',
  '96b2',
  '96b0',
  '96b4',
  '96b6',
  '96b8',
  '96b9',
  '96ce',
  '96cb',
  '96c9',
  '96cd',
  '894d',
  '96dc',
  '970d',
  '96d5',
  '96f9',
  '9704',
  '9706',
  '9708',
  '9713',
  '970e',
  '9711',
  '970f',
  '9716',
  '9719',
  '9724',
  '972a',
  '9730',
  '9739',
  '973d',
  '973e',
  '9744',
  '9746',
  '9748',
  '9742',
  '9749',
  '975c',
  '9760',
  '9764',
  '9766',
  '9768',
  '52d2',
  '976b',
  '9771',
  '9779',
  '9785',
  '977c',
  '9781',
  '977a',
  '9786',
  '978b',
  '978f',
  '9790',
  '979c',
  '97a8',
  '97a6',
  '97a3',
  '97b3',
  '97b4',
  '97c3',
  '97c6',
  '97c8',
  '97cb',
  '97dc',
  '97ed',
  '9f4f',
  '97f2',
  '7adf',
  '97f6',
  '97f5',
  '980f',
  '980c',
  '9838',
  '9824',
  '9821',
  '9837',
  '983d',
  '9846',
  '984f',
  '984b',
  '986b',
  '986f',
  '9870',
  '9871',
  '9874',
  '9873',
  '98aa',
  '98af',
  '98b1',
  '98b6',
  '98c4',
  '98c3',
  '98c6',
  '98e9',
  '98eb',
  '9903',
  '9909',
  '9912',
  '9914',
  '9918',
  '9921',
  '991d',
  '991e',
  '9924',
  '9920',
  '992c',
  '992e',
  '993d',
  '993e',
  '9942',
  '9949',
  '9945',
  '9950',
  '994b',
  '9951',
  '9952',
  '994c',
  '9955',
  '9997',
  '9998',
  '99a5',
  '99ad',
  '99ae',
  '99bc',
  '99df',
  '99db',
  '99dd',
  '99d8',
  '99d1',
  '99ed',
  '99ee',
  '99f1',
  '99f2',
  '99fb',
  '99f8',
  '9a01',
  '9a0f',
  '9a05',
  '99e2',
  '9a19',
  '9a2b',
  '9a37',
  '9a45',
  '9a42',
  '9a40',
  '9a43',
  '9a3e',
  '9a55',
  '9a4d',
  '9a5b',
  '9a57',
  '9a5f',
  '9a62',
  '9a65',
  '9a64',
  '9a69',
  '9a6b',
  '9a6a',
  '9aad',
  '9ab0',
  '9abc',
  '9ac0',
  '9acf',
  '9ad1',
  '9ad3',
  '9ad4',
  '9ade',
  '9adf',
  '9ae2',
  '9ae3',
  '9ae6',
  '9aef',
  '9aeb',
  '9aee',
  '9af4',
  '9af1',
  '9af7',
  '9afb',
  '9b06',
  '9b18',
  '9b1a',
  '9b1f',
  '9b22',
  '9b23',
  '9b25',
  '9b27',
  '9b28',
  '9b29',
  '9b2a',
  '9b2e',
  '9b2f',
  '9b32',
  '9b44',
  '9b43',
  '9b4f',
  '9b4d',
  '9b4e',
  '9b51',
  '9b58',
  '9b74',
  '9b93',
  '9b83',
  '9b91',
  '9b96',
  '9b97',
  '9b9f',
  '9ba0',
  '9ba8',
  '9bb4',
  '9bc0',
  '9bca',
  '9bb9',
  '9bc6',
  '9bcf',
  '9bd1',
  '9bd2',
  '9be3',
  '9be2',
  '9be4',
  '9bd4',
  '9be1',
  '9c3a',
  '9bf2',
  '9bf1',
  '9bf0',
  '9c15',
  '9c14',
  '9c09',
  '9c13',
  '9c0c',
  '9c06',
  '9c08',
  '9c12',
  '9c0a',
  '9c04',
  '9c2e',
  '9c1b',
  '9c25',
  '9c24',
  '9c21',
  '9c30',
  '9c47',
  '9c32',
  '9c46',
  '9c3e',
  '9c5a',
  '9c60',
  '9c67',
  '9c76',
  '9c78',
  '9ce7',
  '9cec',
  '9cf0',
  '9d09',
  '9d08',
  '9ceb',
  '9d03',
  '9d06',
  '9d2a',
  '9d26',
  '9daf',
  '9d23',
  '9d1f',
  '9d44',
  '9d15',
  '9d12',
  '9d41',
  '9d3f',
  '9d3e',
  '9d46',
  '9d48',
  '9d5d',
  '9d5e',
  '9d64',
  '9d51',
  '9d50',
  '9d59',
  '9d72',
  '9d89',
  '9d87',
  '9dab',
  '9d6f',
  '9d7a',
  '9d9a',
  '9da4',
  '9da9',
  '9db2',
  '9dc4',
  '9dc1',
  '9dbb',
  '9db8',
  '9dba',
  '9dc6',
  '9dcf',
  '9dc2',
  '9dd9',
  '9dd3',
  '9df8',
  '9de6',
  '9ded',
  '9def',
  '9dfd',
  '9e1a',
  '9e1b',
  '9e1e',
  '9e75',
  '9e79',
  '9e7d',
  '9e81',
  '9e88',
  '9e8b',
  '9e8c',
  '9e92',
  '9e95',
  '9e91',
  '9e9d',
  '9ea5',
  '9ea9',
  '9eb8',
  '9eaa',
  '9ead',
  '9761',
  '9ecc',
  '9ece',
  '9ecf',
  '9ed0',
  '9ed4',
  '9edc',
  '9ede',
  '9edd',
  '9ee0',
  '9ee5',
  '9ee8',
  '9eef',
  '9ef4',
  '9ef6',
  '9ef7',
  '9ef9',
  '9efb',
  '9efc',
  '9efd',
  '9f07',
  '9f08',
  '76b7',
  '9f15',
  '9f21',
  '9f2c',
  '9f3e',
  '9f4a',
  '9f52',
  '9f54',
  '9f63',
  '9f5f',
  '9f60',
  '9f61',
  '9f66',
  '9f67',
  '9f6c',
  '9f6a',
  '9f77',
  '9f72',
  '9f76',
  '9f95',
  '9f9c',
  '9fa0',
  '582f',
  '69c7',
  '9059',
  '7464',
  '51dc',
  '7199'
];

},{}],9:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
  util = require('./util'),
  _ = require('lodash'),
  imagesLoaded = require('imagesloaded');

var dialog = {
  /**
   * @function
   * @description Appends a dialog to a given container (target)
   * @param {Object} params  params.target can be an id selector or an jquery object
   */
  create: function (params) {
    var $target, id;

    if (_.isString(params.target)) {
      id =
        params.target.charAt(0) === '#'
          ? params.target.substr(1)
          : params.target;
      $target = $('#' + id);
    } else if (params.target instanceof jQuery) {
      $target = params.target;
    } else {
      id = 'dialog-container';
      $target = $('#' + id);
    }

    // if no element found, create one
    if ($target.length === 0 && id) {
      $target = $('<div>')
        .attr('id', id)
        .addClass('dialog-content')
        .appendTo('body');
    }

    // create the dialog
    this.$container = $target;
    this.$container.dialog(_.merge({}, this.settings, params.options || {}));
  },
  /**
   * @function
   * @description Opens a dialog using the given url (params.url) or html (params.html)
   * @param {Object} params
   * @param {Object} params.url should contain the url
   * @param {String} params.html contains the html of the dialog content
   */
  open: function (params) {
    // close any open dialog
    this.close();
    this.create(params);
    this.replace(params);
  },
  /**
   * @description populate the dialog with html content, then open it
   **/
  openWithContent: function (params) {
    var content, position, callback;

    if (!this.$container) {
      return;
    }
    content = params.content || params.html;
    if (!content) {
      return;
    }
    this.$container.empty().html(content);
    if (!this.$container.dialog('isOpen')) {
      this.$container.dialog('open');
    }

    if (params.options) {
      position = params.options.position;
    }
    if (!position) {
      position = this.settings.position;
    }
    imagesLoaded(this.$container).on(
      'done',
      function () {
        this.$container.dialog('option', 'position', position);
      }.bind(this)
    );

    callback =
      typeof params.callback === 'function' ? params.callback : function () {};
    callback();
  },
  /**
   * @description Replace the content of current dialog
   * @param {object} params
   * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
   * @param {string} params.html - If no url property is provided, use html provided to replace
   */
  replace: function (params) {
    if (!this.$container) {
      return;
    }
    if (params.url) {
      params.url = util.appendParamToURL(params.url, 'format', 'ajax');
      ajax.load({
        url: params.url,
        data: params.data,
        callback: function (response) {
          params.content = response;
          this.openWithContent(params);
        }.bind(this),
      });
    } else if (params.html) {
      this.openWithContent(params);
    }
  },
  /**
   * @function
   * @description Closes the dialog
   */
  close: function () {
    if (!this.$container) {
      return;
    }
    this.$container.dialog('close');
  },
  exists: function () {
    return this.$container && this.$container.length > 0;
  },
  isActive: function () {
    return this.exists() && this.$container.children.length > 0;
  },
  settings: {
    autoOpen: false,
    height: 'auto',
    modal: true,
    overlay: {
      opacity: 0.5,
      background: 'black',
    },
    resizable: false,
    title: '',
    width: '800',
    close: function () {
      $(this).dialog('close');
    },
    position: {
      my: 'center',
      at: 'center',
      of: window,
      collision: 'fit',
    },
  },
  loading: function () {
    var me = this;

    this.open({
/**
      html:
        '<div class="msg-wrapper"><image src="' +
        Urls.staticPath +
        '/images/loading-small.gif"></div>',
**/
      html:
        '<div class="msg-wrapper"></div>',
      options: {
        open: function (event, ui) {
          me.setupnotice(ui);
        },
      },
    });
  },
  setupnotice: function (ui) {
    this.$container.addClass('add-product-notice-content');
    this.$container.parent().addClass('add-product-notice-dialog');
  },
};

module.exports = dialog;

},{"./ajax":1,"./util":63,"imagesloaded":70,"lodash":71}],10:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, callback) {
    // load gift certificate details
    var url = util.appendParamToURL(Urls.giftCardCheckBalance, 'giftCertificateID', id);

    ajax.getJson({
        url: url,
        callback: callback
    });
};

},{"./ajax":1,"./util":63}],11:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util');

var setAddToCartHandler = function (e) {
    e.preventDefault();
    var form = $(this).closest('form');

    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    minicart.show(response);
                    form.find('input,textarea').val('');
                }
            });
        } else {
            form.find('span.error').hide();
            for (var id in response.errors.FormErrors) {
                var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);
};

},{"./ajax":1,"./minicart":17,"./util":63}],12:[function(require,module,exports){
'use strict';

exports.init = function () {
  $('.menu-utility-user .contact, .menu-utility-user .newsletter').hover(
    function () {
      $(this).find('.menu-utility-content').show();
    }
  );

  // 'tap' doesn't work as expected so using touchstart instead
  $(document).on('touchstart', function (e) {
    // the tapped element
    var $target = $(e.target);

    // check if it's not the menu or the dropdown itself
    if ($target.closest('.dropdown-menu').length == 0) {
      // check if some dropdown menu is open, otherwise foundation will return an error
      if ($('.dropdown-pane.is-open').length) {
        $('.dropdown-pane.is-open').foundation('close');
      }
    }
  });

  $('a.utility-link').on('click', function (evt) {
    evt.preventDefault();
  });

  // overwrite foundation Enter key event
  $('.menu-utility-user input').each(function (i, input) {
    var $input = $(input);

    // overwrite only on input type text, email and password
    if (
      $input.attr('type') == 'text' ||
      $input.attr('type') == 'email' ||
      $input.attr('type') == 'password'
    ) {
      $input.keydown(function (e) {
        Foundation.Keyboard.handleKey(e, 'DropdownMenu', {
          submit: function () {
            var $form = $input.closest('form');

            // simulate blur event to check if it has error or not
            $input.trigger('blur');

            // prevent submit if there are errors
            if ($form.find('span.error').length == 0) {
              // $form.submit() doesn't work on login so it has to be this *sigh*
              $form.find('button[type="submit"]').trigger('click');
            }
          },
        });
      });
    }
  });
};
Foundation.Keyboard.register('DropdownMenu', {
  ENTER: 'submit',
});

//サイドメニュー
function initAccountNav() {
  // マイページ共通メニュー削除に伴い処理を削除
  // TODO: 呼び出し箇所を再確認し削除予定
}

exports.initAccountNav = initAccountNav;

},{}],13:[function(require,module,exports){
'use strict';

var productTile = require('./product-tile');

/**
 * @function
 * @description Initializes global header navidation
 */
exports.init = function () {
	// スクロール停止class
	const SCROLL_FIX = 'scroll-fixed';
	const $BODY = $('body');
	
	// 全体ラッパー
	let pageWrapper = document.querySelector('#wrapper');
	
	// 告知バー
	let headerBanner = document.querySelector('.header-banner');
	
	// 検索
	let $hMenuSearch = $('.h__menu-search'),
		$hSearchBar = $('.h__search-bar'),
		searchBarHoverOpen = false;
	
	// カート
	let $hMenuCart = $('.h__menu-cart'),
		$miniCartContent = $('.mini-cart-content'),
		menuCartHoverFlag = false;
	
	// ホバーエリア判定
	let checkHoverArea = function(checkClass) {
		let hoverFlag = false;
		
		$(':hover').each(function() {
			if ($(this).hasClass(checkClass)) {
				hoverFlag = true;
				return false;
			}
		});
		return hoverFlag;
	};
	
	// メガメニューすべて非表示
	let hideAllMegaMenu = function() {
		$('.h__menu-block-area').removeClass('show');
		$BODY.removeClass(SCROLL_FIX);
	};
	// メガメニュー非表示
	let hideMegaMenu = function() {
		if (!Foundation.MediaQuery.is('small only')) {
			hideAllMegaMenu();
			
			// 左上メニューのカレント表示を解除
			$('.h__menu-main-list').find('a[href^="#"]').removeClass('h__menu-main-list--current');
		}
		
		$('.h__modal-cover').removeClass('h__modal-cover--show');
		
		// スマホ用処理
		$('.h__menu-btn').find('button').removeClass('h__menu-btn--opened');
		$('.h__menu-block').removeClass('menu-show');
		menuMainListDisplayed = false;
	};
	
	// 検索バー表示／非表示
	let showSearchBar = function() {
		searchBarHoverOpen = true;
		$hMenuSearch.find('button').addClass('h__menu-sub--current');
		$hSearchBar.removeClass('h__search-bar--hide');
		
		// 検索サジェストがある場合は全体ぼかし背景を表示
		if ($('.h__search-block').hasClass('h__search-block--show')) {
			$('.h__modal-cover').addClass('h__modal-cover--show');
		}
		
		// 検索バー分の高さをCSS変数に設定
		if (pageWrapper) {
			pageWrapper.style.setProperty('--search-bar-offset', $hSearchBar.outerHeight() + 'px');
		}
	};
	let hideSearchBar = function() {
		searchBarHoverOpen = false;
		$hMenuSearch.find('button').removeClass('h__menu-sub--current');
		$hSearchBar.addClass('h__search-bar--hide');
		
		// 検索サジェストがある場合は全体ぼかし背景を非表示
		if ($('.h__search-block').hasClass('h__search-block--show')) {
			$('.h__modal-cover').removeClass('h__modal-cover--show');
		}
		
		// 検索バー分の高さを0に設定
		if (pageWrapper) {
			pageWrapper.style.setProperty('--search-bar-offset', '0px');
		}
	};
	
	// 告知バーの高さをCSS変数に設定
	if (pageWrapper) {
		if (headerBanner) {
			const observerHeaderBannerOptions = {
				root: null,
				rootMargin: '0px',
				threshold: 0
			};
			let observerHeaderBanner;
			let doWhenIntersectHeaderBanner = function(entries) {
				if (entries[0].isIntersecting) {
					// 画面内
					pageWrapper.style.setProperty('--banner-offset', headerBanner.offsetHeight + 'px');
				} else {
					pageWrapper.style.setProperty('--banner-offset', '0px');
				}
			};
			observerHeaderBanner = new IntersectionObserver(doWhenIntersectHeaderBanner, observerHeaderBannerOptions);
			observerHeaderBanner.observe(headerBanner);
		} else {
			pageWrapper.style.setProperty('--banner-offset', '0px');
		}
	}
	
	// ベストセラー、新着限定slick
	productTile.init();
	
	// 左上メニューエリア
	$('.h__menu').on({
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				// 左上メニューエリアから外れた場合
				if (!checkHoverArea('h__search-bar') && !checkHoverArea('h__menu-block-area')) {
					// メガメニュー非表示
					hideMegaMenu();
				}
			}
		}
	});
	
	// 左上メニューボタン（SPのみ）
	let menuMainListDisplayed = false;
	$('.h__menu-main-list').each(function() {
		if ($(this).find('a.h__menu-main-list--current').length > 0) {
			menuMainListDisplayed = true;
		}
	});
	$('.h__menu-btn').on('click', 'button', function() {
		let $menuBtn = $(this);
		
		$menuBtn.toggleClass('h__menu-btn--opened');
		
		if ($menuBtn.hasClass('h__menu-btn--opened')) {
			// 検索バーを非表示
			hideSearchBar();
			
			// 初期表示が無ければ、商品＞スキンケアを開いた状態にする
			if (!menuMainListDisplayed) {
				menuMainListDisplayed = true;
				$('.h__menu-main-product').find('a').addClass('h__menu-main-list--current').parent().siblings().find('a').removeClass('h__menu-main-list--current');
				$('.h__menu-block-menu-parent').find('a[href="#h__menu-block-skincare"]').addClass('menu-current').parent().siblings().find('a').removeClass('menu-current');
				$('#a-hmenu-product').addClass('show');
				$('#h__menu-block-skincare').addClass('menu-show');
			}
			
			// メニューを表示
			$('.h__modal-cover').addClass('h__modal-cover--show');
			$('.h__menu-main').addClass('h__menu-main--opened');
			$('.h__menu-block').addClass('menu-show');
			
			$('html').addClass('js__menu-main-opened');
			
			$BODY.addClass(SCROLL_FIX);
		} else {
			$('.h__menu-block').removeClass('menu-show');
			$('.h__menu-main').removeClass('h__menu-main--opened');
			$('.h__modal-cover').removeClass('h__modal-cover--show');
			
			$('html').removeClass('js__menu-main-opened');
			
			$BODY.removeClass(SCROLL_FIX);
		}
	});
	
	// 左上メニュー
	$('.h__menu-main-list').on({
		// 左上メニューアンカーリンク
		'click': function(e) {
			e.preventDefault();
			
			if (Foundation.MediaQuery.is('small only')) {
				$(this).addClass('h__menu-main-list--current').parent().siblings().find('a').removeClass('h__menu-main-list--current');
				$('.h__menu-block').find($(this).attr('href')).addClass('show').siblings().removeClass('show');
				
				// 先頭位置に戻る
				$('.h__menu-block').scrollTop(0);
			}
		},
		'mouseenter': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				$(this).addClass('h__menu-main-list--current').parent().siblings().find('a').removeClass('h__menu-main-list--current');
				$('.h__menu-block').find($(this).attr('href')).addClass('show').siblings().removeClass('show');

				$('.h__modal-cover').addClass('h__modal-cover--show');
				
				$BODY.addClass(SCROLL_FIX);
			}
		},
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				// 他のメニューにホバーしていれば、自身のカレント表示を解除
				if (checkHoverArea('h__menu')) {
					// メガメニュー非表示
					hideMegaMenu();
				}
			}
		}
	}, 'a[href^="#"]').on({
		// 左上メニュー通常リンク
		'mouseenter': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				// メガメニュー非表示
				hideMegaMenu();
			}
		},
	}, 'a:not([href^="#"])');
	
	// メガメニュー左側メニュー
	$('.h__menu-block-menu-parent').on({
		'click': function(e) {
			e.preventDefault();
			
			if (Foundation.MediaQuery.is('small only')) {
				let $this = $(this),
					$showTarget = $($this.attr('href')),
					$hMenuBlockArea = $(this).closest('.h__menu-block-area');
				
				// 切り替え時だけ白背景を表示
				$hMenuBlockArea.css('--a-hmenu-product-height', $(this).closest('.h__menu-block-menu').outerHeight() + $showTarget.outerHeight() + 'px');
				$hMenuBlockArea.addClass('menu-bg-transition');
				setTimeout(function() {
					$hMenuBlockArea.removeClass('menu-bg-transition');
				}, 400); // CSSと同じ秒数
				
				$this.addClass('menu-current').parent().siblings().find('a').removeClass('menu-current');
				$showTarget.addClass('menu-show').siblings().removeClass('menu-show');
				
				// 上部に戻る
				let $hMenuBlock = $('.h__menu-block'),
					$hMenuMainSp = $hMenuBlock.find('.h__menu-main--sp'),
					hMenuMainSpHeight = $hMenuMainSp.outerHeight();
				if ($hMenuBlock.scrollTop() > hMenuMainSpHeight) {
					$hMenuBlock.scrollTop(hMenuMainSpHeight + 1.5);
				}
				
				// 左右に戻る
				let $target = $this.parent(),
					targetLeft = $target.position().left,
					targetRight = targetLeft + $target.outerWidth(),
					$parent = $hMenuBlock.find('.h__menu-block-menu-parent'),
					$hMenuBlockMenu = $hMenuBlock.find('.h__menu-block-menu'),
					hMenuBlockMenuWidth = $hMenuBlockMenu.outerWidth();
				if (targetLeft < 0) {
					$hMenuBlockMenu.animate({
						scrollLeft: targetLeft - $parent.position().left
					}, 200);
				} else if (targetRight > hMenuBlockMenuWidth) {
					$hMenuBlockMenu.animate({
						scrollLeft: targetRight - $parent.position().left - hMenuBlockMenuWidth
					}, 200);
				}
				
				// ベストセラー、新着限定slick位置再設定
				$showTarget.find('.swatch-list.slick-initialized').each(function(idx, elm) {
					$(elm).slick('setPosition');
				});
			}
		},
		'mouseenter': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				let $this = $(this),
					$showTarget = $($this.attr('href'));
				
				$this.addClass('menu-current').parent().siblings().find('a').removeClass('menu-current');
				$showTarget.addClass('menu-show').siblings().removeClass('menu-show');
				
				// ベストセラー、新着限定slick位置再設定
				$showTarget.find('.swatch-list.slick-initialized').each(function(idx, elm) {
					$(elm).slick('setPosition');
				});
			}
		},
		'mouseleave': function() {
			// 何もしない
		}
	}, 'a');
	
	// メガメニューエリア
	$('.h__menu-block-area').on({
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				if (!checkHoverArea('h__search-bar') && !checkHoverArea('h__menu')) {
					// メガメニュー非表示
					hideMegaMenu();
				}
			}
		}
	});
	
	// 検索アイコン
	$hMenuSearch.on({
		'click': function(e) {
			e.preventDefault();
			
			if (Foundation.MediaQuery.is('small only')) {
				let $hMenuSearchBtn = $hMenuSearch.find('button');
				
				$hMenuSearchBtn.toggleClass('h__menu-sub--current');
				
				if ($hMenuSearchBtn.hasClass('h__menu-sub--current')) {
					$hSearchBar.removeClass('h__search-bar--hide');

					// 検索バー表示時にメニューを隠す
					$('.h__menu-btn').find('button').removeClass('h__menu-btn--opened');
					$('.h__menu-block').removeClass('menu-show');
					$('.h__menu-main').removeClass('h__menu-main--opened');
					$('.h__modal-cover').removeClass('h__modal-cover--show');
			
					$BODY.removeClass(SCROLL_FIX);
					
					// 検索サジェストがある場合は全体ぼかし背景を表示
					if ($('.h__search-block').hasClass('h__search-block--show')) {
						$('.h__modal-cover').addClass('h__modal-cover--show');
					}
				} else {
					$hSearchBar.addClass('h__search-bar--hide');
					
					// 検索サジェストがある場合は全体ぼかし背景を非表示
					if ($('.h__search-block').hasClass('h__search-block--show')) {
						$('.h__modal-cover').removeClass('h__modal-cover--show');
					}
				}
			}
		},
		'mouseenter': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				// 検索バーを表示
				showSearchBar();
			}
		},
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				if (!checkHoverArea('h__search-bar')) {
					// 検索バーを非表示
					hideSearchBar();
				}
			}
		}
	})
	
	// 検索バー
	if (pageWrapper) {
		if (!$hSearchBar.hasClass('h__search-bar--hide')) {
			pageWrapper.style.setProperty('--search-bar-offset', $hSearchBar.outerHeight() + 'px');
		} else {
			pageWrapper.style.setProperty('--search-bar-offset', '0px');
		}
	}
	$hSearchBar.on({
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				if (!checkHoverArea('h__menu-block-area') && !checkHoverArea('h__menu')) {
					if (!checkHoverArea('mini-cart-content') && !checkHoverArea('h__search-block')) {
						// メガメニュー非表示
						hideMegaMenu();
					}
				}

				if (!checkHoverArea('h__menu-search') && !checkHoverArea('h__search-block')) {
					// 検索バーを非表示
					hideSearchBar();
				}
			}
		}
	});
	// 検索リセット
	$hSearchBar.on('click', 'button[type="reset"]', function() {
		$(this).closest('form').find('.h__search-bar-input').val('');
		$('.h__search-block').removeClass('h__search-block--show');
		// 検索バーを非表示
		hideSearchBar();
		$('.h__modal-cover').removeClass('h__modal-cover--show');
		
		setTimeout(function() {
			$hSearchBar.find('button[type="reset"]').addClass('hide')
			.end().find('button[type="submit"]').removeClass('hide');
		}, 200);
	});
/***
スクロールしたら検索バーを非表示。ただし、検索アイコンで検索バーを開いたときは表示したままにする。
検索アイコンで検索バーを開いたかを判定するクラスを付ける。
***/
	const observerOptions = {
		root: null,
		rootMargin: '200px 0px ' + document.body.clientHeight + 'px 0px',
		threshold: 1
	};
	let observerSearchBar;
	let doWhenIntersect = function(entries) {
		if (!entries[0].isIntersecting) {
			if (!$hMenuSearch.find('button').hasClass('h__menu-sub--current')) {
				// 検索バーを非表示
				hideSearchBar();
//				$hSearchBar.addClass('h__search-bar--hide');
			}
//			if (!searchBarHoverOpen) {
//				$hSearchBar.addClass('h__search-bar--hide');
//			}
		}
	};
	observerSearchBar = new IntersectionObserver(doWhenIntersect, observerOptions);
	observerSearchBar.observe(document.body);
	
	// カートアイコン
	$hMenuCart.on({
		'mouseenter': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				menuCartHoverFlag = true;

				$(this).addClass('h__menu-sub--current').closest('li').siblings().find('a, button').removeClass('h__menu-sub--current');
				$miniCartContent.addClass('mini-cart-show');
				$('.h__modal-cover').addClass('h__modal-cover--show');
				
				$BODY.addClass(SCROLL_FIX);
			}
		},
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				if (!checkHoverArea('h__search-bar') && !checkHoverArea('mini-cart-content')) {
					$hMenuCart.find('a').removeClass('h__menu-sub--current');
					$miniCartContent.removeClass('mini-cart-show');
					$('.h__modal-cover').removeClass('h__modal-cover--show');
					
					$BODY.removeClass(SCROLL_FIX);
				}
			}
		}
	}, 'a');
	// カートエリア
	$miniCartContent.on({
		'mouseleave': function() {
			if (!Foundation.MediaQuery.is('small only')) {
				if (!checkHoverArea('h__search-bar')) {
					$hMenuCart.find('a').removeClass('h__menu-sub--current');
					$miniCartContent.removeClass('mini-cart-show');
					$('.h__modal-cover').removeClass('h__modal-cover--show');
					
					$BODY.removeClass(SCROLL_FIX);
				}
			}
		}
	}).on('click', '.mini-cart-link-back', function() {
		// お買い物を続けるボタン
		$hMenuCart.find('a').removeClass('h__menu-sub--current');
		$miniCartContent.removeClass('mini-cart-show');
		$('.h__modal-cover').removeClass('h__modal-cover--show');
		
		$BODY.removeClass(SCROLL_FIX);
	});
	
	// スマホメニューリスト開閉
	$('.h__menu-block-title--sp-toggle').on('click', function() {
		$(this).toggleClass('u__toggle-opened').find('+ .u__toggle-target').slideToggle(300);
	});
};

},{"./product-tile":50}],14:[function(require,module,exports){
'use strict';

function entry () {
    $(document).on('keyup blur', '#q, .cart-coupon-code input', function () {
        if ($(this).val().trim().length) {
            return $(this).siblings('button').prop('disabled', false);
        }

        $(this).siblings('button').prop('disabled', true);
    });
}

exports.entry = entry;
},{}],15:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {options.callback();}
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };
};

},{}],16:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
  modal = require('./modal'),
  page = require('./page'),
  util = require('./util'),
  validator = require('./validator');

var login = {
  /**
   * @private
   * @function
   * @description init events for the loginPage
   */
  init: function () {
    //o-auth binding for which icon is clicked
    $('.oAuthIcon').on('click', function () {
      $('#OAuthProvider').val(this.id);
    });

    //toggle the value of the rememberme checkbox
    $('#dwfrm_login_rememberme').on('change', function () {
      if ($('#dwfrm_login_rememberme').attr('checked')) {
        $('#rememberme').val('true');
      } else {
        $('#rememberme').val('false');
      }
    });

    // ログイン押下時の最新規約の同意確認(LINE連携時には同意を求めない)
    // 入力されたユーザーIDのユーザーが同意済かの確認を行い、未同意であれば同意を求めるモーダルフォームを表示。同意確認後は通常のログイン処理を行う
    let isAgreedVersionChecked = false;
    $('#dwfrm_login.js-require-membership-agreement')
      .off('submit.login')
      .on('submit.login', function (e) {
        if (isAgreedVersionChecked) {
          return true;
        }

        e.preventDefault();
        const self = this;

        // 多重クリック防止用
        // ログインボタンの無効化
        const $loginButton = $('#login');
        $loginButton.prop('disabled', true);

        // ログインフォームから入力ユーザー名を取得
        const userName = $(self).find('input[id^=dwfrm_login_username_]').val();
        const password = $(self).find('input[id^=dwfrm_login_password_]').val();
        const params = {
          userName: userName,
          password: password
        };

        // ログイン続行処理定義
        function continueLoggingIn() {
          isAgreedVersionChecked = true;
          $loginButton.prop('disabled', false).trigger('click');
        }

        // サーバーとAjaxで通信し、ユーザーの同意済み会員規約バージョンが最新が確認する
        $.ajax({
          type: 'POST',
          url: util.ajaxUrl(Urls.checkVersionOfMembershipAgreement),
          data: params
        }).then(
          function (response) {
            // レスポンスの型チェック
            if (typeof response !== 'object') {
              alert('response is not object');
              return;
            }

            // レスポンス successではない場合
            if (!response.success) {
              if (response.error) {
                alert(response.error);
              }
              $loginButton.prop('disabled', false);
              return;
            }

            // 同意ダイアログを表示する必要がない場合、ログインを続行する(入力されたユーザーが存在しないと判定された場合も同様に続行しログイン処理で弾く)
            if (!response.isNeedAgreement) {
              continueLoggingIn();
              return;
            }

            // 同意済みのバージョンが会員規約コンテンツバージョンと一致しない場合
            // 会員規約モーダル画面を表示する
            $('#membership-agreement-dialog').dialog({
              width: 640,
              modal: true,
              dialogClass: 'membership-agreement-jquery-dialog-wrapper',
              buttons: [
                {
                  text: '同意する',
                  click: function () {
                    $(this).dialog('close');
                    // ログインを続行する
                    continueLoggingIn();
                  }
                }
              ],
              open: function () {
                // 同意チェックボックスにチェックを入れるまで「同意する」ボタンを無効化する処理
                const $agreeButton = $('.ui-dialog-buttonpane').find(
                  'button:contains("同意する")'
                );
                $agreeButton.prop('disabled', true);
                const $agreeCheckBox = $('#membership-agreement-checkbox');
                $agreeCheckBox.prop('checked', false);
                $agreeCheckBox
                  .off('change.toggleSubmitBtn')
                  .on('change.toggleSubmitBtn', function (e) {
                    if ($agreeCheckBox.prop('checked')) {
                      $agreeButton.prop('disabled', false);
                    } else {
                      $agreeButton.prop('disabled', true);
                    }
                  });
              },
              close: function () {
                $loginButton.prop('disabled', false);
              }
            });
          },
          // 通信に失敗したとき
          function () {
            alert('Request failed');
            $loginButton.prop('disabled', false);
            return;
          }
        );
      });

    $('#password-reset').on('click', function (e) {
      e.preventDefault();
      dialog.open({
        url: $(e.target).attr('href'),
        options: {
          open: function () {
            validator.init();
            var $requestPasswordForm = $('[name$="_requestpassword"]');
            var $submit = $requestPasswordForm.find(
              '[name$="_requestpassword_send"]'
            );
            $($submit).on('click', function (e) {
              if (!$requestPasswordForm.valid()) {
                return;
              }
              e.preventDefault();
              var data = $requestPasswordForm.serialize();
              // add form action to data
              data += '&' + $submit.attr('name') + '=';
              // make sure the server knows this is an ajax request
              if (data.indexOf('ajax') === -1) {
                data += '&format=ajax';
              }
              $.ajax({
                type: 'POST',
                url: $requestPasswordForm.attr('action'),
                data: data,
                success: function (response) {
                  if (
                    typeof response === 'object' &&
                    !response.success &&
                    response.error === 'CSRF Token Mismatch'
                  ) {
                    page.redirect(Urls.csrffailed);
                  } else if (typeof response === 'string') {
                    dialog.$container.html(response);
                  }
                },
                failure: function () {
                  dialog.$container.html(
                    '<h1>' + Resources.SERVER_ERROR + '</h1>'
                  );
                }
              });
            });
          }
        }
      });
    });

    var res_suc = $('.temporaryemail-success');
    var res_err = $('.temporaryemail-error, div.temporaryemail .error-message');

    if (res_suc.length > 0 || res_err.length > 0) {
      var data = {
        is_sucess: res_suc.length > 0 ? true : false,
        title: Resources.TEMP_REGISTER_DIALOG_TITLE,
        content:
          res_suc.length > 0
            ? res_suc.find('span')
            : res_err.find('span').length > 0
            ? res_err.find('span')
            : res_err,
        error:
          res_suc.length > 0
            ? ''
            : '<div class="error-form">' + Resources.VALIDATE_FAILURE + '</div>'
      };

      dialog.open({
        html:
          '<div class="request-password-reset"><h4>' +
          data.title +
          '</h4>' +
          data.error +
          '<p>' +
          data.content.html() +
          '</p></div>'
      });
    }
  }
};

module.exports = login;

},{"./dialog":9,"./modal":18,"./page":20,"./util":63,"./validator":64}],17:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
	util = require('./util'),
	bonusProductsView = require('./bonus-products-view');

var timer = {
	id: null,
	clear: function () {
		if (this.id) {
			window.clearTimeout(this.id);
			delete this.id;
		}
	},
	start: function (duration, callback) {
		this.id = setTimeout(callback, duration);
	}
};

var minicart = {
	init: function () {
		this.$el = $('#hd-cart');
		this.$content = this.$el.find('.mini-cart-content');

		/*$('.mini-cart-product').eq(0).find('.mini-cart-toggle').addClass('fa-caret-down');
		$('.mini-cart-product').not(':first').addClass('collapsed')
			.find('.mini-cart-toggle').addClass('fa-caret-right');

		$('.mini-cart-toggle').on('click', function () {
			$(this).toggleClass('fa-caret-down fa-caret-right');
			$(this).closest('.mini-cart-product').toggleClass('collapsed');
		});*/

		// events
/**
// ミニカート表示処理削除
		this.$el.find('.mini-cart-total').on('mouseenter', function () {
			if (this.$content.not(':visible')) {
				this.slide();
			}
		}.bind(this));

		this.$content.on('mouseenter', function () {
			timer.clear();
		}).on('mouseleave', function () {
			timer.clear();
			timer.start(30, this.close.bind(this));
		}.bind(this));
**/
	},
	/**
	 * @function
	 * @description Shows the given content in the mini cart
	 * @param {String} A HTML string with the content which will be shown
	 */
	show: function (html) {
		//【サイトリニューアル 1.0】サイトリニューアルに伴い、ミニカートhtmlの挿入先を修正
//		this.$el.html(html);
		var cartProductsHtmlText = $($.parseHTML(html)).find('.mini-cart-products')[0].outerHTML;
		var cartTotalsHtmlText = $($.parseHTML(html)).find('.mini-cart-totals')[0].outerHTML;
		var htmlText = cartProductsHtmlText + cartTotalsHtmlText;
		// カートイン後の内容を挿入する
		$('.mini-cart-content').html(htmlText);
		//【サイトリニューアル 1.0】サイトリニューアルに伴い、ミニカートhtmlの挿入先を修正

		if (window.innerWidth >= 768) {
			// util.scrollBrowser(0);

			this.init();

			this.slide();

			bonusProductsView.loadBonusOption();
		}
	},
	/**
	 * @function
	 * @description Slides down and show the contents of the mini cart
	 */
	slide: function () {
		timer.clear();
		// show the item
		this.$content.slideDown('slow');
		// after a time out automatically close it
		timer.start(6000, this.close.bind(this));
	},
	/**
	 * @function
	 * @description Closes the mini cart with given delay
	 * @param {Number} delay The delay in milliseconds
	 */
	close: function (delay) {
		timer.clear();
		this.$content.slideUp(delay);
	},
	notice: function(isError) {
		if (isError) {
			return;
		}

		dialog.open({
			html: '<div class="msg-wrapper"><div class="dialog__msg-block dialog__msg-block--cartin">' + Resources.ADD_PRODUCT_SUCCESS + '</div></div>',
			options: {
				open: function(event, ui) {
					dialog.setupnotice(ui);

					setTimeout(function() {
						dialog.close();
					}, 2000);// cartin modal カートインモーダルを閉じるまでの時間
				},
				close: function(event, ui) {
					setTimeout(function() {
						bonusProductsView.loadBonusOption();
					}, 800);
				}
			}
		});
	}
};

module.exports = minicart;

},{"./bonus-products-view":4,"./dialog":9,"./util":63}],18:[function(require,module,exports){
var util = require('./util');

var $modal = {
    cntr: $('#modal-cntr'),
    body: $('.modal-body')
};

var globalModal = new Foundation.Reveal($modal.cntr);
var callbackFn = null;

module.exports = {
    open: function() {
        globalModal.open();
    },
    
    restoreDefaultClass: function(){
    	$modal.cntr.removeAttr('class');
    	$modal.cntr.attr('class','reveal');
    },
    
    addCustomClass: function(customClass){
    	this.restoreDefaultClass();
    	$modal.cntr.addClass(customClass);
    },

    setContent: function (content) {
        return $modal.body.html(content);
    },

    renderContent: function(content, type) {
        var classType = type || '';

        $modal.body.html('<div id="modal-content" class="modal-content ' + classType + '">' + content + '</div>');
        globalModal.open();
        
        if(typeof callbackFn === 'function'){
        	callbackFn();
        	callbackFn = null; // clear after each use
        }
    },

    renderByUrl: function(contentUrl) {
        return $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(this.renderContent);
    },
    
    setCallback: function(callback){
    	callbackFn = callback;
    },

    events: {
        onOpen: function(cb) {
            $(document).off('open.zf.reveal').on('open.zf.reveal', function () {
                cb();
                $(document).off('open.zf.reveal');
            });
        },

        onClose: function(cb) {
            $(document).off('closed.zf.reveal').on('closed.zf.reveal', function () {
                cb();
                $(document).off('closed.zf.reveal');
            });
        }
    }
};
},{"./util":63}],19:[function(require,module,exports){
'use strict';

var util = require('./util');

exports.init = function init() {
  //On Change Select in PDP
  $('.replenishmentCycle').on('change', function () {
    var footerURL = window.location.href;
    var selection = $(this).val();

    if (window.User.isCustomerAuthenticated == false && selection != 0) {
      $('.replenishmentCycle').val('0');
      var popup = new Foundation.Reveal($('#replenishment-signin'));
      popup.open();
    }

    $('.modal-btn-signin').on('click', function () {
      var urlLink = util.appendParamToURL(
        Urls.showLogin,
        'original',
        footerURL
      );
      window.location = util.appendParamToURL(
        urlLink,
        'replenishment',
        selection
      );
    });

    $('.modal-btn-register').on('click', function () {
      window.location = Urls.showCreateAccount;
    });
  });

  //Update the Order replenishment suggestion based on product variant sizeVariations
  $('input[name=size]').on('click', function () {
    //Get the recommendation from the input data-isreplenishable
    var replennumber = this.getAttribute('data-isreplenishable');

    //Construct the replenishment message
    var replenmsg = '';
    if (replennumber !== null && replennumber > 0) {
      var message = Resources.RECOMMENDED_REPLENISHMENT;

      replenmsg += message;
      replenmsg += replennumber;
      replenmsg += ' ';
      replenmsg += replennumber > 1 ? '${spanPlural}' : '${span}';
      replenmsg += '.';
    }

    //Assign it to replenreccomendation
    $('#replenrecommendation').text(replenmsg);
  });

  //My Account Replenishment Update Button
  $('.replenishmentupdate').on('click', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var uuid = getQueryValue('rid', href);
    var rdays = $('.' + uuid.substring(0, 26) + '_days').val();
    var replenishmentQuantity = $(
      '.' + uuid.substring(0, 26) + '_quantity'
    ).val();
    var updateReplenishment =
      href + '&rdays=' + rdays + '&qty=' + replenishmentQuantity;
    window.location = updateReplenishment;
  });

  //My Account Replenishment Cancel Button
  $('.replenishmentcancel').on('click', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var popup = new Foundation.Reveal($('#cancel-replenishment'));
    popup.open();

    $('.modal-btn-confirm').on('click', function () {
      window.location = href;
    });

    $('.modal-btn-keep').on('click', function () {
      popup.close();
    });
  });

  // Gets the query string value if it exists, returns null if it does not.
  // Example: getQueryValue("reset") will return the value true if the URL is http://www.domain.com?reset=true
  function getQueryValue(str, href) {
    /*var queryString = window.location.search.substring(1);*/
    var queryString = href;
    var queries = queryString.split('?');
    for (var i = 0; i < queries.length; i++) {
      var ft = queries[i].split('=');
      if (ft[0] == str) {
        return ft[1];
      }
    }
    return null;
  }
};

},{"./util":63}],20:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
    title: '',
    type: '',
    params: util.getQueryStringParams(window.location.search.substr(1)),
    redirect: function (newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function () {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./util":63}],21:[function(require,module,exports){
'use strict';

var giftcert = require('../giftcert'),
  tooltip = require('../tooltip'),
  util = require('../util'),
  dialog = require('../dialog'),
  page = require('../page'),
  login = require('../login'),
  validator = require('../validator'),
  headerMenu = require('../header-menu');
const withdraw = require('../withdraw');

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
  var $form = $('#edit-address-form');

  $form.find('input[name="format"]').remove();
  tooltip.init();

  $form
    .on('click', '.apply-button', function (e) {
      e.preventDefault();
      if (!$form.valid()) {
        return false;
      }
      var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');

      url = util.appendParamToURL(url, 'page', 'address');

      var applyName = $form.find('.apply-button').attr('name');
      var options = {
        url: url,
        data: $form.serialize() + '&' + applyName + '=x',
        type: 'POST'
      };
      $.ajax(options).done(function (data) {
        if (typeof data !== 'string') {
          if (data.success) {
            dialog.close();

            if (data.hasOwnProperty('action') && data.action !== '') {
              var expTime = new Date();

              expTime.setTime(expTime.getTime() + 60 * 1000);
            //IPSA_SFCC_OMS-1812 webアプリケーションヘッダのセキュリティガイドライン対応 Start
              document.cookie =
                  'action=' +
                  data.action +
                  '; expires=' +
                  expTime.toUTCString() +
                  '; secure=' +
                  true +
                  ';';
            //IPSA_SFCC_OMS-1812 webアプリケーションヘッダのセキュリティガイドライン対応 End
            }

            page.refresh();
          } else if (data.error) {
            page.redirect(Urls.csrffailed);
          } else {
            window.alert(data.message);
            return false;
          }
        } else {
          $('#dialog-container').html(data);
          account.init();
          tooltip.init();
        }
      });
    })
    .on('click', '.cancel-button, .close-button', function (e) {
      e.preventDefault();
      dialog.close();
    })
    .on('click', '.delete-button', function (e) {
      e.preventDefault();
      if (
        window.confirm(
          String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS)
        )
      ) {
        var url = util.appendParamsToUrl(Urls.deleteAddress, {
          AddressID: $form.find('#addressid').val(),
          format: 'ajax'
        });
        $.ajax({
          url: url,
          method: 'POST',
          dataType: 'json'
        }).done(function (data) {
          if (data.status.toLowerCase() === 'ok') {
            dialog.close();
            page.refresh();
          } else if (data.message.length > 0) {
            window.alert(data.message);
            return false;
          } else {
            dialog.close();
            page.refresh();
          }
        });
      }
    });

  validator.init();
}

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
  $('.order-items')
    .find('li.hidden:first')
    .prev('li')
    .append('<a class="toggle">VIEW ALL</a>')
    .children('.toggle')
    .on('click', function () {
      $(this).parent().siblings('li.hidden').show();
      $(this).remove();
    });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
  var addresses = $('#addresses');
  if (addresses.length === 0) {
    return;
  }

  addresses
    .on('click', '.address-edit, .address-create', function (e) {
      e.preventDefault();
      dialog.open({
        url: this.href,
        options: {
          open: initializeAddressForm
        }
      });
    })
    .on('click', '.delete', function (e) {
      e.preventDefault();
      if (
        window.confirm(
          String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS)
        )
      ) {
        $.ajax({
          url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
          dataType: 'json'
        }).done(function (data) {
          if (data.status.toLowerCase() === 'ok') {
            page.redirect(Urls.addressesList);
          } else if (data.message.length > 0) {
            window.alert(data.message);
          } else {
            page.refresh();
          }
        });
      }
    });
}

function initializePaymentForm() {
  $('#CreditCardForm').on('click', '.cancel-button', function (e) {
    e.preventDefault();
    dialog.close();
  });
}

/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
  $('.add-card').on('click', function (e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href'),
      options: {
        open: initializePaymentForm
      }
    });
  });

  $('.payment-cancel')
    .off('click.payment.cancel')
    .on('click.payment.cancel', function () {
      $(this).css('pointer-events', 'none');
      $('form[name="PaymentCancel"]').trigger('submit');
    });

  var paymentList = $('.payment-list');
  if (paymentList.length === 0) {
    return;
  }

  util.setDeleteConfirmation(
    paymentList,
    String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD)
  );
}

function initializePaymentForm() {
  $('#CreditCardForm').on('click', '.cancel-button', function (e) {
    e.preventDefault();
    dialog.close();
  });
}

function initAccountLink() {
  $('.form-accountlink').on('submit', function (e) {
    const self = this;
    const button = $(':submit', self);

    button.addClass('disabled');
    button.css('pointer-events', 'none');

    setTimeout(function () {
      button.removeClass('disabled');
      button.css('pointer-events', 'auto');
    }, 10000);
  });
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
  toggleFullOrder();
  initAddressEvents();
  initPaymentEvents();
  initAccountLink();
  login.init();
  headerMenu.initAccountNav();
}

/* registration */
// 会員登録時規約確認チェックボックスに応じて適用ボタンを有効・無効化
function enableRegisBtn() {
  $('.registration-agreetopolicy input').on('click', function () {
    if ($('.registration-agreetopolicy input').prop('checked')) {
      $('button.registration-apply-confirm').prop('disabled', false);
    } else {
      $('button.registration-apply-confirm').prop('disabled', true);
    }
  });
}

/* edit profile */
function renderBarcode() {
  var barcode = $('#barcode');
  var membershipID = $('#membershipID').val();

  if (barcode.length > 0) {
    $(barcode).barcode(membershipID, 'ean13', {
      barWidth: barcode.data('width'),
      barHeight: barcode.data('height'),
      fontSize: barcode.data('fontsize')
    });
  }
}

/**
 * お問い合わせ画面のEnterキー押下と多重クリックの防止
 *
 * @private
 */
function initContactus() {
  // Enterキー押下による誤送信を防ぐ
  $('#dwfrm_contactus input').on('keydown', function (e) {
    const ENTER_CODE = 'Enter';
    const ENTER_KEY_CODE = 13;
    const isEnterKeyPressed =
      e.code === ENTER_CODE || e.keyCode === ENTER_KEY_CODE;
    if (isEnterKeyPressed) {
      return false;
    } else {
      return true;
    }
  });

  const $contactusForm = $('#dwfrm_contactus');
  $contactusForm.on('submit', function (e) {
    // 多重クリック防止
    const $submitButton = $('#dwfrm_contactus_send');
    if ($contactusForm.valid()) {
      $submitButton.css('pointer-events', 'none');
    }
  });
}

/* receipt */
//領収書の宛名空チェックボックスに応じてパラメーター付与
function receiptAddressEmptyflg() {
  $('#receiptAddressEmptyflg').on('click', function () {
      var url =$('#receiptOpen').attr('value');
      if ($('#receiptAddressEmptyflg').prop('checked')) {
          $('#receiptOpen').attr("onclick", "window.open('"+url+"&addressEmptyflg=true')");
      }else{
          $('#receiptOpen').attr("onclick", "window.open('"+url+"')");
      }
  });
}

const account = {
  init: function () {
    initializeEvents();
    giftcert.init();
    enableRegisBtn();
    renderBarcode();
    initContactus();
    receiptAddressEmptyflg();
    withdraw.init();
  },
  initCartLogin: function () {
    login.init();
  }
};

module.exports = account;

},{"../dialog":9,"../giftcert":11,"../header-menu":12,"../login":16,"../page":20,"../tooltip":62,"../util":63,"../validator":64,"../withdraw":66}],22:[function(require,module,exports){
'use strict';

var account = require('./account'),
  bonusProductsView = require('../bonus-products-view'),
  cartStoreInventory = require('../storeinventory/cart'),
  util = require('../util'),
  wishlist = require('./wishlist'),
  recommendations = require('./product/recommendations');

//【サイトリニューアル 1.0】 Start カート画面でサンプル商品を選択する
const initSampleSelectionEvent =
	  require('./checkout/sampleselection').initSampleSelectionEvent;
//【サイトリニューアル 1.0】 End カート画面でサンプル商品を選択する

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
  $('#cart-table').on(
    'click',
    '.bonus-item-actions a, .item-details .bonusproducts a',
    function (e) {
      e.preventDefault();
      bonusProductsView.show(this.href);
    }
  );

  // override enter key for coupon code entry
  $('form input[name$="_couponCode"]').on('keydown', function (e) {
    if (e.which === 13 && $(this).val().length === 0) {
      return false;
    }
  });

  //to prevent multiple submissions of the form when removing a product from the cart
  var removeItemEvent = false;
  var wait_ga = true;

  $('button[name$="deleteProduct"]').on('click', function (e) {
    if (wait_ga || removeItemEvent) {
      e.preventDefault();
    }

    if (wait_ga && !removeItemEvent) {
      removeItemEvent = true;

      var me = $(this);
      var info = JSON.parse(this.dataset.info);

      window.dataLayer.push({
        event: 'removeFromCart',
        currencyCode: info.currency,
        userStatus:
          $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged',
        products: [
          {
            name: info.name,
            id: info.id,
            price: info.price,
            brand: info.brand,
            category: info.category,
            variant: info.variant,
            quantity: info.quantity,
          },
        ],
      });

      wait_ga = false;

      setTimeout(function () {
        removeItemEvent = false;

        me.trigger('click');
      }, 200);
    }
  });

  // update price when change quantity value
  $('.quantity-select').on('change', function (e) {
    $('#update-cart-quantity').trigger('click');
  });

  // セルフラッピングセット
  $('.select-items-block').on('click', '.common-bk-btn-w124', function () {
	  $(this).closest('.self-wrapping-select').addClass('hide');
	  $('.select-size-wrap').slideDown(300);
	  $(this).closest('.self-wrapping-fbox').addClass('wrapping-items-selected');
  });
}

exports.init = function () {
  initializeEvents();
  //【サイトリニューアル 1.0】 Start カート画面でサンプル商品を選択する
  initSampleSelectionEvent();
  //【サイトリニューアル 1.0】 End カート画面でサンプル商品を選択する
  if (SitePreferences.STORE_PICKUP) {
    cartStoreInventory.init();
  }
  account.initCartLogin();

  wishlist.initAddEvent(
    $('.save-for-later-btn').not('.saved-wishlist'),
    function (me) {
      var pid = me.data('pid');
      // 2024/08/09 RENEWAL2023-636 Start
      var productCategory = me.data('info').category;
      var productSubCategory = me.data('info').sub_category;
      var productName = me.data('info').name;
      var productVariant = me.data('info').variant;
      var pageCategory = data_general_gtm.pageCategory;
      var productOutOfStock = me.data('info').stock;
      var userStatus = window.UserStatus.userStatus;
      // 2024/08/09 RENEWAL2023-636 End
      
      var frm = $('#Cart-AddToWishlist');
      var url;

      frm.find('input[name="pid"]').val(pid);

      url = util.appendParamToURL(frm.attr('action'), 'pid', pid);

      frm.attr('action', url);

      frm.trigger('submit');
      
      // 2024/08/09 RENEWAL2023-636 Start
      window.dataLayer.push({
        "event": "clickSaveForLater",
        "productCategory": productCategory,
        "productSubCategory": productSubCategory,
        "productName": productName,
        "productVariant": productVariant,
        "pageCategory": pageCategory,
        "productOutOfStock": productOutOfStock,
        "userStatus": userStatus
      })
      // 2024/08/09 RENEWAL2023-636 End
    }
  );

  //【サイトリニューアル 1.0】 Start ほしいものリストから商品を削除する処理を実装
  wishlist.initAddEvent(
    $('.save-for-later-btn.saved-wishlist'),
    function (me) {
      var pid = me.data('pid');
      // 2024/08/09 RENEWAL2023-636 Start
      var productCategory = me.data('info').category;
      var productSubCategory = me.data('info').sub_category;
      var productName = me.data('info').name;
      var productVariant = me.data('info').variant;
      var pageCategory = data_general_gtm.pageCategory;
      var productOutOfStock = me.data('info').stock;
      var userStatus = window.UserStatus.userStatus;
      // 2024/08/09 RENEWAL2023-636 End
      
      var frm = $('#Cart-RemoveWishlist');
      var url;

      frm.find('input[name="pid"]').val(pid);

      url = util.appendParamToURL(frm.attr('action'), 'pid', pid);

      frm.attr('action', url);

      frm.trigger('submit');
      // 2024/08/09 RENEWAL2023-636 Start
      window.dataLayer.push({
        "event": "removeFromWishlist",
        "productCategory": productCategory,
        "productSubCategory": productSubCategory,
        "productName": productName,
        "productVariant": productVariant,
        "pageCategory": pageCategory,
        "productOutOfStock": productOutOfStock,
        "userStatus": userStatus
      })
      // 2024/08/09 RENEWAL2023-636 End
    }
  );
  //【サイトリニューアル 1.0】 End ほしいものリストから商品を削除する処理を実装

  recommendations();
};

},{"../bonus-products-view":4,"../storeinventory/cart":58,"../util":63,"./account":21,"./checkout/sampleselection":29,"./product/recommendations":42,"./wishlist":49}],23:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address');
    // select address from list
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) { return; }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        $form.validate().form();
    });
};

},{"../../util":63,"./shipping":30}],24:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
  formPrepare = require('./formPrepare'),
  giftcard = require('../../giftcard'),
  util = require('../../util');

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
  var $creditCard = $('[data-method="CREDIT_CARD"]');
  $creditCard
    .find('input[name$="creditCard_owner"]')
    .val(data.holder)
    .trigger('change');
  $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
  $creditCard
    .find('input[name*="_creditCard_number"]')
    .val(data.maskedNumber)
    .trigger('change');
  $creditCard
    .find('[name$="_month"]')
    .val(data.expirationMonth)
    .trigger('change');
  $creditCard
    .find('[name$="_year"]')
    .val(data.expirationYear)
    .trigger('change');
  $creditCard.find('input[name$="_cvn"]').val('').trigger('change');
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID) {
  // load card details
  var url = util.appendParamToURL(
    Urls.billingSelectCC,
    'creditCardUUID',
    cardID
  );
  ajax.getJson({
    url: url,
    callback: function (data) {
      if (!data) {
        window.alert(Resources.CC_LOAD_ERROR);
        return false;
      }
      setCCFields(data);
    },
  });
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
  var $paymentMethods = $('.payment-method');
  $paymentMethods.removeClass('payment-method-expanded');

  var $selectedPaymentMethod = $paymentMethods.filter(
    '[data-method="' + paymentMethodID + '"]'
  );
  if ($selectedPaymentMethod.length === 0) {
    $selectedPaymentMethod = $('[data-method="Custom"]');
  }
  $selectedPaymentMethod.addClass('payment-method-expanded');

  // ensure checkbox of payment method is checked
  $('input[name$="_selectedPaymentMethodID"]').prop('checked', false);
  $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');

  formPrepare.validateForm();
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
  var $checkoutForm = $('.checkout-billing');
  var $addGiftCert = $('#add-giftcert');
  var $giftCertCode = $('input[name$="_giftCertCode"]');
  var $addCoupon = $('#add-coupon');
  var $couponCode = $('input[name$="_couponCode"]');
  var $csrf_token = $('input[name$="csrf_token"]');
  var $selectPaymentMethod = $('.payment-method-options');
  var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();

  formPrepare.init({
    formSelector: 'form[id$="billing"]',
    continueSelector: '[name$="billing_save"]',
  });

  // default payment method to 'CREDIT_CARD'
  updatePaymentMethod(
    selectedPaymentMethod ? selectedPaymentMethod : 'CREDIT_CARD'
  );
  $selectPaymentMethod.on('click', 'input[type="radio"]', function () {
    updatePaymentMethod($(this).val());
  });

  // select credit card from list
  $('#creditCardList').on('change', function () {
    var cardUUID = $(this).val();
    if (!cardUUID) {
      return;
    }
    populateCreditCardForm(cardUUID);

    // remove server side error
    $('.required.error').removeClass('error');
    $('.error-message').remove();
  });

  $('#check-giftcert').on('click', function (e) {
    e.preventDefault();
    var $balance = $('.balance');
    if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
      var error = $balance.find('span.error');
      if (error.length === 0) {
        error = $('<span>').addClass('error').appendTo($balance);
      }
      error.html(Resources.GIFT_CERT_MISSING);
      return;
    }

    giftcard.checkBalance($giftCertCode.val(), function (data) {
      if (!data || !data.giftCertificate) {
        $balance
          .html(Resources.GIFT_CERT_INVALID)
          .removeClass('success')
          .addClass('error');
        return;
      }
      $balance
        .html(Resources.GIFT_CERT_BALANCE + ' ' + data.giftCertificate.balance)
        .removeClass('error')
        .addClass('success');
    });
  });

  $addGiftCert.on('click', function (e) {
    e.preventDefault();
    var code = $giftCertCode.val(),
      $error = $checkoutForm.find('.giftcert-error');
    if (code.length === 0) {
      $error.html(Resources.GIFT_CERT_MISSING);
      return;
    }

    var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
      giftCertCode: code,
      format: 'ajax',
    });
    $.getJSON(url, function (data) {
      var fail = false;
      var msg = '';
      if (!data) {
        msg = Resources.BAD_RESPONSE;
        fail = true;
      } else if (!data.success) {
        msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
        fail = true;
      }
      if (fail) {
        $error.html(msg);
        return;
      } else {
        window.location.assign(Urls.billing);
      }
    });
  });

  $addCoupon.on('click', function (e) {
    e.preventDefault();
    var $error = $checkoutForm.find('.coupon-error'),
      code = $couponCode.val();
    var csrf_token = $csrf_token.val();
    if (code.length === 0) {
      $error.html(Resources.COUPON_CODE_MISSING);
      return;
    }

    var url = util.appendParamsToUrl(Urls.addCoupon, {
      couponCode: code,
      format: 'ajax',
      csrf_token: csrf_token,
    });
    $.getJSON(url, function (data) {
      var fail = false;
      var msg = '';
      if (!data) {
        msg = Resources.BAD_RESPONSE;
        fail = true;
      } else if (!data.success) {
        msg = data.message;
        fail = true;
      }
      if (fail) {
        $error.html(msg);
        return;
      }

      //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
      //this will force a page refresh to display the coupon message based on a parameter message
      if (data.success && data.baskettotal === 0) {
        window.location.assign(Urls.billing);
      }
      location.reload();
    });
  });

  // trigger events on enter
  $couponCode.on('keydown', function (e) {
    if (e.which === 13) {
      e.preventDefault();
      $addCoupon.trigger('click');
    }
  });
  $giftCertCode.on('keydown', function (e) {
    if (e.which === 13) {
      e.preventDefault();
      $addGiftCert.trigger('click');
    }
  });
};

},{"../../ajax":1,"../../giftcard":10,"../../util":63,"./formPrepare":25}],25:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var $form, $continue, $requiredInputs, validator;

var hasEmptyRequired = function () {
  // filter out only the visible fields
  var requiredValues = $requiredInputs.filter(':visible').map(function () {
    return $(this).val();
  });
  return _(requiredValues).contains('');
};

var validateForm = function () {
  // only validate form when all required fields are filled to avoid
  // throwing errors on empty form
  if (!validator) {
    return;
  }
  //【サイトリニューアル 1.0】Start サブミットボタンにclass disabled をつけ外しする
  if (!hasEmptyRequired()) {
    if (validator.form()) {
      $continue.prop('disabled', false);
      $continue.removeClass('disabled');
    }
  } else {
    $continue.attr('disabled', 'disabled');
    $continue.addClass('disabled');
  }
  //【サイトリニューアル 1.0】End サブミットボタンにclass disabled をつけ外しする
};

//【サイトリニューアル 1.0】Start フォームチェックの後、ポイントのチェックも行う。サブミットボタンにclass disabled をつけ外しする
var validateEl = function () {
  if ($(this).val() === '') {
    $continue.attr('disabled', 'disabled');
    $continue.addClass('disabled');
  } else {
    // enable continue button on last required field that is valid
    // only validate single field
    if (validator.element(this) && !hasEmptyRequired()) {
      if ($('#tx-pu-apply-dummy').length > 0) {
        $('#tx-pu-apply-dummy').trigger('click');
      } else {
        $continue.prop('disabled', false);
        $continue.removeClass('disabled');
      }
    } else {
      $continue.attr('disabled', 'disabled');
      $continue.addClass('disabled');
    }
  }
};
//【サイトリニューアル 1.0】End フォームチェックの後、ポイントのチェックも行う。サブミットボタンにclass disabled をつけ外しする

var init = function (opts) {
  if (!opts.formSelector || !opts.continueSelector) {
    throw new Error('Missing form and continue action selectors.');
  }
  $form = $(opts.formSelector);
  $continue = $(opts.continueSelector);
  validator = $form.validate();
  $requiredInputs = $('.required', $form).find(':input');
  validateForm();
  // start listening
  $requiredInputs.on('change', validateEl);
  $requiredInputs.filter('input').on('keyup', _.debounce(validateEl, 200));
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;

},{"lodash":71}],26:[function(require,module,exports){
'use strict';

var address = require('./address'),
  billing = require('./billing'),
  multiship = require('./multiship'),
  shipping = require('./shipping'),
  pointexchange = require('./pointexchange'),
  summary = require('./summary');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function() {
  address.init();
  if ($('.checkout-shipping').length > 0) {
    shipping.init();
    //【サイトリニューアル 1.0】 Start 注文内容入力画面でポイント入力用のjsファイルを使用する
    pointexchange.init();
    //【サイトリニューアル 1.0】 End 注文内容入力画面でポイント入力用のjsファイルを使用する
  } else if ($('.checkout-multi-shipping').length > 0) {
    multiship.init();
  } else if ($('.checkout-pointexchange').length > 0) {
    pointexchange.init();
  } else if ($('#tx-paymentprocedure-form').length > 0) {
    //【サイトリニューアル 1.0】 Start 注文確認画面専用のjs ファイルを読み込むように修正
    summary.init();
    //【サイトリニューアル 1.0】 End 注文確認画面専用のjs ファイルを読み込むように修正
  } else {
    billing.init();
  }

  //if on the order review page and there are products that are not available diable the submit order button
  if ($('.order-summary-footer').length > 0) {
    if ($('.notavailable').length > 0) {
      $('.order-summary-footer .submit-order .button-fancy-large').attr(
        'disabled',
        'disabled'
      );
    }
  }
};

},{"./address":23,"./billing":24,"./multiship":27,"./pointexchange":28,"./shipping":30,"./summary":31}],27:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
    $.each($('.item-list'), function () {
        var $this = $(this);
        var $giftMessage = $this.find('.gift-message-text');

        //handle initial load
        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

        //set event listeners
        $this.on('change', function () {
            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
        });
    });
}


/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if  (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' +
                    ((address.ID) ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' +
                    address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode +
                    '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    initMultiGiftMessageBox();
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
        formPrepare.init({
            continueSelector: '[name$="addressSelection_save"]',
            formSelector: '[id$="multishipping_addressSelection"]'
        });
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({url: this.attributes.href.value,  options: {open: function () {
            address.init();
            addEditAddress(e.target);
        }}});
    });
};

},{"../../dialog":9,"../../util":63,"../../validator":64,"./address":23,"./formPrepare":25}],28:[function(require,module,exports){
'use strict';

const util = require('../../util');
const ajax = require('../../ajax');
const initSampleSelectionEvent =
  require('./sampleselection').initSampleSelectionEvent;
//【サイトリニューアル 1.0】Start 注文内容確認ボタンを活性化させても良いかチェックするために追加
const formPrepare = require('./formPrepare')
//【サイトリニューアル 1.0】End 注文内容確認ボタンを活性化させても良いかチェックするために追加

function isApplicablePoint(point) {
  if (!point) {
    return { failure: true, message: '' };
  }
  if (point.match(/[^0-9]/)) {
    return {
      failure: true,
      message: Resources.ERROR_POINT_INVALID
    };
  }

  const appliedPoints = parseInt(point);
  const earnedPoints = document.pointexchange.earnedPoints || 0;
  const merchandizeTotal = document.pointexchange.merchandizeTotal || 0;

  if (appliedPoints <= 0) {
    return {
      failure: true,
      message: Resources.ERROR_POINT_INVALID
    };
  }
  if (merchandizeTotal < appliedPoints) {
    return {
      failure: true,
      message: Resources.ERROR_POINT_OVER_MERCHANDIZETOTAL
    };
  }
  if (earnedPoints < appliedPoints) {
    return {
      failure: true,
      message: Resources.ERROR_POINT_OVER_LIMIT
    };
  }

  return {
    success: true
  };
}

function initInputEvent() {
  $('input[name$="pointexchange_points"]')
    .off('keydown.pointexchange.points')
    .on('keydown.pointexchange.points', function (e) {
      let keyCode = e.keyCode;
      let str = String.fromCharCode(keyCode);
      // 0-9 のキーコードはすべて通す
      if (48 <= keyCode && keyCode <= 57) {
        return true;
      }
      // 0-9（テンキー）の入力もすべて通す
      if (96 <= keyCode && keyCode <= 105) {
        return true;
      }
      // 半角数字と制御コード(BackSpace等)以外は入力をはじく
      if (!(str.match(/[0-9]/) || keyCode < 48 || e.ctrlKey)) {
        return false;
      }
    });

  $('input[name$="pointexchange_points"]')
    .off('blur.pointexchange.points')
    .on('blur.pointexchange.points', function () {
      const value = $(this)
        .val()
        .replace(/[０-９]/g, function (s) {
          // 全角数字を半角数字に変換する
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        })
        .replace(/[^0-9]/g, '')
        .replace(/^0{2,}/, '0');

      if (value) {
        $(this).val(parseInt(value));
      } else {
        $(this).val('');
      }
    });
}

function initApplyEvent() {
  const applyPoint = function (basePoint) {
	const usePointDiscount = $(
      // 【サイトリニューアル 1.0】javascript が動くようにDOMの取得方法を変更
      //'input[name$="pointexchange_usePointDiscount"][value="true"]'
      'input[name$="dwfrm_pointexchange_usePointDiscount"][value="true"]'
      ).is(':checked');

    if (!usePointDiscount) {
      formPrepare.validateForm();
      return;
    }

    // 【サイトリニューアル 1.0】javascript が動くようにDOMの取得方法を変更
    //const $buttonSubmit = $('button[name$="pointexchange_submit"]');
    const $buttonSubmit = $('button[name$="dwfrm_singleshipping_shippingAddress_save"]');
    const $summaryRedeemPoints = $('.order-redeem-points');
    const $summaryOrderTotal = $('.order-total-value');
    const applicableCheck = isApplicablePoint(basePoint);
    const applyPoint = parseInt(basePoint);

    if (applicableCheck.success) {
      // hide error message.
      $('.error-message').hide();
      $('.pu-error').text('');

      // reset applied point.
      const formattedPoint = Number(applyPoint).toLocaleString();
      $('.pointexchange-applied-value').text(formattedPoint);
      $('input[name$="pointexchange_redeemPoints"]').val(applyPoint);
      //【サイトリニューアル 1.0】Start 注文内容確認ボタンを活性化させても良いか入力フォームの方もチェックする
//      $buttonSubmit.prop('disabled', false);
//      $buttonSubmit.removeClass('disabled');
      formPrepare.validateForm();
      //【サイトリニューアル 1.0】End 注文内容確認ボタンを活性化させても良いか入力フォームの方もチェックする

      // reset ordertotal component.
      const currentApplied = $summaryRedeemPoints.text();
      const appliedPoints = currentApplied.replace(/[0-9,]+/, formattedPoint);
      $summaryRedeemPoints.text(appliedPoints);
      $summaryRedeemPoints.closest('.order-discount').removeClass('hide');

      const orderTotal = document.pointexchange.orderTotal;
      if (0 < orderTotal) {
        const adjustedTotal = Number(orderTotal - applyPoint).toLocaleString();
        const orgTotalText = $summaryOrderTotal.text();
        const newTotalText = orgTotalText.replace(/[0-9,]+/, adjustedTotal);
        $summaryOrderTotal.text(newTotalText);
      }
    } else {
      // show error message.
      if (applicableCheck.message) {
        $('.error-message').hide();
      }
      $('.pu-error').text(applicableCheck.message);
      // reset applied point.
      $('.pointexchange-applied-value').text('0');
      $('input[name$="pointexchange_redeemPoints"]').val('');

      // reset ordertotal component.
      $summaryRedeemPoints.closest('.order-discount').addClass('hide');

      const orderTotal = document.pointexchange.orderTotal;
      const adjustedTotal = Number(orderTotal).toLocaleString();
      const orgTotalText = $summaryOrderTotal.text();
      const newTotalText = orgTotalText.replace(/[0-9,]+/, adjustedTotal);
      $summaryOrderTotal.text(newTotalText);
      $buttonSubmit.prop('disabled', true);
      $buttonSubmit.addClass('disabled');
    }
  };

  $('#pu-apply')
    .off('click.pointexchange.apply')
    .on('click.pointexchange.apply', function () {
      const basePoints = $('input[name$="pointexchange_points"]').val();
      applyPoint(String(basePoints));
    });

  $('#pu-applyall')
    .off('click.pointexchange.applyall')
    .on('click.pointexchange.applyall', function () {
      const merchandizeTotal = document.pointexchange.merchandizeTotal;
      const earnedPoints = document.pointexchange.earnedPoints;
      const applicableMaxPoint = Math.min(merchandizeTotal, earnedPoints);

      applyPoint(String(applicableMaxPoint));
      $('input[name$="pointexchange_points"]').val(applicableMaxPoint);
    });
  //【サイトリニューアル 1.0】Start 注文内容確認ボタンを活性化させても良いかチェックするためのダミー要素のイベントを登録
  $('#tx-pu-apply-dummy').on('click', function () {
    const basePoints = $('input[name$="pointexchange_redeemPoints"]').val();
    applyPoint(String(basePoints));
  });
  //【サイトリニューアル 1.0】End 注文内容確認ボタンを活性化させても良いかチェックするためのダミー要素のイベントを登録
}

function initTypeChangeEvent() {
  $('input[name$="pointexchange_usePointDiscount"]')
    .off('change.pointexchange.type')
    .on('change.pointexchange.type', function () {
//      $('.pu-block').removeClass('selected');
//      $(this).closest('.pu-block').addClass('selected');
      const $cartPointDetail = $(this).closest('.pu-select').find('.cart-point-detail');

      const usePointDiscount = $(this).val();
      const $inputRedeemPoints = $('input[name$="pointexchange_redeemPoints"]');
      // 【サイトリニューアル 1.0】javascript が動くようにDOMの取得方法を変更
      //const $buttonSubmit = $('button[name$="pointexchange_submit"]');
      const $buttonSubmit = $('button[name$="dwfrm_singleshipping_shippingAddress_save"]');
      const $inputPoints = $('input[name$="pointexchange_points"]');

      if (usePointDiscount !== 'true') {

        // hide use point area
        $cartPointDetail.find('.use-point-area').slideUp(300)
        .end().find('.pu-error').slideUp(300)
        .end().find('.pu-use-point').slideUp(300);

        // enable submit button.
        $('.error-message').hide();
        //【サイトリニューアル 1.0】Start 注文内容確認ボタンを活性化させても良いか入力フォームの方もチェックする
//        $buttonSubmit.prop('disabled', false);
//        $buttonSubmit.removeClass('disabled');
        formPrepare.validateForm();
        //【サイトリニューアル 1.0】End 注文内容確認ボタンを活性化させても良いか入力フォームの方もチェックする
        $inputPoints.prop('disabled', true);

        // reset redeem point info.
        $('input[name$="pointexchange_points"]').val('');
        $('.pointexchange-applied-value').text('0');
        $('.order-redeem-points').closest('.order-discount').addClass('hide');
        $inputRedeemPoints.val('');

        const $summaryOrderTotal = $('.order-total-value');
        const orderTotal = Number(
          document.pointexchange.orderTotal
        ).toLocaleString();
        const orgTotalText = $summaryOrderTotal.text();
        const newTotalText = orgTotalText.replace(/[0-9,]+/, orderTotal);
        $summaryOrderTotal.text(newTotalText);
      } else {
        const redeemPoints = $inputRedeemPoints.val();
        // disable submit button.
        $buttonSubmit.prop('disabled', !redeemPoints);
        $buttonSubmit.toggleClass('disabled', !redeemPoints);
        $inputPoints.prop('disabled', false);

        $('.pu-error').text('');

        // show use point area
        $cartPointDetail.find('.use-point-area').slideDown(300)
        .end().find('.pu-error').slideDown(300)
        .end().find('.pu-use-point').slideDown(300);

      }
      $('#pu-apply').trigger('click.pointexchange.apply');
    });
}

function initCouponEvent() {
  // use coupon scenario
  const $checkoutForm = $('.checkout-pointexchange');
  const $addCoupon = $('#add-coupon');
  const $couponCode = $('input[name$="_couponCode"]');
  const $csrf_token = $('input[name$="csrf_token"]');

  $addCoupon.on('click', function (e) {
    e.preventDefault();
    // 【サイトリニューアル 1.0】javascript が動くようにDOMの取得方法を変更
    const $error = $('.coupon-code-app .coupon-error');
    //const $error = $checkoutForm.find('.coupon-error');
    const code = $couponCode.val();
    if (code.length === 0) {
      $error.html(Resources.COUPON_CODE_MISSING);
      return;
    }

    const url = util.appendParamsToUrl(Urls.addCoupon, {
      couponCode: code,
      format: 'ajax',
      csrf_token: $csrf_token.val()
    });
    $.getJSON(url, function (data) {
      var fail = false;
      var msg = '';
      if (!data) {
        msg = Resources.BAD_RESPONSE;
        fail = true;
      } else if (!data.success) {
        msg = data.message;
        fail = true;
      }
      if (fail) {
        $error.html(msg);
        return;
      }

      //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
      //this will force a page refresh to display the coupon message based on a parameter message
      if (data.success && data.baskettotal === 0) {
        window.location.assign(URLUtils.url('COPointExchange-Start'));
      }
      location.reload();
    });
  });

  // trigger events on enter
  $couponCode.on('keydown', function (e) {
    if (e.which === 13) {
      e.preventDefault();
      $addCoupon.trigger('click');
    }
  });

  // 【サイトリニューアル 1.0】 Start クーポン削除のイベントを追加
  $('.tx-delete-coupon').on('click', function (e) {
    var $submitForm = $('#tx-Delete-Coupon');
    $submitForm.find('[name=uuid]').val($(this).data('uuid'));
    $submitForm.submit();
  });
  // 【サイトリニューアル 1.0】 End クーポン削除のイベントを追加
}

exports.init = function () {
  //【サイトリニューアル 1.0】Start 注文内容確認ボタンを活性化させても良いか入力フォームの方もチェックする
  formPrepare.init({
    formSelector: 'form[id$="singleshipping_shippingAddress"]',
    continueSelector: '[name$="dwfrm_singleshipping_shippingAddress_save"]',
  });
  //【サイトリニューアル 1.0】End 注文内容確認ボタンを活性化させても良いか入力フォームの方もチェックする
  initApplyEvent();
  initTypeChangeEvent();
  initInputEvent();
  initSampleSelectionEvent();
  initCouponEvent();

  //【サイトリニューアル 1.0】 DOMの構造が変わったため、利用しないのラジオボタンを初期選択
//  const $radio = document.pointexchange.usePointDiscount
//    ? $('input[name$="pointexchange_usePointDiscount"][value="true"]')
//    : $('input[name$="pointexchange_usePointDiscount"][value="false"]');
  const $radio = $('input[name$="dwfrm_pointexchange_usePointDiscount"][value="false"]')

  $radio.prop('checked', true);
  $radio.trigger('change.pointexchange.type');
};

},{"../../ajax":1,"../../util":63,"./formPrepare":25,"./sampleselection":29}],29:[function(require,module,exports){
/**
 * @module SampleSelection
 */

/**
 * ボーナス商品追加用リクエストパラメータ
 *
 * @typedef {object} BonusProductRequestParam
 * @property {string} product.pid
 * @property {number} product.qty
 * @property {object} product.options
 */

/**
 * サンプル選択状態
 *
 * @typedef {object} SampleSelectionData
 * @property {Array<BonusProductRequestParam>} requestParams - サンプルをカートに追加するAjaxのリクエストパラメータ
 * @property {string} sampleTypeName - 確認ダイアログで使用されるサンプル選択種別名
 * @property {number} maxSelectableNum - 最大サンプル選択可能数
 * @property {number} selectedNum - 選択済みサンプル数
 */

//【サイトリニューアル 1.0】 Start 必要なライブラリの読み込み
var progress = require('../../progress');
var minicart = require('../../minicart');
//【サイトリニューアル 1.0】 End 必要なライブラリの読み込み

/**
 * サンプル選択機能 初期化処理
 *
 * @memberof SampleSelection
 * @returns {void}
 */
function initSampleSelectionEvent() {
  // 基本初期化処理
  initSampleSelectionEventBase();

  // 以下：追加初期化処理
  // - フォームサブミット時、サンプルが未選択であれば確認ダイアログを表示
  // - カート追加処理

  let isHookSubmit = true;

  const $form = $('form.checkout-pointexchange');
  const $sampleModal = $('.sample-modal');

  $form.off('submit').on('submit', (e) => {
    // 【サイトリニューアル 1.0】 Start 選択できるボーナス商品がない場合は以下のAJAX通信をしないでSubmitする
    const sampleSelectionItemMap = getSampleSelectionDataMap();
    const sampleSelectionEntries = Object.entries(sampleSelectionItemMap);
    if (sampleSelectionEntries.length < 1) {
        isHookSubmit = false;
    }
    // 【サイトリニューアル 1.0】 End 選択できるボーナス商品がない場合は以下のAJAX通信をしないでSubmitする
      if (!isHookSubmit) {
      return true;
    }
    e.preventDefault();

    // 未選択のサンプル選択があるなら
    const unselectedItems = Object.values(sampleSelectionItemMap).filter(
      (item) => item.selectedNum === 0
    );
    if (unselectedItems.length > 0) {
    // 選択状態に応じて確認ダイアログのタイトルを変更
      const $sampleModalTitle = $('#js-sample-remind-title');
      const modalTitle = uniq(
        unselectedItems.map((item) => item.sampleTypeName)
      ).join($sampleModalTitle.data('sample-remind-joinword'));
      $sampleModalTitle.html(
        $sampleModalTitle.data('sample-remind-base').replace('{0}', modalTitle)
      );
      // 確認ダイアログを表示
      $sampleModal.addClass('sample-modal-show');
      // 画面スクロール停止
      $('body').addClass('modal-scroll-fixed');
    } else {
      // なければ、カートにサンプルを追加して次へ進む
      submitSelection(sampleSelectionItemMap);
    }
  });

  // 確認モーダルで「選択せず次へ進む」押下時
  $sampleModal.on('click', '.no-selecting-sample', () => {
    submitSelection(getSampleSelectionDataMap());
  });

  //【サイトリニューアル 1.0】 Start 注文内容入力画面でラッピング商品をカート追加するためのイベント処理を追加
  // ラッピング商品の数量変更時に、ラッピング商品のカート追加を行う
  $(document).on('change', '.tx-giftbox-div select', (function() {
    var url = Urls.adddWrapingProduct;
    var form = {
      'pid': $(this).closest('.tx-giftbox-div').data('pid'),
      'Quantity': $(this).val()
    }
    addWrappingProduct(url, form);
  }));
  //【サイトリニューアル 1.0】 End 注文内容入力画面でラッピング商品をカート追加するためのイベント処理を追加

  /**
   * サンプル選択状況オブジェクトを受け取り
   * カートに商品を追加（Ajax）
   * 完了後、配送先選択画面へ遷移
   *
   * @param {{[key: string]: SampleSelectionData}} sampleSelectionItemMap
   * @returns {void}
   */
  function submitSelection(sampleSelectionItemMap) {
    const sampleSelectionEntries = Object.entries(sampleSelectionItemMap);

    const jqxhrs = sampleSelectionEntries.map(([uuid, item]) =>
      sendRequestToAddBonusProduct(uuid, item.requestParams)
    );

    Promise.all(jqxhrs)
      .then((dataList) => {
        // 全てのカート追加処理がエラーなく完了していれば
        if (dataList.every((data) => data.success)) {
          // サブミット再開
          isHookSubmit = false;
          //【サイトリニューアル 1.0】 Start カート画面でサンプル商品を選択する サブミット対象を変更
          $form.find('button.tx-submit-button')
//          $form
//            .find('button[name=dwfrm_pointexchange_submit]')
            .trigger('click');
          //【サイトリニューアル 1.0】 End カート画面でサンプル商品を選択する サブミット対象を変更
        } else {
          // エラーが返却された商品はエラーメッセージを選択一覧に表示
          dataList.forEach((data, idx) => {
            if (data.success) {
              return;
            }
            const [uuid] = sampleSelectionEntries[idx];
            Object.keys(data.error).map((pid) => {
              $(
                `.select-sample[data-bonus-discount-uuid="${uuid}"] .selected-block .selected-sample-text[data-pid="${pid}"]`
              ).addClass('disabled'); // cssによってエラーメッセージが付与される
            });
          });
          // 確認モーダルを閉じる
          $sampleModal.removeClass('sample-modal-show');
        }
      })
      .catch((jqXHR) => {
        console.error(`REQUEST_ERROR`, sampleSelectionItemMap, jqXHR);
      });
  }

  /**
   * プロモーションのUUIDをキーとした全てのサンプル選択情報を取得
   *
   * @private
   * @returns {{[key: string]: SampleSelectionData}}
   */
  function getSampleSelectionDataMap() {
    const selectionMap = {};
    $('.select-sample').each((idx, sampleElm) => {
      const $sampleElm = $(sampleElm);
      const uuid = $sampleElm.attr('data-bonus-discount-uuid');
      selectionMap[uuid] = getSampleSelectionData($sampleElm);
    });
    return selectionMap;
  }

  /**
   * 現在のサンプル選択状況を取得
   *
   * @private
   * @param {jQuery} $sampleElm
   * @returns {SampleSelectionData}
   */
  function getSampleSelectionData($sampleElm) {
    const pids = $sampleElm
      .find('.selected-block .selected-sample-text')
      .map((idx, selectedElm) => {
        return $(selectedElm).attr('data-pid');
      })
      .get();
    const maxSelectableNum = $sampleElm.data('max-selectable') || 0;
    const requestParams = pids.map((pid) =>
      mkBonusProductRequestParam(pid, getSelectedQuantityByPid(pid))
    );

    return {
      requestParams,
      sampleTypeName: $sampleElm.data('sample-type-name'),
      maxSelectableNum,
      selectedNum: pids.length
    };
  }

  /**
   * 指定サンプル商品IDの全種のサンプル選択での選択数を取得（サーバー側在庫チェックに使用）
   *
   * @param {string} pid
   * @returns {number}
   */
  function getSelectedQuantityByPid(pid) {
    return $(`.selected-block .selected-sample-text[data-pid="${pid}"]`).length;
  }
}

/**
 * ボーナス商品登録リクエスト用の商品オブジェクトを作成
 *
 * @private
 * @param {string} pid 商品ID
 * @param {number} selectedQuantity 全種サンプル選択における商品(pid)の選択数（在庫チェックに使用）
 * @returns {BonusProductRequestParam} ボーナス商品登録リクエスト用の商品オブジェクト
 */
function mkBonusProductRequestParam(pid, selectedQuantity) {
  return {
    product: {
      pid: pid.toString(),
      qty: 1, // 個数は1で固定
      selectedQuantity,
      options: {}
    }
  };
}

/**
 * ボーナス商品を登録するリクエストの送信
 *
 * @private
 * @param {string} uuid ボーナスディスカウントUUID
 * @param {Array<BonusProductRequestParam>} bonusProducts ボーナス商品情報の配列
 * @returns {object} jQueryAjaxオブジェクト
 */
function sendRequestToAddBonusProduct(uuid, bonusProducts) {
  const util = require('../../util');

  const url = util.appendParamsToUrl(Urls.addBonusProduct, {
    bonusDiscountLineItemUUID: uuid
  });
  const data = {
    bonusproducts: bonusProducts
  };

  return $.ajax({
    type: 'POST',
    dataType: 'json',
    cache: false,
    contentType: 'application/json',
    url: url,
    data: JSON.stringify(data)
  });
}

/**
 * 配列のユニーク化
 *
 * @param {Array<T>} array - 配列
 * @returns {Array<T>} ユニーク化された配列
 */
function uniq(array) {
  const knownElements = new Set();
  for (const elem of array) {
    knownElements.add(elem); // 同じ値を何度追加しても問題ない
  }
  return Array.from(knownElements);
}

//【サイトリニューアル 1.0】 Start 注文内容入力画面でラッピング商品をカート追加するためのイベント処理を追加
/**
 * ラッピング商品のカート追加を行う
 *
 * @param {String} url - ラッピング商品追加用のURL
 * @returns {Object} form - ポストする値
 */
function addWrappingProduct(url, form) {
  // カート追加中に他の操作をさせないため、画面をモーダルで覆う
  progress.show($('#main'));
  $('.loader').css('z-index', 500);
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: url,
    data: form,
    success: function (t) {
      if (t.redirectUrl) {
        window.location.href = t.redirectUrl;
      } else {
          updateMiniCartIcon();
          updateMiniCart();
          updateShippingMethodList();
      }
      progress.hide();
    },
    error : function () {
      progress.hide();
    }
  });
}

/**
 * ミニカートアイコンのHTMLを更新する
 *
 */
function updateMiniCartIcon() {
  $.ajax({
    method: 'Get',
    dataType: 'html',
    url: Urls.headerCartIcon,
    success: function (t) {
      $('#hd-cart').html($(t).html());
    },
    error : function () {
      progress.hide();
    }
  });
}

/**
 * ミニカートの中身のHTMLを更新する
 *
 */
function updateMiniCart() {
  $.ajax({
    method: 'Get',
    dataType: 'html',
    url: Urls.minicart,
    success: function (t) {
      minicart.show(t);
    },
    error : function () {
      progress.hide();
    }
  });
}

/**
 * 配送方法を更新する（ラッピング商品を追加、削除することにより送料が変更される可能性があるため）
 *
 */
function updateShippingMethodList() {
  $.ajax({
    method: 'Get',
    dataType: 'html',
    url: Urls.shippingMethodsList,
    success: function (t) {
      $('#shipping-method-list').html(t);
    },
    error : function () {
      progress.hide();
    }
  });
}
//【サイトリニューアル 1.0】 End 注文内容入力画面でラッピング商品をカート追加するためのイベント処理を追加

/**
 * サンプル選択初期化関数
 * （※納品コードのため、基本的にこの関数内の処理はWBで変更しない）
 */
function initSampleSelectionEventBase() {
  $('.pu-select').on('click', '.pu-title label', function () {
    $(this)
      .closest('.pu-block')
      .addClass('selected')
      .siblings('.pu-block')
      .removeClass('selected');
  });

  // セルフラッピングセット
  $('.select-items-block').on('click', '.common-bk-btn-w124', function () {
      $(this).closest('.self-wrapping-select').addClass('hide');
      $('.select-size-wrap').slideDown(300);
      $(this).closest('.self-wrapping-fbox').addClass('wrapping-items-selected');
  });

  // サンプル選択
  $('.select-sample').each(function () {
    var $selectSample = $(this),
      $categorySelect = $selectSample.find('.category-select'),
      $categoryBlocks = $selectSample.find('.category-blocks > div'),
      $selectedBlock = $selectSample.find('.selected-block'),
      $selectedList = $selectedBlock.find('.cart-in-item-cart-sample-after-category-select-selected-block-select-wrap');
    var maxSelectable = $selectSample.data('max-selectable'),
      selectedNum = 0;

    // プルダウン切り替え
    var showCategoyBlocks = function (val) {
      if (val === '') {
        $categoryBlocks.addClass('hide');
      } else {
        $categoryBlocks
          .filter(function () {
            return $(this).data('cname') === val;
          })
          .removeClass('hide')
          .siblings()
          .addClass('hide');
      }
    };

    // 選択中のサンプルエリア、アイテム選択非活性切り替え
    var setSelected = function () {
      if (selectedNum > 0) {
        $selectedBlock.removeClass('hide');
      } else {
        $selectedBlock.addClass('hide');
      }

      if (selectedNum >= maxSelectable) {
        $categoryBlocks
          .find('button:not(.selected)')
          .closest('.sample-item')
          .addClass('disabled');
      } else {
        $categoryBlocks.find('.sample-item').removeClass('disabled');
      }
    };

    // 初期表示
    showCategoyBlocks($categorySelect.find('select').val());
    $categoryBlocks.find('button.selected').each(function () {
      var $this = $(this),
        $target = $this.closest('.sample-item'),
        pid = $target.data('pid'),
        pname = $target.find('.cart-in-item-cart-sample-after-category-select-sample-label').html(),
        disabled = '';

      if ($target.hasClass('outofstock')) {
        disabled = ' class="disabled"';
      }
      // ----
      // fix：複数カテゴリ対応
      const selectedPids = $selectedList
        .find('p')
        .map((idx, elm) => $(elm).data('pid'))
        .get();
      if (selectedPids.includes(pid)) {
        return;
      }
      // ----

      $selectedList.append(
        '<p class="selected-sample-text" data-pid="' + pid + '"' + disabled + '>' + pname + '</p>'
      );
      selectedNum++;
    });
    setSelected();

    // プルダウン
    $categorySelect.on('change', 'select', function () {
      showCategoyBlocks(this.value);
    });
    // 選択ボタン
    $categoryBlocks.on('click', 'button', function () {
      var $this = $(this),
        $target = $this.closest('.sample-item'),
        pid = $target.data('pid'),
        pname = $target.find('.cart-in-item-cart-sample-after-category-select-sample-label').html();

      if ($this.hasClass('selected')) {
        selectedNum--;

        // 選択中のサンプルを削除
        $selectedList.find('.selected-sample-text[data-pid="' + pid + '"]').remove();
      } else {
        selectedNum++;

        // 選択中のサンプルを追加
        $selectedBlock.removeClass('hide');
        $selectedList.append('<p class="selected-sample-text" data-pid="' + pid + '">' + pname + '</p>');
      }
      // ----
      // fix：複数カテゴリ対応
      $categoryBlocks
        .find('div.sample-item[data-pid="' + pid + '"] button')
        .each((idx, elm) => $(elm).toggleClass('selected'));
      // ----
      // $(this).toggleClass('selected');
      // ----

      // 選択中のサンプルエリア、アイテム選択非活性切り替え
      setSelected();
    });
  });

  // サンプル選択エリア表示
  $('.cart-in-item-cart-sample-before-select-button').on('click', function() {
    $('.cart-in-item-cart-sample-before-select').addClass('hide');
    $('.cart-in-item-cart-sample-after-select').slideToggle(600);
  });

  // モーダル
  var $sampleModal = $('.sample-modal');
  $sampleModal.on('click', '.selecting-sample', function () {
    $sampleModal.removeClass('sample-modal-show'); // モーダル非表示
    // 画面スクロール再開
    $('body').removeClass('modal-scroll-fixed');
  });
}

module.exports.initSampleSelectionEvent = initSampleSelectionEvent;

},{"../../minicart":17,"../../progress":51,"../../util":63}],30:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
  formPrepare = require('./formPrepare'),
  progress = require('../../progress'),
  tooltip = require('../../tooltip'),
  util = require('../../util');

var shippingMethods;
/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
  // show gift message box, if shipment is gift
  $('.gift-message-text').toggleClass(
    'hidden',
    $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true'
  );
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
  var $summary = $('#secondary.summary');
  // indicate progress
  progress.show($summary);

  // load the updated summary area
  $summary.load(Urls.summaryRefreshURL, function () {
    // hide edit shipping method link
    $summary.fadeIn('fast');
    $summary.find('.checkout-mini-cart .minishipment .header a').hide();
    $summary.find('.order-totals-table .order-shipping .label a').hide();
  });
}

/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
  var $form = $('.address');
  var params = {
    address1: $form.find('input[name$="_address1"]').val(),
    address2: $form.find('input[name$="_address2"]').val(),
    countryCode: $form.find('select[id$="_country"]').val(),
    stateCode: $form.find('select[id$="_state"]').val(),
    postalCode: $form.find('input[name$="_postal"]').val(),
    city: $form.find('input[name$="_city"]').val()
  };
  return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
  // nothing entered
  if (!shippingMethodID) {
    return;
  }
  // attempt to set shipping method
  var url = getShippingMethodURL(Urls.selectShippingMethodsList, {
    shippingMethodID: shippingMethodID
  });
  ajax.getJson({
    url: url,
    callback: function (data) {
      updateSummary();
      if (!data || !data.shippingMethodID) {
        window.alert("Couldn't select shipping method.");
        return false;
      }
      // display promotion in UI and update the summary section,
      // if some promotions were applied
      $('.shippingpromotions').empty();

      // TODO the for loop below isn't doing anything?
      // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
      //     var len = data.shippingPriceAdjustments.length;
      //     for (var i=0; i < len; i++) {
      //         var spa = data.shippingPriceAdjustments[i];
      //     }
      // }
    }
  });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
  var $shippingMethodList = $('#shipping-method-list');
  if (!$shippingMethodList || $shippingMethodList.length === 0) {
    return;
  }
  var url = getShippingMethodURL(Urls.shippingMethodsJSON);

  ajax.getJson({
    url: url,
    callback: function (data) {
      if (!data) {
        return false;
      }
      if (shippingMethods && shippingMethods.toString() === data.toString()) {
        // No need to update the UI.  The list has not changed.
        return true;
      }

      // We need to update the UI.  The list has changed.
      // Cache the array of returned shipping methods.
      shippingMethods = data;
      // indicate progress
      progress.show($shippingMethodList);

      // load the shipping method form
      var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
      $shippingMethodList.load(smlUrl, function () {
        $shippingMethodList.fadeIn('fast');
        // rebind the radio buttons onclick function to a handler.
        $shippingMethodList
          .find('[name$="_shippingMethodID"]')
          .on('click', function () {
            selectShippingMethod($(this).val());
          });

        // update the summary
        updateSummary();
        progress.hide();
        tooltip.init();
        //if nothing is selected in the shipping methods select the first one
        if ($shippingMethodList.find('.input-radio:checked').length === 0) {
          $shippingMethodList
            .find('.input-radio:first')
            .prop('checked', 'checked');
        }
      });
    }
  });
}

exports.init = function () {
  formPrepare.init({
    continueSelector: '[name$="shippingAddress_save"]',
    formSelector: '[id$="singleshipping_shippingAddress"]'
  });
  $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);

  $('.address').on(
    'change',
    'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_zip"]',
    updateShippingMethodList
  );
  
  //【サイトリニューアル 1.0】 Start カートに戻るボタン押下時のイベントを設定
  $('.tx-back-cart-button').on('click', function(e) {
    e.preventDefault();
    window.location.href = Urls.cartShow;
  });
  //【サイトリニューアル 1.0】 End カートに戻るボタン押下時のイベントを設定

  giftMessageBox();
  updateShippingMethodList();
};

exports.updateShippingMethodList = updateShippingMethodList;

},{"../../ajax":1,"../../progress":51,"../../tooltip":62,"../../util":63,"./formPrepare":25}],31:[function(require,module,exports){
//【サイトリニューアル 1.0】 Start 注文確認画面専用のjs ファイルを新規作成
'use strict';

var util = require('../../util');

exports.init = function () {
  $(document).on('click', '.tx-back-shipping-button', (function () {
    var redirectUrl = Urls.shippingStart;
    if ($(this).data('idname') !== undefined) {
      redirectUrl += '#' + $(this).data('idname')
    }
    window.location.href = redirectUrl;
  }));

  $(document).on('click', '.tx-paymentprocedure-button', (function () {
    $('#tx-paymentprocedure-form').submit();
  }));
};
//【サイトリニューアル 1.0】 End 注文確認画面専用のjs ファイルを新規作成

},{"../../util":63}],32:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
  ajax = require('../ajax'),
  page = require('../page'),
  productTile = require('../product-tile');
//quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
  $('#compare-table').on('click', '.remove-link', function (e) {
    e.preventDefault();
    ajax.getJson({
      url: this.href,
      callback: function () {
        page.refresh();
      },
    });
  });
  //.on('click', '.open-quick-view', function (e) {
  //    e.preventDefault();
  //    var url = $(this).closest('.product').find('.thumb-link').attr('href');
  //    quickview.show({
  //        url: url,
  //        source: 'quickview'
  //    });
  //});

  $('#compare-category-list').on('change', function () {
    $(this).closest('form').trigger('submit');
  });
}

exports.init = function () {
  productTile.init();
  initializeEvents();
  addProductToCart.init();
};

},{"../ajax":1,"../page":20,"../product-tile":50,"./product/addToCart":35}],33:[function(require,module,exports){
'use strict';

var addToCart = require('./product/addToCart'),
  wishlist = require('./wishlist'),
  util = require('../util');

var cp_custom_event = {
  cart: false,
  wishlist: false,
};

function getProductStatus(pid, callback_fn) {
  $.ajax({
    type: 'GET',
    url: Urls.checkStatus + '?pid=' + pid + '&format=ajax',
  }).done(function (data) {
    callback_fn(pid, data);
  });
}

function initAddToCartDefault(callback_fn) {
  cp_custom_event.cart = true;

  addToCart.initAddToCart($('#product-action-form #add-to-cart'), function (
    form,
    remain_quantity
  ) {
    callback_fn(form, remain_quantity);
  });
}

exports.init = function () {
  if (!cp_custom_event.cart) {
    addToCart.initAddToCart($('#product-action-form #add-to-cart'), null);
  }

  if (!cp_custom_event.wishlist) {
    wishlist.initAddEvent(
      $('#product-action-form #add-to-wishlist'),
      function () {
        var frm = $('#product-action-form #save-for-later');
        var url = util.appendParamToURL(
          frm.attr('action'),
          'pid',
          frm.find('.add-to-wishlist-pid').val()
        );

        frm.attr('action', url);

        $('#product-action-form #save-for-later').trigger('submit');
      }
    );
  }
};

exports.init_window = function () {
  window.getProductStatus = getProductStatus;
  window.initAddToBasket = addToCart.initAddToCart;
  window.initAddToBasketDefault = initAddToCartDefault;
  window.initSaveForLater = wishlist.initAddEvent;
  window.cp_custom_event = cp_custom_event;
};

},{"../util":63,"./product/addToCart":35,"./wishlist":49}],34:[function(require,module,exports){
'use strict';

var addToCart = require('./product/addToCart'),
  headerMenu = require('../header-menu');

//3桁カンマ区切り
function mypageSplit3(price) {
  return (price + '').replace(/(\d)(?=(\d{3})+$)/g, '$1,');
}

/**
 * Initial slick slider for point exchange
 * */
function initSlick() {
  $('.exchange-products').slick({
    arrows: true,
    dots: true,
    draggable: false,
    slidesToScroll: 3,
    slidesToShow: 3,
    speed: 500,
    swipe: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          draggable: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          swipe: true,
          touchMove: true
        }
      }
    ]
  });
}

/**
 * Initial point
 * */
function initPoint() {
  var $targetProducts = $('.target-products'), $selectedProducts = $('.selected-products').find('.row'),
    $pointUse = $('#point-use'), $pointBalance = $('#point-balance'), $cartin = $('#point-cartin a'),
    initPoint = parseInt($('#point-init').html(), 10), currentPoint = initPoint, usedPoint = $('#point-use').html(),
    $addToCart = $('.add-to-cart'), $pids = $('#pids'), pids = $pids.val();
  var cartUrl = '/addcart?pid=', cartUrlParam = '';

  //初期処理
  if ($('#point-use').length) {
    usedPoint = parseInt(usedPoint.replace(/,/g, ''), 10);
  }
  currentPoint = currentPoint - usedPoint;

  // ポイント計算
  var calcPoint = function (point) {
    // 保持ポイント
    currentPoint -= point;
    // 使用ポイント
    usedPoint += point;

    $pointUse.html(mypageSplit3(usedPoint));
    $pointBalance.html(mypageSplit3(currentPoint));

    // 選択ボタン再計算
    resetButton(currentPoint);

    // カートに入れるボタン
    if ($selectedProducts.find('.column').length > 0) {
      cartUrlParam = '';
      pids = '';
      $selectedProducts.find('.column').each(function () {
        cartUrlParam += ',' + $(this).data('pid');
        pids += ',' + $(this).data('pid');
      });

      $cartin.removeClass('disabled');

      $pids.val(pids.slice(1));
    } else {
      $cartin.addClass('disabled');

      $pids.val('');
    }
  };

  // 選択商品解除
  var cancelProduct = function (pid) {
    // ボタン解除
    $targetProducts.find('[data-pid="' + pid + '"]').find('.btn').removeClass('selected');

    // 選択した商品から削除
    $selectedProducts.find('[data-pid="' + pid + '"]').remove();
  };

  // 選択ボタン初期設定
  var resetButton = function (point) {
    $targetProducts.find('.btn:not(".selected, .out-of-stock, .disabled")').each(function () {
      var $this = $(this), $target = $this.closest('.product-block');

      if (parseInt($target.data('point'), 10) > point) {
        $this.addClass('shortage');
      } else {
        $this.removeClass('shortage');
      }
    });
  };

  // 選択ボタン初期設定
  resetButton(currentPoint);

  // 選択ボタンクリック
  $targetProducts.on('click', '.btn:not(".shortage, .out-of-stock, .disabled")', function () {
    var $this = $(this), $target = $this.closest('.product-block'),
      pid = $target.data('pid'), point = parseInt($target.data('point'), 10);

    if ($this.hasClass('selected')) {
      // 選択商品解除
      cancelProduct(pid);

      // ポイント計算（保持ポイントから減算）
      calcPoint(-point);
    } else {
      // 選択
      $this.addClass('selected');

      // 選択した商品へ追加
      var html = '<div class="small-12 medium-6 column" data-pid="' + pid + '" data-point="' + point + '"><div><p class="close"></p>';
      html += '<div class="product-image">' + $target.find('.product-image').html() + '</div>';
      html += '<div><p class="pro-name">' + $target.find('.pro-name').html() + '</p><p>数量:　1<br>使用ポイント:　' + mypageSplit3(point) + 'pt</p></div>';
      html += '</div></div>';
      $selectedProducts.append(html);

      // ポイント計算（保持ポイントへ加算）
      calcPoint(point);
    }
  });

  // 選択した商品解除
  $selectedProducts.on('click', '.close', function () {
    var $target = $(this).closest('.column');

    // 選択商品解除
    cancelProduct($target.data('pid'));

    // ポイント計算（保持ポイントから減算）
    calcPoint(-(parseInt($target.data('point'), 10)));
  }).on('click', 'a', function () {
    return false;
  });
}

function getExtra1Level(data) {
  const dataArray = data.split('.');

  if (dataArray.length !== 2) {
    return null;
  }

  const level = parseInt(dataArray[1], 10);

  if (isNaN(level)) {
    return null;
  }

  return level < 1 || level > 5 ? null : level;
}

//レシピ
function initRecipe() {
  $('.recipe-parameters').each(function () {
    $(this).find('> div').each(function () {
      var $this = $(this), $target = $this.find('> div'), num = $this.find('> span').html();

      if ($target.hasClass('p-bar')) {
        $target.find('> span').css('width', num + '%');
      } else if ($target.hasClass('p-point')) {
        var $point = $target.find('> span'),
          pointW = $point.outerWidth(),
          targetW = $target.outerWidth();

        $point.css('left', (num - ((pointW / 2) / targetW * 100)) + '%');
      } else if ($target.hasClass('p-level')) {
        var level = num.slice(-1);

        $target.find('> span').eq(5 - level).addClass('c');
      }
    });
  });
  $('.recipe-skin-type-slick').slick({
    arrows: false,
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 750,
    swipe: false,
    touchMove: false
  });
  $('#recipe-skin-type').find('.anchor-list').on('click', 'li', function () {
    var $this = $(this);

    $this.addClass('current').siblings().removeClass('current');
    $('.recipe-skin-type-slick').slick('slickGoTo', $this.index(), false);
  });

  var mql = window.matchMedia('screen and (max-width: 768px)');
  var $recipeSkinCondSlick = $('.recipe-skin-cond-slick');
  var checkBreakPoint = function (mqle) {
    if (mqle.matches) {
      // スマホ
      $recipeSkinCondSlick.not('.slick-initialized').slick({
        arrows: true,
        draggable: false,
        dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 750
      });
    } else {
      // PC
      if ($recipeSkinCondSlick.hasClass('slick-initialized')) {
        $recipeSkinCondSlick.slick('unslick');
      }
    }
  }
  mql.addListener(checkBreakPoint);
  checkBreakPoint(mql);

  $('.recipe-products-list').each(function () {
    $(this).slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $('.anchor-list').on('click', 'a', function () {
    var $target = $($(this).attr('href'));

    $('html, body').stop().animate({
      scrollTop: $target.offset().top
    }, 500);

    return false;
  });

  // タッチアップガイドモーダル
  (function () {
    var showTugModal = function(targetId) {
      var $target = $(targetId);

      $target.addClass('modal-show').find('.tug-modal-block').addClass('c');
    }

    var closeTugModal = function() {
      var $target = $('.recipe-tug-modal.modal-show');

      $target.removeClass('modal-show').find('.tug-modal-block').removeClass('c');
    };

    $('.recipe-care-point').on('click', 'a[href^="#recipe-tug-"]', function (e) {
      e.preventDefault();

      showTugModal($(this).attr('href'));
    }).on('click', '.tug-modal-bg', function() {
      closeTugModal();
    }).on('click', '.tug-close', function() {
      closeTugModal();
    }).find('.tug-modal-block').append('<div class="tug-close"></div>');

    $(document).on('keydown', function(e) {
      if (e.keyCode === 27) {
        closeTugModal();
      }
    });
  }());
}

/**
 * @private
 * @function
 * @description Binds the events of point use page
 */
function initializeEvents() {
  // サイドメニュー
  headerMenu.initAccountNav();
  initSlick();
  initPoint();

  addToCart.initAddAllToCart($('.point-use .add-to-cart'), true, addToCart_Callback);

  // レシピ
  initRecipe();
}

/**
 * @description Binds the events to remove all selected items and disable the `select` button of added items.
 * */
function addToCart_Callback() {
  // remove all selected items
  if ($('#pids').val() != '') {
    $('p.to-point-exchange').removeClass('hide');
  }
  $('.selected-products .row').html('');
  $('#pids').val('');
  // disable `select` button of added items
  var selectedItems = $('.exchange-products').find('p.btn.selected');
  selectedItems.removeClass('selected').addClass('out-of-stock');
  selectedItems.html(Resources.OVER_LIMIT);
  // set default the href of add to cart button
  $('.add-to-cart').addClass('disabled');
}

var point = {
  init: function () {
    initializeEvents();
  }
};

module.exports = point;

},{"../header-menu":12,"./product/addToCart":35}],35:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
  minicart = require('../../minicart'),
  page = require('../../page'),
  util = require('../../util'),
  Promise = require('promise'),
  variant = require('./variant'),
  _ = require('lodash');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form, psetid) {
  var $form = $(form),
    $qty = $form.find('input[name="Quantity"], select[name="Quantity"]'),
    urlpost;

  if (
    $qty.length === 0 ||
    isNaN($qty.val()) ||
    parseInt($qty.val(), 10) === 0
  ) {
    $qty.val('1');
  }

  urlpost = util.ajaxUrl(Urls.addProduct);
  urlpost =
    psetid != '' && psetid != null
      ? util.appendParamToURL(urlpost, 'psetid', psetid)
      : urlpost;

  return Promise.resolve(
    $.ajax({
      type: 'POST',
      url: urlpost,
      data: $form.serialize()
    })
  ).then(function (response) {
    try {
      response = JSON.parse(response);
    } catch (er) {}

    const isError = response.status === 'error';
    const message = isError ? response.message : null;
    const responseHTML = response.hasOwnProperty('status') ? null : response;

    return {
      error: isError,
      response: responseHTML,
      msg: message,
      isWithinOrderablePeriod: response.isWithinOrderablePeriod
    };
  });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
  e.preventDefault();

  var info = JSON.parse(this.dataset.info);

  var $form = $(this).closest('form');
  var $qty = $form.find('input[name="Quantity"], select[name="Quantity"]');
  var qty = 1;

  if (
    !($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0)
  ) {
    qty = $qty.val();
  }

  window.dataLayer.push({
    event: 'addToCart',
    currencyCode: info.currency,
    userStatus: $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged',
    products: [
      {
        name: info.name,
        id: info.id,
        category: info.category,
        price: info.hasOwnProperty('is_kit')
          ? $('#kit-net-price').text()
          : info.price,
        brand: info.brand,
        quantity: qty
      }
    ]
  });

//  if (window.innerWidth < 768) {
    dialog.loading();
//  }

  addItemToCart($form, null).then(
    function (response) {
      var $uuid = $form.find('input[name="uuid"]');

      dialog.close();

      if ($uuid.length > 0 && $uuid.val().length > 0) {
        page.refresh();
      } else {
        showResult(!response.error, response.response, function () {
          checkRemainQuantity($form);
        });
      }
    }.bind(this)
  );
};

/**
 * @description Handler to handle the add all items to cart event
 */
function initAddAllToCart(cmd, id_list, callback) {
  cmd.off('click').on('click', function (e) {
    e.preventDefault();

    var me = $(this);

    if (me.hasClass('disabled')) {
      return;
    }

    var current_form = me.closest('form');

//    if (window.innerWidth < 768) {
      dialog.loading();
//    }

    var obj_list = !id_list
      ? $('#product-set-list').find('form').toArray()
      : current_form.find('#pids').val().split(',');
    var psetid = 'ps_';

    psetid += !id_list
      ? $(this).attr('data-uid') + new Date().getTime()
      : Math.floor(Math.random() * 1000) + 1 + '' + new Date().getTime();

    Promise.all(
      _.map(obj_list, function (obj) {
        var frm;

        if (id_list !== null) {
          frm = current_form;

          frm.find('#pid').val(obj);
        } else {
          frm = obj;
        }

        return addItemToCart(frm, psetid);
      })
    ).then(function (responses) {
      var total_error = 0;
      var total_response;

      dialog.close();

      total_response = responses.length;

      for (var i = 0; i < total_response; i++) {
        if (responses[i].error) {
          total_error++;
        }
      }

      if (total_error < total_response) {
        Promise.resolve(
          $.ajax({
            type: 'GET',
            url: util.appendParamToURL(Urls.minicartWBonus, 'psetid', psetid)
          })
        ).then(function (response) {
          showResult(true, response, function () {
            for (var i = 0; i < $productForms.length; i++) {
              checkRemainQuantity($productForms[i]);
            }
          });
        });
      } else {
        showResult(false, null, function () {});
      }

      if (callback) {
        callback();
      }
    });
  });
}

/**
 * @description Show result after add to cart and do checking
 */
function showResult(success, response, checking_fn) {
  if (success) {

//    if (window.innerWidth < 768) {
      minicart.notice(false);
//    }

    minicart.show(response);

    updateMiniCartIcon();

    checking_fn();

    return;
  }

  minicart.notice(true);
}

/**
 * ミニカートアイコンのHTMLを更新する
 *
 */
function updateMiniCartIcon() {
  $.ajax({
    method: 'Get',
    dataType: 'html',
    url: Urls.headerCartIcon,
    success: function (t) {
      $('#hd-cart').html($(t).html());
    }
  });
}

/**
 * @description Checking remain quantity
 */
function checkRemainQuantity(form, checking_fn) {
  var pid;

  form = $(form);

  pid = form.find('#pid');

  if (pid.length > 0) {
    setTimeout(function () {
      var remain_quantity;

      pid = pid.val();

      remain_quantity = $('#remain_quantity_' + pid);

      if (remain_quantity.length > 0) {
        if (checking_fn == null) {
          variant.checkStatus(pid, parseInt(remain_quantity.val(), 10));
        } else {
          checking_fn(form, parseInt(remain_quantity.val(), 10));
        }
      }
    }, 20);
  }
}

function initAddToCart(cmd, checking_fn) {
  cmd.off('click').on('click', function (e) {
    e.preventDefault();

    var me = $(this);

    if (me.hasClass('disabled')) {
      return;
    }

    var info = JSON.parse(this.dataset.info);
    var frm = me.closest('form');
    var $qty = frm.find('input[name="Quantity"], select[name="Quantity"]');
    var qty = 1;

    if (
      !(
        $qty.length === 0 ||
        isNaN($qty.val()) ||
        parseInt($qty.val(), 10) === 0
      )
    ) {
      qty = $qty.val();
    }

    window.dataLayer.push({
      event: 'addToCart',
      currencyCode: info.currency,
      userStatus:
        $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged',
      products: [
        {
          name: info.name,
          id: info.id,
          category: info.category,
          price: info.hasOwnProperty('is_kit')
            ? $('#kit-net-price').text()
            : info.price,
          brand: info.brand,
          quantity: qty
        }
      ]
    });

//    if (window.innerWidth < 768) {
      dialog.loading();
//    }

    addItemToCart(frm, null).then(
      function (response) {
        var $uuid = frm.find('input[name="uuid"]');

        dialog.close();

        if (response.error && !response.isWithinOrderablePeriod) {
          window.location.href = Urls.cartShow;

          return;
        }

        // ページの商品が「注文制限商品」で、カート追加時エラーでなければ、ページ内埋め込み変数「注文制限商品がカートに追加済みか」をtrueにし、これ以上追加できない旨のメッセージを表示する
        // (TODO: 既存処理では、カート追加時Ajaxのレスポンスとしてhtmlを返しており、dtoの受け渡しが冗長になるため、カートに追加成功したという情報以外はクライアントだけで処理を完結させている。
        //        カート追加時の処理に大規模な修正が入った時にリファクタリングを検討してください)
        if (isOrderRestrictedProductPage()) {
          showOrderRestrictedProductAlreadyInCartError(info.id);
        }

        if ($uuid.length > 0 && $uuid.val().length > 0) {
          page.refresh();
        } else {
          showResult(!response.error, response.response, function () {
            checkRemainQuantity(frm, checking_fn);
          });
        }
      }.bind(this)
    );
  });
}

/**
 * 「現在表示しているページの商品が注文制限商品か」をページ内埋め込み変数から取得する
 *
 * @returns {undefined}
 */
function isOrderRestrictedProductPage() {
  return $('#js-is-order-restricted-product').val() === 'true';
}

/**
 * ページ内に埋め込まれた「注文制限商品がカートに追加済み」フラグをtrueにし、エラーメッセージを表示する
 * (注文制限商品のカートに追加が成功した時、これ以上追加できないことを表示するために呼び出す)
 *
 * @param {string} pid - 商品ID
 * @returns {undefined}
 */
function showOrderRestrictedProductAlreadyInCartError(pid) {
  $('#js-has-order-restricted-product-in-cart').val('true');
  $('#js-order-restricted-product-id-in-cart').val(pid);
  $('#js-is-add-to-cart-error-on-order-restriction').val('true');

  const $errorElm = $('.js-orderrestricted-error-for-responsive');
  $errorElm.removeClass('hide');
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
exports.init = function () {
  initAddAllToCart($('#add-all-to-cart'));
  initAddToCart($('.product-detail .add-to-cart'), null);
  //【サイトリニューアル 1.0】画面下部のカートインボタンにイベントハンドラを登録
  initAddToCart($('.pdp_under .add-to-cart'), null);
  //【サイトリニューアル 1.0】画面下部のカートインボタンにイベントハンドラを登録
};

exports.initAddToCart = initAddToCart;
exports.initAddAllToCart = initAddAllToCart;
exports.updateMiniCartIcon = updateMiniCartIcon;

},{"../../dialog":9,"../../minicart":17,"../../page":20,"../../util":63,"./variant":43,"lodash":71,"promise":72}],36:[function(require,module,exports){
'use strict';

var ajax =  require('../../ajax'),
    util = require('../../util');

var updateContainer = function (data) {
    var $availabilityMsg = $('#pdpMain .availability .availability-msg');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    if (!data) {
        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
        return;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            message = Resources.IN_STOCK;
        } else {
            // In stock with conditions ...
            message = data.inStockMsg;
        }
        $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = data.preOrderMsg;
        }
        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = data.backOrderMsg;
        }
        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
    }
    if (data.inStockDate !== '') {
        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = Resources.REMAIN_NOT_AVAILABLE;
        }
        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
    }
};

var getAvailability = function () {
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: $('#pid').val(),
            Quantity: $(this).val()
        }),
        callback: updateContainer
    });
};

module.exports = function () {
    $('#pdpMain').on('change', '.pdpForm input[name="Quantity"]', getAvailability);
};

},{"../../ajax":1,"../../util":63}],37:[function(require,module,exports){
'use strict';
var dialog = require('../../dialog');
var modal = require('../../modal');
var util = require('../../util');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');

function lazyLoadThumbnails() {
  $('.product-thumbnails').each(function () {
    var $that = $(this);

    if ($that.find('li').length > 1) {
      $that.find('ul').slick({
        infinite: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 9999,
            settings: {
              dots: false,
              arrows: true,
              vertical: true,
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 769,
            settings: {
              dots: true,
              vertical: false,
              arrows: false,
              centerMode: false,
              slidesToShow: 1
            }
          }
        ]
      });
    }
  });
}

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts, $targetImgContainer) {
  $targetImgContainer.find('.primary-image').attr({
    src: atts.url,
    alt: atts.alt,
    title: atts.title
  });

  if (
    !dialog.isActive() &&
    !util.isMobile() &&
    atts.hasOwnProperty('hires') &&
    atts.hires != '' &&
    atts.hires != null
  ) {
    $targetImgContainer.find('.main-image').find('img').attr('src', atts.hires);
  }
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
  if (dialog.isActive() || util.isMobile()) {
    $('#pdpMain .main-image').removeAttr('href');
  }

  if ($('.product-thumbnails').length > 0) {
    lazyLoadThumbnails();

    // handle product thumbnail click event
    $('.product-thumbnails').on('click', '.productthumbnail', function () {
      var $that = $(this);

      $that
        .closest('.product-thumbnails')
        .find('.productthumbnail.selected')
        .removeClass('selected');
      $that.addClass('selected');
      $that.closest('.product-thumbnails').find('.productthumbnail.slick-current').addClass('selected');

      setMainImage(
        $that.data('lgimg'),
        $that.closest('.product-thumbnails').siblings('.product-primary-image')
      );
    });
  }
};

module.exports.setMainImage = setMainImage;
module.exports.lazyLoadThumbnails = lazyLoadThumbnails;

},{"../../dialog":9,"../../modal":18,"../../util":63,"lodash":71,"qs":82,"url":89}],38:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
  productStoreInventory = require('../../storeinventory/product'),
  tooltip = require('../../tooltip'),
  util = require('../../util'),
  addToCart = require('./addToCart'),
  availability = require('./availability'),
  image = require('./image'),
  productNav = require('./productNav'),
  productSet = require('./productSet'),
  recommendations = require('./recommendations'),
  variant = require('./variant'),
  productKit = require('./productKit');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
  productNav();
  recommendations();
  tooltip.init();
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
  var $pdpMain = $('#pdpMain');

  addToCart.init();
  availability();
  variant();
  image();
  productSet();

  if ($('#primary').hasClass('product-kit')) {
    productKit();
  }

  if (SitePreferences.STORE_PICKUP) {
    productStoreInventory.init();
  }

  // Add to Wishlist and Add to Gift Registry links behaviors
  $pdpMain.on(
    'click',
    '[data-action="wishlist"], [data-action="gift-registry"]',
    function () {
      var data = util.getQueryStringParams($('.pdpForm').serialize());
      if (data.cartAction) {
        delete data.cartAction;
      }
      var url = util.appendParamsToUrl(this.href, data);
      this.setAttribute('href', url);
    }
  );

  // product options
  $pdpMain.on('change', '.product-options select', function () {
    var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
    var selectedItem = $(this).children().filter(':selected').first();
    salesPrice.text(selectedItem.data('combined'));
  });

  // prevent default behavior of thumbnail link and add this Button
  $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
    e.preventDefault();
  });

  $('.size-chart-link a').on('click', function (e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href')
    });
  });
}

var product = {
  initializeEvents: initializeEvents,
  init: function () {
    initializeDom();
    initializeEvents();
  }
};

module.exports = product;

},{"../../dialog":9,"../../storeinventory/product":60,"../../tooltip":62,"../../util":63,"./addToCart":35,"./availability":36,"./image":37,"./productKit":39,"./productNav":40,"./productSet":41,"./recommendations":42,"./variant":43}],39:[function(require,module,exports){
'use strict';

var util = require('../../util');

var $dom = {
  $w: null,
  $header: null,
  $footer: null,
  $primary: null,
  $secondary: null,
  $kitResult: null
};

// jQueryオブジェクト取得
function setDoms() {
  $dom.$w = $(window);
  $dom.$header = $('#header');
  $dom.$footer = $('#footer');
  $dom.$primary = $('#primary');
  $dom.$secondary = $('#secondary');
  $dom.$kitResult = $('#kit-result');
}

// slick設定
function initSlick() {
  $('.kinds').slick({
    arrows: true,
    dots: true,
    draggable: false,
    slidesToScroll: 3,
    slidesToShow: 3,
    speed: 500,
    swipe: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          draggable: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          swipe: true,
          touchMove: true
        }
      }
    ]
  });

  $('.slick-fade').slick({
    arrows: false,
    fade: true,
    dots: false,
    draggable: false,
    speed: 300,
    swipe: false,
    touchMove: false
  });
}

// 価格設定
function setResultPrice() {
  // 価格表示
  var $kitSelectedList = $dom.$secondary.find('.kit-selected-list > div'),
    $resultMessage = $dom.$kitResult.find('.message:not(.error)'),
    $resultPrice = $dom.$kitResult.find('.price'),
    $resultButton = $dom.$kitResult.find('.button'),
    result_net = $('#kit-net-price');
  var priceValue = 0;
  var net_price = 0;

  if (
    $kitSelectedList.filter('.selected').length ===
    $kitSelectedList.not('.kit-come-with').length
  ) {
    // 購入可能
    $kitSelectedList.filter('.selected').each(function () {
      var $this = $(this);

      priceValue += parseInt($this.data('price'), 10);
      net_price += parseInt($this.data('netprice'), 10);
    });
    $('.bonus-product-data').each(function () {
      const $this = $(this);
      priceValue += parseInt($this.data('price'), 10);
      net_price += parseInt($this.data('netprice'), 10);
    });

    $resultMessage.addClass('hide');
    $resultPrice
      .removeClass('hide')
      .find('span')
      .text(String(priceValue).replace(/(\d)(?=(\d{3})+$)/g, '$1,') + '円');
    $resultButton.removeClass('disabled');

    result_net.text(net_price);
  } else {
    // 購入可能
    $resultMessage.removeClass('hide');
    $resultPrice.addClass('hide');
    $resultButton.addClass('disabled');
  }
}

// 左側商品選択のスクロール
function setScrollSecondary() {
  var $secondaryWrap = $dom.$secondary.find('.kit-wrap');

  $dom.$w.on('load resize scroll', function () {
    var wTop = $dom.$w.scrollTop(),
      winH = $dom.$w.height(),
      headerH = $dom.$header.height(),
      secondaryPos = $dom.$secondary.offset().top,
      kitResultPos = $dom.$kitResult.offset().top;

    if (wTop + headerH > secondaryPos) {
      $secondaryWrap.addClass('fixed');

      if (wTop + winH > kitResultPos) {
        $secondaryWrap.css({
          top: 'auto',
          bottom: wTop + winH - kitResultPos
        });
      } else {
        $secondaryWrap.css({
          top: headerH,
          bottom: 'auto'
        });
      }
    } else {
      $secondaryWrap.removeClass('fixed');
    }
  });
}

// 右側の選択解除
function cancelPrimaryUnit(targetId) {
  var $targetPrimary = $('#' + targetId),
    $targetGroup = $targetPrimary.find('.select-area');

  $targetGroup
    .removeClass('open')
    .closest('.slick-list')
    .removeClass('open')
    .end()
    .find('li, p')
    .removeClass('selected');
}

// 左側の選択解除
function cancelSecondaryUnit(targetId) {
  var $targetPrimary = $('#' + targetId),
    $targetSecondary = $dom.$secondary.find(
      'div[data-select="' + targetId + '"]'
    );

  $targetSecondary
    .removeClass('selected')
    .data({
      pid: '',
      price: 0,
      netprice: 0
    })
    .find('.pro-img img')
    .remove()
    .end()
    .find('.pro-name')
    .html(
      '<a href="#' + targetId + '">' + $targetPrimary.find('h3').text() + '</a>'
    );
}
// 左側の選択設定
function setSecondaryUnit(targetId, obj) {
  var $targetSecondary = $dom.$secondary.find(
      'div[data-select="' + targetId + '"]'
    ),
    $proImg = $targetSecondary.find('.pro-img');

  $targetSecondary
    .addClass('selected')
    .data({
      pid: obj.pid,
      price: obj.price,
      netprice: obj.netprice
    })
    .find('.pro-name')
    .html(obj.name);

  $proImg.find('img').remove().end().prepend(obj.image);
}

function setSelectedDataToSubmit() {
  var selected_list;
  var total_selected;
  var selected = [];

  selected_list = $dom.$secondary
    .find('.kit-selected-list > div')
    .filter('.selected');

  total_selected = selected_list.length;

  for (var i = 0; i < total_selected; i++) {
    selected.push($(selected_list[i]).data('pid'));
  }

  $('#variation_selected').val(selected.join(','));
}

module.exports = function () {
  var status = util.getPdpStatus();

  // jQueryオブジェクト取得
  setDoms();

  // slick設定
  initSlick();

  // プルダウン初期化
  $dom.$primary.find('.select-area li:first-child').addClass('show');

  // 左側商品選択のスクロール
  setScrollSecondary();

  // 右側で選択、解除
  (function () {
    var $selectPulldown = $dom.$primary.find('.select-area ul'),
      $selectPulldownToggle = $dom.$primary.find('.select-area .toggle'),
      $selectBtn = $dom.$primary.find('.select-area p').not('.out-of-stock');

    // プルダウン開閉
    var togglePulldown = function ($selectArea) {
      if ($selectArea.hasClass('open')) {
        $selectArea
          .removeClass('open')
          .closest('.slick-list')
          .removeClass('open');
      } else {
        // 他を全て閉じる
        $dom.$primary.find('.select-area, .slick-list').removeClass('open');

        $selectArea.addClass('open').closest('.slick-list').addClass('open');
      }
    };

    // プルダウン開閉
    $selectPulldownToggle.on('click', function () {
      togglePulldown($(this).parent());
    });

    // プルダウン変更で表示のみ切り替え、選択状態の設定はボタンで
    $selectPulldown.on('click', 'li', function () {
      if ($('#add-kit-to-cart').hasClass('over-limit')) {
        return;
      }

      var $this = $(this),
        $selectArea = $this.parents('.select-area'),
        $selectBtn = $selectArea.find('p'),
        $slickClone,
        $cloneSelectArea,
        cloneNum,
        index = $selectArea.find('li').index(this);

      // slickクローン取得
      cloneNum = $selectArea.closest('.slick-slide').data('num');
      $slickClone = $selectArea
        .closest('.slick-list')
        .find('.slick-slide.slick-cloned')
        .filter('[data-num="' + cloneNum + '"]');
      $cloneSelectArea = $slickClone.find('.select-area');

      // ボタン状態 表示切り替え
      if ($this.hasClass('selected')) {
        $selectBtn.addClass('selected');
        $cloneSelectArea.find('p').addClass('selected');
      } else {
        $selectBtn.removeClass('selected');
        $cloneSelectArea.find('p').removeClass('selected');
      }

      if ($this.hasClass('show')) {
        // プルダウン開閉
        togglePulldown($selectArea);
      } else {
        $this.siblings('.disabled').css('display', 'none');

        // 注文制限により商品がカートに追加できない時は、選択ボタンをアクディブにしない
        if (!status.isAddToCartErrorOnOrderRestriction) {
          $selectBtn.removeClass('disabled');
        }

        $this.siblings().removeClass('show').end().addClass('show');
        $selectArea
          .removeClass('open')
          .closest('.slick-list')
          .removeClass('open');

        // 在庫切れの場合
        if (
          $this.closest('.kind').find('.product-block').eq(index).data('oos')
        ) {
          $selectBtn.addClass('out-of-stock').html('在庫がありません');
        } else {
          $selectBtn.removeClass('out-of-stock').html('選択');
        }

        //slick切り替え
        $selectArea.siblings('.slick-fade').each(function () {
          $(this).slick('slickGoTo', index, false);
        });

        // slickクローン設定
        $cloneSelectArea.siblings('.slick-fade').each(function () {
          $(this).slick('slickGoTo', index, false);
        });
        $cloneSelectArea
          .removeClass('open')
          .replaceWith($selectArea.clone(true))
          .end()
          .closest('.slick-list')
          .removeClass('open');
      }
    });

    // 選択ボタンクリック
    $selectBtn.on('click', function () {
      if ($('#add-kit-to-cart').hasClass('over-limit')) {
        return;
      }

      var $this = $(this),
        $thisLi = $this.siblings('ul').find('li'),
        $kindsGroup;

      if ($this.hasClass('disabled') || $this.hasClass('out-of-stock')) {
        return;
      } else if ($this.hasClass('selected')) {
        // 解除
        $kindsGroup = $this.closest('section');

        $kindsGroup.find('.select-area').find('li, p').removeClass('selected');

        // 左側の選択解除
        cancelSecondaryUnit($kindsGroup.attr('id'));
      } else {
        // 選択
        var obj = { pid: '', price: '', image: '', name: '', netprice: '' },
          $slickClone,
          cloneNum,
          $target;

        // slickクローン取得
        cloneNum = $this.closest('.slick-slide').data('num');
        $slickClone = $this
          .closest('.slick-list')
          .find('.slick-slide.slick-cloned')
          .filter('[data-num="' + cloneNum + '"]');

        $kindsGroup = $this.closest('section');

        $kindsGroup.find('.select-area').find('li, p').removeClass('selected');
        $this.addClass('selected');
        $thisLi.filter('.show').addClass('selected');

        // slickクローン設定
        $slickClone
          .find('.select-area')
          .replaceWith($this.parent('.select-area').clone(true));

        // 左側の選択商品を設定
        $target = $this
          .closest('.kind')
          .find('.product-block')
          .eq($thisLi.index($thisLi.filter('li.show')));
        obj.pid = $target.data('pid');
        obj.price = $target.data('price');
        obj.netprice = $target.data('netprice');
        obj.image = $target.find('.product-image').html();
        obj.name = $target.find('h4').text();
        setSecondaryUnit($kindsGroup.attr('id'), obj);
      }

      // 価格計算
      setResultPrice();
    });
  })();
  // 左側で解除
  (function () {
    $dom.$secondary.find('.deselect').on('click', function () {
      var targetId = $(this).parents('[data-select]').data('select');

      cancelPrimaryUnit(targetId);
      cancelSecondaryUnit(targetId);

      // 価格計算
      setResultPrice();
    });
  })();

  // 左側アンカーリンク
  (function () {
    $dom.$secondary.find('.pro-name').on('click', 'a', function () {
      util.scrollBrowser(
        $($(this).attr('href')).offset().top - $dom.$header.height() - 10
      );
      return false;
    });
  })();

  // 購入ボタンクリック
  $dom.$kitResult.find('.button').on('click', function (e) {
    if ($(this).hasClass('over-limit')) {
      // todo
    } else if ($(this).hasClass('disabled')) {
      e.preventDefault();

      $dom.$kitResult.find('.message').css('opacity', 0).delay(150).animate(
        {
          opacity: 1
        },
        250
      );
    } else {
      setSelectedDataToSubmit();

      $('#add-to-cart').trigger('click');
    }
  });
};

},{"../../util":63}],40:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    util = require('../../util');

/**
 * @description loads product's navigation
 **/
module.exports = function () {
    var $pidInput = $('.pdpForm input[name="pid"]').last(),
        $navContainer = $('#product-nav-container');
    // if no hash exists, or no pid exists, or nav container does not exist, return
    if (window.location.hash.length <= 1 || $pidInput.length === 0 || $navContainer.length === 0) {
        return;
    }

    var pid = $pidInput.val(),
        hash = window.location.hash.substr(1),
        url = util.appendParamToURL(Urls.productNav + '?' + hash, 'pid', pid);

    ajax.load({
        url: url,
        target: $navContainer
    });
};

},{"../../ajax":1,"../../util":63}],41:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
  tooltip = require('../../tooltip'),
  util = require('../../util');

module.exports = function () {
  var $addToCart = $('#add-to-cart'),
    $addAllToCart = $('#add-all-to-cart'),
    $productSetList = $('#product-set-list');

  var updateAddToCartButtons = function () {
    if (
      $productSetList.find('.add-to-cart[disabled]').length > 0 ||
      $productSetList.find('.add-to-cart').length <
        $productSetList.find('form').length
    ) {
      $addAllToCart.attr('disabled', 'disabled');
      $addAllToCart.addClass('disabled');
    } else {
      $addAllToCart.prop('disabled', false);
      $addAllToCart.removeClass('disabled');
    }
  };

  if ($productSetList.length > 0) {
    updateAddToCartButtons();
  }
  // click on swatch for product set
  $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
    e.preventDefault();

    if ($(this).parents('li').hasClass('unselectable')) {
      return;
    }
    var url = Urls.getSetItem + this.search;
    var $container = $(this).closest('.product-set-item');
    var qty = $container.find('form input[name="Quantity"]').first().val();

    ajax.load({
      url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
      target: $container,
      callback: function () {
        updateAddToCartButtons();
        tooltip.init();

        var attr_list;

        attr_list = $container.find('li.attribute');

        if (attr_list.length !== attr_list.find('li.selected').length) {
          $container.find('p.out-of-stock').addClass('hide');
        } else {
          $container.find('p.out-of-stock').removeClass('hide');
        }
      },
    });
  });
};

},{"../../ajax":1,"../../tooltip":62,"../../util":63}],42:[function(require,module,exports){
'use strict';

var productTile = require('../../product-tile');

/**
 * @description Creates product recommendation carousel using Slick carousel
 **/
function initRecommendationCarousel() {
  var $carousel = $('.carousel-recommendations').not('.slick-initialized');
  if (
    !$carousel ||
    $carousel.length === 0 ||
    $carousel.children().length === 0
  ) {
    return;
  }
  $carousel.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    slide: 'li',
    dots: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  productTile.init();  
}

module.exports = function() {
  initRecommendationCarousel();
  document.addEventListener('refreshRecommendationCarousel', function() {
    initRecommendationCarousel();
  })
};

},{"../../product-tile":50}],43:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
  image = require('./image'),
  progress = require('../../progress'),
  productStoreInventory = require('../../storeinventory/product'),
  util = require('../../util'),
  wishlist = require('../wishlist'),
  addToCart = require('./addToCart'),
  dialog = require('../../dialog'),
  bonusProductsView = require('../../bonus-products-view');

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/

function pdpMobileSwatchesCarousel() {
  var spSlideNum = 5;
/*
  if (Foundation.MediaQuery.is('small only')) {
    $('.swatches.color').slick({
      arrows: true,
      centerMode: false,
      centerPadding: '16px',
      responsive: [
        {
          breakpoint: 9999,
          settings: 'unslick'
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 8
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: spSlideNum,
            slidesToScroll: spSlideNum
          }
        }
      ]
    });

    // get the selected variant
    var selectedVariant = $('.swatches.color li.selected');

    // know it's index
    var indexOfSelected = selectedVariant.attr('data-slick-index');

    // automatically slide to variant upon page load
    $('.swatches.color').slick('slickGoTo', indexOfSelected, false);
  }
  */
}

function initAddWishlist() {
  wishlist.initAddEvent(
    $('.save-for-later-btn').not('.saved-wishlist'),
    function () {
    //【サイトリニューアル 1.0】サイトリニューアルに伴い、お気に入り登録処理変更
    var $url = Urls.wishlistAddAjax;
    var $wishBtn = $('.save-for-later-btn').not('.saved-wishlist');
    var info = JSON.parse($wishBtn.attr('data-info'));
    var data = "pid=" + info.id;
    $.ajax({
        type: 'POST',
        url: $url,
        data: data
      }).done(function(reaponse) {
          if (reaponse.redirecturl != '') {
              window.location.href = reaponse.redirecturl;
              return;
          }
          dialog.open({
              html: '<div class="msg-wrapper"><div class="dialog__msg-block dialog__msg-block--favorite">' + Resources.ADD_FAVORITE_SUCCESS + '</div></div>',
              options: {
                  open: function(event, ui) {
                      dialog.setupnotice(ui);
                      setTimeout(function() {
                          dialog.close();
                      }, 1000);
                  },
                  close: function(event, ui) {
                      setTimeout(function() {
                          bonusProductsView.loadBonusOption();
                      }, 800);
                  }
              }
          });
          var $wishBtn = $('.save-for-later-btn').not('.saved-wishlist');
          $wishBtn.removeClass('processing');
          $wishBtn.addClass('hide');
          $('.save-for-later-btn.saved-wishlist').removeClass('hide');
      }).fail(function(reaponse) {
          var $wishBtn = $('.save-for-later-btn').not('.saved-wishlist');
          $wishBtn.removeClass('processing');
      });
    //【サイトリニューアル 1.0】サイトリニューアルに伴い、お気に入り登録処理変更
    });

  //【サイトリニューアル 1.0】サイトリニューアルに伴い、お気に入り解除処理追加
  $('.save-for-later-btn.saved-wishlist').off('click').on('click', function (e) {
      e.preventDefault();
      var $wishBtn = $('.save-for-later-btn.saved-wishlist');
      if ($wishBtn.hasClass('processing')) {
          return;
      }
      $wishBtn.addClass('processing');

      var inf = $wishBtn.attr('data-info');
      var info = JSON.parse(inf);
      if (info) {
          window.dataLayer.push({
            event: 'removeFromWishlist',
            productCategory: info.category,
            productSubCategory: info.sub_category,
            productName: info.name,
            productVariant: info.variant,
            pageCategory: data_general_gtm.pageCategory,
            productOutOfStock: info.stock,
            userStatus:
              $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged',
          });
        }
      var $url = Urls.wishlistRemoveAjax;
      var data = "pid=" + info.id;
      setTimeout(function () {
        $.ajax({
            type: 'POST',
            url: $url,
            data: data
          }).done(function(reaponse) {
              dialog.open({
            	  html: '<div class="msg-wrapper"><div class="dialog__msg-block dialog__msg-block--favorite">' + Resources.DEL_FAVORITE_SUCCESS + '</div></div>',
                  options: {
                      open: function(event, ui) {
                          dialog.setupnotice(ui);
                          setTimeout(function() {
                              dialog.close();
                          }, 1000);
                      },
                      close: function(event, ui) {
                          setTimeout(function() {
                              bonusProductsView.loadBonusOption();
                          }, 800);
                      }
                  }
              });
              var $wishBtn = $('.save-for-later-btn.saved-wishlist');
              $wishBtn.removeClass('processing');
              $wishBtn.addClass('hide');
              $('.save-for-later-btn').not('.saved-wishlist').removeClass('hide');
          }).fail(function(reaponse) {
        	  var $wishBtn = $('.save-for-later-btn.saved-wishlist');
              $wishBtn.removeClass('processing');
          });
        }, 200);
  });
  //【サイトリニューアル 1.0】サイトリニューアルに伴い、お気に入り解除処理追加
}

var updateContent = function (href, isProductSet) {
  var $pdpForm = $('.pdpForm');
  var qty = $pdpForm.find('input[name="Quantity"]').first().val();
  var params = {
    Quantity: isNaN(qty) ? '1' : qty,
    format: 'ajax',
    productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
  };

  progress.show($('#pdpMain'));

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    target: $('#product-content'),
    callback: function () {
      if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
      }

      //【サイトリニューアル 1.0】サイトリニューアルに伴い、画面下部の再描画処理を見直し修正
      var isPdpPage = $('#js-is-Under-Add').val() === 'true';
      if (isPdpPage) {
        var underParams = {
          Quantity: isNaN(qty) ? '1' : qty,
          format: 'ajax',
          productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
          updatedetail: 'under'
        };

        $.ajax({
            dataType: 'html',
            url: util.appendParamsToUrl(href, underParams),
            xhrFields: {
                withCredentials: true
            }
        })
        .done(function (response) {
        	progress.hide();
            $('.pdp_under').find('.product-content-detail').empty().html($(response).find('.product-content-detail').html());
            $('.pdp-main').off('change').on('change', '.variation-select', function () {
              if ($(this).val().length === 0) {
                return;
              }
              updateContent($(this).val());
            });

            image();

            pdpMobileSwatchesCarousel();

            $(document).trigger('gtvariationchange');

            // tooltip, modalなど
            $('.product-info').foundation();

            checkStatus(null, null);

            initAddWishlist();
            addToCart.init();
            initAdditionalFooter();

            $('.product-desc-detail').eq(0).css('display', 'block');
            $('.product-desc-h').eq(0).addClass('comp-open');
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            }
        })
        .always(function () {
            progress.hide();
        });
      } else {
          image();

          pdpMobileSwatchesCarousel();

          $(document).trigger('gtvariationchange');

          // tooltip, modalなど
          $('.product-info').foundation();

          checkStatus(null, null);

          initAddWishlist();
          addToCart.init();
          initAdditionalFooter();

          $('.product-desc-detail').eq(0).css('display', 'block');
          $('.product-desc-h').eq(0).addClass('comp-open');
      }
      //【サイトリニューアル 1.0】サイトリニューアルに伴い、画面下部の再描画処理を見直し修正
    }
  });

};

function updateSetContent($ele, href) {
  var $productSetItemCtnr = $ele.parents('.product-set-item'),
    qty = $productSetItemCtnr.find('form select[name="Quantity"]').val();

  progress.show($productSetItemCtnr);

  $.get(
    util.appendParamsToUrl(href, {
      Quantity: isNaN(qty) ? '1' : qty,
      format: 'ajax',
      setproduct: true
    })
  ).success(function (html) {
    $productSetItemCtnr.html(html);
    image();
    pdpMobileSwatchesCarousel();
  });
}

function changeInfoData(cmd, instock) {
  if (cmd.length == 0) return;

  var inf = cmd.attr('data-info');

  inf = inf != null ? JSON.parse(inf) : null;
  inf.stock = instock ? 'instock' : 'outofstock';
  inf = JSON.stringify(inf);

  cmd.attr('data-info', inf);
}

/**
 * 注文制限商品に関するエラーを表示する
 *
 * @param {string} pid - 商品ID
 */
function showOrderRestrictionError(pid) {
  var status = util.getPdpStatus();
  var replaceTargetText = '[js-product-name]';
  var $orderRestrictionErrorBlock = $(
    '.order-restricted-product-error[data-pid="' + pid + '"]'
  );

  function getErrorMessageFromTemplate(selector) {
    return $orderRestrictionErrorBlock.find(selector).first().text();
  }

  // エラーメッセージを生成
  var errorMessage = null;
  if (status.isOrderRestrictedProduct) {
    if (status.hasOrderRestrictedProductInCart) {
      if (status.orderRestrictedProductIdInCart === pid) {
        errorMessage = getErrorMessageFromTemplate(
          '.js-orderrestricted-error-template-already-exists'
        );
      } else {
        errorMessage = getErrorMessageFromTemplate(
          '.js-orderrestricted-error-template-other-exists'
        ).replace(replaceTargetText, status.orderRestrictedProductNameInCart);
      }
    } else if (status.hasNormalProductInCart) {
      errorMessage = getErrorMessageFromTemplate(
        '.js-orderrestricted-error-template-other-exists'
      ).replace(replaceTargetText, status.productName);
    }
  } else {
    if (status.hasOrderRestrictedProductInCart) {
      errorMessage = getErrorMessageFromTemplate(
        '.js-orderrestricted-error-template-other-exists'
      ).replace(replaceTargetText, status.orderRestrictedProductNameInCart);
    }
  }

  if (!errorMessage) return;

  $orderRestrictionErrorBlock.find('.error').text(errorMessage);
  $orderRestrictionErrorBlock.removeClass('hide');
}

//【サイトリニューアル 1.0】サイトリニューアルでのメッセージ表示処理
function showOrderRestrictionError_pdp(pid) {
	  var status = util.getPdpStatus();
	  var replaceTargetText = '[js-product-name]';
	  var $orderRestrictionErrorBlock = $(
	    '.order-restricted-product-error[data-pid="' + pid + '"]'
	  );

	  function getErrorMessageFromTemplate(selector) {
	    return $orderRestrictionErrorBlock.find(selector).first().text();
	  }

	  // エラーメッセージを生成
	  var errorMessage = null;
	  if (status.isOrderRestrictedProduct) {
	    if (status.hasOrderRestrictedProductInCart) {
	      if (status.orderRestrictedProductIdInCart === pid) {
	        errorMessage = getErrorMessageFromTemplate(
	          '.js-orderrestricted-error-template-already-exists'
	        );
	      } else {
	        errorMessage = getErrorMessageFromTemplate(
	          '.js-orderrestricted-error-template-other-exists'
	        ).replace(replaceTargetText, status.orderRestrictedProductNameInCart);
	      }
	    } else if (status.hasNormalProductInCart) {
	      errorMessage = getErrorMessageFromTemplate(
	        '.js-orderrestricted-error-template-other-exists'
	      ).replace(replaceTargetText, status.productName);
	    }
	  } else {
	    if (status.hasOrderRestrictedProductInCart) {
	      errorMessage = getErrorMessageFromTemplate(
	        '.js-orderrestricted-error-template-other-exists'
	      ).replace(replaceTargetText, status.orderRestrictedProductNameInCart);
	    }
	  }

	  if (!errorMessage) return;

	  var $errMsg = $('.ppd-bottom-noadd');
	  $errMsg.text(errorMessage);
	  $errMsg.removeClass('hide');
	}
//【サイトリニューアル 1.0】サイトリニューアルでのメッセージ表示処理
/**
 * カート追加フォームで、カート追加可/否によるボタンの表示制御を行う
 * @param {string|null} checkPid - 対象商品ID
 * @param {number|null} remainQuantity - 残数
 * @param {boolean} isFirstLoad
 * @returns {undefined}
 */
var checkStatus = function (checkPid, remainQuantity, isFirstLoad) {
  // 埋め込み変数を取得
  var status = util.getPdpStatus();

  var $containers = $('div[data-checkid]');
  var isGivenCheckId = checkPid != null;

  for (var n = 0; n < $containers.length; n++) {
    var $container = $($containers[n]);
    var pid = $container.attr('data-checkid');
    var uuid = $container.attr('data-checkuuid');

    if (isGivenCheckId && pid !== checkPid) {
      continue;
    }

    // DOM要素を取得
    var $actionForm = $('.product-form-actions-' + pid);
    // カート追加ボタン
    var $addToCartButton = $actionForm.find('.add-to-cart').not('.js-fixed');
    // 固定フッター上：カート追加ボタン
    var $additionalAddToCartButton = $actionForm.find('.add-to-cart.js-fixed');
    // 固定フッター上：カート追加ボタン（非活性）
    var $disabledAddToCartButton = $actionForm.find(
      '.js-disabled-add-to-cart-btn'
    );
    // 在庫切れボタン
    var $outOfStockButton = $actionForm
      .find('.out-of-stock.oos')
      .not('.js-fixed');
    var $additionalOutOfStockButton = $actionForm.find(
      '.out-of-stock.oos.js-fixed'
    );

    var $productSelectBlock = $('.product-select-attribute-' + pid);
    var $inventoryBlock = $productSelectBlock.find('.inventory');
    var $quantitySelector = $('select[class*="quantity-selector-' + pid + '"]');
    var $quantityErrorBlock = $('[class*="quantity-error-' + pid + '"]');

    // 固定フッター上：追加できませんボタン
    var $additionalOverLimitButton = $actionForm.find('.over-limit');

    /** 最大選択可能数 */
    var maxOrderableNum =
      remainQuantity !== null ? remainQuantity : status.maxOrderable;
    var $wishlistAdded = $container.find('#wishlist_added');
    var $catLimitMsgBlock = $container.find('#cat_limit_msg');

    /** 在庫に関する表示を制御するフラグ(?) */
    var isInStockForEndProcess = status.isKit || status.isInStock;

    //【サイトリニューアル 1.0】リニューアル後のサイトではセレクタが異なるため専用の処理を追加
    var isPdpPage = $('#js-is-pdp-page').val() === 'true';
    var $actionFormNew = $('.product-add-to-cart').not('.js-fixed');
    var $actionFormCartFixedNew = $('.product-add-to-cart-fixed');
    var $addCartButtonNew = $actionFormNew.find('.add-to-cart');
    var $addCartButtonCartFixedNew = $actionFormCartFixedNew.find('.add-to-cart');
    var $noaddmsg = $('.ppd-bottom-button');
    //【サイトリニューアル 1.0】リニューアル後のサイトではセレクタが異なるため専用の処理を追加

    // 1商品のみ購入制限により商品をカートに追加できない時の制御(在庫がない時は在庫がない時の表示を優先)
    if (status.isInStock && status.isAddToCartErrorOnOrderRestriction) {
      if (isPdpPage) {
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
          showOrderRestrictionError_pdp(pid);
          $('.quantity').empty()
          $addCartButtonNew.addClass('disabled');
          $addCartButtonCartFixedNew.addClass('disabled');
          $addCartButtonCartFixedNew.prop('disabled', true);
          $addCartButtonNew.attr('disabled', 'disabled');
          $addCartButtonCartFixedNew.attr('disabled', 'disabled');
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
      } else {
          // エラーメッセージの表示
          showOrderRestrictionError(pid);
          // 数量選択部を非表示
          $inventoryBlock.remove();
          // カート追加ボタンを無効化
          $addToCartButton.prop('disabled', true);
          $additionalAddToCartButton.remove();
          // キット選択ボタンを無効化
          if (status.isKit) {
            $('.add-to-selected').prop('disabled', true).addClass('disabled');
            $('#add-kit-to-cart').prop('disabled', true).addClass('disabled');
          }
          // (ABTestB案用)
          // 購入上限ボタンを有効化
          $additionalOverLimitButton.removeClass('hide');
      }
    }

    // master product
    // マスター商品（バリエーション選択で未選択時）は、常に数量選択部、カートに入れるボタンは非表示となる
    if (status.isMaster) {
      if (isPdpPage) {
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
          $addCartButtonNew.addClass('hide');
          $('.ppd-bottom-noadd').addClass('hide');
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
      } else {
          // 数量選択部の削除
          $inventoryBlock.remove();
          // カートに入れるで使用するFormの削除
          $actionForm.not('.js-fixed').remove();
          // 固定フッターのカート追加ボタンを非活性化
          $additionalAddToCartButton.remove();
          $disabledAddToCartButton.removeClass('hide');
          // 在庫がない場合に表示するdivを非表示にする
          $quantityErrorBlock.addClass('hide');

          // 予約販売終了メッセージを削除する
          var $preorderProductError = getPreorderProductErrorElem(pid);
          if ($preorderProductError.length > 0) {
            $preorderProductError.remove();
          }

          if (!isGivenCheckId) {
            checkStatusEndProcess($actionForm, true, status.isKit, $wishlistAdded);
          }
      }

      return;
    }

    if (status.isBeforeReleaseStart) {
      // ----------------
      // 販売開始前
      // ----------------
      if (isPdpPage) {
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
          $addCartButtonNew.addClass('disabled');
          $addCartButtonCartFixedNew.addClass('disabled');
          $addCartButtonCartFixedNew.prop('disabled', true);
          $addCartButtonNew.attr('disabled', 'disabled');
          $addCartButtonCartFixedNew.attr('disabled', 'disabled');
          $addCartButtonNew.html(Resources.KIT_INFO_PRODUCT_BEFORERELEASE);
          $addCartButtonCartFixedNew.html(Resources.KIT_INFO_PRODUCT_BEFORERELEASE);
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
      } else {
          // 数量選択部の削除
          $inventoryBlock.remove();
          // カートに入れるボタンの削除
          $addToCartButton.remove();
          $quantityErrorBlock.addClass('hide');
          // 固定フッター上のボタン変更
          $additionalAddToCartButton.remove();

          // 予約販売終了メッセージを削除する
          var $preorderProductError = getPreorderProductErrorElem(pid);
          if ($preorderProductError.length > 0) {
            $preorderProductError.remove();
          }

          if (status.isKit) {
            $('.message').addClass('hide');
            $('.add-to-selected').remove();
            $('#kit-subprice').remove();
            $('#kit-net-price').remove();
            $('#add-kit-to-cart').remove();
            $('.quantity-error-kit').addClass('hide');
            // 注文制限のエラーが出てない時のみ表示する(エラーメッセージが被っているため)
            if (!status.isAddToCartErrorOnOrderRestriction) {
              $('.quantity-error-kit.before-release').removeClass('hide');
            }

            return;
          }

          if (
            $actionForm.not('.js-fixed').find('.out-of-stock.before-release')
              .length <= 0
          ) {
            // 非表示にしていたボタンを表示箇所に移動する
            $actionForm
              .not('.js-fixed')
              .prepend($('#action-clone .out-of-stock.before-release'));
          }

          // 非表示にしていた「在庫がありません」ボタンを表示する
          $actionForm.find('.out-of-stock.before-release').removeClass('hide');

      }

      checkStatusEndProcess($actionForm, false, false, $wishlistAdded);

      return;
    } else if (status.isPreOrderProduct && status.isAfterPreOrderEnd) {
      // ----------------
      // 予約商品（予約期間終了後）
      // ----------------
      if (isPdpPage) {
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
          $addCartButtonNew.addClass('disabled');
          $addCartButtonCartFixedNew.addClass('disabled');
          $addCartButtonCartFixedNew.prop('disabled', true);
          $addCartButtonNew.attr('disabled', 'disabled');
          $addCartButtonCartFixedNew.attr('disabled', 'disabled');
          $addCartButtonNew.html(Resources.GLOBAL_OUTOFSTOCK_LABEL);
          $addCartButtonCartFixedNew.html(Resources.GLOBAL_OUTOFSTOCK_LABEL);
          $('.ppd-bottom-noadd').html($('[id*="preorder-product-error-' + pid + '"]').find('.js-preorder-product-error-template').html());
          $('.ppd-bottom-noadd').removeClass('hide');
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
      } else {
          // 数量選択部の削除
          $inventoryBlock.remove();
          // カートに入れるボタンの削除
          $addToCartButton.remove();
          $additionalAddToCartButton.remove();

          $quantityErrorBlock.addClass('hide');

          if (status.isKit) {
            $('#primary').remove();
            $('#secondary').remove();
            $('#kit-result').remove();
            $('#product-content').remove();

            $('.kit-oos-message').removeClass('hide');

            return;
          }

          if ($outOfStockButton.length <= 0) {
            // 非表示にしていたボタンを表示箇所に移動する
            $actionForm
              .not('.js-fixed')
              .prepend($('#action-clone .out-of-stock.oos'));
          }

          // 非表示にしていた「在庫がありません」ボタンを表示する
          $outOfStockButton.removeClass('hide');
          $additionalOutOfStockButton.removeClass('hide');

          // 予約販売終了メッセージを表示する
          var $preorderProductError = getPreorderProductErrorElem(pid);
          if ($preorderProductError.length > 0) {
            $preorderProductError.removeClass('hide');
          }
      }

      checkStatusEndProcess($actionForm, false, false, $wishlistAdded);

      return;
    }

    if (!status.isPreOrderSettingValid && isInStockForEndProcess) {
      if (isPdpPage) {
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
          $addCartButtonNew.addClass('disabled');
          $addCartButtonCartFixedNew.addClass('disabled');
          $addCartButtonCartFixedNew.prop('disabled', true);
          $addCartButtonNew.attr('disabled', 'disabled');
          $addCartButtonCartFixedNew.attr('disabled', 'disabled');
          $addCartButtonNew.html(Resources.GLOBAL_OUTOFSTOCK_LABEL);
          $addCartButtonCartFixedNew.html(Resources.GLOBAL_OUTOFSTOCK_LABEL);
          if (status.isPreOrderProduct) {
              // 予約販売期間中の在庫切れのメッセージを表示する
              $('.ppd-bottom-noadd').html($('[id*="quantity-error-' + pid + '"]').find('.js-quantity-error-template').html());
              $('.ppd-bottom-noadd').removeClass('hide');
          } else {
              $('.ppd-bottom-noadd').addClass('hide');
          }
          //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
      } else {
          // 数量選択部の削除
          $inventoryBlock.remove();
          // カートに入れるボタンの削除
          $addToCartButton.remove();
          // 固定フッターのカート追加ボタンを在庫なしに
          $additionalAddToCartButton.remove();
          $additionalOutOfStockButton.removeClass('hide');

          if ($outOfStockButton.length <= 0) {
            // 非表示にしていた「在庫がありません」ボタンを表示箇所に移動する
            $actionForm
              .not('.js-fixed')
              .prepend($('#action-clone .out-of-stock.oos'));
          }

          // 非表示にしていた「在庫がありません」ボタンを表示する
          $outOfStockButton.removeClass('hide');

          if (status.isPreOrderProduct) {
            // 予約販売期間中の在庫切れのメッセージを表示する
            $quantityErrorBlock
              .find('#out-of-stock-preorder-message')
              .removeClass('hide');

            // 在庫がない場合に表示するdivを表示にする
            $quantityErrorBlock.removeClass('hide');
          } else {
            $quantityErrorBlock.addClass('hide');
          }
      }
    } else {
      //instock && can order
      if (maxOrderableNum > 0) {
        isInStockForEndProcess = true;

        if ($quantitySelector.length > 0) {
            if (isPdpPage) {
                //【サイトリニューアル 1.0】リニューアル後のサイトでは「数量選択」のセレクタが異なるため専用の処理を追加
                $('.quantity').empty();
                //【サイトリニューアル 1.0】リニューアル後のサイトでは「数量選択」のセレクタが異なるため専用の処理を追加
            } else {
                $quantitySelector.empty();
            }
        } else {
          if (isPdpPage) {
              //【サイトリニューアル 1.0】リニューアル後のサイトでは「数量選択」のセレクタが異なるため専用の処理を追加
        	  var classlabel = $('#classlabel').val();
        	  $('.quantity').empty();
              $('.quantity').prepend('<label for="select_quantity" class="' + classlabel + '">数量</label><div class="value"><select id="select_quantity" name="Quantity"></select></div>');
              for (var i = 1; i <= maxOrderableNum; i++) {
            	  $('.quantity').find('select').append(
                    '<option value="' +
                      i +
                      '"' +
                      (i > 1 ? '' : ' selected="selected"') +
                      '>' +
                      i +
                      '</option>'
                  );
              }
              //【サイトリニューアル 1.0】リニューアル後のサイトでは「数量選択」のセレクタが異なるため専用の処理を追加
          } else {
              // 数量選択部の削除
              $inventoryBlock.remove();

              $productSelectBlock.prepend(
                '<div class="inventory"><div class="quantity"><label for="select_quantity_' +
                  uuid +
                  '" class="label">数量</label><div class="value"><select id="select_quantity_' +
                  uuid +
                  '" class="quantity-selector-' +
                  pid +
                  ' valid" name="Quantity" aria-invalid="false"></select></div></div></div>'
              );

              $quantitySelector = $(
                'select[class*="quantity-selector-' + pid + '"]'
              );

              for (var i = 1; i <= maxOrderableNum; i++) {
                  $quantitySelector.append(
                    '<option value="' +
                      i +
                      '"' +
                      (i > 1 ? '' : ' selected="selected"') +
                      '>' +
                      i +
                      '</option>'
                  );
                }

          }
        }

        if (status.isKit) {
          $('.message').removeClass('hide');

          if (typeof isFirstLoad == 'undefined' || !isFirstLoad) {
            $('#add-kit-to-cart').removeClass('disabled');
          }

          // 在庫がない場合のクラスを削除
          $('#add-kit-to-cart').removeClass('over-limit');

          // 数量エラー文言を非表示
          $('.quantity-error-kit').addClass('hide');
        } else {
          if (isPdpPage) {
            //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
            $addCartButtonNew.removeClass('hide');
            $actionFormCartFixedNew.removeClass('hide');
            //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
          } else {
            if (!isGivenCheckId && $actionForm.find('#add-to-cart').length <= 0) {
                $actionForm
                  .not('.js-fixed')
                  .prepend($('#action-clone button[data-id="add-to-cart"]'));

                var cmd = $actionForm.find('button[data-id="add-to-cart"]');

                cmd.attr('id', cmd.attr('data-id'));
              }

              // 在庫がありませんボタンの削除
              $actionForm.find('.out-of-stock').remove();

              // 在庫がない場合に表示するdivを非表示にする
              $quantityErrorBlock.addClass('hide');
          }
        }
      }
      //instock and can not order (reach limit)
      else if (isInStockForEndProcess) {
        if (isPdpPage) {
            //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
            $addCartButtonNew.addClass('disabled');
            $addCartButtonCartFixedNew.addClass('disabled');
            $addCartButtonCartFixedNew.prop('disabled', true);
            $addCartButtonNew.attr('disabled', 'disabled');
            $addCartButtonCartFixedNew.attr('disabled', 'disabled');
            $addCartButtonCartFixedNew.html(Resources.GLOBAL_PURCHASELIMIT_LABEL);
            $noaddmsg.find('.ppd-bottom-noadd').removeClass('hide');
            //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
        } else {
            var $kitQuantityErrorBlock;

            // 数量選択部の削除
            $inventoryBlock.remove();
            // 固定フッター上のボタンの変更
            $additionalAddToCartButton.remove();
            $additionalOverLimitButton.removeClass('hide');

            $catLimitMsgBlock =
              $catLimitMsgBlock.length > 0 ? $catLimitMsgBlock.val() : '';

            if (status.isKit) {
              $('.message').addClass('hide');

              $('#kit-subprice').addClass('hide');

              $('#add-kit-to-cart').addClass('disabled');
              $('#add-kit-to-cart').addClass('over-limit');

              $('.add-to-selected').addClass('disabled');

              $kitQuantityErrorBlock = $('.quantity-error-kit');
            } else {
              $addToCartButton.addClass('disabled');
              $additionalAddToCartButton.prop('disabled', true);
              $addToCartButton.attr('disabled', 'disabled');

              $('#add-all-to-cart').addClass('disabled');
              $('#add-all-to-cart').attr('disabled', 'disabled');

              $('.out-of-stock').remove();

              $kitQuantityErrorBlock = $quantityErrorBlock;
            }

            if ($catLimitMsgBlock !== '') {
              $kitQuantityErrorBlock.find('.over_limit').addClass('hide');

              $kitQuantityErrorBlock.find('.cat_limit').text($catLimitMsgBlock);
              $kitQuantityErrorBlock.find('.cat_limit').removeClass('hide');
            } else {
              $kitQuantityErrorBlock.find('.cat_limit').addClass('hide');
              $kitQuantityErrorBlock.find('.over_limit').removeClass('hide');
              // 予約商品の在庫切れメッセージを非表示にする
              var $outOfStockPreorderMessage = $kitQuantityErrorBlock.find(
                '#out-of-stock-preorder-message'
              );
              if ($outOfStockPreorderMessage.length > 0) {
                $outOfStockPreorderMessage.addClass('hide');
              }
            }

            // キットエラーメッセージ表示
            // 注文制限のエラーが出てない時のみ表示する(エラーメッセージが被っているため)
            if (!status.isAddToCartErrorOnOrderRestriction) {
              // "before release" error message should not be shown
              $kitQuantityErrorBlock.not('.before-release').removeClass('hide');
            }
        }
      } else {
        // ----------------
        // 在庫なし時
        // ----------------
        if (isPdpPage) {
            //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
            $addCartButtonNew.addClass('disabled');
            $addCartButtonCartFixedNew.addClass('disabled');
            $addCartButtonCartFixedNew.prop('disabled', true);
            $addCartButtonNew.attr('disabled', 'disabled');
            $addCartButtonCartFixedNew.attr('disabled', 'disabled');
            $addCartButtonNew.html(Resources.GLOBAL_OUTOFSTOCK_LABEL);
            $addCartButtonCartFixedNew.html(Resources.GLOBAL_OUTOFSTOCK_LABEL);
            if (status.isOnPreOrder) {
                $('.ppd-bottom-noadd').html($('[id*="quantity-error-' + pid + '"]').find('.js-quantity-error-template').html());
                $('.ppd-bottom-noadd').removeClass('hide');
            } else {
                $('.ppd-bottom-noadd').addClass('hide');
            }
            //【サイトリニューアル 1.0】リニューアル後のサイトでは「カートに入れる」ボタンのセレクタが異なるため専用の処理を追加
        } else {
            // 数量選択部の削除
            $inventoryBlock.remove();
            // カートに入れるボタンの削除
            $addToCartButton.remove();
            $additionalAddToCartButton.remove();

            if ($outOfStockButton.length <= 0) {
              $actionForm
                .not('.js-fixed')
                .prepend($('#action-clone .out-of-stock.oos'));
            }

            // 在庫がありませんボタンを表示
            $outOfStockButton.removeClass('hide');
            $additionalOutOfStockButton.removeClass('hide');

            if (status.isOnPreOrder) {
              // 予約販売期間中の在庫切れのメッセージを表示する
              $quantityErrorBlock
                .find('#out-of-stock-preorder-message')
                .removeClass('hide');

              // 在庫がない場合に表示するdivを表示にする
              $quantityErrorBlock.removeClass('hide');
            } else {
              // 在庫がない場合に表示するdivを非表示にする
              $quantityErrorBlock.addClass('hide');
            }
        }
      }
    }

    // 予約販売終了メッセージを削除する
    var $preorderProductError = getPreorderProductErrorElem(pid);
    if ($preorderProductError.length > 0) {
      $preorderProductError.remove();
    }

    if (isGivenCheckId) {
      return;
    }

    checkStatusEndProcess(
      $actionForm,
      isInStockForEndProcess,
      status.isKit,
      $wishlistAdded
    );
  }
};

/**
 * Get preorder product error JQuery<HtMLElement> by productId.
 *
 * @param {string} productId
 * @return {JQuery<HTMLElement>}
 */
function getPreorderProductErrorElem(productId) {
  return $('[id*="preorder_product_error_' + productId + '"]');
}

/**
 * Ending process of Checking Status
 * @param {object} actionForm
 * @param {boolean} instockStatus
 * @param {boolean} isKit
 * @param {object} wishlistAddedElement
 */
function checkStatusEndProcess(
  actionForm,
  instockStatus,
  isKit,
  wishlistAddedElement
) {
  changeInfoData(
    actionForm.find('.save-for-later-btn').not('.saved-wishlist'),
    instockStatus
  );
  changeInfoData(actionForm.find('.add-to-cart'), instockStatus);

  if (isKit || wishlistAddedElement.length == 0) {
    return;
  }

  const isWishlistAdded = wishlistAddedElement.val() === 'true';

  if (isWishlistAdded) {
    actionForm
      .find('.save-for-later-btn')
      .not('.saved-wishlist')
      .addClass('hide');
    actionForm.find('.save-for-later-btn.saved-wishlist').removeClass('hide');

    return;
  }

  actionForm
    .find('.save-for-later-btn')
    .not('.saved-wishlist')
    .removeClass('hide');
  actionForm.find('.save-for-later-btn.saved-wishlist').addClass('hide');
}

/**
 * 固定フッター＋バリエーション選択モーダルの初期化
 * (for ab-test-pdp-2023 segment-b)
 */
function initAdditionalFooter() {
  // ※納品コード
  if (document.getElementById('pdpMain')) {
    var $w = $(window),
      $pagetop = $('#to-pagetop').find('a'),
      $footer = $('#footer');

    var $cartFixed = $('.product-add-to-cart-fixed'),
      $cartinBtnArea = $('.ppd-bottom-button').eq(0);

    // 固定カートボタン
    $(document).on('load.pdpMain scroll.pdpMain', function () {
      var $stickyHeader = $('#header');
      var scrollPos = $w.scrollTop(),
        windowH = window.innerHeight,
        footerPos = $footer.offset().top;

      if (
        Foundation.MediaQuery.is('medium') &&
        windowH > document.documentElement.clientHeight
      ) {
        windowH = document.documentElement.clientHeight;
      }

      if (
        $cartinBtnArea.offset().top < scrollPos + windowH - 26 &&
        $cartinBtnArea.offset().top + $cartinBtnArea.innerHeight() >
          scrollPos + $stickyHeader.outerHeight()
      ) {
        // 通常のカートインボタンが画面内にあるとき固定カートボタンを非表示
        $cartFixed.addClass('hide');
      } else {
        if (scrollPos + windowH > footerPos) {
          $cartFixed.addClass('hide');
        } else {
          $cartFixed.removeClass('hide');
        }
      }
    });

    // 色・容量選択
    var $variantModal = $('.variant-modal');
	var windowheight = $(window).height();
	var $headerbanner = $('.header-banner').outerHeight();
	var $siteheader = $('.site-header').outerHeight();
	var $modalh2 = $('.variant-modal h2').outerHeight();
	var $modalheight = windowheight - $headerbanner - $siteheader - $modalh2;
    $cartFixed.on('click', '.product-price-select', function () {
      // モーダル表示
	  $('html, body').css('overflow', 'hidden');
	  $('.variant-modal-select').css('max-height', $modalheight);
      $variantModal.addClass('show');
    });
    $variantModal
      .on('click', '.variant-modal-close', function () {
        // モーダル閉じる
        $variantModal.removeClass('show');
		$('html, body').removeAttr('style');
      })
      .on('click', '.variant-modal-select a', function (e) {
        // ---- WB追加ここから ----
        e.preventDefault();
        updateContent(this.href);
        // ---- WB追加ここまで ----

        // モーダルのスタイルを解除する
		$('html, body').removeAttr('style');

        // 選択
        $(this)
          .addClass('selected')
          .parent()
          .siblings()
          .find('a')
          .removeClass('selected');
      });
  }
}

/**
 * レフィルボタンの表示制御
 * 説明3(shortDescription3）エリアにレフィルリンクが含まれていればレフィルボタンを表示する
 * @returns {void}
 */
function initRefillButton() {
  const $refillLink = $('.product-info-sd3 a:contains("レフィル")');
  if ($refillLink.length <= 0) {
    return;
  }

  const $refillButton = $('a.js-refill-link');
  $refillButton.attr('href', $refillLink.attr('href'));
  $refillButton.removeClass('hide');
}

module.exports = function () {
  var $pdpMain = $('#pdpMain');

  // hover on swatch - should update main image with swatch image
  $('.pdp-main').on('mouseenter mouseleave', '.swatchanchor', function () {
    var largeImg = $(this).data('lgimg'),
      $targetImgContainer = $(this)
        .closest('.product-info')
        .siblings('.product-image-container'),
      $imgZoom = $pdpMain.find('.main-image'),
      $mainImage = $pdpMain.find('.primary-image');

    if (!largeImg) {
      return;
    }

    // store the old data from main image for mouseleave handler
    $(this).data('lgimg', {
      hires: $imgZoom.attr('href'),
      url: $mainImage.attr('src'),
      alt: $mainImage.attr('alt'),
      title: $mainImage.attr('title')
    });

    // 【サイトリニューアル 1.0】サイトリニューアルに伴い、マウスホバーした際に画像を変更するセレクタの修正
    var $imageContainer = $('.product-primary-image');
    // 【サイトリニューアル 1.0】サイトリニューアルに伴い、マウスホバーした際に画像を変更するセレクタの修正
    // set the main image
    image.setMainImage(largeImg, $imageContainer);
  });

  // click on swatch - should replace product content with new variant
  $pdpMain.on('click', '.product-detail .swatchanchor', function (e) {
    e.preventDefault();
    updateContent(this.href, $(this).parent().parent().hasClass('pset-sw'));
  });

  // change drop down variation attribute - should replace product content with new variant
  //【サイトリニューアル 1.0】サイトリニューアルに伴い、「カートに入れる」ボタンのイベントハンドラを見直し修正
//  $pdpMain.on('change', '.variation-select', function () {
//    if ($(this).val().length === 0) {
//      return;
//    }
//    updateContent($(this).val());
//  });
  $('.pdp-main').off('change').on('change', '.variation-select', function () {
    if ($(this).val().length === 0) {
      return;
    }
    updateContent($(this).val());
  });
  //【サイトリニューアル 1.0】サイトリニューアルに伴い、「カートに入れる」ボタンのイベントハンドラを見直し修正
  // PC/SMP切り替え表示
  (function () {
    var mqSmallOnly = Foundation.MediaQuery.is('small only');

    $(window).on('resize', function () {
      var winW = window.innerWidth;

      if (mqSmallOnly && winW >= 769) {
        mqSmallOnly = false;
      } else if (!mqSmallOnly && winW < 769) {
        mqSmallOnly = true;

        pdpMobileSwatchesCarousel();
      }
    });
  })();

  checkStatus(null, null, true);

  pdpMobileSwatchesCarousel();

  // 全成分表示
  $pdpMain.on('click', '.product-component h2:not([class])', function () {
    $(this).toggleClass('comp-open').find('+ p').slideToggle(250);
  });

  // 商品詳細ページh2開閉
  $('.product-desc-detail').eq(0).css('display', 'block');
  $('.product-desc-h').eq(0).addClass('comp-open');
  $pdpMain.on('click', '.product-desc-h', function () {
    $(this).toggleClass('comp-open').find('+ .product-desc-detail').slideToggle(250);
  });


  $pdpMain.on('click', '#contentzone2 .ct-attention-toggle', function() {
	$(this).toggleClass('opened').find('+ div').slideToggle(250);
  });

  //【サイトリニューアル 1.0】レフィルはこちらボタンのクリックイベント追加
  $('.pdp-main').on('click', '.refill', function() {
    window.location.href = this.dataset.url;
  });
  //【サイトリニューアル 1.0】レフィルはこちらボタンのクリックイベント追加

  initAddWishlist();
  addToCart.init();
  initAdditionalFooter();
  initRefillButton();
};

module.exports.checkStatus = checkStatus;

},{"../../ajax":1,"../../bonus-products-view":4,"../../dialog":9,"../../progress":51,"../../storeinventory/product":60,"../../util":63,"../wishlist":49,"./addToCart":35,"./image":37}],44:[function(require,module,exports){
(function (global){
'use strict';

function initReceipt() {
/**
 * simplebar - v6.2.5
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */

var SimpleBar=function(){"use strict";var e=function(t,i){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i])},e(t,i)};var t=!("undefined"==typeof window||!window.document||!window.document.createElement),i="object"==typeof global&&global&&global.Object===Object&&global,s="object"==typeof self&&self&&self.Object===Object&&self,r=i||s||Function("return this")(),l=r.Symbol,o=Object.prototype,n=o.hasOwnProperty,a=o.toString,c=l?l.toStringTag:void 0;var h=Object.prototype.toString;var u=l?l.toStringTag:void 0;function d(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":u&&u in Object(e)?function(e){var t=n.call(e,c),i=e[c];try{e[c]=void 0;var s=!0}catch(e){}var r=a.call(e);return s&&(t?e[c]=i:delete e[c]),r}(e):function(e){return h.call(e)}(e)}var p=/\s/;var v=/^\s+/;function f(e){return e?e.slice(0,function(e){for(var t=e.length;t--&&p.test(e.charAt(t)););return t}(e)+1).replace(v,""):e}function m(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}var b=/^[-+]0x[0-9a-f]+$/i,g=/^0b[01]+$/i,x=/^0o[0-7]+$/i,y=parseInt;function E(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return null!=e&&"object"==typeof e}(e)&&"[object Symbol]"==d(e)}(e))return NaN;if(m(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=m(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=f(e);var i=g.test(e);return i||x.test(e)?y(e.slice(2),i?2:8):b.test(e)?NaN:+e}var O=function(){return r.Date.now()},w=Math.max,S=Math.min;function A(e,t,i){var s,r,l,o,n,a,c=0,h=!1,u=!1,d=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function p(t){var i=s,l=r;return s=r=void 0,c=t,o=e.apply(l,i)}function v(e){return c=e,n=setTimeout(b,t),h?p(e):o}function f(e){var i=e-a;return void 0===a||i>=t||i<0||u&&e-c>=l}function b(){var e=O();if(f(e))return g(e);n=setTimeout(b,function(e){var i=t-(e-a);return u?S(i,l-(e-c)):i}(e))}function g(e){return n=void 0,d&&s?p(e):(s=r=void 0,o)}function x(){var e=O(),i=f(e);if(s=arguments,r=this,a=e,i){if(void 0===n)return v(a);if(u)return clearTimeout(n),n=setTimeout(b,t),p(a)}return void 0===n&&(n=setTimeout(b,t)),o}return t=E(t)||0,m(i)&&(h=!!i.leading,l=(u="maxWait"in i)?w(E(i.maxWait)||0,t):l,d="trailing"in i?!!i.trailing:d),x.cancel=function(){void 0!==n&&clearTimeout(n),c=0,s=a=r=n=void 0},x.flush=function(){return void 0===n?o:g(O())},x}var k=function(){return k=Object.assign||function(e){for(var t,i=1,s=arguments.length;i<s;i++)for(var r in t=arguments[i])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},k.apply(this,arguments)},W=null,M=null;function N(){if(null===W){if("undefined"==typeof document)return W=0;var e=document.body,t=document.createElement("div");t.classList.add("simplebar-hide-scrollbar"),e.appendChild(t);var i=t.getBoundingClientRect().right;e.removeChild(t),W=i}return W}function L(e){return e&&e.ownerDocument&&e.ownerDocument.defaultView?e.ownerDocument.defaultView:window}function z(e){return e&&e.ownerDocument?e.ownerDocument:document}t&&window.addEventListener("resize",(function(){M!==window.devicePixelRatio&&(M=window.devicePixelRatio,W=null)}));var C=function(e){return Array.prototype.reduce.call(e,(function(e,t){var i=t.name.match(/data-simplebar-(.+)/);if(i){var s=i[1].replace(/\W+(.)/g,(function(e,t){return t.toUpperCase()}));switch(t.value){case"true":e[s]=!0;break;case"false":e[s]=!1;break;case void 0:e[s]=!0;break;default:e[s]=t.value}}return e}),{})};function T(e,t){var i;e&&(i=e.classList).add.apply(i,t.split(" "))}function R(e,t){e&&t.split(" ").forEach((function(t){e.classList.remove(t)}))}function D(e){return".".concat(e.split(" ").join("."))}var V=Object.freeze({__proto__:null,getElementWindow:L,getElementDocument:z,getOptions:C,addClasses:T,removeClasses:R,classNamesToQuery:D}),H=L,j=z,B=C,_=T,q=R,P=D,X=function(){function e(t,i){void 0===i&&(i={});var s=this;if(this.removePreventClickId=null,this.minScrollbarWidth=20,this.stopScrollDelay=175,this.isScrolling=!1,this.isMouseEntering=!1,this.scrollXTicking=!1,this.scrollYTicking=!1,this.wrapperEl=null,this.contentWrapperEl=null,this.contentEl=null,this.offsetEl=null,this.maskEl=null,this.placeholderEl=null,this.heightAutoObserverWrapperEl=null,this.heightAutoObserverEl=null,this.rtlHelpers=null,this.scrollbarWidth=0,this.resizeObserver=null,this.mutationObserver=null,this.elStyles=null,this.isRtl=null,this.mouseX=0,this.mouseY=0,this.onMouseMove=function(){},this.onWindowResize=function(){},this.onStopScrolling=function(){},this.onMouseEntered=function(){},this.onScroll=function(){var e=H(s.el);s.scrollXTicking||(e.requestAnimationFrame(s.scrollX),s.scrollXTicking=!0),s.scrollYTicking||(e.requestAnimationFrame(s.scrollY),s.scrollYTicking=!0),s.isScrolling||(s.isScrolling=!0,_(s.el,s.classNames.scrolling)),s.showScrollbar("x"),s.showScrollbar("y"),s.onStopScrolling()},this.scrollX=function(){s.axis.x.isOverflowing&&s.positionScrollbar("x"),s.scrollXTicking=!1},this.scrollY=function(){s.axis.y.isOverflowing&&s.positionScrollbar("y"),s.scrollYTicking=!1},this._onStopScrolling=function(){q(s.el,s.classNames.scrolling),s.options.autoHide&&(s.hideScrollbar("x"),s.hideScrollbar("y")),s.isScrolling=!1},this.onMouseEnter=function(){s.isMouseEntering||(_(s.el,s.classNames.mouseEntered),s.showScrollbar("x"),s.showScrollbar("y"),s.isMouseEntering=!0),s.onMouseEntered()},this._onMouseEntered=function(){q(s.el,s.classNames.mouseEntered),s.options.autoHide&&(s.hideScrollbar("x"),s.hideScrollbar("y")),s.isMouseEntering=!1},this._onMouseMove=function(e){s.mouseX=e.clientX,s.mouseY=e.clientY,(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&s.onMouseMoveForAxis("x"),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&s.onMouseMoveForAxis("y")},this.onMouseLeave=function(){s.onMouseMove.cancel(),(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&s.onMouseLeaveForAxis("x"),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&s.onMouseLeaveForAxis("y"),s.mouseX=-1,s.mouseY=-1},this._onWindowResize=function(){s.scrollbarWidth=s.getScrollbarWidth(),s.hideNativeScrollbar()},this.onPointerEvent=function(e){var t,i;s.axis.x.track.el&&s.axis.y.track.el&&s.axis.x.scrollbar.el&&s.axis.y.scrollbar.el&&(s.axis.x.track.rect=s.axis.x.track.el.getBoundingClientRect(),s.axis.y.track.rect=s.axis.y.track.el.getBoundingClientRect(),(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&(t=s.isWithinBounds(s.axis.x.track.rect)),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&(i=s.isWithinBounds(s.axis.y.track.rect)),(t||i)&&(e.stopPropagation(),"pointerdown"===e.type&&"touch"!==e.pointerType&&(t&&(s.axis.x.scrollbar.rect=s.axis.x.scrollbar.el.getBoundingClientRect(),s.isWithinBounds(s.axis.x.scrollbar.rect)?s.onDragStart(e,"x"):s.onTrackClick(e,"x")),i&&(s.axis.y.scrollbar.rect=s.axis.y.scrollbar.el.getBoundingClientRect(),s.isWithinBounds(s.axis.y.scrollbar.rect)?s.onDragStart(e,"y"):s.onTrackClick(e,"y")))))},this.drag=function(t){var i,r,l,o,n,a,c,h,u,d,p;if(s.draggedAxis&&s.contentWrapperEl){var v=s.axis[s.draggedAxis].track,f=null!==(r=null===(i=v.rect)||void 0===i?void 0:i[s.axis[s.draggedAxis].sizeAttr])&&void 0!==r?r:0,m=s.axis[s.draggedAxis].scrollbar,b=null!==(o=null===(l=s.contentWrapperEl)||void 0===l?void 0:l[s.axis[s.draggedAxis].scrollSizeAttr])&&void 0!==o?o:0,g=parseInt(null!==(a=null===(n=s.elStyles)||void 0===n?void 0:n[s.axis[s.draggedAxis].sizeAttr])&&void 0!==a?a:"0px",10);t.preventDefault(),t.stopPropagation();var x=("y"===s.draggedAxis?t.pageY:t.pageX)-(null!==(h=null===(c=v.rect)||void 0===c?void 0:c[s.axis[s.draggedAxis].offsetAttr])&&void 0!==h?h:0)-s.axis[s.draggedAxis].dragOffset,y=(x="x"===s.draggedAxis&&s.isRtl?(null!==(d=null===(u=v.rect)||void 0===u?void 0:u[s.axis[s.draggedAxis].sizeAttr])&&void 0!==d?d:0)-m.size-x:x)/(f-m.size)*(b-g);"x"===s.draggedAxis&&s.isRtl&&(y=(null===(p=e.getRtlHelpers())||void 0===p?void 0:p.isScrollingToNegative)?-y:y),s.contentWrapperEl[s.axis[s.draggedAxis].scrollOffsetAttr]=y}},this.onEndDrag=function(e){var t=j(s.el),i=H(s.el);e.preventDefault(),e.stopPropagation(),q(s.el,s.classNames.dragging),t.removeEventListener("mousemove",s.drag,!0),t.removeEventListener("mouseup",s.onEndDrag,!0),s.removePreventClickId=i.setTimeout((function(){t.removeEventListener("click",s.preventClick,!0),t.removeEventListener("dblclick",s.preventClick,!0),s.removePreventClickId=null}))},this.preventClick=function(e){e.preventDefault(),e.stopPropagation()},this.el=t,this.options=k(k({},e.defaultOptions),i),this.classNames=k(k({},e.defaultOptions.classNames),i.classNames),this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetSizeAttr:"offsetWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,forceVisible:!1,track:{size:null,el:null,rect:null,isVisible:!1},scrollbar:{size:null,el:null,rect:null,isVisible:!1}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetSizeAttr:"offsetHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,forceVisible:!1,track:{size:null,el:null,rect:null,isVisible:!1},scrollbar:{size:null,el:null,rect:null,isVisible:!1}}},"object"!=typeof this.el||!this.el.nodeName)throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));this.onMouseMove=function(e,t,i){var s=!0,r=!0;if("function"!=typeof e)throw new TypeError("Expected a function");return m(i)&&(s="leading"in i?!!i.leading:s,r="trailing"in i?!!i.trailing:r),A(e,t,{leading:s,maxWait:t,trailing:r})}(this._onMouseMove,64),this.onWindowResize=A(this._onWindowResize,64,{leading:!0}),this.onStopScrolling=A(this._onStopScrolling,this.stopScrollDelay),this.onMouseEntered=A(this._onMouseEntered,this.stopScrollDelay),this.init()}return e.getRtlHelpers=function(){if(e.rtlHelpers)return e.rtlHelpers;var t=document.createElement("div");t.innerHTML='<div class="simplebar-dummy-scrollbar-size"><div></div></div>';var i=t.firstElementChild,s=null==i?void 0:i.firstElementChild;if(!s)return null;document.body.appendChild(i),i.scrollLeft=0;var r=e.getOffset(i),l=e.getOffset(s);i.scrollLeft=-999;var o=e.getOffset(s);return document.body.removeChild(i),e.rtlHelpers={isScrollOriginAtZero:r.left!==l.left,isScrollingToNegative:l.left!==o.left},e.rtlHelpers},e.prototype.getScrollbarWidth=function(){try{return this.contentWrapperEl&&"none"===getComputedStyle(this.contentWrapperEl,"::-webkit-scrollbar").display||"scrollbarWidth"in document.documentElement.style||"-ms-overflow-style"in document.documentElement.style?0:N()}catch(e){return N()}},e.getOffset=function(e){var t=e.getBoundingClientRect(),i=j(e),s=H(e);return{top:t.top+(s.pageYOffset||i.documentElement.scrollTop),left:t.left+(s.pageXOffset||i.documentElement.scrollLeft)}},e.prototype.init=function(){t&&(this.initDOM(),this.rtlHelpers=e.getRtlHelpers(),this.scrollbarWidth=this.getScrollbarWidth(),this.recalculate(),this.initListeners())},e.prototype.initDOM=function(){var e,t;this.wrapperEl=this.el.querySelector(P(this.classNames.wrapper)),this.contentWrapperEl=this.options.scrollableNode||this.el.querySelector(P(this.classNames.contentWrapper)),this.contentEl=this.options.contentNode||this.el.querySelector(P(this.classNames.contentEl)),this.offsetEl=this.el.querySelector(P(this.classNames.offset)),this.maskEl=this.el.querySelector(P(this.classNames.mask)),this.placeholderEl=this.findChild(this.wrapperEl,P(this.classNames.placeholder)),this.heightAutoObserverWrapperEl=this.el.querySelector(P(this.classNames.heightAutoObserverWrapperEl)),this.heightAutoObserverEl=this.el.querySelector(P(this.classNames.heightAutoObserverEl)),this.axis.x.track.el=this.findChild(this.el,"".concat(P(this.classNames.track)).concat(P(this.classNames.horizontal))),this.axis.y.track.el=this.findChild(this.el,"".concat(P(this.classNames.track)).concat(P(this.classNames.vertical))),this.axis.x.scrollbar.el=(null===(e=this.axis.x.track.el)||void 0===e?void 0:e.querySelector(P(this.classNames.scrollbar)))||null,this.axis.y.scrollbar.el=(null===(t=this.axis.y.track.el)||void 0===t?void 0:t.querySelector(P(this.classNames.scrollbar)))||null,this.options.autoHide||(_(this.axis.x.scrollbar.el,this.classNames.visible),_(this.axis.y.scrollbar.el,this.classNames.visible))},e.prototype.initListeners=function(){var e,t=this,i=H(this.el);if(this.el.addEventListener("mouseenter",this.onMouseEnter),this.el.addEventListener("pointerdown",this.onPointerEvent,!0),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),null===(e=this.contentWrapperEl)||void 0===e||e.addEventListener("scroll",this.onScroll),i.addEventListener("resize",this.onWindowResize),this.contentEl){if(window.ResizeObserver){var s=!1,r=i.ResizeObserver||ResizeObserver;this.resizeObserver=new r((function(){s&&i.requestAnimationFrame((function(){t.recalculate()}))})),this.resizeObserver.observe(this.el),this.resizeObserver.observe(this.contentEl),i.requestAnimationFrame((function(){s=!0}))}this.mutationObserver=new i.MutationObserver((function(){i.requestAnimationFrame((function(){t.recalculate()}))})),this.mutationObserver.observe(this.contentEl,{childList:!0,subtree:!0,characterData:!0})}},e.prototype.recalculate=function(){if(this.heightAutoObserverEl&&this.contentEl&&this.contentWrapperEl&&this.wrapperEl&&this.placeholderEl){var e=H(this.el);this.elStyles=e.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction;var t=this.contentEl.offsetWidth,i=this.heightAutoObserverEl.offsetHeight<=1,s=this.heightAutoObserverEl.offsetWidth<=1||t>0,r=this.contentWrapperEl.offsetWidth,l=this.elStyles.overflowX,o=this.elStyles.overflowY;this.contentEl.style.padding="".concat(this.elStyles.paddingTop," ").concat(this.elStyles.paddingRight," ").concat(this.elStyles.paddingBottom," ").concat(this.elStyles.paddingLeft),this.wrapperEl.style.margin="-".concat(this.elStyles.paddingTop," -").concat(this.elStyles.paddingRight," -").concat(this.elStyles.paddingBottom," -").concat(this.elStyles.paddingLeft);var n=this.contentEl.scrollHeight,a=this.contentEl.scrollWidth;this.contentWrapperEl.style.height=i?"auto":"100%",this.placeholderEl.style.width=s?"".concat(t||a,"px"):"auto",this.placeholderEl.style.height="".concat(n,"px");var c=this.contentWrapperEl.offsetHeight;this.axis.x.isOverflowing=0!==t&&a>t,this.axis.y.isOverflowing=n>c,this.axis.x.isOverflowing="hidden"!==l&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==o&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.hideNativeScrollbar();var h=this.axis.x.isOverflowing?this.scrollbarWidth:0,u=this.axis.y.isOverflowing?this.scrollbarWidth:0;this.axis.x.isOverflowing=this.axis.x.isOverflowing&&a>r-u,this.axis.y.isOverflowing=this.axis.y.isOverflowing&&n>c-h,this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el&&(this.axis.x.scrollbar.el.style.width="".concat(this.axis.x.scrollbar.size,"px")),this.axis.y.scrollbar.el&&(this.axis.y.scrollbar.el.style.height="".concat(this.axis.y.scrollbar.size,"px")),this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y")}},e.prototype.getScrollbarSize=function(e){var t,i;if(void 0===e&&(e="y"),!this.axis[e].isOverflowing||!this.contentEl)return 0;var s,r=this.contentEl[this.axis[e].scrollSizeAttr],l=null!==(i=null===(t=this.axis[e].track.el)||void 0===t?void 0:t[this.axis[e].offsetSizeAttr])&&void 0!==i?i:0,o=l/r;return s=Math.max(~~(o*l),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(s=Math.min(s,this.options.scrollbarMaxSize)),s},e.prototype.positionScrollbar=function(t){var i,s,r;void 0===t&&(t="y");var l=this.axis[t].scrollbar;if(this.axis[t].isOverflowing&&this.contentWrapperEl&&l.el&&this.elStyles){var o=this.contentWrapperEl[this.axis[t].scrollSizeAttr],n=(null===(i=this.axis[t].track.el)||void 0===i?void 0:i[this.axis[t].offsetSizeAttr])||0,a=parseInt(this.elStyles[this.axis[t].sizeAttr],10),c=this.contentWrapperEl[this.axis[t].scrollOffsetAttr];c="x"===t&&this.isRtl&&(null===(s=e.getRtlHelpers())||void 0===s?void 0:s.isScrollOriginAtZero)?-c:c,"x"===t&&this.isRtl&&(c=(null===(r=e.getRtlHelpers())||void 0===r?void 0:r.isScrollingToNegative)?c:-c);var h=c/(o-a),u=~~((n-l.size)*h);u="x"===t&&this.isRtl?-u+(n-l.size):u,l.el.style.transform="x"===t?"translate3d(".concat(u,"px, 0, 0)"):"translate3d(0, ".concat(u,"px, 0)")}},e.prototype.toggleTrackVisibility=function(e){void 0===e&&(e="y");var t=this.axis[e].track.el,i=this.axis[e].scrollbar.el;t&&i&&this.contentWrapperEl&&(this.axis[e].isOverflowing||this.axis[e].forceVisible?(t.style.visibility="visible",this.contentWrapperEl.style[this.axis[e].overflowAttr]="scroll",this.el.classList.add("".concat(this.classNames.scrollable,"-").concat(e))):(t.style.visibility="hidden",this.contentWrapperEl.style[this.axis[e].overflowAttr]="hidden",this.el.classList.remove("".concat(this.classNames.scrollable,"-").concat(e))),this.axis[e].isOverflowing?i.style.display="block":i.style.display="none")},e.prototype.showScrollbar=function(e){void 0===e&&(e="y"),this.axis[e].isOverflowing&&!this.axis[e].scrollbar.isVisible&&(_(this.axis[e].scrollbar.el,this.classNames.visible),this.axis[e].scrollbar.isVisible=!0)},e.prototype.hideScrollbar=function(e){void 0===e&&(e="y"),this.axis[e].isOverflowing&&this.axis[e].scrollbar.isVisible&&(q(this.axis[e].scrollbar.el,this.classNames.visible),this.axis[e].scrollbar.isVisible=!1)},e.prototype.hideNativeScrollbar=function(){this.offsetEl&&(this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-".concat(this.scrollbarWidth,"px"):"0px",this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-".concat(this.scrollbarWidth,"px"):"0px")},e.prototype.onMouseMoveForAxis=function(e){void 0===e&&(e="y");var t=this.axis[e];t.track.el&&t.scrollbar.el&&(t.track.rect=t.track.el.getBoundingClientRect(),t.scrollbar.rect=t.scrollbar.el.getBoundingClientRect(),this.isWithinBounds(t.track.rect)?(this.showScrollbar(e),_(t.track.el,this.classNames.hover),this.isWithinBounds(t.scrollbar.rect)?_(t.scrollbar.el,this.classNames.hover):q(t.scrollbar.el,this.classNames.hover)):(q(t.track.el,this.classNames.hover),this.options.autoHide&&this.hideScrollbar(e)))},e.prototype.onMouseLeaveForAxis=function(e){void 0===e&&(e="y"),q(this.axis[e].track.el,this.classNames.hover),q(this.axis[e].scrollbar.el,this.classNames.hover),this.options.autoHide&&this.hideScrollbar(e)},e.prototype.onDragStart=function(e,t){var i;void 0===t&&(t="y");var s=j(this.el),r=H(this.el),l=this.axis[t].scrollbar,o="y"===t?e.pageY:e.pageX;this.axis[t].dragOffset=o-((null===(i=l.rect)||void 0===i?void 0:i[this.axis[t].offsetAttr])||0),this.draggedAxis=t,_(this.el,this.classNames.dragging),s.addEventListener("mousemove",this.drag,!0),s.addEventListener("mouseup",this.onEndDrag,!0),null===this.removePreventClickId?(s.addEventListener("click",this.preventClick,!0),s.addEventListener("dblclick",this.preventClick,!0)):(r.clearTimeout(this.removePreventClickId),this.removePreventClickId=null)},e.prototype.onTrackClick=function(e,t){var i,s,r,l,o=this;void 0===t&&(t="y");var n=this.axis[t];if(this.options.clickOnTrack&&n.scrollbar.el&&this.contentWrapperEl){e.preventDefault();var a=H(this.el);this.axis[t].scrollbar.rect=n.scrollbar.el.getBoundingClientRect();var c=null!==(s=null===(i=this.axis[t].scrollbar.rect)||void 0===i?void 0:i[this.axis[t].offsetAttr])&&void 0!==s?s:0,h=parseInt(null!==(l=null===(r=this.elStyles)||void 0===r?void 0:r[this.axis[t].sizeAttr])&&void 0!==l?l:"0px",10),u=this.contentWrapperEl[this.axis[t].scrollOffsetAttr],d=("y"===t?this.mouseY-c:this.mouseX-c)<0?-1:1,p=-1===d?u-h:u+h,v=function(){o.contentWrapperEl&&(-1===d?u>p&&(u-=40,o.contentWrapperEl[o.axis[t].scrollOffsetAttr]=u,a.requestAnimationFrame(v)):u<p&&(u+=40,o.contentWrapperEl[o.axis[t].scrollOffsetAttr]=u,a.requestAnimationFrame(v)))};v()}},e.prototype.getContentElement=function(){return this.contentEl},e.prototype.getScrollElement=function(){return this.contentWrapperEl},e.prototype.removeListeners=function(){var e=H(this.el);this.el.removeEventListener("mouseenter",this.onMouseEnter),this.el.removeEventListener("pointerdown",this.onPointerEvent,!0),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl&&this.contentWrapperEl.removeEventListener("scroll",this.onScroll),e.removeEventListener("resize",this.onWindowResize),this.mutationObserver&&this.mutationObserver.disconnect(),this.resizeObserver&&this.resizeObserver.disconnect(),this.onMouseMove.cancel(),this.onWindowResize.cancel(),this.onStopScrolling.cancel(),this.onMouseEntered.cancel()},e.prototype.unMount=function(){this.removeListeners()},e.prototype.isWithinBounds=function(e){return this.mouseX>=e.left&&this.mouseX<=e.left+e.width&&this.mouseY>=e.top&&this.mouseY<=e.top+e.height},e.prototype.findChild=function(e,t){var i=e.matches||e.webkitMatchesSelector||e.mozMatchesSelector||e.msMatchesSelector;return Array.prototype.filter.call(e.children,(function(e){return i.call(e,t)}))[0]},e.rtlHelpers=null,e.defaultOptions={forceVisible:!1,clickOnTrack:!0,scrollbarMinSize:25,scrollbarMaxSize:0,ariaLabel:"scrollable content",classNames:{contentEl:"simplebar-content",contentWrapper:"simplebar-content-wrapper",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging",scrolling:"simplebar-scrolling",scrollable:"simplebar-scrollable",mouseEntered:"simplebar-mouse-entered"},scrollableNode:null,contentNode:null,autoHide:!0},e.getOptions=B,e.helpers=V,e}(),Y=X.helpers,F=Y.getOptions,I=Y.addClasses,$=function(t){function i(){for(var e=[],s=0;s<arguments.length;s++)e[s]=arguments[s];var r=t.apply(this,e)||this;return i.instances.set(e[0],r),r}return function(t,i){if("function"!=typeof i&&null!==i)throw new TypeError("Class extends value "+String(i)+" is not a constructor or null");function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}(i,t),i.initDOMLoadedElements=function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"),(function(e){"init"===e.getAttribute("data-simplebar")||i.instances.has(e)||new i(e,F(e.attributes))}))},i.removeObserver=function(){var e;null===(e=i.globalObserver)||void 0===e||e.disconnect()},i.prototype.initDOM=function(){var e,t,i,s=this;if(!Array.prototype.filter.call(this.el.children,(function(e){return e.classList.contains(s.classNames.wrapper)})).length){for(this.wrapperEl=document.createElement("div"),this.contentWrapperEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),I(this.wrapperEl,this.classNames.wrapper),I(this.contentWrapperEl,this.classNames.contentWrapper),I(this.offsetEl,this.classNames.offset),I(this.maskEl,this.classNames.mask),I(this.contentEl,this.classNames.contentEl),I(this.placeholderEl,this.classNames.placeholder),I(this.heightAutoObserverWrapperEl,this.classNames.heightAutoObserverWrapperEl),I(this.heightAutoObserverEl,this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.contentWrapperEl.appendChild(this.contentEl),this.offsetEl.appendChild(this.contentWrapperEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl),null===(e=this.contentWrapperEl)||void 0===e||e.setAttribute("tabindex","0"),null===(t=this.contentWrapperEl)||void 0===t||t.setAttribute("role","region"),null===(i=this.contentWrapperEl)||void 0===i||i.setAttribute("aria-label",this.options.ariaLabel)}if(!this.axis.x.track.el||!this.axis.y.track.el){var r=document.createElement("div"),l=document.createElement("div");I(r,this.classNames.track),I(l,this.classNames.scrollbar),r.appendChild(l),this.axis.x.track.el=r.cloneNode(!0),I(this.axis.x.track.el,this.classNames.horizontal),this.axis.y.track.el=r.cloneNode(!0),I(this.axis.y.track.el,this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}X.prototype.initDOM.call(this),this.el.setAttribute("data-simplebar","init")},i.prototype.unMount=function(){X.prototype.unMount.call(this),i.instances.delete(this.el)},i.initHtmlApi=function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(i.handleMutations),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))},i.handleMutations=function(e){e.forEach((function(e){e.addedNodes.forEach((function(e){1===e.nodeType&&(e.hasAttribute("data-simplebar")?!i.instances.has(e)&&document.documentElement.contains(e)&&new i(e,F(e.attributes)):e.querySelectorAll("[data-simplebar]").forEach((function(e){"init"!==e.getAttribute("data-simplebar")&&!i.instances.has(e)&&document.documentElement.contains(e)&&new i(e,F(e.attributes))})))})),e.removedNodes.forEach((function(e){1===e.nodeType&&("init"===e.getAttribute("data-simplebar")?i.instances.has(e)&&!document.documentElement.contains(e)&&i.instances.get(e).unMount():Array.prototype.forEach.call(e.querySelectorAll('[data-simplebar="init"]'),(function(e){i.instances.has(e)&&!document.documentElement.contains(e)&&i.instances.get(e).unMount()})))}))}))},i.instances=new WeakMap,i}(X);return t&&$.initHtmlApi(),$}();
	
	// 表スクロール
	new SimpleBar(document.querySelector('.receipt-details__list'));
	
	// 印刷ボタン
	$('.recipt__title-sup').on('click', 'a', function(event) {
		event.preventDefault();
		
		window.print();
	});
}

/**
 * @private
 * @function
 * @description Binds the events of receipt page
 */
function initializeEvents() {
  initReceipt();
}

var receipt = {
  init: function () {
    initializeEvents();
  }
};

module.exports = receipt;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],45:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    //quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    var $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $afterAddress);
    });

    //$('.item-list').on('click', '.item-edit-details a', function (e) {
    //    e.preventDefault();
    //    var productListID = $('input[name=productListID]').val();
    //    quickview.show({
    //        url: e.target.href,
    //        source: 'giftregistry',
    //        productlistid: productListID
    //    });
    //});
}

exports.init = function () {
    initializeEvents();
    addProductToCart.init();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":1,"../login":16,"../util":63,"./product/addToCart":35}],46:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
  productTile = require('../product-tile'),
  progress = require('../progress'),
  util = require('../util');
const searchplaceholder = require('../searchplaceholder');
const initRecommendations = require('./product/recommendations');

function infiniteScroll() {
  // getting the hidden div, which is the placeholder for the next page
  var loadingPlaceHolder = $(
    '.infinite-scroll-placeholder[data-loading-state="unloaded"]'
  );
  // get url hidden in DOM
  var gridUrl = loadingPlaceHolder.attr('data-grid-url');

  if (
    loadingPlaceHolder.length === 1 &&
    util.elementInViewport(loadingPlaceHolder.get(0), 250)
  ) {
    // switch state to 'loading'
    // - switches state, so the above selector is only matching once
    // - shows loading indicator
    loadingPlaceHolder.attr('data-loading-state', 'loading');
    loadingPlaceHolder.addClass('infinite-scroll-loading');

    // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
    var fillEndlessScrollChunk = function (html) {
      loadingPlaceHolder.removeClass('infinite-scroll-loading');
      loadingPlaceHolder.attr('data-loading-state', 'loaded');
      $('div.search-result-content').append(html);
    };

    // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
    // it was removed to temporarily address RAP-2649

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: gridUrl,
      success: function (response) {
        // put response into cache
        try {
          sessionStorage['scroll-cache_' + gridUrl] = response;
        } catch (e) {
          // nothing to catch in case of out of memory of session storage
          // it will fall back to load via ajax
        }
        // update UI
        fillEndlessScrollChunk(response);
        productTile.init();
      }
    });
  }
}
/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
  if (!url || url === window.location.href) {
    return;
  }
  progress.show($('.search-result-content'));
  $('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
    compareWidget.init();
    productTile.init();

    // add custom toggle functionality
    $('.c-title__has-toggle:not(.u__toggle-opened)').next('.toggle-content').hide();
    $('.c-title__has-toggle').on('click', function () {
      $(this).toggleClass('u__toggle-opened').next('.toggle-content').slideToggle(250);
    });

    progress.hide();
    history.pushState(undefined, '', url);
  });
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
  var $main = $('#main');
  // compare checked
  $main.on('click', 'input[type="checkbox"].compare-check', function () {
    var cb = $(this);
    var tile = cb.closest('.product-tile');

    var func = this.checked
      ? compareWidget.addProduct
      : compareWidget.removeProduct;
    var itemImg = tile.find('.product-image a img').first();
    func({
      itemid: tile.data('itemid'),
      uuid: tile[0].id,
      img: itemImg,
      cb: cb
    });
  });

  // handle toggle refinement blocks
  $main.on('click', '.refinement h3', function () {
    $(this).toggleClass('expanded').siblings('ul').toggle();
  });

  // handle events for updating grid
  $main.on(
    'click',
    '.refinements a, .pagination a, .breadcrumb-refinement-value a',
    function (e) {
      // don't intercept for category and folder refinements, as well as unselectable
      if (
        $(this).parents('.category-refinement').length > 0 ||
        $(this).parents('.folder-refinement').length > 0 ||
        $(this).parent().hasClass('unselectable')
      ) {
        return;
      }
      e.preventDefault();
      updateProductListing(this.href);
    }
  );

  // handle event for filter selection
  $main.on('change', '.filter .product-listing-filter', function (e) {
    e.preventDefault();
    updateProductListing($('option:selected', this).attr('data-url'));
  });

  // handle event for VIEW MORE button
  $main.on('click', '#view-more', function (e) {
    e.preventDefault();
    $('html')
      .addClass('disable-infinite-scroll')
      .removeClass('infinite-scroll');
    updateProductListing($(this).attr('data-grid-url'));

  });

  // handle events item click. append params.
  $main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
    var a = $(this);
    // get current page refinement values
    var wl = window.location;

    var qsParams =
      wl.search.length > 1
        ? util.getQueryStringParams(wl.search.substr(1))
        : {};
    var hashParams =
      wl.hash.length > 1 ? util.getQueryStringParams(wl.hash.substr(1)) : {};

    // merge hash params with querystring params
    var params = $.extend(hashParams, qsParams);
    if (!params.start) {
      params.start = 0;
    }
    // get the index of the selected item and save as start parameter
    var tile = a.closest('.product-tile');
    var idx = tile.data('idx') ? +tile.data('idx') : 0;

    // convert params.start to integer and add index
    params.start = +params.start + (idx + 1);
    // set the hash and allow normal action to continue
    a[0].hash = $.param(params);
  });

  // handle sorting change
  $main
    .on('change', '.sort-by select', function (e) {
      e.preventDefault();
      updateProductListing($(this).find('option:selected').val());
    })
    .on('change', '.items-per-page select', function () {
      var refineUrl = $(this).find('option:selected').val();
      if (refineUrl === 'INFINITE_SCROLL') {
        $('html')
          .addClass('infinite-scroll')
          .removeClass('disable-infinite-scroll');
      } else {
        $('html')
          .addClass('disable-infinite-scroll')
          .removeClass('infinite-scroll');
        updateProductListing(refineUrl);
      }
    });

/*
  // 検索結果：なし ページ用
  var $w = $(window);
  $('.pt_product-search-noresult .no-hits-area .sitemap-level1').on(
    'click',
    function () {
      if ($w.width() <= 768) {
        $(this).toggleClass('opened').find('+ ul').slideToggle(300);
      }
    }
  );
*/
	
	// 横並びメニュー位置揃え
	window.addEventListener('load', function() {
		if (Foundation.MediaQuery.is('small only')) {
			let $plpMenuBlock = $('.plp__menu-block'),
				$plpMenuBlockList = $plpMenuBlock.find('.plp__menu-block-list'),
				$targetA = $plpMenuBlockList.find('.menu-current'),
				$target = $targetA.parent();
			let targetLeft = $target.position().left,
				targetRight = targetLeft + $target.outerWidth(),
				plpMenuBlockWidth = $plpMenuBlock.outerWidth();
			if (targetLeft < 0) {
				$plpMenuBlock.scrollLeft(targetLeft - $plpMenuBlockList.position().left);
			} else if (targetRight > plpMenuBlockWidth) {
				$plpMenuBlock.scrollLeft(targetRight - $plpMenuBlockList.position().left - plpMenuBlockWidth);
			}
		}
	});
}

exports.init = function () {
  compareWidget.init();
  if (SitePreferences.LISTING_INFINITE_SCROLL) {
    $(window).on('scroll', infiniteScroll);
  }
  productTile.init();
  initializeEvents();
  searchplaceholder.initSearchPlaceholder('#q-no');
  initRecommendations();
};

},{"../compare-widget":6,"../product-tile":50,"../progress":51,"../searchplaceholder":54,"../util":63,"./product/recommendations":42}],47:[function(require,module,exports){
'use strict';

exports.init = function() {
/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.8",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");

var Lethargy;
(function(){var t;t="undefined"!=typeof exports&&null!==exports?exports:this,Lethargy=t.Lethargy=function(){function t(t,s,i,l){this.stability=null!=t?Math.abs(t):8,this.sensitivity=null!=s?1+Math.abs(s):100,this.tolerance=null!=i?1+Math.abs(i):1.1,this.delay=null!=l?l:150,this.lastUpDeltas=function(){var t,s,i;for(i=[],t=1,s=2*this.stability;s>=1?s>=t:t>=s;s>=1?t++:t--)i.push(null);return i}.call(this),this.lastDownDeltas=function(){var t,s,i;for(i=[],t=1,s=2*this.stability;s>=1?s>=t:t>=s;s>=1?t++:t--)i.push(null);return i}.call(this),this.deltasTimestamp=function(){var t,s,i;for(i=[],t=1,s=2*this.stability;s>=1?s>=t:t>=s;s>=1?t++:t--)i.push(null);return i}.call(this)}return t.prototype.check=function(t){var s;return t=t.originalEvent||t,null!=t.wheelDelta?s=t.wheelDelta:null!=t.deltaY?s=-40*t.deltaY:(null!=t.detail||0===t.detail)&&(s=-40*t.detail),this.deltasTimestamp.push(Date.now()),this.deltasTimestamp.shift(),s>0?(this.lastUpDeltas.push(s),this.lastUpDeltas.shift(),this.isInertia(1)):(this.lastDownDeltas.push(s),this.lastDownDeltas.shift(),this.isInertia(-1))},t.prototype.isInertia=function(t){var s,i,l,a,e,n,h;return s=-1===t?this.lastDownDeltas:this.lastUpDeltas,null===s[0]?t:this.deltasTimestamp[2*this.stability-2]+this.delay>Date.now()&&s[0]===s[2*this.stability-1]?!1:(l=s.slice(0,this.stability),i=s.slice(this.stability,2*this.stability),h=l.reduce(function(t,s){return t+s}),e=i.reduce(function(t,s){return t+s}),n=h/l.length,a=e/i.length,Math.abs(n)<Math.abs(a*this.tolerance)&&this.sensitivity<Math.abs(a)?t:!1)},t.prototype.showLastUpDeltas=function(){return this.lastUpDeltas},t.prototype.showLastDownDeltas=function(){return this.lastDownDeltas},t}()}).call(this);

	var $w = $(window), $header = $('#header'), $hdNavMenu = $('#hd-nav').find('> .nav'),
		$contents = $('.contents'),
		$hero = $('#homepage-hero'),
		$pickup = $('#pickup'),
		$featured = $('#featured'),
		$bs = $('#best-seller');
	var $headerBanner = $('.header-banner'), hBannerFlag = false;
	var doingScroll = false;
	
	var clickToScroll = function(e) {
		e.preventDefault();
		
		doingScroll = true;
		$('html, body').animate({
			scrollTop: $(e.currentTarget.getAttribute('href')).offset().top
		}, 500, function() {
			doingScroll = false;
		});
		
		return false;
	};
	
	// headerBanner有無判定
	if ($headerBanner.length > 0) {
		hBannerFlag = true;
		$('#wrapper').addClass('has-hb');
		
		var setHeaderBannerPos = function() {
			var headerBannerH = $headerBanner.outerHeight();
			
			$headerBanner.css('top', -headerBannerH - 1);
			$header.css({
				top: -($header.height() + headerBannerH),
				marginTop: headerBannerH
			});
			
			$pickup.css('padding-top', headerBannerH);
		};
		$w.on('resize', setHeaderBannerPos);
		setHeaderBannerPos();
	}
	
	// ヒーローエリア
	var setHero = function() {
		var $heroSlide = $('#hero-slide'), $heroSlides = $hero.find('.hero-slide'), $arrow = $hero.find('.arrow'),
			$heroFirstImg = $heroSlides.eq(0).find('img');
		
		if ($heroSlides.eq(0).data('logo-color') === 'white') {
			$arrow.addClass('white');
		}
		
		$heroSlides.each(function() {
			$(this).css('background-image', 'url(' + $(this).data('bg') + ')');
		});
		if ($heroSlides.length > 1) {
			$heroSlide.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				if ($heroSlides.eq(nextSlide).data('logo-color') === 'white') {
					$arrow.addClass('white');
				} else {
					$arrow.removeClass('white');
				}
			}).slick({
				autoplay: true,
				autoplaySpeed: 3000,
				arrows: false,
				cssEase: 'linear',
				draggable: false,
				fade: true,
				pauseOnFocus: false,
				pauseOnHover: false,
				speed: 1000,
				swipe: false,
				touchMove: false
			});
		}
		
		var setHeroArea = function() {
			$contents.css('margin-top', $hero.outerHeight());
			
			if (Foundation.MediaQuery.is('small only')) {
				var heroH = window.innerHeight;
				
				$hero.css('height', heroH);
				$contents.css('margin-top', heroH);
				
				if (($heroFirstImg.hasClass('h-fit') && $heroFirstImg.width() <= $heroSlide.width())
					|| ($heroFirstImg.hasClass('w-fit') && $heroFirstImg.height() <= $heroSlide.height())) {
					$heroSlide.addClass('fit-cover');
				} else {
					$heroSlide.removeClass('fit-cover');
				}
			}
		};
		var setHeroSize = function() {
			if ($w.scrollTop() >= $contents.offset().top - $header.height()) {
				$headerBanner.addClass('show');
				$header.addClass('show');
			} else {
				$headerBanner.removeClass('show');
				$header.removeClass('show');
				
				// グロバールメニュー閉じる
				$hdNavMenu.removeClass('show');
			}
			
			// スマホ画面全体表示
			if (Foundation.MediaQuery.is('small only')) {
				var heroH = window.innerHeight;
				
				$hero.css('height', heroH);
				$contents.css('margin-top', heroH);
			} else {
				$hero.css('height', '');
			}
		};
		
		document.addEventListener('readystatechange', function(e) {
			if (/interactive|complete/.test(e.target.readyState)) {
				setHeroArea();
				setHeroSize();
			}
		});
		if (/interactive|complete/.test(document.readyState)) {
			setHeroArea();
			setHeroSize();
		}
		$w.on('resize', setHeroArea);
		$w.on('resize scroll', setHeroSize);
		
		var beforePos = $w.scrollTop();
		$w.on('scroll', function() {
			var wTop = $w.scrollTop(), pickupTop = $pickup.offset().top;
			
			if (doingScroll) {
				return false;
			}
			if (wTop >= 0 && wTop < pickupTop && wTop - beforePos > 20) {
				doingScroll = true;

				$('html, body').animate({
					scrollTop: pickupTop
				}, 500, function() {
					doingScroll = false;
				});
			}
			beforePos = wTop;
		});
		
		// SCROLLクリック
		$arrow.on('click', 'a', clickToScroll);
		
		// Hammer（スマホ）
		(function() {
			var h = new Hammer(document.getElementById('homepage-hero'));
			
			h.get('pan').set({direction: Hammer.DIRECTION_VERTICAL});
			h.on('panup', function(e) {
				if (e.isFinal) {
					$arrow.find('a').trigger('click');
				}
			}).on('pandown', function(e) {
				if (e.isFinal) {
					$('html, body').animate({
						scrollTop: 0
					}, 500);
				}
			});
		})();
		
		// マウスホイール、トラックパッド対応
		(function() {
			var mouseWheelEvent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
			var lethargy = new Lethargy(), lethargyCheck;
			
			$hero.on(mouseWheelEvent, function(e) {
				var delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
				
				lethargyCheck = lethargy.check(e);
				
				// ホイールイベントと親（window）への伝搬を無効
				e.preventDefault();
				e.stopPropagation();
				
				if (lethargyCheck !== false) {
					// 通常スクロール
					if (!doingScroll) {
						if (delta < 0) {
							// 下方向の移動で、メインビジュアルが画面内に見える場合、pickupまで移動。他のイベントはキャンセル
							$arrow.find('a').trigger('click');
						} else {
							doingScroll = true;
							
							$('html, body').animate({
								scrollTop: 0
							}, 500, function() {
								doingScroll = false;
							});
						}
					}
					return false;
				} else {
					// 慣性スクロール
					e.preventDefault();
					if (delta < 0 && $w.scrollTop() < $pickup.offset().top) {
						if (!doingScroll) {
							$arrow.find('a').trigger('click');
						}
					}
					if (delta >= 0 && !doingScroll) {
						doingScroll = true;
						
						$('html, body').animate({
							scrollTop: 0
						}, 500, function() {
							doingScroll = false;
						});
					}
					return false;
				}
			});
			
			var doingWheelScroll = false, wheelTimer = 0;
			var recheckEndWheel = function() {
				clearTimeout(wheelTimer);
				wheelTimer = setTimeout(function() {
					doingWheelScroll = false;
				}, 150);
			};
			window.addEventListener('wheel', function(e) {
				var delta = -e.deltaY,
					windowTop = $w.scrollTop(), winH = $w.height(), pickupTop = $pickup.offset().top;
				
				if (doingScroll) {
					// スクロール実行中は何もせず、フラグのみ設定
					e.preventDefault();
					doingWheelScroll = true;
				}
				if (doingWheelScroll && windowTop >= pickupTop) {
					// 位置がオーバーした分を調整
					e.preventDefault();
					$w.scrollTop($pickup.offset().top);
					// 慣性スクロールが続く場合に監視を延長
					recheckEndWheel();
				}
				
				if (!doingScroll && delta > 0 && windowTop + winH * 1/2 < pickupTop) {
					e.preventDefault();
					doingScroll = true;

					$('html, body').stop().animate({
						scrollTop: 0
					}, 500, function() {
						doingScroll = false;
					});
				}
			}, {passive: false});
		})();
	};
	
	if (document.getElementById('homepage-hero')) {
		setHero();
	} else {
		$headerBanner.addClass('show');
		$header.addClass('show');
		$contents.addClass('no-hero');
	}
	
	// ピックアップ
	(function() {
		var $pickupSlide = $pickup.find('.pickup-slide');
		
		var removeTopCover = function() {
			$w.off('load.top-cover');
			
			// 緞帳を非表示
			$('#top-cover').stop().animate({
				opacity: 0
			}, 500, function() {
				$(this).remove();
			});
		};
		
		// サイト内遷移の場合、ピックアップへ移動
		if (document.referrer && document.referrer.indexOf(document.domain) > -1) {
			setTimeout(function() {
				$w.scrollTop($pickup.offset().top);
			}, 0);
		}
		
		document.addEventListener('readystatechange', function(e) {
			if (e.target.readyState === 'complete') {
				removeTopCover();
			}
		});
		if (document.readyState === 'complete') {
			removeTopCover();
		}
		
		$pickup.find('> div').on('init', function(e, slick) {
			slick.$dots.find('.slick-active').removeClass('slick-active').end().off('init');
			$pickup.on('beforeChange', function(e, slick, cSlide, nSilde) {
				slick.$dots.find('li').removeClass('slick-active-init');
			});
			setTimeout(function() {
				slick.$dots.find('li').eq(0).addClass('slick-active-init');
			}, 0);
		}).slick({
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			cssEase: 'linear',
			dots: true,
			draggable: false,
			fade: true,
			focusOnSelect: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			speed: 1000,
			swipe: false,
			touchMove: false
		});
		
		// スマホ表示
		$w.on('load scroll', function() {
			var scrollPos = $w.scrollTop(), winH = $w.height();
			
			$pickupSlide.each(function() {
				if (scrollPos + winH >= $(this).offset().top) {
					$(this).addClass('show');
				}
			});
		});
	})();
	
	// NEWS
	(function() {
		var $sfNews = $('#sf-news').find('> div');
		
		$sfNews.on('click', 'p', function() {
			$sfNews.toggleClass('open');
		})
	})();
	
	// FEATURED
	(function() {
		var $featuredHead = $featured.find('h2'),
			lastListImg = $featured.find('li').last().find('img');
			
		// 見出し固定（スマホ）
		$w.on('load resize scroll', function() {
			var scrollPos = $w.scrollTop(), headerH = $header.height() + (hBannerFlag ? $headerBanner.height() : 0),
				featuredPos = $featured.offset().top;
			
			if (scrollPos + headerH >= featuredPos && scrollPos + headerH + $featuredHead.outerHeight() * 0.5 < lastListImg.offset().top + lastListImg.height()) {
				$featured.addClass('fixed').find('h2').css('top', headerH);
			} else {
				$featured.removeClass('fixed');
			}
		});
	})();
	
	// ベストセラー
	(function() {
		var $bsList = $bs.find('ul.products li'), $bsTextList;
		var textList = '', i = 0;
		
		$bsList.each(function() {
			var $this = $(this), $span = $this.find('span');
			
			$this.css('background-image', 'url(' + $this.data('bg') + ')')
			.find('a').css('background-image', 'url(' + $this.data('bg-sp') + ')');
			
			textList += '<li>' + $span.html() + '</li>';
			$span.wrapInner('<em>');
		});
		
		// スマホ表示
		$bs.append('<ul class="text">' + textList + '</ul>');
		$bsTextList = $bs.find('ul.text li');
		
		$bsList.eq(0).addClass('show');
		$bsTextList.eq(0).addClass('show');
		setInterval(function() {
			i++;
			if (i >= $bsList.length) {
				i = 0;
			}
			$bsList.removeClass('show').eq(i).addClass('show');
			$bsTextList.removeClass('show').eq(i).addClass('show');
		}, 2500);
	})();
	
	// ページの先頭へ戻る再設定
	(function() {
		var $w = $(window),
			$pagetop = $('#to-pagetop').find('a'),
			$footer = $('#footer');
		
		$pagetop.off('click.backToTop');
		$(document).off('load.backToTop scroll.backToTop');
		
		$(document).on('load.storefront scroll.storefront', function() {
			var scrollPos = $w.scrollTop(),
				windowH = window.innerHeight,
				footerPos = $footer.offset().top;

			if (Foundation.MediaQuery.is('medium') && windowH > document.documentElement.clientHeight) {
				windowH = document.documentElement.clientHeight;
			}

			if (scrollPos > $pickup.offset().top) {
				$pagetop.addClass('show');
			} else {
				$pagetop.removeClass('show');
			}

			if (scrollPos + windowH > footerPos) {
				$pagetop.css('bottom', scrollPos + windowH - footerPos + 20);
			} else {
				if (Foundation.MediaQuery.is('small only')) {
					$pagetop.css('bottom', 32);
				} else {
					$pagetop.css('bottom', 20);
				}
			}
		});
		$pagetop.attr('href', '#pickup').on('click.storefront', clickToScroll);
	})();
};

},{}],48:[function(require,module,exports){
'use strict';
var dialog = require('../dialog');

exports.init = function () {
  var NEIGHBOR_API = Urls.storesNeighborJson;
  var MSG_ERR =
      'エラーが発生しました。<br>大変申し訳ございませんが、しばらくしてからもう一度アクセスしてください。',
    MSG_NO_REULT =
      '現在地周辺に店舗が見つかりませんでした。<br>別の検索方法をお試しください。',
    MSG_NO_GPS =
      '位置サービスが利用できません。<br>設定を確認してください。';

  // プルダウン切替
  var setSelect = function () {
    var $refineSearch = $('.refine-search'),
      $select,
      $selected;

    $select = $refineSearch.find('.option-select');

    // ページロード時は選択状態の項目を表示
    $selected = $select.find('option:selected');
    $select
      .val($selected.val())
      .siblings('.select-label')
      .text($selected.text())
      .end()
      .blur();

    $refineSearch.on('change', 'select', function () {
      var $this = $(this);

      // select表示変更
      $selected = $this.find('option:selected');
      $this.siblings('.select-label').text($selected.text()).end().blur();
    });
  };

  // 店舗検索トップ
  var setStoresTop = function () {
    // 端末の位置情報を取得
    navigator.geolocation.getCurrentPosition(
      function (position) {
        // ボタン押下可
        $('.to-neighbor').find('a.c-btn__btn').removeClass('disabled');
      },
      function (error) {
        // メッセージ表示
        $('.to-neighbor').find('.stores-error').removeClass('hide');
      }
    );

    $('#stores-top')
      .on('click', '.box h3', function () {
        $(this)
          .toggleClass('expanded')
          .next('.hide-box')
          .stop()
          .slideToggle(300);
      })
      .on('click', '.box button[name="btn_pref"]', function () {
        // 都道府県ボタンクリック時
        var $button = $(this),
          $closestForm = $button.closest('form');

        // ---- WB修正前 ----
        // $closestForm
        //   .find('input[name="dwfrm_storelocator_state"]')
        //   .val($button.val())
        //   .end()
        //   .submit();
        // ---- WB追加ここから ----
        // SFCC form の仕様で、アクションを受け取るためにname属性付きのsubmitが必要なため納品コードを修正
        $closestForm
          .find('input[name="dwfrm_storelocator_state"]')
          .val($button.val())
          .end();
        $closestForm.find(':submit').click();
        // ---- WB追加ここまで ----
      });
  };

  // 現在地周辺の店舗を探す
  var setStoresNeighbor = function () {
    // ---- WB追加ここから ----
    const storesDetailsUrl = $('#stores-neighbor').data('storedetails-url');
    // ---- WB追加ここまで ----
    var $mapBlock = $('#map-block'),
      $neighborList;
    var markerDataC = $mapBlock.data('marker-c'),
      markerDataN = $mapBlock.data('marker-n'),
      markerDataNs = $mapBlock.data('marker-ns');

    // JSONの'rank'でソート
    var sortStoreRank = function (a, b) {
      return a.rank - b.rank;
    };

    // メッセージ表示
    var showStoresNeighborMessage = function (message) {
      $mapBlock
        .addClass('hide')
        .after('<p class="stores-neighbor-msg hide">' + message + '</p>');

      $('.stores-neighbor-msg').removeClass('hide');
      $('.refine-search').removeClass('hide');
    };

    // 地図表示、店舗情報
    var initMap = function (position, storeInfo) {
      var gMap,
        storeInfoHtml = '',
        markerArray = [],
        markerC;

      var changeMarkerSize = function (target) {
        for (var i = 0; i < markerArray.length; i++) {
          markerArray[i].setIcon({
            url: markerDataNs,
            scaledSize: new google.maps.Size(32, 45)
          });
        }

        markerArray[target].setIcon({
          url: markerDataN,
          scaledSize: new google.maps.Size(47, 66)
        });
      };

      var changeCurrentMarker = function (target) {
        if (target >= markerArray.length) {
          target = target % markerArray.length;
        }
        
        // マーカーのサイズ変更
        changeMarkerSize(target);

        // 地図の中心を変更
        gMap.panTo({
          lat: markerArray[target].position.lat(),
          lng: markerArray[target].position.lng()
        });
      };

      gMap = new google.maps.Map(document.getElementById('map-neighbor'), {
        center: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        mapTypeControl: false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        zoom: 15
      });

      // 現在地のマーカーを設置
      markerC = new google.maps.Marker({
        position: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        map: gMap,
        icon: markerDataC,
        clickable: false
      });

      for (var key in storeInfo) {
        if (storeInfo.hasOwnProperty(key)) {
          // 地図上に店舗のマーカーを設置
          var markerN = new google.maps.Marker({
            position: {
              lat: storeInfo[key].storeLat,
              lng: storeInfo[key].storeLon
            },
            map: gMap,
            icon: {
              url: markerDataN
            },
            label: {
              className: 'marker-position',
              fontSize: '12px',
              text: String(storeInfo[key].rank)
            }
          });

          markerN.rank = storeInfo[key].rank;
          markerArray.push(markerN);

          google.maps.event.addListener(markerN, 'click', function () {
            // slickの店舗ブロックをスライド
            $neighborList.slick('slickGoTo', this.rank - 1, false);
          });

          // 店舗情報HTML生成
          storeInfoHtml += '<div class="neighbor-box">';
          storeInfoHtml +=
            '<h2><span class="num">' +
            storeInfo[key].rank +
            '</span><span class="store-name"><span>' +
            storeInfo[key].storeName +
            '</span></span></h2><div>';
          storeInfoHtml += '<div>';
          storeInfoHtml += '<p>' + storeInfo[key].storeAddress + '</p>';
          storeInfoHtml +=
            '<p>現在地より<span class="distance">' +
            storeInfo[key].distance +
            '</span>m</p>';
          storeInfoHtml += '</div>';
          storeInfoHtml +=
            '<p class="to-detail"><a href="' +
            storesDetailsUrl +
            '&StoreID=' +
            storeInfo[key].storeID +
            '">店舗詳細</a></p>';
          storeInfoHtml += '</div></div>';
        }
      }

      // 一番近い店舗を中心に変更
      changeMarkerSize(0);
      gMap.panTo({
        lat: markerArray[0].position.lat(),
        lng: markerArray[0].position.lng()
      });

      if (storeInfo.length <= 3 && storeInfo.length > 1) {
        // センターモードのため複製
        storeInfoHtml += storeInfoHtml;
      } else if (storeInfo.length <= 1) {
        $neighborList.addClass('fixed');
      }

      $neighborList
        .html(storeInfoHtml)
        .on('init', function (e, slick) {
          $neighborList.on('click', 'h2', function () {
            var $this = $(this),
              $slickSlide = $this.closest('.slick-slide'),
              targetIndex;

            targetIndex = $slickSlide.data('slick-index');
            if (targetIndex >= storeInfo.length) {
              targetIndex -= storeInfo.length;
            }
            // slickの店舗ブロックをスライド
            $neighborList.slick('slickGoTo', targetIndex, false);
          });
        })
        .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          changeCurrentMarker(nextSlide);
        })
        .slick({
          arrows: true,
          centerMode: true,
          dots: false,
          variableWidth: true,
          slidesToScroll: 1,
          slidesToShow: 3,
          speed: 750,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                arrows: false,
                slidesToShow: 1
              }
            }
          ]
        });
    };

    var successPostionCB = function (position) {
      $.ajax({
        type: 'POST',
        url: NEIGHBOR_API,
        dataType: 'json',
        data: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        },
        timeout: 5000
      })
        .done(function (response, textStatus, jqXHR) {
          if (response.length > 0) {
            // 店舗あり
            response.sort(sortStoreRank);

            $mapBlock.html(
              '<div id="map-neighbor"></div><div class="neighbor-list"></div>'
            );
            $neighborList = $('.neighbor-list');
            setTimeout(function () {
              $neighborList.addClass('stores-show');
              $('#map-neighbor').addClass('stores-show');
            }, 1);

            initMap(position, response);
          } else {
            // 店舗なし
            showStoresNeighborMessage(MSG_NO_REULT);
          }
        })
        .fail(function (xhr) {
          // エラー
          showStoresNeighborMessage(MSG_ERR);
        });
    };
    var errorPostionCB = function (error) {
      var errMsg = '';

      switch (error.code) {
        case 1:
          errMsg = MSG_NO_GPS;
          break;
        case 2:
          errMsg = MSG_NO_GPS;
          break;
        case 3:
          errMsg = MSG_ERR;
          break;
      }
      showStoresNeighborMessage(errMsg);
    };

    // 端末の位置情報を取得
    navigator.geolocation.getCurrentPosition(successPostionCB, errorPostionCB);
  };

  // 店舗検索の結果
  var setStoresList = function () {
    // 端末の位置情報を取得
    navigator.geolocation.getCurrentPosition(
      function (position) {
        // 並べ替えボタンを表示
        $('.stores-list-result').addClass('stores-gps');
        // ---- WB追加ここから ----
        // formのhiddenフィールドに位置情報をセット
        ['latitude', 'longitude'].forEach((key) => {
          const $field = $(`input#js-formfield-${key}`);
          if (!$field.length) {
            return;
          }
          $field.val(position.coords[key]);
        });
        // ---- WB追加ここまで ----
      },
      function (error) {}
    );
    // ---- WB追加ここから ----
    // 「VIEW MORE」「VIEW ALL」ボタン押下時、結果表示後追加項目の位置へスクロール
    const $viewmoreTop = $('.js-viewmore-top');
    const $header = $('header#header');
    if ($viewmoreTop.length > 0 && $header.length > 0) {
      // ヘッダーの下に要素がくるようにスクロール
      $(window).scrollTop($viewmoreTop.position().top - $header.height());
    }
    // ---- WB追加ここまで ----
  };

  $(function () {
    setSelect();

    if (document.getElementById('stores-top')) {
      // 店舗検索トップ
      setStoresTop();
    } else if (document.getElementById('stores-neighbor')) {
      // 現在地周辺の店舗を探す
      setStoresNeighbor();
    } else if (document.getElementById('stores-list')) {
      // 店舗検索の結果
      setStoresList();
    }
  });
};

},{"../dialog":9}],49:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
  page = require('../page'),
  login = require('../login'),
  util = require('../util'),
  headerMenu = require('../header-menu'),
  minicart = require('../minicart'),
  dialog = require('../dialog');

var initAddEvent = function (cmd, callback_fn) {
  cmd.off('click').on('click', function (e) {
    var me = $(this);

    e.preventDefault();

    if (me.hasClass('processing')) {
      return;
    }

    me.addClass('processing');

    var info = JSON.parse(this.dataset.info);

    setTimeout(function () {
      callback_fn(me);
    }, 200);
  });
};

var initRemoveEvent = function () {
  var wait_ga = true;
  var is_clicked = false;

  $('.remove-wish-item-btn').on('click', function (e) {
    if (wait_ga || is_clicked) {
      e.preventDefault();
    }

    if (wait_ga && !is_clicked) {
      is_clicked = true;

      var me = $(this);
      var info = JSON.parse(this.dataset.info);

      if (info) {
        window.dataLayer.push({
          event: 'removeFromWishlist',
          productCategory: info.category,
          productSubCategory: info.sub_category,
          productName: info.name,
          productVariant: info.variant,
          pageCategory: data_general_gtm.pageCategory,
          productOutOfStock: info.stock,
          userStatus:
            $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged',
        });
      }

      wait_ga = false;

      setTimeout(function () {
        is_clicked = false;

        me.trigger('click');
      }, 200);
    }
  });
};

var initCartEvent = function () {
  var wait_ga = true;
  var is_clicked = false;

  $('.add-to-cart').on('click', function (e) {
    if (wait_ga || is_clicked) {
      e.preventDefault();
    }

    if (wait_ga && !is_clicked) {
      is_clicked = true;

      var me = $(this);
      var info = JSON.parse(this.dataset.info);
      var form = $(this).closest('form');
      var e_qty = form.find('input[name="Quantity"], select[name="Quantity"]');
      var qty = 1;

      if (!(e_qty.length === 0 || isNaN(e_qty.val()))) {
        qty = e_qty.val();
      }

      if (info) {
        window.dataLayer.push({
          event: 'addToCart',
          currencyCode: info.currency,
          userStatus:
            $('#sign-in-dropdown-link').length > 0 ? 'logged' : 'notlogged',
          products: [
            {
              name: info.name,
              id: info.id,
              category: info.category,
              price: info.hasOwnProperty('is_kit')
                ? $('#kit-net-price').text()
                : info.price,
              brand: info.brand,
              quantity: qty,
            },
          ],
        });
      }

      wait_ga = false;

      setTimeout(function () {
        is_clicked = false;

        me.trigger('click');
      }, 200);
    }
  });

  $('.tx-pl-item-form').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    var clicked_button_name = e.originalEvent.submitter.name;
    if (clicked_button_name.indexOf('_deleteItem') > -1) {
      var $csrf_token = $form.find('input[name$="csrf_token"]');
      var info = e.originalEvent.submitter.dataset.info;
      var info_json = info ? JSON.parse(info) : {};
      var csrf_Value = $csrf_token.val();
      removeItemFromWishlist(info_json.id, csrf_Value);
      return false;
    }
    dialog.loading();
    addItemToCart($form).then(
      function (response) {
        if (response.error && !response.isWithinOrderablePeriod) {
          window.location.href = Urls.cartShow;
          return;
        }
        dialog.close();
        showResult(!response.error, response.response, function () {});
      }.bind(this)
    );
  });
};

var removeItemFromWishlist = function (pid, csrfTtoken) {
  var urlpost = util.ajaxUrl(Urls.wishlistRemoveAjax);
  var data = "pid=" + pid + "&csrf_token=" + csrfTtoken;
  $.ajax({
    type: 'POST',
    url: urlpost,
    data: data
  }).done(function(reaponse) {
    window.location.href =Urls. wishlistShow;
  });
}


/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
  var $form = $(form);
  var urlpost = util.ajaxUrl(Urls.addProduct)
  return Promise.resolve(
    $.ajax({
      type: 'POST',
      url: urlpost,
      data: $(form).serialize()
    })
  ).then(function (response) {
    try {
      response = JSON.parse(response);
    } catch (er) {}
    const isError = response.status === 'error';
    const message = isError ? response.message : null;
    const responseHTML = response.hasOwnProperty('status') ? null : response;
    return {
      error: isError,
      response: responseHTML,
      msg: message,
      isWithinOrderablePeriod: response.isWithinOrderablePeriod
    };
  });
}
/**
 * @description Show result after add to cart and do checking
 */
function showResult(success, response, checking_fn) {
  if (success) {
//      if (window.innerWidth < 768) {
    minicart.notice(false);
//      }
    minicart.show(response);
    addProductToCart.updateMiniCartIcon();
    checking_fn();
    return;
  }
  minicart.notice(true);
  }


exports.init = function () {
  addProductToCart.init();
  $('#editAddress').on('change', function () {
    page.redirect(
      util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val())
    );
  });

  //add js logic to remove the , from the qty feild to pass regex expression on client side
  $('.option-quantity-desired input').on('focusout', function () {
    $(this).val($(this).val().replace(',', ''));
  });

  initRemoveEvent();
  initCartEvent();
  login.init();
  headerMenu.initAccountNav();
};

exports.initAddEvent = initAddEvent;

},{"../dialog":9,"../header-menu":12,"../login":16,"../minicart":17,"../page":20,"../util":63,"./product/addToCart":35}],50:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded');
var util = require('./util');
var dialog = require('./dialog');
var minicart = require('./minicart');
var bonusProductsView = require('./bonus-products-view');

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

function initCarouselSwatches() {
    $('.swatch-list:not(.c-pl__item-swatch-list)').not('.slick-slider').slick({
    	dots: false,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 3,
        speed: 300
    });
	// 新フォーマット
	$('.swatch-list.c-pl__item-swatch-list').not('.slick-slider').slick({
		dots: false,
//		focusOnSelect: true,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		speed: 300
	});
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
	var mql = window.matchMedia('screen and (max-width: 48.0613em)'); // SP表示

    gridViewToggle();
    $('.c-pl__item-wishlist').on('click', function (e) {
		e.preventDefault();
	});
    $('.c-pl__item-swatches').on('click', function (e) {
		e.preventDefault();
	});
    $('.c-pl__item-select').on('click', function (e) {
		e.preventDefault();
	});
    $('.c-pl__item-cart').on('click', function (e) {
		e.preventDefault();
	});
    $('.swatch-list').on('mouseleave', function () {
		if (mql.matches) {
			return false;
		}

        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image img').eq(0),
            data = $thumb.data('current');

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });

		$tile.find('.c-pl__item-name').html(data.title).end()
			.find('.c-pl__item-price span').html(data.price);
    });
    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) { return; }

        var $tile = $(this).closest('.product-tile');
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        //【サイトリニューアル 1.0】 Start カラー選択時のurl変更処理を修正
        var linkUrl = $(this).attr('href') == null ? $(this).attr('data-url') : $(this).attr('href');
//        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
//        $tile.find('name-link').attr('href', $(this).attr('href'));
        $tile.find('.thumb-link').attr('href', linkUrl);
        $tile.find('name-link').attr('href', linkUrl);
        //【サイトリニューアル 1.0】 Start カラー選択時のurl変更処理を修正

        var data = $(this).children('img').filter(':first').data('thumb') || $(this).children('span').filter(':first').data('thumb');
        var $thumb = $tile.find('.product-image img').eq(0);

        var $wishlistBtn = $tile.find('.c-pl__item-wishlist').find('.button');
        var $cartBtn = $tile.find('.c-pl__item-cart').find('.c-btn__btn');
        var $hdnPid =  $tile.find('input[name="pid"]');

        var $url = util.appendParamsToUrl(Urls.productVariationChange, {pid: data.pid});
        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: $url,
          })
        .done(function (res) {
            if (res.success == true) {
                $thumb.attr({
                    src: data.src,
                    alt: data.alt,
                    title: data.title
                });
        		$thumb.data('current', {
                    src: data.src,
                    alt: data.alt,
                    title: data.title,
        			price: data.price
        		});

        		if (res.inWishlist) {
        			$wishlistBtn.addClass('saved-wishlist');
        		} else {
        			$wishlistBtn.removeClass('saved-wishlist');
        		}
        		$wishlistBtn.data('info', res.wishListInfo);

        		$tile.find('.c-pl__item-name').html(data.title).end()
    			.find('.c-pl__item-price span').html(data.price);

        		$cartBtn.data('info', res.productInfo);
                if (res.checkStatus.isAddToCartErrorOnOrderRestriction) {
                	$cartBtn.html(Resources.GLOBAL_PURCHASELIMIT_LABEL);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isBeforeReleaseStart) {
                	$cartBtn.html(Resources.GLOBAL_BEFORERELEAS);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isAfterReleaseEnd) {
                	$cartBtn.html(Resources.GLOBAL_AFTERRELEASEND);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isBeforePreorderStart) {
                	$cartBtn.html(Resources.GLOBAL_BEFOREPREORDER);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isAfterPreOrderEnd) {
                	$cartBtn.html(Resources.GLOBAL_AFTERPREORDEREND);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.availableCount <= 0) {
                	$cartBtn.html(Resources.OUT_OF_STOCK);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.maxOrderable <= 0) {
                	$cartBtn.html(Resources.GLOBAL_OVERLIMIT);
                	$cartBtn.addClass('noadd');
                } else {
                	$cartBtn.html(Resources.GLOBAL_ADDCART);
                	$cartBtn.removeClass('noadd');
                }
                $hdnPid.val(data.pid);
            } else {
            	console.log('[ERROR] ajax request: ' + Urls.productVariationChange);
            }
        })
        .fail(function (xhr, textStatus) {
        	console.log('[ERROR] ajax request: ' + Urls.productVariationChange);
        });

    }).on('mouseenter', function () {
		if (mql.matches) {
			return false;
		}

        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image img').eq(0),
            data = $(this).children('img').filter(':first').data('thumb') || $(this).children('span').filter(':first').data('thumb'),
            current = $thumb.attr('data-current');

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: data.src,
                alt: data.alt,
                title: data.title,
				price: data.price
            });
        }

		$tile.find('.c-pl__item-name').html(data.title).end()
			.find('.c-pl__item-price span').html(data.price);

        // Set the tile image to the values provided on the swatch data attributes
        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
	$('.c-pl__item-select-variation').on('change', function () {
		var $tile = $(this).closest('.product-tile'),
			$thumb = $tile.find('.product-image img').eq(0),
			data = $(this).find('option:selected').data('thumb'),
			current = $thumb.data('current');
		var linkUrl = $(this).find('option:selected').attr('href') == null ? $(this).find('option:selected').attr('data-url') : $(this).find('option:selected').attr('href');
        $tile.find('.thumb-link').attr('href', linkUrl);
        $tile.find('name-link').attr('href', linkUrl);

        var $wishlistBtn = $tile.find('.c-pl__item-wishlist').find('.button');
        var $cartBtn = $tile.find('.c-pl__item-cart').find('.c-btn__btn');
        var $hdnPid =  $tile.find('input[name="pid"]');

        var $url = util.appendParamsToUrl(Urls.productVariationChange, {pid: data.pid});
        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: $url,
          })
        .done(function (res) {
            if (res.success == true) {
                if (!current) {
                    $thumb.data('current', {
                        src: data.src,
                        alt: data.alt,
                        title: data.title,
                        price: data.price
                    });
                }

        		if (res.inWishlist) {
        			$wishlistBtn.addClass('saved-wishlist');
        		} else {
        			$wishlistBtn.removeClass('saved-wishlist');
        		}
        		$wishlistBtn.data('info', res.wishListInfo);

        		$tile.find('.c-pl__item-name').html(data.title).end()
    			.find('.c-pl__item-price span').html(data.price);

        		$thumb.attr({
                    src: data.src,
                    alt: data.alt,
                    title: data.title
                });

        		$cartBtn.data('info', res.productInfo);
                if (res.checkStatus.isAddToCartErrorOnOrderRestriction) {
                	$cartBtn.html(Resources.GLOBAL_PURCHASELIMIT_LABEL);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isBeforeReleaseStart) {
                	$cartBtn.html(Resources.GLOBAL_BEFORERELEAS);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isAfterReleaseEnd) {
                	$cartBtn.html(Resources.GLOBAL_AFTERRELEASEND);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isBeforePreorderStart) {
                	$cartBtn.html(Resources.GLOBAL_BEFOREPREORDER);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.isAfterPreOrderEnd) {
                	$cartBtn.html(Resources.GLOBAL_AFTERPREORDEREND);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.availableCount <= 0) {
                	$cartBtn.html(Resources.OUT_OF_STOCK);
                	$cartBtn.addClass('noadd');
                } else if (res.checkStatus.maxOrderable <= 0) {
                	$cartBtn.html(Resources.GLOBAL_OVERLIMIT);
                	$cartBtn.addClass('noadd');
                } else {
                	$cartBtn.html(Resources.GLOBAL_ADDCART);
                	$cartBtn.removeClass('noadd');
                }
                $hdnPid.val(data.pid);
            } else {
            	console.log('[ERROR] ajax request: ' + Urls.productVariationChange);
            }
        })
        .fail(function (xhr, textStatus) {
        	console.log('[ERROR] ajax request: ' + Urls.productVariationChange);
        });
    });
	$('.c-pl__item-cart .c-btn__btn').off('click').on('click', function (e) {
		e.preventDefault();

		var me = $(this);
	    if (me.hasClass('noadd')) {
	        return;
	    }

	    var $tile = $(this).closest('.product-tile');
	    var $cartBtn = $tile.find('.c-pl__item-cart').find('.c-btn__btn');
	    var $form = $tile.find('form');
	    var $pid =  $tile.find('input[name="pid"]').val();
	    var $isKit = $tile.find('input[name="isKit"]').val();

	    if ($isKit === 'true') {
	    	var productKitUrl = $cartBtn.data('url');
	    	window.location.href = productKitUrl.url;
	    	return;
	    }

	    var info = $cartBtn.data('info');
	    window.dataLayer.push(info);

	    dialog.loading();

	    addItemToCart($form).then(function(response) {
	    	dialog.close();
            if (response.error && !response.isWithinOrderablePeriod) {
	            window.location.href = Urls.cartShow;
	            return;
            }
            showResult(!response.error, response.response, function () {
            	var $url = util.appendParamsToUrl(Urls.productCheckStatusUpdate, {pid: $pid});
                $.ajax({
                    type: 'GET',
                    cache: false,
                    contentType: 'application/json',
                    url: $url,
                  })
                .done(function (res) {
                	if (res.success == true) {
                        if (res.checkStatus.isAddToCartErrorOnOrderRestriction) {
                        	$cartBtn.html(Resources.GLOBAL_PURCHASELIMIT_LABEL);
                        	$cartBtn.addClass('noadd');
                        } else if (res.checkStatus.isBeforeReleaseStart) {
                        	$cartBtn.html(Resources.GLOBAL_BEFORERELEAS);
                        	$cartBtn.addClass('noadd');
                        } else if (res.checkStatus.isAfterReleaseEnd) {
                        	$cartBtn.html(Resources.GLOBAL_AFTERRELEASEND);
                        	$cartBtn.addClass('noadd');
                        } else if (res.checkStatus.isBeforePreorderStart) {
                        	$cartBtn.html(Resources.GLOBAL_BEFOREPREORDER);
                        	$cartBtn.addClass('noadd');
                        } else if (res.checkStatus.isAfterPreOrderEnd) {
                        	$cartBtn.html(Resources.GLOBAL_AFTERPREORDEREND);
                        	$cartBtn.addClass('noadd');
                        } else if (res.checkStatus.availableCount <= 0) {
                        	$cartBtn.html(Resources.OUT_OF_STOCK);
                        	$cartBtn.addClass('noadd');
                        } else if (res.checkStatus.maxOrderable <= 0) {
                        	$cartBtn.html(Resources.GLOBAL_OVERLIMIT);
                        	$cartBtn.addClass('noadd');
                        } else {
                        	$cartBtn.html(Resources.GLOBAL_ADDCART);
                        	$cartBtn.removeClass('noadd');
                        }
                    } else {
                    	console.log('[ERROR] ajax request: ' + Urls.productCheckStatusUpdate);
                    }
                })
                .fail(function (xhr, textStatus) {
                	console.log('[ERROR] ajax request: ' + Urls.productCheckStatusUpdate);
                });
            });
	    });
	});
}
function initializeWishListEvents() {
	$('.save-for-later-btn').not('.saved-wishlist').off('click').on('click', function (e) {
		e.preventDefault();
		var $tile = $(this).closest('.product-tile');
		var $wishlistBtn = $tile.find('.c-pl__item-wishlist').find('.button');
		var $form = $tile.find('form');

		if ($wishlistBtn.hasClass('processing')) {
			return;
		}

		$wishlistBtn.addClass('processing');

	    var info = $wishlistBtn.data('info');
	    window.dataLayer.push(info);

	    var $url = Urls.addToWishlistAjaxMenu;
	    var pid = $form.find('input[name$="pid"]').val();
	    var csrf_token = $form.find('input[name$="csrf_token"]').val();
	    var data = "pid=" + pid + "&csrf_token=" + csrf_token;
	    $.ajax({
	    	type: 'POST',
	    	url: $url,
	    	data: data
	    })
	    .done(function(res) {
	    	if (res.success == true) {
		    	if (res.redirecturl != '') {
		    		window.location.href = res.redirecturl;
		    		return;
		    	}
		    	dialog.open({
		    		html: '<div class="msg-wrapper"><div class="dialog__msg-block dialog__msg-block--favorite">' + Resources.ADD_FAVORITE_SUCCESS + '</div></div>',
		    		options: {
		    			open: function(event, ui) {
		    				dialog.setupnotice(ui);
		    				setTimeout(function() {
		    					dialog.close();
		    				}, 1000);
		    			},
		    			close: function(event, ui) {
		    				setTimeout(function() {
		    					bonusProductsView.loadBonusOption();
		    				}, 800);
		    			}
		    		}
		    	});
		    	$wishlistBtn.removeClass('processing');
		    	$wishlistBtn.addClass('saved-wishlist');
		    	initializeWishListEvents();
	    	} else {
	    		console.log('[ERROR] ajax request: ' + Urls.addToWishlistAjaxMenu);
	    		$wishlistBtn.removeClass('processing');
	    	}
	    })
	    .fail(function(res) {
	    	console.log('[ERROR] ajax request: ' + Urls.addToWishlistAjaxMenu);
	    	$wishlistBtn.removeClass('processing');
	    });
	});
	$('.save-for-later-btn.saved-wishlist').off('click').on('click', function (e) {
		e.preventDefault();
		var $tile = $(this).closest('.product-tile');
		var $wishlistBtn = $tile.find('.c-pl__item-wishlist').find('.button');
		var $form = $tile.find('form');

		if ($wishlistBtn.hasClass('processing')) {
			return;
		}

	    var info = $wishlistBtn.data('info');
	    window.dataLayer.push(info);

	    var $url = Urls.removeToWishlistAjaxMenu;
	    $.ajax({
	    	type: 'POST',
	    	url: $url,
	    	data: $form.serialize()
	    })
	    .done(function(res) {
	    	if (res.success == true) {
		    	if (res.redirecturl != '') {
		    		window.location.href = res.redirecturl;
		    		return;
		    	}
		    	dialog.open({
		    		html: '<div class="msg-wrapper"><div class="dialog__msg-block dialog__msg-block--favorite">' + Resources.DEL_FAVORITE_SUCCESS + '</div></div>',
		    		options: {
		    			open: function(event, ui) {
		    				dialog.setupnotice(ui);
		    				setTimeout(function() {
		    					dialog.close();
		    				}, 1000);
		    			},
		    			close: function(event, ui) {
		    				setTimeout(function() {
		    					bonusProductsView.loadBonusOption();
		    				}, 800);
		    			}
		    		}
		    	});
		    	$wishlistBtn.removeClass('processing');
		    	$wishlistBtn.removeClass('saved-wishlist');
		    	initializeWishListEvents();
	    	} else {
	    		console.log('[ERROR] ajax request: ' + Urls.removeToWishlistAjaxMenu);
	    		$wishlistBtn.removeClass('processing');
	    	}
	    })
	    .fail(function(res) {
	    	console.log('[ERROR] ajax request: ' + Urls.removeToWishlistAjaxMenu);
	    	$wishlistBtn.removeClass('processing');
	    });
	});
}

var addItemToCart = function (form) {
	var urlpost = util.ajaxUrl(Urls.addProduct);
	  return Promise.resolve(
		    $.ajax({
		      type: 'POST',
		      url: urlpost,
		      data: form.serialize()
		    })
		  ).then(function (response) {
		    try {
		      response = JSON.parse(response);
		    } catch (er) {}

		    const isError = response.status === 'error';
		    const message = isError ? response.message : null;
		    const responseHTML = response.hasOwnProperty('status') ? null : response;

		    return {
		      error: isError,
		      response: responseHTML,
		      msg: message,
		      isWithinOrderablePeriod: response.isWithinOrderablePeriod
		    };
		  });
};
function showResult(success, response, checking_fn) {
	  if (success) {

	    minicart.notice(false);

	    minicart.show(response);

	    updateMiniCartIcon();

	    checking_fn();

	    return;
	  }

	  minicart.notice(true);
}

/**
 * ミニカートアイコンのHTMLを更新する
 *
 */
function updateMiniCartIcon() {
  $.ajax({
    method: 'Get',
    dataType: 'html',
    url: Urls.headerCartIcon,
    success: function (t) {
      $('#hd-cart').html($(t).html());
    }
  });
}

exports.init = function () {
    var $tiles = $('.tiles-container .product-tile');
    if ($tiles.length === 0) { return; }
    imagesLoaded('.tiles-container').on('done', function () {
        $tiles.not('.c-pl__item').syncHeight();
        $tiles.each(function (idx) {
            $(this).data('idx', idx);
        });
    });

    initCarouselSwatches();
    initializeEvents();
    initializeWishListEvents();
};
},{"./bonus-products-view":4,"./dialog":9,"./minicart":17,"./util":63,"imagesloaded":70}],51:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],52:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    product = require('./pages/product'),
    util = require('./util'),
    _ = require('lodash');


var makeUrl = function (url, source, productListID) {
    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }
    return url;
};

var removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

var quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });
    },

    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        var url;
        if (!this.exists()) {
            this.init();
        }
        url = makeUrl(options.url, options.source, options.productlistid);

        dialog.open({
            target: this.$container,
            url: url,
            options: {
                width: 920,
                title: Resources.QUICK_VIEW_POPUP,
                open: function () {
                    this.setup(url);
                    if (typeof options.callback === 'function') { options.callback(); }
                }.bind(this)
            }
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;

},{"./dialog":9,"./pages/product":38,"./util":63,"lodash":71}],53:[function(require,module,exports){
'use strict';

$(function () {
  // if reCaptcha is off, do nothing.
  if ($('#captcha').length === 0) {
    return;
  }

  $('button[name$="_contactus_send"]').prop('disabled', true);
  window.reCaptchaCallback = reCaptchaCallback;
  window.reCaptchaExpiredCallback = reCaptchaExpiredCallback;
});

/**
 * This is the process called after the ReCaptcha execution.
 * A successful reCaptcha activates the Send button.
 * @returns {undefined}
 */
function reCaptchaCallback() {
  $('button[name$="_contactus_send"]').prop('disabled', false);
}

/**
 * This is the process called after the ReCaptcha execution.
 * Deactivate the Send button if the reCaptcha fails.
 * @returns {undefined}
 */
function reCaptchaExpiredCallback() {
  $('button[name$="_contactus_send"]').prop('disabled', true);
}

},{}],54:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */
function initializeEvents() {
  initSearchPlaceholder('#q');
}

/**
 * @param {string} searchBoxSelector 検索窓要素のセレクタ
 */
function initSearchPlaceholder(searchBoxSelector) {
  // Desktop、SPで異なるプレースホルダー文言を表示
  const mediumWidth = 769; // px
  const $searchBox = $(searchBoxSelector);

  function updateSearchboxPlaceholder() {
    const width = $(window).width();
    const isDesktop = width > mediumWidth;
    const deviceType = isDesktop ? 'desktop' : 'sp';
    $searchBox.attr(
      'placeholder',
      $searchBox.data('placeholder-' + deviceType)
    );
  }

  // 初期化
  updateSearchboxPlaceholder();
  // ウィンドウがリサイズされたときの処理
  $(window)
    .off('resize.searchcatalog' + searchBoxSelector)
    .on('resize.searchcatalog' + searchBoxSelector, updateSearchboxPlaceholder);
}

exports.initSearchPlaceholder = initSearchPlaceholder;
exports.init = initializeEvents;

},{}],55:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
  lastQuery = null,
  runningQuery = null,
  delay = 30,
  $resultsContainer;

var searchsuggest = {
  /**
   * @function
   * @description Configures parameters and required object instances
   */
  init: function (container, defaultValue) {
    var $searchContainer = $(container);
    var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
    var $searchField = $searchForm.find('input[name="q"]');

    // disable browser auto complete
    $searchField.attr('autocomplete', 'off');

    // on focus listener (clear default value)
    $searchField.on('focus', function () {
      if (!$resultsContainer) {
        // create results container if needed
        $resultsContainer = $('<div/>')
          .attr('id', 'search-suggestions')
          .appendTo($searchContainer);
      }
      if ($searchField.val() === defaultValue) {
        $searchField.val('');
      }
    });

    $(document).on(
      'click',
      function (e) {
        if (!$searchContainer.is(e.target)) {
          setTimeout(this.clearResults, 200);
        }
      }.bind(this)
    );
    // 入力フォームに文字が入力された時のイベント
    $searchField.on(
      'input',
      function (e) {

        currentQuery = $searchField.val().trim();

        // no query currently running, init an update
        if (!runningQuery) {
          runningQuery = currentQuery;
          setTimeout(this.suggest.bind(this), delay);
        }
      }.bind(this)
    );
  },

  /**
   * @function
   * @description trigger suggest action
   */
  suggest: function () {
    // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
    // (we had a little delay)
    if (runningQuery !== currentQuery) {
      // update running query to the most recent search phrase
      runningQuery = currentQuery;
    }

    // if it's empty clear the results box and return
    if (runningQuery.length === 0) {
      this.clearResults();
      runningQuery = null;
      return;
    }

    // if the current search phrase is the same as for the last suggestion call, just return
    if (lastQuery === runningQuery) {
      runningQuery = null;
      return;
    }

    // build the request url
    var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

    // execute server call
    $.get(
      reqUrl,
      function (data) {
        var suggestionHTML = data,
          ansLength = suggestionHTML.trim().length;

        // if there are results populate the results div
        if (ansLength === 0) {
          this.clearResults();
        } else {
          // update the results div
          //【サイトリニューアル 1.0】 #31177 対応 サジェストの検索ボタンにイベントを実装
//          $resultsContainer.html(suggestionHTML).fadeIn(200);
          var $suggestContainer = $('.h__search-block');
          $suggestContainer.html(suggestionHTML).fadeIn(200, function() {
            //【サイトリニューアル 1.0】 #31270 対応 サジェスト表示時、検索ボタンが変更されない不具合を修正
            $suggestContainer.addClass('h__search-block--show');
            $('.h__modal-cover').addClass('h__modal-cover--show');
            $('.h__search-bar').find('button[type="submit"]').addClass('hide');
            $('.h__search-bar').find('button[type="reset"]').removeClass('hide');
            //【サイトリニューアル 1.0】 #31270 対応 サジェスト表示時、検索ボタンが変更されない不具合を修正
            $('.h__search-block-button').off('click').on('click', '.c-btn__btn-primary', function(e) {
            	$('#h__search').find('form[name="simpleSearch"]').trigger('submit');
            });
          });
          // 【サイトリニューアル 1.0】 #31177 対応 サジェストの検索ボタンにイベントを実装
        }

        // record the query that has been executed
        lastQuery = runningQuery;
        // reset currently running query
        runningQuery = null;

        // check for another required update (if current search phrase is different from just executed call)
        if (currentQuery !== lastQuery) {
          // ... and execute immediately if search has changed while this server call was in transit
          runningQuery = currentQuery;
          setTimeout(this.suggest.bind(this), delay);
        }
        this.hideLeftPanel();
      }.bind(this)
    );
  },
  /**
   * @function
   * @description
   */
  clearResults: function () {
    if (!$resultsContainer) {
      return;
    }
    $resultsContainer.fadeOut(200, function () {
      $resultsContainer.empty();
    });
  },
  /**
   * @function
   * @description
   */
  hideLeftPanel: function () {
    //hide left panel if there is only a matching suggested custom phrase
    if (
      $('.search-suggestion-left-panel-hit').length === 1 &&
      $('.search-phrase-suggestion a')
        .text()
        .replace(/(^[\s]+|[\s]+$)/g, '')
        .toUpperCase() ===
        $('.search-suggestion-left-panel-hit a').text().toUpperCase()
    ) {
      $('.search-suggestion-left-panel').css('display', 'none');
      $('.search-suggestion-wrapper-full').addClass(
        'search-suggestion-wrapper'
      );
      $('.search-suggestion-wrapper').removeClass(
        'search-suggestion-wrapper-full'
      );
    }
  },
};

module.exports = searchsuggest;

},{"./util":63}],56:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */
exports.init = function () {
   $('.slick').slick();
};

},{}],57:[function(require,module,exports){
'use strict';

var MAX_QUANTITY = 5;
var $productActionForm, $addToCart;

// 在庫チェック
function checkStock($target) {
  window.getProductStatus($target.data('pid'), function (pid, data) {
    var $pdp = $target.closest('.static-pdp-main'),
      $cartBtn = $pdp.find('.static-add-to-cart');
    var $selectQuantity = $pdp.find('.select-quantity'),
      maxQuantity,
      options,
      i;

    if (data.instock) {
      // 在庫あり
      $pdp.removeClass('outofstock');
    } else if (!data.instock) {
      // 在庫なし
      $pdp.addClass('outofstock');
    }

    // 数量プルダウン設定
    if ($selectQuantity.length > 0) {
      maxQuantity = $selectQuantity.data('max-quantity');
      if (typeof maxQuantity === 'undefined') {
        maxQuantity = MAX_QUANTITY;
      } else {
        maxQuantity = parseInt(maxQuantity, 10);
      }

      $selectQuantity.children('option').remove();
      options = '';
      for (i = 0; i < maxQuantity && i < data.max_orderable; i++) {
        options += '<option value="' + (i + 1) + '">' + (i + 1) + '</option>';
      }
      if (options === '') {
        $selectQuantity.closest('.inventory').addClass('hide');
      } else {
        $selectQuantity
          .append(options)
          .closest('.inventory')
          .removeClass('hide');
      }
    }

    if (data.max_orderable > 0) {
      $cartBtn.prop('disabled', false);
      $pdp.find('.msg-area').addClass('hide');
    } else {
      var msg = data.cat_limit_msg;

      $cartBtn.prop('disabled', true);

      if (msg === null || msg === '') {
        msg = $pdp.find('.msg-area').data('msg-default');
      }
      $pdp.find('.msg-area').removeClass('hide').html(msg);
    }

    // カート追加不可チェック
    var getBtnBlock = function () {
      var $btnObject = $pdp.find('.btns');

      if ($btnObject.length < 1) {
        $btnObject = $pdp.find('.btn').eq(0);
      }

      return $btnObject;
    };
    var $btnBlock = getBtnBlock();
    if ($btnBlock.length > 0) {
      var $msgArea = $pdp.find('.msg-area');
      var btnMsg = 'カートに追加できません';

      $pdp.find('.restriction-msg').remove();

      if (data.isAddToCartErrorOnOrderRestriction) {
        // 在庫ありの場合のみメッセージ表示
        if (data.instock) {
          // カート追加不可
          if (data.hasOrderRestrictedProductInCart) {
            if (pid == data.orderRestrictedProductIdInCart) {
              btnMsg = 'これ以上追加できません';
            } else {
              $btnBlock.before(
                '<p class="restriction-msg">' +
                  data.orderRestrictedProductNameInCart +
                  'をご注文の場合は、他の商品を同時に購入することはできません。</p>'
              );
            }
          } else {
            $btnBlock.before(
              '<p class="restriction-msg">' +
                data.productName +
                'をご注文の場合は、他の商品を同時に購入することはできません。</p>'
            );
          }
          $cartBtn.prop('disabled', true);
          $msgArea.removeClass('hide').html(btnMsg);
        }
      } else {
        if (data.max_orderable > 0) {
          // カート追加可能
          $cartBtn.prop('disabled', false);
          $msgArea.addClass('hide');
        } else {
          // カート追加不可（個数）
          $cartBtn.prop('disabled', true);
          $msgArea.removeClass('hide').html($msgArea.data('msg-default'));
        }
      }
    }
  });
}

// カートボタンpid切替設定
function initButtonPid() {
  $('.static-pdp-main').each(function () {
    var $pdp = $(this),
      $cartBtn = $pdp.find('.static-add-to-cart');
    var setButtonPid = function ($targetPdp, pid) {
      $targetPdp.find('.static-add-to-cart').data('pid', pid);

      // 在庫チェック
      checkStock($cartBtn);
    };
    var changeProductImage = function ($targetPdp, pid) {
      var $spdpImages = $targetPdp.closest('.spdp').find('.spdp-images');

      $spdpImages
        .find('> div')
        .removeClass('current')
        .filter('.pro-img-' + pid)
        .addClass('current');
    };

    // 容量変更
    $pdp.find('.va-size').on('change', '.variation-select', function () {
      setButtonPid($pdp, $(this).val());
      changeProductImage($pdp, $(this).val());
    });

    // 色変更
    $pdp.find('.va-color').on('change', '.variation-select', function () {
      setButtonPid($pdp, $(this).val());
      changeProductImage($pdp, $(this).val());
    });

    // サムネイルクリック変更
    $pdp.find('ul.va-pro-thumb').on('click', 'li', function () {
      var $this = $(this);

      // サムネイル選択設定
      $this.addClass('current').siblings().removeClass('current');

      setButtonPid($pdp, $this.data('pid'));
      changeProductImage($pdp, $this.data('pid'));
    });
  });
}

function initProductStatus() {
  $productActionForm = $('#product-action-form');
  $addToCart = $('#add-to-cart');

  if ($productActionForm.length < 1) {
    return false;
  }

  // カートボタンpid切替設定
  initButtonPid();

  // カートボタン設定
  $('.static-add-to-cart').each(function () {
    var $this = $(this);

    // ページロード時の在庫チェック
    checkStock($this);

    $this.on('click', function () {
      var $selectQuantity = $this
          .closest('.static-pdp-main')
          .find('.select-quantity'),
        quantity;

      quantity = $selectQuantity.length > 0 ? $selectQuantity.val() : 1;

      // カートイン処理
      $productActionForm
        .find('.add-to-cart-pid')
        .val($this.data('pid'))
        .end()
        .find('.add-to-cart-quantity')
        .val(quantity);

      $addToCart.trigger('click');

      // カートイン後の在庫チェック（ページ内全て）、少し待ってから実行
      setTimeout(function() {
        $('.static-add-to-cart').each(function () {
          checkStock($(this));
        });
      }, 200);

      return false;
    });
  });
}

exports.init = function () {
  initProductStatus();
};

},{}],58:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
  setSelectedStore: function (storeId) {
    var $selectedStore = $('.store-tile.' + storeId),
      $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
      storeAddress = $selectedStore.find('.store-address').html(),
      storeStatus = $selectedStore.find('.store-status').data('status'),
      storeStatusText = $selectedStore.find('.store-status').text();
    this.selectedStore = storeId;

    $lineItem
      .find('.instore-delivery .selected-store-address')
      .data('storeId', storeId)
      .attr('data-store-id', storeId)
      .html(storeAddress);
    $lineItem
      .find('.instore-delivery .selected-store-availability')
      .data('status', storeStatus)
      .attr('data-status', storeStatus)
      .text(storeStatusText);
    $lineItem
      .find('.instore-delivery .delivery-option')
      .prop('disabled', false)
      .trigger('click');
  },
  cartSelectStore: function (selectedStore) {
    var self = this;
    inventory
      .getStoresInventory(this.uuid)
      .then(function (stores) {
        inventory.selectStoreDialog({
          stores: stores,
          selectedStoreId: selectedStore,
          selectedStoreText: Resources.SELECTED_STORE,
          continueCallback: function () {},
          selectStoreCallback: self.setSelectedStore.bind(self),
        });
      })
      .done();
  },
  setDeliveryOption: function (value, storeId) {
    // set loading state
    $('.item-delivery-options').addClass('loading').children().hide();

    var data = {
      plid: this.uuid,
      storepickup: value === 'store' ? true : false,
    };
    if (value === 'store') {
      data.storepickup = true;
      data.storeid = storeId;
    } else {
      data.storepickup = false;
    }
    $.ajax({
      url: Urls.setStorePickup,
      data: data,
      success: function () {
        // remove loading state
        $('.item-delivery-options').removeClass('loading').children().show();
      },
    });
  },
  init: function () {
    var self = this;
    $('.item-delivery-options .set-preferred-store').on('click', function (e) {
      e.preventDefault();
      self.uuid = $(this).data('uuid');
      var selectedStore = $(this)
        .closest('.instore-delivery')
        .find('.selected-store-address')
        .data('storeId');
      if (!User.zip) {
        inventory.zipPrompt(function () {
          self.cartSelectStore(selectedStore);
        });
      } else {
        self.cartSelectStore(selectedStore);
      }
    });
    $('.item-delivery-options .delivery-option').on('click', function () {
      // reset the uuid
      var selectedStore = $(this)
        .closest('.instore-delivery')
        .find('.selected-store-address')
        .data('storeId');
      self.uuid = $(this).closest('.cart-row').data('uuid');
      self.setDeliveryOption($(this).val(), selectedStore);
    });
  },
};

module.exports = cartInventory;

},{"./":59}],59:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button" data-store-id="' + store.storeId + '"' +
        (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        '<div id="preferred-store-panel">',
        '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>',
        '</div>'
    ].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function (zipCode) {
    var regexes = {
            canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
            usa: /^\d{5}(-\d{4})?$/
        },
        valid = false;
    if (!zipCode) { return; }
    _.each(regexes, function (re) {
        var regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

var storeinventory = {
    zipPrompt: function (callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function () {
                        var zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":9,"../util":63,"lodash":71,"promise":72}],60:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    inventory = require('./');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
    }
};

module.exports = productInventory;

},{"./":59,"lodash":71}],61:[function(require,module,exports){
'use strict';

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * @function setCookie
 *
 * @param {string} key - The cookie name
 * @param {string} value - The cookie value
 * @param {integer} minutes - The number of minutes to expire the cookie
 **/
function setCookie (key, value, minutes) {
    var date = new Date();
    date.setTime(date + (minutes * 60 * 1000));

    document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{}],62:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    $(document).tooltip({
        items: '.tooltip',
        track: true,
        content: function () {
            return $(this).find('.tooltip-content').html();
        }
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};

},{}],63:[function(require,module,exports){
'use strict';

var _ = require('lodash');

/**
 * PDP表示制御用変数オブジェクト
 *
 * @typedef PdpStatus
 * @property {boolean} isMaster - マスター商品？
 * @property {boolean} isKit -  キット商品？
 * @property {boolean} isInStock - 在庫あり？
 * @property {number} maxOrderable - 注文可能数
 * @property {boolean} isPreOrderProduct - 予約商品？
 * @property {boolean} isBeforeReleaseStart - 通常販売開始前？
 * @property {boolean} isAfterPreOrderEnd - 予約販売期間終了？
 * @property {boolean} isOnPreOrder - 予約期間中の予約商品？
 * @property {boolean} isPreOrderSettingValid - 予約注文の設定に不備なし？
 * @property {boolean} isOrderRestrictedProduct - PDPの商品が注文制限商品？
 * @property {boolean} hasOrderRestrictedProductInCart - 1商品のみ購入制限商品がカート内に存在する？
 * @property {boolean} hasNormalProductInCart - カート内に何らかの商品が存在する？(ボーナス商品を除く)
 * @property {string|null} orderRestrictedProductNameInCart - カート内に存在する注文制限商品の商品名(存在しなければnull)
 * @property {string|null} orderRestrictedProductIdInCart - カート内に存在する注文制限商品のID(存在しなければnull)
 * @property {boolean} isAddToCartErrorOnOrderRestriction - 注文制限の観点でエラーがあるか？
 * @property {string} productName - 商品名
 */

/**
 * 商品ページ内不可視要素(checkstatus.isml)に埋め込まれたステータス変数を取得
 *
 * @returns {PdpStatus} PDP表示制御用変数オブジェクト
 * @see {@link app_shiseido_ipsa_core/cartridge/templates/default/product/components/checkstatus.isml}
 */
function getPdpStatus() {
  const isOrderRestrictedProduct =
    $('#js-is-order-restricted-product').val() === 'true';
  const hasOrderRestrictedProductInCart =
    $('#js-has-order-restricted-product-in-cart').val() === 'true';
  const hasNormalProductInCart =
    $('#js-has-normal-product-in-cart').val() === 'true';
  return {
    isMaster: $('#is_master').length > 0 && $('#is_master').val() === 'true',
    isKit: $('#is_kit').val() === 'true',
    isInStock: $('#instock').val() === 'true',
    maxOrderable:
      $('#max_orderable').length > 0 ? parseInt($('#max_orderable').val()) : 0,
    isPreOrderProduct: $('#js-is-preorder-product').val() === 'true',
    isBeforeReleaseStart: $('#js-is-before-release-start').val() === 'true',
    isAfterPreOrderEnd: $('#js-is-after-preorder-end').val() === 'true',
    isOnPreOrder: $('#js-is-on-preorder').val() === 'true',
    isPreOrderSettingValid: $('#js-is-preorder-setting-valid').val() === 'true',
    isOrderRestrictedProduct: isOrderRestrictedProduct,
    hasOrderRestrictedProductInCart: hasOrderRestrictedProductInCart,
    hasNormalProductInCart: hasNormalProductInCart,
    orderRestrictedProductNameInCart:
      $('#js-order-restricted-product-name-in-cart').val() || null,
    orderRestrictedProductIdInCart:
      $('#js-order-restricted-product-id-in-cart').val() || null,
    isAddToCartErrorOnOrderRestriction:
      $('#js-is-add-to-cart-error-on-order-restriction').val() === 'true',
    productName: $('#js-product-name').val()
  };
}

var util = {
  /**
   * @function
   * @description appends the parameter with the given name and value to the given url and returns the changed url
   * @param {String} url the url to which the parameter will be added
   * @param {String} name the name of the parameter
   * @param {String} value the value of the parameter
   */
  appendParamToURL: function (url, name, value) {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
      return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
  },

  /**
   * @function
   * @description remove the parameter and its value from the given url and returns the changed url
   * @param {String} url the url from which the parameter will be removed
   * @param {String} name the name of parameter that will be removed from url
   */
  removeParamFromURL: function (url, name) {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
      return url;
    }
    var hash;
    var params;
    var domain = url.split('?')[0];
    var paramUrl = url.split('?')[1];
    var newParams = [];
    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
      hash = paramUrl.split('#')[1] || '';
      paramUrl = paramUrl.split('#')[0];
    }
    params = paramUrl.split('&');
    for (var i = 0; i < params.length; i++) {
      // put back param to newParams array if it is not the one to be removed
      if (params[i].split('=')[0] !== name) {
        newParams.push(params[i]);
      }
    }
    return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
  },

  /**
   * @function
   * @description appends the parameters to the given url and returns the changed url
   * @param {String} url the url to which the parameters will be added
   * @param {Object} params
   */
  appendParamsToUrl: function (url, params) {
    var _url = url;
    _.each(
      params,
      function (value, name) {
        _url = this.appendParamToURL(_url, name, value);
      }.bind(this)
    );
    return _url;
  },
  /**
   * @function
   * @description extract the query string from URL
   * @param {String} url the url to extra query string from
   **/
  getQueryString: function (url) {
    var qs;
    if (!_.isString(url)) {
      return;
    }
    var a = document.createElement('a');
    a.href = url;
    if (a.search) {
      qs = a.search.substr(1); // remove the leading ?
    }
    return qs;
  },
  /**
   * @function
   * @description
   * @param {String}
   * @param {String}
   */
  elementInViewport: function (el, offsetToTop) {
    var top = el.offsetTop,
      left = el.offsetLeft,
      width = el.offsetWidth,
      height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    if (typeof offsetToTop !== 'undefined') {
      top -= offsetToTop;
    }

    if (window.pageXOffset !== null) {
      return (
        top < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
      );
    }

    if (document.compatMode === 'CSS1Compat') {
      return (
        top <
          window.document.documentElement.scrollTop +
            window.document.documentElement.clientHeight &&
        left <
          window.document.documentElement.scrollLeft +
            window.document.documentElement.clientWidth &&
        top + height > window.document.documentElement.scrollTop &&
        left + width > window.document.documentElement.scrollLeft
      );
    }
  },

  /**
   * @function
   * @description Appends the parameter 'format=ajax' to a given path
   * @param {String} path the relative path
   */
  ajaxUrl: function (path) {
    return this.appendParamToURL(path, 'format', 'ajax');
  },

  /**
   * @function
   * @description
   * @param {String} url
   */
  toAbsoluteUrl: function (url) {
    if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
      url = '/' + url;
    }
    return url;
  },
  /**
   * @function
   * @description Loads css dynamically from given urls
   * @param {Array} urls Array of urls from which css will be dynamically loaded.
   */
  loadDynamicCss: function (urls) {
    var i,
      len = urls.length;
    for (i = 0; i < len; i++) {
      this.loadedCssFiles.push(this.loadCssFile(urls[i]));
    }
  },

  /**
   * @function
   * @description Loads css file dynamically from given url
   * @param {String} url The url from which css file will be dynamically loaded.
   */
  loadCssFile: function (url) {
    return $('<link/>')
      .appendTo($('head'))
      .attr({
        type: 'text/css',
        rel: 'stylesheet'
      })
      .attr('href', url); // for i.e. <9, href must be added after link has been appended to head
  },
  // array to keep track of the dynamically loaded CSS files
  loadedCssFiles: [],

  /**
   * @function
   * @description Removes all css files which were dynamically loaded
   */
  clearDynamicCss: function () {
    var i = this.loadedCssFiles.length;
    while (0 > i--) {
      $(this.loadedCssFiles[i]).remove();
    }
    this.loadedCssFiles = [];
  },
  /**
   * @function
   * @description Extracts all parameters from a given query string into an object
   * @param {String} qs The query string from which the parameters will be extracted
   */
  getQueryStringParams: function (qs) {
    if (!qs || qs.length === 0) {
      return {};
    }
    var params = {},
      unescapedQS = decodeURIComponent(qs);
    // Use the String::replace method to iterate over each
    // name-value pair in the string.
    unescapedQS.replace(
      new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
      function ($0, $1, $2, $3) {
        params[$1] = $3;
      }
    );
    return params;
  },

  fillAddressFields: function (address, $form) {
    for (var field in address) {
      if (field === 'ID' || field === 'UUID' || field === 'key') {
        continue;
      }
      // if the key in address object ends with 'Code', remove that suffix
      // keys that ends with 'Code' are postalCode, stateCode and countryCode
      $form
        .find('[name$="' + field.replace('Code', '') + '"]')
        .val(address[field]);
      // update the state fields
      if (field === 'countryCode') {
        $form.find('[name$="country"]').trigger('change');
        // retrigger state selection after country has changed
        // this results in duplication of the state code, but is a necessary evil
        // for now because sometimes countryCode comes after stateCode
        $form.find('[name$="state"]').val(address.stateCode);
      }
    }
  },
  /**
   * @function
   * @description Updates the number of the remaining character
   * based on the character limit in a text area
   */
  limitCharacters: function () {
    $('form')
      .find('textarea[data-character-limit]')
      .each(function () {
        var characterLimit = $(this).data('character-limit');
        var charCountHtml = String.format(
          Resources.CHAR_LIMIT_MSG,
          '<span class="char-remain-count">' + characterLimit + '</span>',
          '<span class="char-allowed-count">' + characterLimit + '</span>'
        );
        var charCountContainer = $(this).next('div.char-count');
        if (charCountContainer.length === 0) {
          charCountContainer = $('<div class="char-count"/>').insertAfter(
            $(this)
          );
        }
        charCountContainer.html(charCountHtml);
        // trigger the keydown event so that any existing character data is calculated
        $(this).trigger('change');
      });
  },
  /**
   * @function
   * @description Binds the onclick-event to a delete button on a given container,
   * which opens a confirmation box with a given message
   * @param {String} container The name of element to which the function will be bind
   * @param {String} message The message the will be shown upon a click
   */
  setDeleteConfirmation: function (container, message) {
    $(container).on('click', '.delete', function () {
      return window.confirm(message);
    });
  },
  /**
   * @function
   * @description Scrolls a browser window to a given x point
   * @param {String} The x coordinate
   */
  scrollBrowser: function (xLocation) {
    $('html, body').animate({ scrollTop: xLocation }, 500);
  },

  isMobile: function () {
    var mobileAgentHash = [
      'mobile',
      'tablet',
      'phone',
      'ipad',
      'ipod',
      'android',
      'blackberry',
      'windows ce',
      'opera mini',
      'palm'
    ];
    var idx = 0;
    var isMobile = false;
    var userAgent = navigator.userAgent.toLowerCase();

    while (mobileAgentHash[idx] && !isMobile) {
      isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
      idx++;
    }
    return isMobile;
  },

  getPdpStatus: getPdpStatus
};

module.exports = util;

},{"lodash":71}],64:[function(require,module,exports){
'use strict';

var customformvalidator = require('./customformvalidator');

var naPhone =
  /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
  phone: {
    us: naPhone,
    ca: naPhone,
    fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
    it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
    jp: /^[0-9]{10,11}$/,
    cn: /.*/,
    gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
  },
  postal: {
    us: /^\d{5}(-\d{4})?$/,
    ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
    fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
    it: /^([0-9]){5}$/,
    jp: /^([0-9]){7}$/,
    cn: /^([0-9]){6}$/,
    gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
  },
  notCC: /^(?!(([0-9 -]){13,19})).*$/,
  halfsize: /([０-９])$/
};
// global form validator settings
var settings = {
  errorClass: 'error',
  errorElement: 'span',
  onkeyup: false,
  onfocusout: function (element) {
    if (!this.checkable(element)) {
      this.element(element);
    }
  }
};
/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
  var country = $(el).closest('form').find('.country');
  var isValid = isNotHalfSizeNumber(value);
  var isOptional = this.optional(el);
  if (isValid && country.length !== 0) {
    var rgx = regex.phone[country.val().toLowerCase()];
    isValid = rgx.test(value.trim());
  }
  return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
  var isValid = regex.notCC.test(value.trim());
  return isValid;
};

function isNotHalfSizeNumber(value) {
  return !regex.halfsize.test(value.trim());
}

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, function (_arg1, $input) {
  return isNotHalfSizeNumber($input.value)
    ? Resources.INVALID_PHONE
    : Resources.HALF_SIZE;
});

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Check the zip code is valid format or not.<br>
 * @param {String} value The zip code will be checked.<br>
 * @returns true if the zip code is valid format, otherwise false.
 */
var isValidZipCode = function (value) {
  return value.match(/^\d{7}$/);
};

/**
 * Validate the zip code.<br>
 * @param {String} value The zip code will be validated.<br>
 * @returns true if the zip code is valid (half size numeric and correct format), otherwise false.
 */
var validateZipCode = function (value) {
  var valid = isNotHalfSizeNumber(value);

  if (valid) {
    valid = isValidZipCode(value);
  }

  return valid;
};

/**
 * Add postal validation method to jQuery validation plugin.
 * Text fields must have 'postal' css class to be validated as phone
 */
$.validator.addMethod('postal', validateZipCode, function () {
  var zip = $('.postal').val();

  if (!isNotHalfSizeNumber(zip)) {
    return Resources.HALF_SIZE;
  } else {
    return Resources.ZIP_INVALID;
  }
});

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod(
  'gift-cert-amount',
  function (value, el) {
    var isOptional = this.optional(el);
    var isValid =
      !isNaN(value) && parseFloat(value) >= 5 && parseFloat(value) <= 5000;
    return isOptional || isValid;
  },
  Resources.GIFT_CERT_AMOUNT_INVALID
);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod(
  'positivenumber',
  function (value) {
    if (value.trim().length === 0) {
      return true;
    }
    return !isNaN(value) && Number(value) >= 0;
  },
  ''
); // '' should be replaced with error message if needed

/**
 * Add custom validation method for IPSA site
 * TIS custom add
 */
$.validator.addMethod(
  'input-text',
  customformvalidator.charcode_validation,
  function (_arg1, $input) {
    return $input.dataset.custom_validation_error_msg;
  }
);


$.extend($.validator.messages, {
  required: Resources.VALIDATE_REQUIRED,
  remote: Resources.VALIDATE_REMOTE,
  email: Resources.VALIDATE_EMAIL,
  url: Resources.VALIDATE_URL,
  date: Resources.VALIDATE_DATE,
  dateISO: Resources.VALIDATE_DATEISO,
  number: Resources.VALIDATE_NUMBER,
  digits: Resources.VALIDATE_DIGITS,
  creditcard: Resources.VALIDATE_CREDITCARD,
  equalTo: Resources.VALIDATE_EQUALTO,
  maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
  minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
  rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
  range: $.validator.format(Resources.VALIDATE_RANGE),
  max: $.validator.format(Resources.VALIDATE_MAX),
  min: $.validator.format(Resources.VALIDATE_MIN)
});

var validator = {
  regex: regex,
  settings: settings,
  init: function () {
    var self = this;
    $('form:not(.suppress)').each(function () {
      $(this).validate(self.settings);
    });
  },
  initForm: function (f) {
    $(f).validate(this.settings);
  }
};

module.exports = validator;

},{"./customformvalidator":8}],65:[function(require,module,exports){
var modal = require('./modal');

module.exports = {
	init: function (cb) {
		if(typeof window.YT !== "undefined") {
			return cb();
		}

		window.onYouTubeIframeAPIReady = cb;

		// load youtube iframe api
		var tag = document.createElement("script");

		tag.async = true;
		tag.src = "https://www.youtube.com/iframe_api";

		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},

	playInline: function ($ele, videoId) {
		var eleId = $ele.attr("id");
		if(!eleId || !videoId) { return; }

		new YT.Player(eleId, {
			videoId: videoId,
			width: $ele.width(),
			height: $ele.height(),
			playerVars: {rel: 0},
			events: {
				onReady: function (evt) {
					var player = evt.target;
					player.playVideo();
				}
			}
		})
	},

	playInModal: function (videoId) {
		if(!videoId) { return; }

		modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

		new YT.Player("video-player", {
			videoId: videoId,
			events: {
				onReady: function (evt) {
					var player = evt.target;
					modal.events.onOpen(function () {
						var modalBodyWidth = $(".modal-body").width();
						//$("#video-player").width(modalBodyWidth);
						player.playVideo();
					});
					modal.events.onClose(function () { player.destroy(); });
					modal.open();
				}
			}
		})
	}
};
},{"./modal":18}],66:[function(require,module,exports){
/**
 * 退会ページ 初期化処理
 */
function init() {
  // ----( 納品コード )----
  // モーダル
  var $sampleModal = $('.sample-modal');
  $sampleModal.on('click', '.no-withdraw-btn', function () {
    $sampleModal.removeClass('withdraw-modal-show'); // モーダル非表示
  });
  // $('.withdraw-content').on('click', 'button', function() {
  // 	$sampleModal.addClass('sample-modal-show'); // モーダル表示
  // 	return false;
  // });
  // ----( 納品コードここまで )----
  let isHookSubmit = true;
  const $submitButton = $('button.js-widhdraw-submit');
  $submitButton.off('click').on('click', function (e) {
    if (!isHookSubmit) {
      return true;
    }
    $sampleModal.addClass('withdraw-modal-show'); // モーダル表示
    e.preventDefault();
  });
  $sampleModal.on('click', '.withdraw-btn', function () {
    isHookSubmit = false;
    $submitButton.trigger('click');
  });
}

module.exports.init = init;

},{}],67:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":68}],68:[function(require,module,exports){
(function (global){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],69:[function(require,module,exports){
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {

'use strict';

var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

},{}],70:[function(require,module,exports){
/*!
 * imagesLoaded v3.2.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ], function( EventEmitter, eventie ) {
      return factory( window, EventEmitter, eventie );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('wolfy87-eventemitter'),
      require('eventie')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EventEmitter,
      window.eventie
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EventEmitter, eventie ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) == '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options, onAlways );
    }
    // use elem as selector string
    if ( typeof elem == 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options == 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0; i < this.elements.length; i++ ) {
      var elem = this.elements[i];
      this.addElementImages( elem );
    }
  };

  /**
   * @param {Node} element
   */
  ImagesLoaded.prototype.addElementImages = function( elem ) {
    // filter siblings
    if ( elem.nodeName == 'IMG' ) {
      this.addImage( elem );
    }
    // get background image on element
    if ( this.options.background === true ) {
      this.addElementBackgroundImages( elem );
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
      return;
    }
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    for ( var i=0; i < childImgs.length; i++ ) {
      var img = childImgs[i];
      this.addImage( img );
    }

    // get child background images
    if ( typeof this.options.background == 'string' ) {
      var children = elem.querySelectorAll( this.options.background );
      for ( i=0; i < children.length; i++ ) {
        var child = children[i];
        this.addElementBackgroundImages( child );
      }
    }
  };

  var elementNodeTypes = {
    1: true,
    9: true,
    11: true
  };

  ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
    var style = getStyle( elem );
    // get url inside url("...")
    var reURL = /url\(['"]*([^'"\)]+)['"]*\)/gi;
    var matches = reURL.exec( style.backgroundImage );
    while ( matches !== null ) {
      var url = matches && matches[1];
      if ( url ) {
        this.addBackground( url, elem );
      }
      matches = reURL.exec( style.backgroundImage );
    }
  };

  // IE8
  var getStyle = window.getComputedStyle || function( elem ) {
    return elem.currentStyle;
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.addBackground = function( url, elem ) {
    var background = new Background( url, elem );
    this.images.push( background );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !this.images.length ) {
      this.complete();
      return;
    }

    function onProgress( image, elem, message ) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout( function() {
        _this.progress( image, elem, message );
      });
    }

    for ( var i=0; i < this.images.length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.once( 'progress', onProgress );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image, elem, message ) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emit( 'progress', this, image, elem );
    if ( this.jqDeferred && this.jqDeferred.notify ) {
      this.jqDeferred.notify( this, image );
    }
    // check if completed
    if ( this.progressedCount == this.images.length ) {
      this.complete();
    }

    if ( this.options.debug && console ) {
      console.log( 'progress: ' + message, image, elem );
    }
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emit( eventName, this );
    this.emit( 'always', this );
    if ( this.jqDeferred ) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[ jqMethod ]( this );
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    eventie.bind( this.proxyImage, 'load', this );
    eventie.bind( this.proxyImage, 'error', this );
    // bind to image as well for Firefox. #191
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth !== undefined;
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.img, message );
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  // -------------------------- Background -------------------------- //

  function Background( url, element ) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = new LoadingImage();

  Background.prototype.check = function() {
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function() {
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  Background.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.element, message );
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
    jQuery = jQuery || window.jQuery;
    if ( !jQuery ) {
      return;
    }
    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;

});

},{"eventie":69,"wolfy87-eventemitter":91}],71:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],72:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":77}],73:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":68}],74:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":73}],75:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":73}],76:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":73}],77:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":73,"./done.js":74,"./es6-extensions.js":75,"./finally.js":76,"./node-extensions.js":78,"./synchronous.js":79}],78:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":73,"asap":67}],79:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":73}],80:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],81:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

},{}],82:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":81,"./parse":83,"./stringify":84}],83:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }
        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    if (typeof options.charset === 'undefined') {
        options.charset = defaults.charset;
    }

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};

},{"./utils":85}],84:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var formats = require('./formats');

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    var charset = options.charset || defaults.charset;
    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly,
            charset
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":81,"./utils":85}],85:[function(require,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};

},{}],86:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],87:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],88:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":86,"./encode":87}],89:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":90,"punycode":80,"querystring":88}],90:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],91:[function(require,module,exports){
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

},{}]},{},[3]);
